webpackJsonp(["app"],{

/***/ "./app/components/about/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/about/scss/index.scss");

var _aboutStatistics = __webpack_require__("./app/components/about/js/about-statistics.component.js");

var _aboutStatistics2 = _interopRequireDefault(_aboutStatistics);

var _aboutSection = __webpack_require__("./app/components/about/js/about-section.component.js");

var _aboutSection2 = _interopRequireDefault(_aboutSection);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('about-statistics', _aboutStatistics2.default);
_componentsCollection2.default.getInstance().define('about-section', _aboutSection2.default);

/***/ }),

/***/ "./app/components/about/js/about-section.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _intersectionHelper = __webpack_require__("./app/general/js/intersection-helper.js");

var _intersectionHelper2 = _interopRequireDefault(_intersectionHelper);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _styleObserver = __webpack_require__("./app/general/js/style-observer.js");

var _styleObserver2 = _interopRequireDefault(_styleObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AboutSectionComponent = function (_BaseComponent) {
    _inherits(AboutSectionComponent, _BaseComponent);

    function AboutSectionComponent() {
        _classCallCheck(this, AboutSectionComponent);

        var _this = _possibleConstructorReturn(this, (AboutSectionComponent.__proto__ || Object.getPrototypeOf(AboutSectionComponent)).apply(this, arguments));

        (0, _styleObserver2.default)(function () {
            _this.init();
        });
        return _this;
    }

    _createClass(AboutSectionComponent, [{
        key: 'init',
        value: function init() {
            _intersectionHelper2.default.enterViewportOnce(this.element, this.animate.bind(this), { rootMargin: '-25% 0px -20% 0px' });
        }
    }, {
        key: 'animate',
        value: function animate() {
            this.element.classList.add('is-visible');
        }
    }]);

    return AboutSectionComponent;
}(_baseComponent2.default);

exports.default = AboutSectionComponent;

/***/ }),

/***/ "./app/components/about/js/about-statistics.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _intersectionHelper = __webpack_require__("./app/general/js/intersection-helper.js");

var _intersectionHelper2 = _interopRequireDefault(_intersectionHelper);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AboutStatisticsNumberComponent = function (_BaseComponent) {
    _inherits(AboutStatisticsNumberComponent, _BaseComponent);

    function AboutStatisticsNumberComponent() {
        _classCallCheck(this, AboutStatisticsNumberComponent);

        var _this = _possibleConstructorReturn(this, (AboutStatisticsNumberComponent.__proto__ || Object.getPrototypeOf(AboutStatisticsNumberComponent)).apply(this, arguments));

        var content = _this.element.innerHTML;
        _this.element.innerHTML = content.replace(/\d+,?\d*/, function (x) {
            // wrap number to the <span> tag
            return '<span>' + x + '</span>';
        });

        //get first numerical value in the element content string
        var numericalValue = _this.element.dataset.value.match(/\d+,?\d*/);
        if (!numericalValue) return _possibleConstructorReturn(_this);
        _this.value = numericalValue[0];

        _intersectionHelper2.default.enterViewportOnce(_this.element, _this.init.bind(_this));
        return _this;
    }

    _createClass(AboutStatisticsNumberComponent, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            var currentValue = parseInt(this.value.replace(',', ''));
            var fromValue = Math.max(currentValue - 1, 0);
            var number = { value: fromValue };

            TweenLite.to(number, 1, {
                value: currentValue,
                onUpdate: function onUpdate() {
                    _this2.render(number.value);
                }
            });
        }
    }, {
        key: 'render',
        value: function render(value) {
            var stringValue = Math.floor(value).toString();
            if (stringValue.length > 3) {
                stringValue = stringValue.substr(0, stringValue.length - 3) + ',' + stringValue.substr(stringValue.length - 3, stringValue.length);
            }
            this.element.getElementsByTagName('SPAN')[0].innerHTML = stringValue;
        }
    }]);

    return AboutStatisticsNumberComponent;
}(_baseComponent2.default);

exports.default = AboutStatisticsNumberComponent;

/***/ }),

/***/ "./app/components/about/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/account-settings/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/account-settings/scss/index.scss");

/***/ }),

/***/ "./app/components/account-settings/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/article/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/article/scss/index.scss");

/***/ }),

/***/ "./app/components/article/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/auction-results/html/template.hbs":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("./node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "    <div class=\"auction-results__group auction-results__group--"
    + container.escapeExpression(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\">\r\n        <div class=\"flip-number flip-number--results \">\r\n"
    + ((stack1 = helpers.each.call(alias1,depth0,{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\r\n    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "                <div class=\"flip-number__digit\">\r\n                    "
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\r\n                </div>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.numbers : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

/***/ }),

/***/ "./app/components/auction-results/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/auction-results/scss/index.scss");

var _auctionResultNumber = __webpack_require__("./app/components/auction-results/js/auction-result-number.component.js");

var _auctionResultNumber2 = _interopRequireDefault(_auctionResultNumber);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('auction-result-number', _auctionResultNumber2.default);

/***/ }),

/***/ "./app/components/auction-results/js/auction-result-number.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _template = __webpack_require__("./app/components/auction-results/html/template.hbs");

var _template2 = _interopRequireDefault(_template);

var _intersectionHelper = __webpack_require__("./app/general/js/intersection-helper.js");

var _intersectionHelper2 = _interopRequireDefault(_intersectionHelper);

var _TweenLite = __webpack_require__("./node_modules/gsap/TweenLite.js");

var _TweenLite2 = _interopRequireDefault(_TweenLite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AuctionResultNumberComponent = function (_BaseComponent) {
    _inherits(AuctionResultNumberComponent, _BaseComponent);

    function AuctionResultNumberComponent() {
        _classCallCheck(this, AuctionResultNumberComponent);

        var _this = _possibleConstructorReturn(this, (AuctionResultNumberComponent.__proto__ || Object.getPrototypeOf(AuctionResultNumberComponent)).apply(this, arguments));

        _this.number = parseInt(_this.element.dataset.number);
        if (isNaN(_this.number)) {
            throw new Error('data-number is not a number');
        }

        _intersectionHelper2.default.enterViewportOnce(_this.element, _this.init.bind(_this), {
            threshold: 1.0
        });
        return _this;
    }

    _createClass(AuctionResultNumberComponent, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            var number = { value: 0 };

            _TweenLite2.default.to(number, 2.5, {
                value: this.number,
                ease: Power4.easeOut,
                onUpdate: function onUpdate() {
                    _this2.render(number);
                }
            });
        }
    }, {
        key: 'render',
        value: function render(number) {
            var value = Math.ceil(number.value);
            var numbers = this.getSplittedValue(value);
            this.element.innerHTML = (0, _template2.default)({ numbers: numbers });
        }
    }, {
        key: 'getSplittedValue',
        value: function getSplittedValue(value) {

            var digits = this.getPreparedDigitsArray(value);
            var chunkSize = 3;
            var arrayLength = digits.length;

            var chunks = [];

            for (var index = arrayLength; index > 0; index -= chunkSize) {
                var start = Math.max(index - chunkSize, 0);
                var chunk = digits.slice(start, index);
                chunks.unshift(chunk);
            }

            return chunks;
        }
    }, {
        key: 'getPreparedDigitsArray',
        value: function getPreparedDigitsArray(value) {
            var targetStringLength = (this.number + '').length;
            var valueString = value + '';

            var digits = valueString.split('');

            if (digits.length < targetStringLength) {
                var leftDigits = targetStringLength - digits.length;
                var filledArray = [];
                for (var i = 0; i < leftDigits; i++) {
                    filledArray.push('');
                }
                digits.unshift(filledArray);
            }

            return digits;
        }
    }]);

    return AuctionResultNumberComponent;
}(_baseComponent2.default);

exports.default = AuctionResultNumberComponent;

/***/ }),

/***/ "./app/components/auction-results/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/auth-forms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/auth-forms/scss/index.scss");

var _authForms = __webpack_require__("./app/components/auth-forms/js/auth-forms.component.js");

var _authForms2 = _interopRequireDefault(_authForms);

var _loginForm = __webpack_require__("./app/components/auth-forms/js/login-form.component.js");

var _loginForm2 = _interopRequireDefault(_loginForm);

var _forgotPasswordForm = __webpack_require__("./app/components/auth-forms/js/forgot-password-form.component.js");

var _forgotPasswordForm2 = _interopRequireDefault(_forgotPasswordForm);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('auth-forms', _authForms2.default);

_componentsCollection2.default.getInstance().define('login-form', _loginForm2.default);

_componentsCollection2.default.getInstance().define('forgot-password-form', _forgotPasswordForm2.default);

/***/ }),

/***/ "./app/components/auth-forms/js/auth-forms.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TimelineLite = __webpack_require__("./node_modules/gsap/TimelineLite.js");

var _TimelineLite2 = _interopRequireDefault(_TimelineLite);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AuthFormsComponent = function (_BaseComponent) {
    _inherits(AuthFormsComponent, _BaseComponent);

    function AuthFormsComponent() {
        _classCallCheck(this, AuthFormsComponent);

        var _this = _possibleConstructorReturn(this, (AuthFormsComponent.__proto__ || Object.getPrototypeOf(AuthFormsComponent)).apply(this, arguments));

        _this.loginForm = _this.refs.loginForm;
        _this.forgotPasswordForm = _this.refs.forgotPasswordForm;
        _this.showForgotPasswordTrigger = _this.refs.showForgotPasswordTrigger;
        _this.showLoginTrigger = _this.refs.showLoginTrigger;

        _this.forgotPasswordTriggerClick = _this.forgotPasswordTriggerClick.bind(_this);
        _this.loginTriggerClick = _this.loginTriggerClick.bind(_this);

        _this.init();
        return _this;
    }

    _createClass(AuthFormsComponent, [{
        key: 'init',
        value: function init() {
            this.tween = new _TimelineLite2.default({ paused: true });
            this.tween.to(this.loginForm, 0.3, { opacity: 0, display: 'none' });
            this.tween.to(this.forgotPasswordForm, 0.3, { opacity: 1, display: 'flex' });

            this.showForgotPasswordTrigger.addEventListener('click', this.forgotPasswordTriggerClick);
            this.showLoginTrigger.addEventListener('click', this.loginTriggerClick);
        }
    }, {
        key: 'forgotPasswordTriggerClick',
        value: function forgotPasswordTriggerClick() {
            this.tween.play();
        }
    }, {
        key: 'loginTriggerClick',
        value: function loginTriggerClick() {
            this.tween.reverse();
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.tween = null;
            this.showForgotPasswordTrigger.removeEventListener('click', this.forgotPasswordTriggerClick);
            this.showLoginTrigger.removeEventListener('click', this.loginTriggerClick);
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['loginForm', 'forgotPasswordForm', 'showForgotPasswordTrigger', 'showLoginTrigger'];
        }
    }]);

    return AuthFormsComponent;
}(_baseComponent2.default);

exports.default = AuthFormsComponent;

/***/ }),

/***/ "./app/components/auth-forms/js/forgot-password-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _popupResultForm = __webpack_require__("./app/components/form/js/popup-result-form.component.js");

var _popupResultForm2 = _interopRequireDefault(_popupResultForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//just extend PopupResultFormComponent behavior but use existing class name and id
var ForgotPasswordFormComponent = function (_PopupResultFormCompo) {
  _inherits(ForgotPasswordFormComponent, _PopupResultFormCompo);

  function ForgotPasswordFormComponent() {
    _classCallCheck(this, ForgotPasswordFormComponent);

    return _possibleConstructorReturn(this, (ForgotPasswordFormComponent.__proto__ || Object.getPrototypeOf(ForgotPasswordFormComponent)).apply(this, arguments));
  }

  return ForgotPasswordFormComponent;
}(_popupResultForm2.default);

exports.default = ForgotPasswordFormComponent;

/***/ }),

/***/ "./app/components/auth-forms/js/login-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _asyncForm = __webpack_require__("./app/components/form/js/async-form.component.js");

var _asyncForm2 = _interopRequireDefault(_asyncForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginFormComponent = function (_AsyncForm) {
    _inherits(LoginFormComponent, _AsyncForm);

    function LoginFormComponent() {
        _classCallCheck(this, LoginFormComponent);

        return _possibleConstructorReturn(this, (LoginFormComponent.__proto__ || Object.getPrototypeOf(LoginFormComponent)).apply(this, arguments));
    }

    _createClass(LoginFormComponent, [{
        key: 'onSuccess',
        value: function onSuccess(response) {
            if (response.ReturnUrl) {
                window.location.href = response.ReturnUrl;
            } else {
                window.location.reload();
            }
        }
    }]);

    return LoginFormComponent;
}(_asyncForm2.default);

exports.default = LoginFormComponent;

/***/ }),

/***/ "./app/components/auth-forms/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/auth-modal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/auth-modal/scss/index.scss");

var _authTrigger = __webpack_require__("./app/components/auth-modal/js/auth-trigger.component.js");

var _authTrigger2 = _interopRequireDefault(_authTrigger);

var _authModal = __webpack_require__("./app/components/auth-modal/js/auth-modal.component.js");

var _authModal2 = _interopRequireDefault(_authModal);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('auth-trigger', _authTrigger2.default);

_componentsCollection2.default.getInstance().define('auth-modal', _authModal2.default);

/***/ }),

/***/ "./app/components/auth-modal/js/auth-modal.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = __webpack_require__("./app/general/js/modal.js");

var _modal2 = _interopRequireDefault(_modal);

var _eventBus = __webpack_require__("./app/general/js/event-bus.js");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _app = __webpack_require__("./app/general/js/app.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AuthModalComponent = function (_BaseComponent) {
    _inherits(AuthModalComponent, _BaseComponent);

    function AuthModalComponent() {
        _classCallCheck(this, AuthModalComponent);

        var _this = _possibleConstructorReturn(this, (AuthModalComponent.__proto__ || Object.getPrototypeOf(AuthModalComponent)).apply(this, arguments));

        _this.modal = null;

        _this.init();
        return _this;
    }

    _createClass(AuthModalComponent, [{
        key: 'init',
        value: function init() {
            this.triggerClickSubscription = _eventBus2.default.addListener(_app.EVENT_AUTH_TRIGGER_CLICK, this.showModal.bind(this));
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            if (this.modal === null) {
                this.modal = _modal2.default.create(this.element);
            }

            this.modal.open();
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.triggerClickSubscription.remove();
            this.modal = null;
        }
    }]);

    return AuthModalComponent;
}(_baseComponent2.default);

exports.default = AuthModalComponent;

/***/ }),

/***/ "./app/components/auth-modal/js/auth-trigger.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventBus = __webpack_require__("./app/general/js/event-bus.js");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _app = __webpack_require__("./app/general/js/app.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AuthTriggerComponent = function (_BaseComponent) {
    _inherits(AuthTriggerComponent, _BaseComponent);

    function AuthTriggerComponent() {
        _classCallCheck(this, AuthTriggerComponent);

        var _this = _possibleConstructorReturn(this, (AuthTriggerComponent.__proto__ || Object.getPrototypeOf(AuthTriggerComponent)).apply(this, arguments));

        _this.onClick = _this.onClick.bind(_this);
        _this.init();
        return _this;
    }

    _createClass(AuthTriggerComponent, [{
        key: 'init',
        value: function init() {
            this.element.addEventListener('click', this.onClick);
        }
    }, {
        key: 'onClick',
        value: function onClick(e) {
            e.preventDefault();
            _eventBus2.default.emit(_app.EVENT_AUTH_TRIGGER_CLICK);
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.element.removeEventListener('click', this.onClick);
        }
    }]);

    return AuthTriggerComponent;
}(_baseComponent2.default);

exports.default = AuthTriggerComponent;

/***/ }),

/***/ "./app/components/auth-modal/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/banners/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/banners/scss/index.scss");

/***/ }),

/***/ "./app/components/banners/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/bidding-cards/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/bidding-cards/scss/index.scss");

/***/ }),

/***/ "./app/components/bidding-cards/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/buying-selling/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/buying-selling/scss/index.scss");

var _buyingSelling = __webpack_require__("./app/components/buying-selling/js/buying-selling.component.js");

var _buyingSelling2 = _interopRequireDefault(_buyingSelling);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('buying-selling', _buyingSelling2.default);

/***/ }),

/***/ "./app/components/buying-selling/js/buying-selling.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _TimelineLite = __webpack_require__("./node_modules/gsap/TimelineLite.js");

var _TimelineLite2 = _interopRequireDefault(_TimelineLite);

var _createEvent = __webpack_require__("./app/general/js/create-event.js");

var _createEvent2 = _interopRequireDefault(_createEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuyingSellingComponent = function (_BaseComponent) {
    _inherits(BuyingSellingComponent, _BaseComponent);

    function BuyingSellingComponent() {
        _classCallCheck(this, BuyingSellingComponent);

        var _this = _possibleConstructorReturn(this, (BuyingSellingComponent.__proto__ || Object.getPrototypeOf(BuyingSellingComponent)).apply(this, arguments));

        _this.content = _this.refs.content;
        _this.select = _this.refs.select;
        _this.onTypeSelect = _this.onTypeSelect.bind(_this);

        _this.init();
        return _this;
    }

    _createClass(BuyingSellingComponent, [{
        key: 'init',
        value: function init() {
            this.select.addEventListener('change', this.onTypeSelect);
            this.onTypeSelect();
        }
    }, {
        key: 'onTypeSelect',
        value: function onTypeSelect() {
            var _this2 = this;

            var timeline = new _TimelineLite2.default();
            timeline.to(this.content, 0.3, { opacity: 0, onComplete: function onComplete() {
                    if (_this2.select.value == 'buyer') {
                        _this2.element.classList.add('is-buyer');
                        _this2.element.classList.remove('is-seller');
                    } else {
                        _this2.element.classList.remove('is-buyer');
                        _this2.element.classList.add('is-seller');
                    }

                    document.dispatchEvent((0, _createEvent2.default)('buyingSelling:switch'));
                } });
            timeline.to(this.content, 0.5, { opacity: 1 });
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.select.removeEventListener('change', this.onTypeSelect);
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['select'];
        }
    }]);

    return BuyingSellingComponent;
}(_baseComponent2.default);

exports.default = BuyingSellingComponent;

/***/ }),

/***/ "./app/components/buying-selling/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/card/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/card/scss/index.scss");

/***/ }),

/***/ "./app/components/card/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/collapsed/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/collapsed/scss/index.scss");

var _collapsed = __webpack_require__("./app/components/collapsed/js/collapsed.component.js");

var _collapsed2 = _interopRequireDefault(_collapsed);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('collapsed', _collapsed2.default);

/***/ }),

/***/ "./app/components/collapsed/js/collapsed.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _asyncForm = __webpack_require__("./app/components/form/js/async-form.component.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CollapsedComponent = function (_BaseComponent) {
    _inherits(CollapsedComponent, _BaseComponent);

    function CollapsedComponent() {
        _classCallCheck(this, CollapsedComponent);

        var _this = _possibleConstructorReturn(this, (CollapsedComponent.__proto__ || Object.getPrototypeOf(CollapsedComponent)).apply(this, arguments));

        _this.trigger = _this.refs.trigger;
        _this.content = _this.refs.content;

        _this.isOpened = _this.options.isOpened || false;
        _this.onInnerFieldValidationFailed = _this.onInnerFieldValidationFailed.bind(_this);
        _this.toggle = _this.toggle.bind(_this);

        _this.init();
        return _this;
    }

    _createClass(CollapsedComponent, [{
        key: 'init',
        value: function init() {
            if (!this.trigger) {
                return;
            }
            this.$content = (0, _jquery2.default)(this.content);
            this.trigger.addEventListener('click', this.toggle);

            if (this.isOpened) {
                this.open();
            }

            this.element.addEventListener(_asyncForm.EVENT_FIELD_VALIDATION_FAILED, this.onInnerFieldValidationFailed);
        }
    }, {
        key: 'toggle',
        value: function toggle(e) {
            if (this.isOpened) {
                this.close();
            } else {
                this.open();
            }
        }
    }, {
        key: 'open',
        value: function open() {
            var _this2 = this;

            this.element.classList.add('is-opened');
            this.$content.slideDown(400, function () {
                _this2.inProgress = false;
            });
            this.isOpened = true;
        }
    }, {
        key: 'close',
        value: function close() {
            var _this3 = this;

            this.element.classList.remove('is-opened');
            this.$content.slideUp(400, function () {
                _this3.inProgress = false;
            });
            this.isOpened = false;
        }
    }, {
        key: 'onInnerFieldValidationFailed',
        value: function onInnerFieldValidationFailed(e) {
            if (!this.isOpened) {
                this.open();
            }
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.trigger.removeEventListener('click', this.toggle);
            this.element.removeEventListener(_asyncForm.EVENT_FIELD_VALIDATION_FAILED, this.onInnerFieldValidationFailed);
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['trigger', 'content'];
        }
    }]);

    return CollapsedComponent;
}(_baseComponent2.default);

exports.default = CollapsedComponent;

/***/ }),

/***/ "./app/components/collapsed/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/contact/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/contact/scss/index.scss");

var _contactForm = __webpack_require__("./app/components/contact/js/contact-form.component.js");

var _contactForm2 = _interopRequireDefault(_contactForm);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('contact-form', _contactForm2.default);

/***/ }),

/***/ "./app/components/contact/js/contact-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _popupResultForm = __webpack_require__("./app/components/form/js/popup-result-form.component.js");

var _popupResultForm2 = _interopRequireDefault(_popupResultForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContactFormComponent = function (_PopupResultFormCompo) {
  _inherits(ContactFormComponent, _PopupResultFormCompo);

  function ContactFormComponent() {
    _classCallCheck(this, ContactFormComponent);

    return _possibleConstructorReturn(this, (ContactFormComponent.__proto__ || Object.getPrototypeOf(ContactFormComponent)).apply(this, arguments));
  }

  return ContactFormComponent;
}(_popupResultForm2.default);

exports.default = ContactFormComponent;

/***/ }),

/***/ "./app/components/contact/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/cookie-management/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/cookie-management/scss/index.scss");

var _cookieManagement = __webpack_require__("./app/components/cookie-management/js/cookie-management.js");

var _cookieManagement2 = _interopRequireDefault(_cookieManagement);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('cookie-management', _cookieManagement2.default);

/***/ }),

/***/ "./app/components/cookie-management/js/cookie-management.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsCookie = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookieManagement = {
    cookiePolicyLink: HTMLElement,
    cookieBanner: HTMLElement,
    cookieBannerSeeMoreButton: HTMLElement,
    cookieBannerSeeMorePanel: HTMLElement,
    cookiePreferencesCookieName: "CookiePrefs",
    cookiePreferencesCookie: Object,
    gaCookieAllowedCheckbox: HTMLInputElement,
    saveCookiePreferencesButton: HTMLButtonElement,
    acceptAllCookiesButton: HTMLElement,

    Init: function Init() {
        var moduleContext = this;

        moduleContext.cookiePolicyLink = document.querySelector(".cookie-policy-link");
        moduleContext.cookieBanner = document.querySelector("#cookie-warning");
        moduleContext.cookieBannerSeeMoreButton = document.querySelector("#cookie-banner-see-more-link");
        moduleContext.cookieBannerSeeMorePanel = document.querySelector(".cookie-preferences");
        moduleContext.gaCookieAllowedCheckbox = document.querySelector("#ga-cookie-allowed");
        moduleContext.saveCookiePreferencesButton = document.querySelector("#save-cookie-preferences");
        moduleContext.acceptAllCookiesButton = document.querySelector("#cookie-banner-accept-all-button");
        moduleContext.GetCookiePreferencesCookie();
        moduleContext.PopulatePreferencesCheckboxes();
        moduleContext.LoadCookieWarningBanner();

        //Assign click events
        if (moduleContext.cookiePolicyLink !== undefined && moduleContext.cookiePolicyLink !== null) {
            moduleContext.AssignCookiePolicyLinkClickEvent();
        }
        if (moduleContext.saveCookiePreferencesButton !== undefined && moduleContext.saveCookiePreferencesButton !== null) {
            moduleContext.AssignSaveCookiePreferencesClickEvent();
        }
        if (moduleContext.cookieBannerSeeMoreButton !== undefined && moduleContext.cookieBannerSeeMoreButton !== null) {
            moduleContext.AssignSeeMoreButtonClickEvent();
        }
        if (moduleContext.acceptAllCookiesButton !== undefined && moduleContext.acceptAllCookiesButton !== null) {
            moduleContext.AssignAcceptAllCookiesButtonClickEvent();
        }
    },
    AssignCookiePolicyLinkClickEvent: function AssignCookiePolicyLinkClickEvent() {
        var moduleContext = this;
        moduleContext.cookiePolicyLink.addEventListener("click", function () {
            moduleContext.TriggerCookieBanner(true);
        });
    },
    AssignSaveCookiePreferencesClickEvent: function AssignSaveCookiePreferencesClickEvent() {
        var moduleContext = this;
        moduleContext.saveCookiePreferencesButton.addEventListener("click", function () {
            moduleContext.GetCookiePreferencesOnSave();
            moduleContext.SavePreferencesCookie();
        });
    },
    AssignSeeMoreButtonClickEvent: function AssignSeeMoreButtonClickEvent() {
        var moduleContext = this;
        moduleContext.cookieBannerSeeMoreButton.addEventListener("click", function () {
            moduleContext.TriggerCookieMoreInfoPanel();
        });
    },
    AssignAcceptAllCookiesButtonClickEvent: function AssignAcceptAllCookiesButtonClickEvent() {
        var moduleContext = this;
        moduleContext.acceptAllCookiesButton.addEventListener("click", function () {
            moduleContext.SetAcceptAllCookiePreferencesCookieObject();
            moduleContext.PopulatePreferencesCheckboxes();
            moduleContext.SavePreferencesCookie();
        });
    },
    TriggerCookieBanner: function TriggerCookieBanner(show) {
        var moduleContext = this;
        if (show) {
            (0, _jquery2.default)(moduleContext.cookieBanner).slideDown();
        } else {
            (0, _jquery2.default)(moduleContext.cookieBanner).slideUp();

            //Reset checkboxes to ensure their state matches that of the preferences cookie (if set)
            moduleContext.GetCookiePreferencesCookie();
            moduleContext.PopulatePreferencesCheckboxes();
        }
    },
    TriggerCookieMoreInfoPanel: function TriggerCookieMoreInfoPanel(show) {
        var moduleContext = this;
        //Resorted to js animation as transitions on auto height aren't possible.
        if (show !== undefined) {
            if (show) {
                (0, _jquery2.default)(moduleContext.cookieBannerSeeMorePanel).slideDown();
            } else {
                (0, _jquery2.default)(moduleContext.cookieBannerSeeMorePanel).slideUp();
            }
        } else {
            (0, _jquery2.default)(moduleContext.cookieBannerSeeMorePanel).slideToggle();
        }
    },
    SetAcceptAllCookiePreferencesCookieObject: function SetAcceptAllCookiePreferencesCookieObject() {
        var moduleContext = this;
        var cookiePreferences = {};
        cookiePreferences.ga = true;
        moduleContext.cookiePreferencesCookie = cookiePreferences;
        return cookiePreferences;
    },
    GetCookiePreferencesCookie: function GetCookiePreferencesCookie() {
        var moduleContext = this;
        moduleContext.cookiePreferencesCookie = _jsCookie2.default.getJSON(moduleContext.cookiePreferencesCookieName);
    },
    LoadCookieWarningBanner: function LoadCookieWarningBanner() {
        var moduleContext = this;
        if (moduleContext.cookiePreferencesCookie === undefined) {
            moduleContext.TriggerCookieBanner(true);
        }
    },
    PopulatePreferencesCheckboxes: function PopulatePreferencesCheckboxes() {
        var moduleContext = this;
        if (moduleContext.cookiePreferencesCookie !== undefined) {
            if (moduleContext.cookiePreferencesCookie.ga === false) {
                moduleContext.gaCookieAllowedCheckbox.checked = false;
            } else {
                moduleContext.gaCookieAllowedCheckbox.checked = true;
            }
        } else {
            moduleContext.gaCookieAllowedCheckbox.checked = true;
        }
    },
    GetCookiePreferencesOnSave: function GetCookiePreferencesOnSave() {
        var moduleContext = this;
        var cookiePreferences = {};
        cookiePreferences.ga = moduleContext.gaCookieAllowedCheckbox.checked;
        moduleContext.cookiePreferencesCookie = cookiePreferences;
        return cookiePreferences;
    },
    SavePreferencesCookie: function SavePreferencesCookie() {
        var moduleContext = this;
        _jsCookie2.default.set(moduleContext.cookiePreferencesCookieName, moduleContext.cookiePreferencesCookie, { expires: 365, secure: true });

        moduleContext.TidyUpExistingCookiesByPreference();

        moduleContext.TriggerCookieBanner(false);
        moduleContext.TriggerCookieMoreInfoPanel(false);
    },
    TidyUpExistingCookiesByPreference: function TidyUpExistingCookiesByPreference() {
        var moduleContext = this;
        if (moduleContext.cookiePreferencesCookie !== undefined && moduleContext.cookiePreferencesCookie.ga !== true) {
            moduleContext.DisableGATracking();
        }
    },
    DisableGATracking: function DisableGATracking() {
        if (window.gaData !== undefined) {
            if (ga !== null && ga !== undefined) {
                var gaTrackingId = ga.getAll()[0].get('trackingId');
                if (gaTrackingId !== undefined) {
                    var hostname = location.hostname;
                    if (hostname.includes("www.")) {
                        hostname = hostname.replace("www.", ".");
                    }
                    //console.log("location.hostname", hostname);
                    window['ga-disable-' + gaTrackingId] = true;
                    _jsCookie2.default.remove("_ga", { path: '/', domain: hostname, secure: true });
                    _jsCookie2.default.remove("_gid", { path: '/', domain: hostname, secure: true });
                    _jsCookie2.default.remove("_gat_" + gaTrackingId, { path: '/', domain: hostname, secure: true });
                    _jsCookie2.default.remove("_ga", { path: '/', domain: hostname, secure: false });
                    _jsCookie2.default.remove("_gid", { path: '/', domain: hostname, secure: false });
                    _jsCookie2.default.remove("_gat_" + gaTrackingId, { path: '/', domain: hostname, secure: false });
                } else {
                    console.error("Unable to fetch ga tracking id");
                }
            }
        }
    }
};
if (document.readyState !== 'loading') {
    cookieManagement.Init();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        cookieManagement.Init();
    });
}

/***/ }),

/***/ "./app/components/cookie-management/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/cta-block/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/cta-block/scss/index.scss");

/***/ }),

/***/ "./app/components/cta-block/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/disclaimer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/disclaimer/scss/index.scss");

/***/ }),

/***/ "./app/components/disclaimer/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/download-catalogue/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/download-catalogue/scss/index.scss");

var _downloadCatalogue = __webpack_require__("./app/components/download-catalogue/js/download-catalogue.component.js");

var _downloadCatalogue2 = _interopRequireDefault(_downloadCatalogue);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('download-catalogue', _downloadCatalogue2.default);

/***/ }),

/***/ "./app/components/download-catalogue/js/download-catalogue.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _downloadFilePopupForm = __webpack_require__("./app/components/form/js/download-file-popup-form.component.js");

var _downloadFilePopupForm2 = _interopRequireDefault(_downloadFilePopupForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DownloadCatalogueComponent = function (_DownloadFilePopupFor) {
  _inherits(DownloadCatalogueComponent, _DownloadFilePopupFor);

  function DownloadCatalogueComponent() {
    _classCallCheck(this, DownloadCatalogueComponent);

    return _possibleConstructorReturn(this, (DownloadCatalogueComponent.__proto__ || Object.getPrototypeOf(DownloadCatalogueComponent)).apply(this, arguments));
  }

  return DownloadCatalogueComponent;
}(_downloadFilePopupForm2.default);

exports.default = DownloadCatalogueComponent;

/***/ }),

/***/ "./app/components/download-catalogue/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/energy-certificate/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/energy-certificate/scss/index.scss");

var _energyCertificate = __webpack_require__("./app/components/energy-certificate/js/energy-certificate.component.js");

var _energyCertificate2 = _interopRequireDefault(_energyCertificate);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('energy-certificate', _energyCertificate2.default);

/***/ }),

/***/ "./app/components/energy-certificate/js/energy-certificate.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TweenLite = __webpack_require__("./node_modules/gsap/TweenLite.js");

var _TweenLite2 = _interopRequireDefault(_TweenLite);

var _intersectionHelper = __webpack_require__("./app/general/js/intersection-helper.js");

var _intersectionHelper2 = _interopRequireDefault(_intersectionHelper);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EnergyCertificateComponent = function (_BaseComponent) {
    _inherits(EnergyCertificateComponent, _BaseComponent);

    function EnergyCertificateComponent() {
        _classCallCheck(this, EnergyCertificateComponent);

        var _this = _possibleConstructorReturn(this, (EnergyCertificateComponent.__proto__ || Object.getPrototypeOf(EnergyCertificateComponent)).apply(this, arguments));

        _this.level = _this.element.dataset.level;
        if (!_this.level) {
            throw new Error('unknown data-level');
        }

        _this.init();
        return _this;
    }

    _createClass(EnergyCertificateComponent, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            this.levels = [].concat(_toConsumableArray(this.element.children));

            this.activeLevel = this.levels.find(function (levelElement) {
                return levelElement.dataset.level === _this2.level;
            });

            if (this.activeLevel) {
                this.activeLevel.classList.add('is-active');
                this.activeLevelArrow = this.activeLevel.querySelector('i');
                _intersectionHelper2.default.enterViewportOnce(this.element, this.animate.bind(this), {
                    threshold: 1.0
                });
            }
        }
    }, {
        key: 'animate',
        value: function animate() {
            var _this3 = this;

            _TweenLite2.default.to(this.levels, 2.5, {
                width: '100%',
                onComplete: function onComplete() {
                    _TweenLite2.default.to(_this3.activeLevelArrow, 0.5, { opacity: 0.6 });
                }
            });
        }
    }]);

    return EnergyCertificateComponent;
}(_baseComponent2.default);

exports.default = EnergyCertificateComponent;

/***/ }),

/***/ "./app/components/energy-certificate/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/favorites-button/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/favorites-button/scss/index.scss");

var _favoritesButton = __webpack_require__("./app/components/favorites-button/js/favorites-button.component.js");

var _favoritesButton2 = _interopRequireDefault(_favoritesButton);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('favorites-button', _favoritesButton2.default);

/***/ }),

/***/ "./app/components/favorites-button/js/LotFavoritesButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _api = __webpack_require__("./app/general/js/api.js");

var _api2 = _interopRequireDefault(_api);

var _eventBus = __webpack_require__("./app/general/js/event-bus.js");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _app = __webpack_require__("./app/general/js/app.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EVENT_ON_CHANGE_SAVED_STATUS = 'lots:onSavedButtonChange';

var LotFavoritesButton = function (_React$PureComponent) {
    _inherits(LotFavoritesButton, _React$PureComponent);

    function LotFavoritesButton(props) {
        _classCallCheck(this, LotFavoritesButton);

        var _this = _possibleConstructorReturn(this, (LotFavoritesButton.__proto__ || Object.getPrototypeOf(LotFavoritesButton)).call(this, props));

        _this.isInitiator = false;
        _this.state = {
            button: _this.props.button,
            isLoading: false
        };

        _this.onButtonClick = _this.onButtonClick.bind(_this);
        return _this;
    }

    _createClass(LotFavoritesButton, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.lotSaveButtonChangeEventName = this.getLotSaveButtonChangeEventName();
            if (this.lotSaveButtonChangeEventName) {
                this.subscription = _eventBus2.default.addListener(this.lotSaveButtonChangeEventName, this.onChangeSaveButton.bind(this));
            }
        }
    }, {
        key: 'onChangeSaveButton',
        value: function onChangeSaveButton(saveButton) {
            if (this.isInitiator) {
                this.isInitiator = false;
            } else {
                this.applySaveButton(saveButton);
            }
        }
    }, {
        key: 'getLotSaveButtonChangeEventName',
        value: function getLotSaveButtonChangeEventName() {
            if (this.state.button) {
                return EVENT_ON_CHANGE_SAVED_STATUS + ':' + this.state.button.lotId;
            } else {
                return null;
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.applySaveButton(nextProps.button);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.subscription) {
                this.subscription.remove();
            }
        }
    }, {
        key: 'onButtonClick',
        value: function onButtonClick(e) {
            var _this2 = this;

            e.preventDefault();
            if (this.state.button.triggerLogin) {
                _eventBus2.default.emit(_app.EVENT_AUTH_TRIGGER_CLICK);
            } else {
                this.setState({ isLoading: true }, function () {
                    _this2.toggle();
                });
            }
        }
    }, {
        key: 'applySaveButton',
        value: function applySaveButton(saveButton) {
            this.setState({ button: saveButton });
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            var _this3 = this;

            _api2.default.post(this.state.button.action).then(function (_ref) {
                var saveButton = _ref.data.saveButton;

                _this3.applySaveButton(saveButton);

                _this3.isInitiator = true;
                if (_this3.lotSaveButtonChangeEventName) {
                    _eventBus2.default.emit(_this3.lotSaveButtonChangeEventName, saveButton);
                }
            }, function (error) {
                return Promise.reject(error);
            }).finally(function () {
                _this3.setState({
                    isLoading: false
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var button = this.state.button;
            if (button) {
                var isSaved = button.isSaved,
                    text = button.text;

                var mobileSticky = this.props.mobileSticky;
                return _react2.default.createElement(
                    'button',
                    { type: 'button',
                        className: 'btn favorites-button ' + (isSaved ? 'is-saved' : '') + ' ' + (mobileSticky ? 'favorites-button--mobile-sticky' : ''),
                        onClick: this.onButtonClick },
                    _react2.default.createElement(
                        'span',
                        { className: 'btn__wrap' },
                        _react2.default.createElement(
                            'svg',
                            { width: '15', height: '15', className: 'icon icon--before' },
                            _react2.default.createElement('use', { xlinkHref: '#icon-star' })
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'favorites-button__text' },
                            text
                        ),
                        _react2.default.createElement('div', {
                            className: 'spinner spinner--inner spinner--faded ' + (this.state.isLoading ? 'is-loading' : '') })
                    )
                );
            }

            return null;
        }
    }]);

    return LotFavoritesButton;
}(_react2.default.PureComponent);

exports.default = LotFavoritesButton;


LotFavoritesButton.defaultProps = {
    mobileSticky: false
};

/***/ }),

/***/ "./app/components/favorites-button/js/favorites-button.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _LotFavoritesButton = __webpack_require__("./app/components/favorites-button/js/LotFavoritesButton.js");

var _LotFavoritesButton2 = _interopRequireDefault(_LotFavoritesButton);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FavoritesButtonComponent = function (_BaseComponent) {
    _inherits(FavoritesButtonComponent, _BaseComponent);

    function FavoritesButtonComponent() {
        _classCallCheck(this, FavoritesButtonComponent);

        var _this = _possibleConstructorReturn(this, (FavoritesButtonComponent.__proto__ || Object.getPrototypeOf(FavoritesButtonComponent)).apply(this, arguments));

        _this.button = _this.options.button;
        _this.mobileSticky = _this.options.mobileSticky || false;

        _this.init();
        return _this;
    }

    _createClass(FavoritesButtonComponent, [{
        key: 'init',
        value: function init() {
            _reactDom2.default.render(_react2.default.createElement(_LotFavoritesButton2.default, { mobileSticky: this.mobileSticky, button: this.button }), this.element);
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            _reactDom2.default.unmountComponentAtNode(this.element);
        }
    }]);

    return FavoritesButtonComponent;
}(_baseComponent2.default);

exports.default = FavoritesButtonComponent;

/***/ }),

/***/ "./app/components/favorites-button/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/featured-lots/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/featured-lots/scss/index.scss");

/***/ }),

/***/ "./app/components/featured-lots/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/file-input/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _fileInput = __webpack_require__("./app/components/file-input/js/file-input.component.js");

var _fileInput2 = _interopRequireDefault(_fileInput);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('file-input', _fileInput2.default);

/***/ }),

/***/ "./app/components/file-input/js/file-input.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileInput = function (_BaseComponent) {
    _inherits(FileInput, _BaseComponent);

    function FileInput() {
        _classCallCheck(this, FileInput);

        var _this = _possibleConstructorReturn(this, (FileInput.__proto__ || Object.getPrototypeOf(FileInput)).apply(this, arguments));

        _this.defaultCaption = 'No file chosen';
        _this.onFileChange = _this.onFileChange.bind(_this);

        _this.init();
        return _this;
    }

    _createClass(FileInput, [{
        key: 'init',
        value: function init() {
            this.fileControl = this.element.querySelector('input[type="file"]');
            this.captionContainer = this.element;
            if (!this.fileControl || !this.captionContainer) {
                return;
            }

            this.fileControl.setAttribute('style', '\n         width: 0.1px;\n         height: 0.1px;\n         opacity: 0;\n         overflow: hidden;\n         position: absolute;\n         z-index: -1;\n         ');

            this.caption = document.createElement('span');
            this.captionContainer.appendChild(this.caption);

            this.fileControl.addEventListener('change', this.onFileChange);
            this.updateCaption();
        }
    }, {
        key: 'onFileChange',
        value: function onFileChange(e) {
            this.updateCaption();
        }
    }, {
        key: 'updateCaption',
        value: function updateCaption() {
            var caption = '';
            if (this.fileControl.files && this.fileControl.files.length > 1) {
                caption = this.fileControl.files.length + ' files selected';
            } else {
                caption = this.fileControl.value.split('\\').pop();
            }
            if (caption) {
                this.caption.innerHTML = caption;
            } else {
                this.caption.innerHTML = this.defaultCaption;
            }
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.fileControl.removeEventListener('change', this.onFileChange);
        }
    }]);

    return FileInput;
}(_baseComponent2.default);

exports.default = FileInput;

/***/ }),

/***/ "./app/components/flip-number/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/flip-number/scss/index.scss");

/***/ }),

/***/ "./app/components/flip-number/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/footer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/footer/scss/index.scss");

/***/ }),

/***/ "./app/components/footer/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/form-result-replacer/html/default-template.hbs":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("./node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"embedded-success\">\r\n    <h2 class=\"embedded-success__title\">"
    + alias4(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper)))
    + "</h2>\r\n    <p class=\"embedded-success__text\">"
    + alias4(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper)))
    + "</p>\r\n</div>\r\n";
},"useData":true});

/***/ }),

/***/ "./app/components/form-result-replacer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/form-result-replacer/scss/index.scss");

var _formResultReplacer = __webpack_require__("./app/components/form-result-replacer/js/form-result-replacer.component.js");

var _formResultReplacer2 = _interopRequireDefault(_formResultReplacer);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('form-result-replacer', _formResultReplacer2.default);

/***/ }),

/***/ "./app/components/form-result-replacer/js/form-result-replacer.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _asyncForm = __webpack_require__("./app/components/form/js/async-form.component.js");

var _asyncForm2 = _interopRequireDefault(_asyncForm);

var _TimelineLite = __webpack_require__("./node_modules/gsap/TimelineLite.js");

var _TimelineLite2 = _interopRequireDefault(_TimelineLite);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _defaultTemplate = __webpack_require__("./app/components/form-result-replacer/html/default-template.hbs");

var _defaultTemplate2 = _interopRequireDefault(_defaultTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormResultReplacer = function (_BaseComponent) {
    _inherits(FormResultReplacer, _BaseComponent);

    function FormResultReplacer() {
        _classCallCheck(this, FormResultReplacer);

        var _this = _possibleConstructorReturn(this, (FormResultReplacer.__proto__ || Object.getPrototypeOf(FormResultReplacer)).apply(this, arguments));

        _this.isResultShown = false;

        // form element for AsyncForm
        _this.formElement = _this.element.querySelector('.js-form-result-replacer-form');
        // element for "thank you message" inserting
        _this.resultElement = _this.element.querySelector('.js-form-result-replacer-result');
        //optional container in case we want to hide not only formElement but its parent or sibling
        _this.replaceElement = _this.element.querySelector('.js-form-result-replacer-replace');

        if (_this.formElement && _this.resultElement) {
            _this.init();
        } else {
            throw new Error('formElement and resultElement are not specified');
        }
        return _this;
    }

    _createClass(FormResultReplacer, [{
        key: 'init',
        value: function init() {
            this.resultElement.style.display = 'none';
            this.formComponent = this.createFormInstance();
        }
    }, {
        key: 'createFormInstance',
        value: function createFormInstance() {
            return new _asyncForm2.default(this.formElement, { props: { onSuccess: this.onFormSuccess.bind(this) } });
        }
    }, {
        key: 'onFormSuccess',
        value: function onFormSuccess(result) {
            if (this.isResultShown) {
                return;
            }

            var hideElements = [this.formElement];
            if (this.replaceElement) {
                hideElements.push(this.replaceElement);
            }

            this.tween = new _TimelineLite2.default({ paused: true });
            this.tween.to(hideElements, 0.5, { opacity: 0, display: 'none' });
            this.tween.to(this.resultElement, 0.5, { opacity: 1, display: 'block' });
            this.tween.play();

            this.resultElement.innerHTML = this.getMessage(result);
            this.isResultShown = true;
        }
    }, {
        key: 'getMessage',
        value: function getMessage(result) {
            return (0, _defaultTemplate2.default)(result);
        }
    }]);

    return FormResultReplacer;
}(_baseComponent2.default);

exports.default = FormResultReplacer;

/***/ }),

/***/ "./app/components/form-result-replacer/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/form/html/download-file-notification-template.hbs":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("./node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "            <p class=\"modal__download-file-notice\">Your download should automatically begin in a few seconds, but if\r\n                not, click 'download' button below.</p>\r\n            <a class=\"btn btn--green btn--m-full js-download-file-button\" href=\""
    + alias2(alias1(depth0, depth0))
    + "\">\r\n                <span class=\"btn__wrap\">"
    + alias2(alias1((depths[1] != null ? depths[1].downloadText : depths[1]), depth0))
    + "</span>\r\n            </a>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, options, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, buffer = 
  "<div class=\"modal__content modal__content--centered\">\r\n    <div class=\"modal__heading\">\r\n        "
    + alias4(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper)))
    + "\r\n    </div>\r\n    <div class=\"modal__body\">\r\n\r\n        <p>"
    + alias4(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper)))
    + "</p>\r\n\r\n";
  stack1 = ((helper = (helper = helpers.downloadUrl || (depth0 != null ? depth0.downloadUrl : depth0)) != null ? helper : alias2),(options={"name":"downloadUrl","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
  if (!helpers.downloadUrl) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\r\n    </div>\r\n    <div class=\"modal__close-link js-modal-close\">close window</div>\r\n</div>\r\n";
},"useData":true,"useDepths":true});

/***/ }),

/***/ "./app/components/form/html/errors-summary.hbs":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("./node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "        <p>"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "</p>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"form__callout form__callout--error\">\r\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.errors : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\r\n";
},"useData":true});

/***/ }),

/***/ "./app/components/form/html/success-message-template.hbs":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("./node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"form__callout form__callout--success\">\r\n    <h4>"
    + alias4(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper)))
    + "</h4>\r\n    <p>"
    + alias4(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper)))
    + "</p>\r\n</div>\r\n";
},"useData":true});

/***/ }),

/***/ "./app/components/form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/form/scss/index.scss");

var _embeddedResultForm = __webpack_require__("./app/components/form/js/embedded-result-form.component.js");

var _embeddedResultForm2 = _interopRequireDefault(_embeddedResultForm);

var _popupResultForm = __webpack_require__("./app/components/form/js/popup-result-form.component.js");

var _popupResultForm2 = _interopRequireDefault(_popupResultForm);

var _validationFieldset = __webpack_require__("./app/components/form/js/validation-fieldset.component.js");

var _validationFieldset2 = _interopRequireDefault(_validationFieldset);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('embedded-result-form', _embeddedResultForm2.default);

_componentsCollection2.default.getInstance().define('popup-result-form', _popupResultForm2.default);

_componentsCollection2.default.getInstance().define('validation-fieldset', _validationFieldset2.default);

/***/ }),

/***/ "./app/components/form/js/async-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EVENT_FIELD_VALIDATION_SUCCEEDED = exports.EVENT_FIELD_VALIDATION_FAILED = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _api = __webpack_require__("./app/general/js/api.js");

var _api2 = _interopRequireDefault(_api);

var _gtm = __webpack_require__("./app/general/js/gtm.js");

var _gtm2 = _interopRequireDefault(_gtm);

var _createEvent = __webpack_require__("./app/general/js/create-event.js");

var _createEvent2 = _interopRequireDefault(_createEvent);

var _parsleyjs = __webpack_require__("./node_modules/parsleyjs/dist/parsley.js");

var _parsleyjs2 = _interopRequireDefault(_parsleyjs);

var _parsleyLocale = __webpack_require__("./app/components/form/js/parsley-locale.js");

var _parsleyLocale2 = _interopRequireDefault(_parsleyLocale);

var _errorsSummary = __webpack_require__("./app/components/form/html/errors-summary.hbs");

var _errorsSummary2 = _interopRequireDefault(_errorsSummary);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _recaptcha = __webpack_require__("./app/components/recaptcha/js/recaptcha.component.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ENCTYPE_URLENCODED = 'application/x-www-form-urlencoded';
var ENCTYPE_MULTIPART = 'multipart/form-data';

var EVENT_FIELD_VALIDATION_FAILED = exports.EVENT_FIELD_VALIDATION_FAILED = 'field-validation-failed';
var EVENT_FIELD_VALIDATION_SUCCEEDED = exports.EVENT_FIELD_VALIDATION_SUCCEEDED = 'field-validation-succeeded';

var AsyncFormComponent = function (_BaseComponent) {
    _inherits(AsyncFormComponent, _BaseComponent);

    function AsyncFormComponent() {
        _classCallCheck(this, AsyncFormComponent);

        var _this = _possibleConstructorReturn(this, (AsyncFormComponent.__proto__ || Object.getPrototypeOf(AsyncFormComponent)).apply(this, arguments));

        _this.$element = (0, _jquery2.default)(_this.element);
        _this.method = _this.element.method || 'get';
        _this.action = _this.element.action;
        _this.enctype = _this.element.enctype || ENCTYPE_URLENCODED;

        if (_this.element.nodeName !== 'FORM') {
            throw new Error('element must be a form');
        }

        if (_this.props.onSuccess) {
            if (typeof _this.props.onSuccess === "function") {
                _this.onSuccess = _this.props.onSuccess;
            } else {
                throw new Error('onSuccess must be function');
            }
        }

        _this.isSubmiting = false;

        _this.formControlSelector = '.js-form-control';
        _this.serverInvalidFields = {};

        //reset form in case of success submit
        _this.resetOnSuccess = 'resetOnSuccess' in _this.element.dataset ? _this.element.dataset.resetOnSuccess !== 'false' : true;

        _this.spinnerElement = _this.element.querySelector('.js-async-form-spinner');
        _this.errorsSummary = _this.element.querySelector('.js-async-form-errors-summary');
        _this.submitElement = _this.element.querySelector('.js-async-form-submit');
        _this.init();
        return _this;
    }

    _createClass(AsyncFormComponent, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            this.parsleyForm = new _parsleyjs2.default.Factory(this.element, {
                inputs: _parsleyjs2.default.options.inputs + ',[data-parsley-subforms-required]',
                // exclude hidden and disabled
                // but also we are able manage it by adding particular attribute to fields' parent and to make fields to validate despite of their visibility
                excluded: function excluded(index, element) {
                    var $element = (0, _jquery2.default)(element);

                    var defaultExclude = $element.is('input[type=button], input[type=submit], input[type=reset], input[type=hidden], :disabled');
                    if (defaultExclude) {
                        return true;
                    }

                    var parentGroup = $element.closest('[data-hidden-group]');
                    return parentGroup.length > 0 ? parentGroup.is('[data-hidden-group="is-hidden"]') : $element.is(':hidden');
                },
                errorClass: 'has-error',
                successClass: 'is-success',
                classHandler: function classHandler(field) {
                    return field.$element.closest(_this2.formControlSelector);
                },
                errorsContainer: function errorsContainer(field) {
                    return field.$element.closest(_this2.formControlSelector);
                },
                errorsWrapper: '<div class="error-message"></ul>',
                errorTemplate: '<div></div>'
            });

            //prevent form submit
            this.element.addEventListener('submit', function (e) {
                return e.preventDefault();
            });
            this.parsleyForm.on('form:validate', this.onSubmitClick.bind(this));
            this.parsleyForm.on('field:error', this.onFieldValidationFail.bind(this));
            this.parsleyForm.on('field:success', this.onFieldValidationSuccess.bind(this));
            this.parsleyForm.on('form:submit', this.onSubmit.bind(this));
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            var _this3 = this;

            if (!this.isSubmiting) {

                this.isSubmiting = true;
                try {
                    this.beforeSubmit();
                    (0, _api2.default)({
                        method: this.method,
                        url: this.getUrl(),
                        data: this.getRequestParams()
                    }).then(function (result) {
                        _this3.afterSubmit();
                        _this3.resetForm();
                        return _this3.handleSuccessSubmit(result.data);
                    }, function (error) {
                        //first we have to proceed validation errors
                        if ((0, _api.isValidationError)(error)) {
                            _this3.renderServerErrors((0, _api.getValidationErrors)(error));
                        }
                        _this3.afterSubmit();
                        return _this3.onError(error);
                    });
                } catch (err) {
                    console.error(err);
                }
            }
        }
    }, {
        key: 'handleSuccessSubmit',
        value: function handleSuccessSubmit(result) {
            if (result.submitTrackingInfo) {
                _gtm2.default.push(result.submitTrackingInfo);
            }
            return this.onSuccess(result);
        }
    }, {
        key: 'renderServerErrors',
        value: function renderServerErrors(errors) {
            var _this4 = this;

            var groupedErrors = {};

            errors.forEach(function (error, i) {
                if (!(error.key in groupedErrors)) {
                    groupedErrors[error.key] = [];
                }
                groupedErrors[error.key].push(error.message);
            });

            var hasFieldErrors = false;

            this.parsleyForm.fields.forEach(function (field) {
                var element = field.$element[0];
                // for the cases when we emulate field with non HTMLInputElement and so on
                // for example for subformsRequired validator
                var fieldName = element.name ? element.name : element.getAttribute('data-name');

                if (fieldName in groupedErrors) {

                    hasFieldErrors = true;

                    //programmatically add constraint once (not public Parsley method)
                    if (!(fieldName in _this4.serverInvalidFields)) {
                        field.addConstraint('server');
                        _this4.serverInvalidFields.fieldName = true;
                    }

                    var _errors = groupedErrors[fieldName];
                    delete groupedErrors[fieldName];

                    //programmatically set constraint error text
                    field.options.serverMessage = _errors.join(', ');
                    //refresh stored value
                    delete field.serverErrorValue;

                    if (AsyncFormComponent.isReturnsEmpty(field)) {
                        field.options.validateIfEmpty = true;
                    }

                    if (AsyncFormComponent.isCaptchaField(field)) {
                        field.element.dispatchEvent((0, _createEvent2.default)(_recaptcha.EVENT_ON_ERROR));
                    }
                }
            });

            //validate to cause an error if we have field errors
            if (hasFieldErrors) {
                this.parsleyForm.validate();
            }

            this.showErrorsSummary(groupedErrors);
        }
    }, {
        key: 'showErrorsSummary',
        value: function showErrorsSummary(groupped) {
            if (this.errorsSummary) {
                if (Object.keys(groupped).length) {
                    var errors = Object.keys(groupped).reduce(function (errors, key) {
                        return [].concat(_toConsumableArray(errors), _toConsumableArray(groupped[key]));
                    }, []);
                    this.errorsSummary.innerHTML = (0, _errorsSummary2.default)({ errors: errors });
                    this.errorsSummary.classList.add('is-shown');
                } else {
                    this.hideErrorsSummary();
                }
            }
        }
    }, {
        key: 'hideErrorsSummary',
        value: function hideErrorsSummary() {
            if (this.errorsSummary) {
                this.errorsSummary.classList.remove('is-shown');
            }
        }
    }, {
        key: 'getRequestParams',
        value: function getRequestParams() {
            var data = null;
            switch (this.enctype) {
                case ENCTYPE_URLENCODED:
                    data = this.getUrlencodedFormData();
                    break;
                case ENCTYPE_MULTIPART:
                    data = this.getMultipartFormData();
                    break;
                default:
                    throw new Error('Unknown form enctype');
            }

            return data;
        }
    }, {
        key: 'getUrlencodedFormData',
        value: function getUrlencodedFormData() {
            var dataObject = this.$element.serializeJSON({
                checkboxUncheckedValue: "false",
                parseBooleans: true,
                useIntKeysAsArrayIndex: true
            });
            // we don't need default captcha entry in our data
            // because we handle it manually in RecaptchaComponent
            delete dataObject[_recaptcha.DEFAULT_RECAPTCHA_FIELD_NAME];
            return _jquery2.default.param(dataObject);
        }
    }, {
        key: 'getMultipartFormData',
        value: function getMultipartFormData() {

            var recaptureField = this.element.querySelector("[name='" + _recaptcha.DEFAULT_RECAPTCHA_FIELD_NAME + "']");
            // Removing the name of the recaptcha field.
            // It shouldn't be included to FormData object.
            if (recaptureField) recaptureField.removeAttribute("name");

            var formData = new FormData(this.element);
            // Restoring the name of the recaptcha field.
            if (recaptureField) recaptureField.setAttribute("name", _recaptcha.DEFAULT_RECAPTCHA_FIELD_NAME);

            var uncheckedCheckboxesData = this.getUncheckedCheckboxesData();
            // patch default form data with unchecked checkboxes
            Object.keys(uncheckedCheckboxesData).map(function (name) {
                formData.append(name, uncheckedCheckboxesData[name]);
            });
            return formData;
        }
    }, {
        key: 'getUncheckedCheckboxesData',
        value: function getUncheckedCheckboxesData() {
            var checkboxesInputs = [].concat(_toConsumableArray(this.element.querySelectorAll('input[type="checkbox"]')));
            return checkboxesInputs.reduce(function (result, checkbox) {
                if (!checkbox.checked) {
                    result[checkbox.name] = false;
                }
                return result;
            }, {});
        }
    }, {
        key: 'getUrl',
        value: function getUrl() {
            return this.action;
        }
    }, {
        key: 'onSubmitClick',
        value: function onSubmitClick() {
            //hook for descendants
        }
    }, {
        key: 'onFieldValidationFail',
        value: function onFieldValidationFail(field) {
            var event = (0, _createEvent2.default)(EVENT_FIELD_VALIDATION_FAILED);
            event.field = field;
            field.element.dispatchEvent(event);
        }
    }, {
        key: 'onFieldValidationSuccess',
        value: function onFieldValidationSuccess(field) {
            var event = (0, _createEvent2.default)(EVENT_FIELD_VALIDATION_SUCCEEDED);
            event.field = field;
            field.element.dispatchEvent(event);
        }
    }, {
        key: 'onBeforeSubmit',
        value: function onBeforeSubmit() {
            //hook for descendants
            //can be used for showing preloader
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess(result) {
            //hook for descendants
        }
    }, {
        key: 'onError',
        value: function onError(error) {
            //hook for descendants
        }
    }, {
        key: 'onAfterSubmit',
        value: function onAfterSubmit() {
            //hook for descendants
            //can be used for hiding preloader
        }
    }, {
        key: 'onAfterReset',
        value: function onAfterReset() {
            //hook for descendants
        }
    }, {
        key: 'afterSubmit',
        value: function afterSubmit() {
            if (this.spinnerElement) {
                this.spinnerElement.classList.remove('is-loading');
            }
            if (this.submitElement) {
                this.submitElement.disabled = false;
            }
            this.handleCaptchaInputs();
            this.isSubmiting = false;
            this.onAfterSubmit();
        }
    }, {
        key: 'beforeSubmit',
        value: function beforeSubmit() {
            if (this.spinnerElement) {
                this.spinnerElement.classList.add('is-loading');
            }
            if (this.submitElement) {
                this.submitElement.disabled = true;
            }
            this.onBeforeSubmit();
        }
    }, {
        key: 'resetForm',
        value: function resetForm() {
            var _this5 = this;

            if (this.resetOnSuccess) {
                //slow down a little so modal will be able to be hidden before reset
                setTimeout(function () {
                    _this5.element.reset();
                    _this5.parsleyForm.reset();
                    _this5.onAfterReset();
                }, 1000);
            }

            this.hideErrorsSummary();
        }
    }, {
        key: 'handleCaptchaInputs',
        value: function handleCaptchaInputs() {
            var captchas = this.parsleyForm.fields.filter(function (field) {
                return AsyncFormComponent.isCaptchaField(field);
            });
            captchas.forEach(function (field) {
                //reset ui state of parsley for every captcha field
                field.reset();
                field.element.dispatchEvent((0, _createEvent2.default)(_recaptcha.EVENT_AFTER_SUBMIT));
            });
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.parsleyForm.destroy();
        }
    }], [{
        key: 'isCaptchaField',
        value: function isCaptchaField(field) {
            return 'recaptcha' in field.constraintsByName;
        }
    }, {
        key: 'isReturnsEmpty',
        value: function isReturnsEmpty(field) {
            return field.element.tagName === 'INPUT' && field.element.type === 'file';
        }
    }]);

    return AsyncFormComponent;
}(_baseComponent2.default);

exports.default = AsyncFormComponent;


_parsleyjs2.default.addValidator('accountType', {
    validateMultiple: function validateMultiple(values) {
        return values.length > 0;
    },
    validateString: function validateString(value) {
        return (/\S/.test(value)
        );
    },
    priority: 512,
    messages: {
        en: 'Please specify account type'
    }
});

_parsleyjs2.default.addValidator('subformsRequired', {
    validate: function validate(value, requirement, instance) {
        return instance.element.hasChildNodes();
    },
    priority: 512,
    messages: {
        en: 'Please add at least one entry'
    }
});

_parsleyjs2.default.addValidator('recaptcha', {
    validateString: function validateString(value) {
        return (/\S/.test(value)
        );
    },
    priority: 512,
    messages: {
        en: 'Please confirm that you are not a robot'
    }
});

_parsleyjs2.default.addValidator('server', {
    validateString: function validateString(value, c, field) {
        //if field cant store value we show error just once
        if (AsyncFormComponent.isReturnsEmpty(field)) {
            if (field.serverErrorValue !== true) {
                field.serverErrorValue = true;
                return false;
            } else {
                return true;
            }
        }

        //otherwise field is valid only if new value do not matches old one
        if ('serverErrorValue' in field) {
            return field.serverErrorValue !== field.$element.val();
        } else {
            field.serverErrorValue = field.$element.val();
            return false;
        }
    },
    requirementType: 'string',
    priority: 1024
});

/***/ }),

/***/ "./app/components/form/js/download-file-popup-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _asyncForm = __webpack_require__("./app/components/form/js/async-form.component.js");

var _asyncForm2 = _interopRequireDefault(_asyncForm);

var _notification = __webpack_require__("./app/general/js/notification.js");

var _notification2 = _interopRequireDefault(_notification);

var _gtm = __webpack_require__("./app/general/js/gtm.js");

var _gtm2 = _interopRequireDefault(_gtm);

var _downloadFileNotificationTemplate = __webpack_require__("./app/components/form/html/download-file-notification-template.hbs");

var _downloadFileNotificationTemplate2 = _interopRequireDefault(_downloadFileNotificationTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DownloadFilePopupFormComponent = function (_AsyncFormComponent) {
    _inherits(DownloadFilePopupFormComponent, _AsyncFormComponent);

    function DownloadFilePopupFormComponent() {
        _classCallCheck(this, DownloadFilePopupFormComponent);

        var _this = _possibleConstructorReturn(this, (DownloadFilePopupFormComponent.__proto__ || Object.getPrototypeOf(DownloadFilePopupFormComponent)).apply(this, arguments));

        _this.downloadTrackingInfo = null;
        _this.redirectTimeout = null;
        _this.onDownloadButtonClick = _this.onDownloadButtonClick.bind(_this);
        return _this;
    }

    _createClass(DownloadFilePopupFormComponent, [{
        key: 'onSuccess',
        value: function onSuccess(result) {
            var _this2 = this;

            this.cleanUp();

            var notification = void 0;
            var template = this.getTemplate();
            notification = _notification2.default.create(template(result));
            notification.open();

            if (result.downloadUrl) {
                this.downloadButton = notification.getElement().querySelector('.js-download-file-button');
                if (this.downloadButton) {
                    this.downloadButton.addEventListener('click', this.onDownloadButtonClick);
                }
                this.downloadTrackingInfo = result.downloadTrackingInfo;
                this.redirectTimeout = setTimeout(function () {
                    _this2.autoDownload(result.downloadUrl);
                }, 2000);

                // Main save button
                $(".lot-nav__buttons .lot-nav__btn button").addClass("is-saved");
                $(".lot-nav__buttons .favorites-button__text").text("saved");

                $(".lots-list__inner a.lots-list__item--active .lot-item__favorites-button button").addClass("is-saved");
                $(".lots-list__inner a.lots-list__item--active .lot-item__favorites-button span.favorites-button__text").text("saved");
            }
        }
    }, {
        key: 'handleTracking',
        value: function handleTracking() {
            if (this.downloadTrackingInfo) {
                _gtm2.default.push(this.downloadTrackingInfo);
                this.downloadTrackingInfo = null;
            }
        }
    }, {
        key: 'autoDownload',
        value: function autoDownload(url) {
            this.redirectTimeout = null;
            if (this.downloadButton) {
                this.downloadButton.removeEventListener('click', this.onDownloadButtonClick);
            }
            this.handleTracking();
            window.location.href = url;
        }
    }, {
        key: 'onDownloadButtonClick',
        value: function onDownloadButtonClick(e) {
            this.handleTracking();
            this.cleanUp();
        }
    }, {
        key: 'getTemplate',
        value: function getTemplate() {
            return _downloadFileNotificationTemplate2.default;
        }
    }, {
        key: 'cleanUp',
        value: function cleanUp() {
            if (this.downloadButton) {
                this.downloadButton.removeEventListener('click', this.onDownloadButtonClick);
            }
            if (this.redirectTimeout) {
                clearTimeout(this.redirectTimeout);
                this.redirectTimeout = null;
            }
        }
    }]);

    return DownloadFilePopupFormComponent;
}(_asyncForm2.default);

exports.default = DownloadFilePopupFormComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./app/components/form/js/embedded-result-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _asyncForm = __webpack_require__("./app/components/form/js/async-form.component.js");

var _asyncForm2 = _interopRequireDefault(_asyncForm);

var _successMessageTemplate = __webpack_require__("./app/components/form/html/success-message-template.hbs");

var _successMessageTemplate2 = _interopRequireDefault(_successMessageTemplate);

var _TimelineLite = __webpack_require__("./node_modules/gsap/TimelineLite.js");

var _TimelineLite2 = _interopRequireDefault(_TimelineLite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmbeddedResultFormComponent = function (_AsyncForm) {
    _inherits(EmbeddedResultFormComponent, _AsyncForm);

    function EmbeddedResultFormComponent() {
        _classCallCheck(this, EmbeddedResultFormComponent);

        var _this = _possibleConstructorReturn(this, (EmbeddedResultFormComponent.__proto__ || Object.getPrototypeOf(EmbeddedResultFormComponent)).apply(this, arguments));

        _this.resultContainer = _this.refs.resultContainer;
        _this.resultShowTimeout = null;

        _this.tween = new _TimelineLite2.default({ paused: true });
        _this.tween.to(_this.resultContainer, 0.5, { opacity: 1, display: 'block' });
        return _this;
    }

    _createClass(EmbeddedResultFormComponent, [{
        key: 'onSuccess',
        value: function onSuccess(response) {
            this.renderSuccessMessage(response);
        }
    }, {
        key: 'renderSuccessMessage',
        value: function renderSuccessMessage(response) {
            if (this.resultShowTimeout) {
                clearTimeout(this.resultShowTimeout);
                this.resultShowTimeout = null;
            }
            this.resultContainer.innerHTML = (0, _successMessageTemplate2.default)(response);
            this.tween.play();
            this.resultShowTimeout = setTimeout(this.hideSuccessResult.bind(this), 5000);
        }
    }, {
        key: 'hideSuccessResult',
        value: function hideSuccessResult() {
            this.tween.reverse();
            this.resultShowTimeout = null;
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['resultContainer'];
        }
    }]);

    return EmbeddedResultFormComponent;
}(_asyncForm2.default);

exports.default = EmbeddedResultFormComponent;

/***/ }),

/***/ "./app/components/form/js/parsley-locale.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _parsleyjs = __webpack_require__("./node_modules/parsleyjs/dist/parsley.js");

var _parsleyjs2 = _interopRequireDefault(_parsleyjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_parsleyjs2.default.addMessages('en-custom', {
    defaultMessage: "This value seems to be invalid.",
    type: {
        email: "This value should be a valid email.",
        url: "This value should be a valid url.",
        number: "This value should be a valid number.",
        integer: "This value should be a valid integer.",
        digits: "This value should be digits.",
        alphanum: "This value should be alphanumeric."
    },
    notblank: "This value should not be blank.",
    required: "This value is required.",
    pattern: "This value seems to be invalid.",
    min: "This value should be greater than or equal to %s.",
    max: "This value should be lower than or equal to %s.",
    range: "This value should be between %s and %s.",
    minlength: "This value is too short. It should have %s characters or more.",
    maxlength: "This value is too long. It should have %s characters or fewer.",
    length: "This value length is invalid. It should be between %s and %s characters long.",
    mincheck: "You must select at least %s choices.",
    maxcheck: "You must select %s choices or fewer.",
    check: "You must select between %s and %s choices.",
    equalto: "This value should be the same."
});

_parsleyjs2.default.setLocale('en-custom');

/***/ }),

/***/ "./app/components/form/js/popup-result-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _asyncForm = __webpack_require__("./app/components/form/js/async-form.component.js");

var _asyncForm2 = _interopRequireDefault(_asyncForm);

var _notification = __webpack_require__("./app/general/js/notification.js");

var _notification2 = _interopRequireDefault(_notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopupResultFormComponent = function (_AsyncForm) {
    _inherits(PopupResultFormComponent, _AsyncForm);

    function PopupResultFormComponent() {
        _classCallCheck(this, PopupResultFormComponent);

        return _possibleConstructorReturn(this, (PopupResultFormComponent.__proto__ || Object.getPrototypeOf(PopupResultFormComponent)).apply(this, arguments));
    }

    _createClass(PopupResultFormComponent, [{
        key: 'onSuccess',
        value: function onSuccess(result) {
            var notification = void 0;
            var template = this.getTemplate();
            if (template !== null) {
                notification = _notification2.default.create(template(result));
            } else {
                notification = _notification2.default.createDefault(result);
            }
            notification.open();
        }
    }, {
        key: 'getTemplate',
        value: function getTemplate() {
            return null;
        }
    }]);

    return PopupResultFormComponent;
}(_asyncForm2.default);

exports.default = PopupResultFormComponent;

/***/ }),

/***/ "./app/components/form/js/validation-fieldset.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _asyncForm = __webpack_require__("./app/components/form/js/async-form.component.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STATE_SUCCESS = 1;
var STATE_FAILED = 2;

var ValidationFieldset = function (_BaseComponent) {
    _inherits(ValidationFieldset, _BaseComponent);

    function ValidationFieldset() {
        _classCallCheck(this, ValidationFieldset);

        var _this = _possibleConstructorReturn(this, (ValidationFieldset.__proto__ || Object.getPrototypeOf(ValidationFieldset)).apply(this, arguments));

        _this.state = null;

        _this.onInnerFieldValidationFailed = _this.onInnerFieldValidationFailed.bind(_this);
        _this.onInnerFieldValidationSucceed = _this.onInnerFieldValidationSucceed.bind(_this);
        _this.init();
        return _this;
    }

    _createClass(ValidationFieldset, [{
        key: "init",
        value: function init() {
            this.element.addEventListener(_asyncForm.EVENT_FIELD_VALIDATION_FAILED, this.onInnerFieldValidationFailed);
            this.element.addEventListener(_asyncForm.EVENT_FIELD_VALIDATION_SUCCEEDED, this.onInnerFieldValidationSucceed);
        }
    }, {
        key: "onInnerFieldValidationFailed",
        value: function onInnerFieldValidationFailed(_ref) {
            var field = _ref.field;

            if (this.state !== STATE_FAILED) {
                this.checkState(field);
            }
        }
    }, {
        key: "onInnerFieldValidationSucceed",
        value: function onInnerFieldValidationSucceed(_ref2) {
            var field = _ref2.field;

            if (this.state !== STATE_SUCCESS) {
                this.checkState(field);
            }
        }
    }, {
        key: "checkState",
        value: function checkState(field) {
            var _this2 = this;

            var hasErrors = field.parent.fields.filter(function (field) {
                return _this2.element.contains(field.element);
            }).some(function (field) {
                return field.validationResult !== true;
            });
            var newState = hasErrors ? STATE_FAILED : STATE_SUCCESS;
            if (this.state !== newState) {
                this.updateState(newState);
            }
        }
    }, {
        key: "updateState",
        value: function updateState(newState) {
            this.state = newState;
            switch (newState) {
                case STATE_SUCCESS:
                    this.element.classList.remove('vf-has-error');
                    this.element.classList.add('vf-is-success');
                    break;
                case STATE_FAILED:
                    this.element.classList.remove('vf-is-success');
                    this.element.classList.add('vf-has-error');
                    break;
            }
        }
    }, {
        key: "onDestroy",
        value: function onDestroy() {
            this.element.removeEventListener(_asyncForm.EVENT_FIELD_VALIDATION_FAILED, this.onInnerFieldValidationFailed);
            this.element.removeEventListener(_asyncForm.EVENT_FIELD_VALIDATION_SUCCEEDED, this.onInnerFieldValidationSucceed);
        }
    }]);

    return ValidationFieldset;
}(_baseComponent2.default);

exports.default = ValidationFieldset;

/***/ }),

/***/ "./app/components/form/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/full-width-promo/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/full-width-promo/scss/index.scss");

/***/ }),

/***/ "./app/components/full-width-promo/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/get-document-form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getDocumentForm = __webpack_require__("./app/components/get-document-form/js/get-document-form.component.js");

var _getDocumentForm2 = _interopRequireDefault(_getDocumentForm);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('get-document-form', _getDocumentForm2.default);

/***/ }),

/***/ "./app/components/get-document-form/js/get-document-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _downloadFilePopupForm = __webpack_require__("./app/components/form/js/download-file-popup-form.component.js");

var _downloadFilePopupForm2 = _interopRequireDefault(_downloadFilePopupForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GetDocumentFormComponent = function (_DownloadFilePopupFor) {
  _inherits(GetDocumentFormComponent, _DownloadFilePopupFor);

  function GetDocumentFormComponent() {
    _classCallCheck(this, GetDocumentFormComponent);

    return _possibleConstructorReturn(this, (GetDocumentFormComponent.__proto__ || Object.getPrototypeOf(GetDocumentFormComponent)).apply(this, arguments));
  }

  return GetDocumentFormComponent;
}(_downloadFilePopupForm2.default);

exports.default = GetDocumentFormComponent;

/***/ }),

/***/ "./app/components/gmap/img/circle.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/circle.png";

/***/ }),

/***/ "./app/components/gmap/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _gmap = __webpack_require__("./app/components/gmap/js/gmap.component.js");

var _gmap2 = _interopRequireDefault(_gmap);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('gmap', _gmap2.default);

/***/ }),

/***/ "./app/components/gmap/js/gmap.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _eventBus = __webpack_require__("./app/general/js/event-bus.js");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _app = __webpack_require__("./app/general/js/app.js");

var _loadGmap = __webpack_require__("./app/components/gmap/js/loadGmap.js");

var _loadGmap2 = _interopRequireDefault(_loadGmap);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("./app/components/gmap/img/circle.png");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GmapComponent = function (_BaseComponent) {
    _inherits(GmapComponent, _BaseComponent);

    function GmapComponent() {
        _classCallCheck(this, GmapComponent);

        var _this = _possibleConstructorReturn(this, (GmapComponent.__proto__ || Object.getPrototypeOf(GmapComponent)).apply(this, arguments));

        _this._markers = {
            pin: {},
            circle: {
                url: "/assets/dist/images/circle.png",
                width: 65,
                height: 65,
                centerX: 32,
                centerY: 32
            }
        };

        _this.map = _this.refs.map;
        _this.marker = _this.refs.marker;

        _this.lat = (0, _jquery2.default)(_this.marker).data('lat') || 0;
        _this.lng = (0, _jquery2.default)(_this.marker).data('lng') || 0;
        _this.markerType = (0, _jquery2.default)(_this.marker).data('marker') || 'pin';

        (0, _loadGmap2.default)(function () {
            _this.init();
            _eventBus2.default.addListener(_app.EVENT_RESIZE_FINISHED, function () {
                _this.init();
            });
        });
        return _this;
    }

    _createClass(GmapComponent, [{
        key: 'init',
        value: function init() {

            var myLatLng = {
                lat: this.lat,
                lng: this.lng
            };

            // in case the map is inside the hidden block
            var parent = this.element.parentNode;
            var parentsHidden = [];

            while (parent.style) {
                if (parent.style.display === 'none') {
                    parentsHidden.unshift(parent);
                }
                parent = parent.parentNode;
            }
            // make all hidden parent elements visible before map creating
            parentsHidden.forEach(function (currentElement) {
                currentElement.classList.add('faux-hidden');
            });

            var zoom = (0, _jquery2.default)(this.map).data('zoom') || 11; // 11 is default zoom
            var map = new google.maps.Map(this.map, {
                zoom: zoom,
                center: myLatLng,
                disableDefaultUI: true
            });

            this.addMarker(map);

            // revert hidden parent elements
            google.maps.event.addListener(map, 'tilesloaded', function () {
                parentsHidden.forEach(function (currentElement) {
                    currentElement.classList.remove('faux-hidden');
                });
            });
        }
    }, {
        key: 'addMarker',
        value: function addMarker(map) {
            var position = new google.maps.LatLng(this.lat, this.lng);
            var markerSettings = this._markers[this.markerType];
            var icon = {
                url: markerSettings.url,
                scaledSize: new google.maps.Size(markerSettings.width, markerSettings.height),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(markerSettings.centerX, markerSettings.centerY)
            };

            var marker = new google.maps.Marker({
                position: position,
                map: map,
                icon: icon,
                cursor: 'inherit'
            });
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['map', 'marker'];
        }
    }]);

    return GmapComponent;
}(_baseComponent2.default);

exports.default = GmapComponent;

/***/ }),

/***/ "./app/components/gmap/js/loadGmap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = onReady;

var _intersectionHelper = __webpack_require__("./app/general/js/intersection-helper.js");

var _intersectionHelper2 = _interopRequireDefault(_intersectionHelper);

var _persistentConnector = __webpack_require__("./app/general/js/persistent-connector.js");

var _persistentConnector2 = _interopRequireDefault(_persistentConnector);

var _jquery = __webpack_require__("./app/general/js/jquery.waypoints.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _noframework = __webpack_require__("./app/general/js/noframework.waypoints.js");

var _noframework2 = _interopRequireDefault(_noframework);

var _inview = __webpack_require__("./app/general/js/inview.js");

var _inview2 = _interopRequireDefault(_inview);

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var callbackName = 'onGmapLoad';
var googleMapsApiKey = _app2.default.getConfig('googleMapsApiKey');
var isLoaded = false;
var onloadQueue = [];
var connector = void 0;

window[callbackName] = function () {
    isLoaded = true;
    onloadQueue.forEach(function (callback) {
        return callback();
    });
};

function onReady(callback) {
    if (isLoaded) {
        callback();
    } else {
        onloadQueue.push(callback);
    }
}

function insertScript() {
    var script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.onerror = function () {
        connector.recover();
    };
    script.src = 'https://maps.googleapis.com/maps/api/js?v=2.exp&sensor=false&callback=' + callbackName + '&key=' + googleMapsApiKey + '&channel=01';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(script, s);
}

function initGmapScriptLoading() {
    if (!isLoaded) {
        connector = new _persistentConnector2.default(insertScript, { name: 'Gmap script' });
        insertScript();
    }
}

//postload the lot details dynamic map on click of the static map
var lotDetailsStaticMap = document.getElementById('lot-details-static-map');

if (document.querySelector('[data-dc="gmap"]')) {
    console.log("document.querySelector('[data-dc=\"gmap\"]') fired");
    //load the map when visible in the viewport, unless the map has a postload flag set to true (lot details map postloads)
    if (!document.querySelector('[data-postload-map="true"]')) {
        _intersectionHelper2.default.enterViewportOnce(document.querySelector('[data-dc="gmap"]'), initGmapScriptLoading);
    } else {
        if (lotDetailsStaticMap !== undefined && lotDetailsStaticMap != null) {
            var result = new Waypoint.Inview({
                element: lotDetailsStaticMap,
                enter: function enter() {
                    var mapLoaded = lotDetailsStaticMap.dataset.mapLoaded === 'true';
                    if (!mapLoaded) {
                        var lat = lotDetailsStaticMap.dataset.lat;
                        var lng = lotDetailsStaticMap.dataset.lng;
                        var url = 'url(\'https://maps.googleapis.com/maps/api/staticmap?center=' + lat + ',' + lng + '&zoom=15&channel=01&scale=1&size=845x200&maptype=roadmap&key=' + googleMapsApiKey + '&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff0000%7Clabel:%7C' + lat + ',' + lng + '\')';
                        lotDetailsStaticMap.style.backgroundImage = url;
                        lotDetailsStaticMap.style.backgroundPosition = "center";
                        lotDetailsStaticMap.dataset.mapLoaded = true;
                    }
                }
            });
        }
    }

    if (document.querySelector('.js-print')) {
        document.querySelector('.js-print').addEventListener('click', function (e) {
            e.preventDefault();
            initGmapScriptLoading();
            if (isLoaded) {
                window.print();
            } else {
                onloadQueue.push(function () {
                    setTimeout(function () {
                        window.print();
                    }, 500);
                });
            }
        });
    }
}

if (lotDetailsStaticMap) {

    lotDetailsStaticMap.addEventListener('click', function (e) {

        e.preventDefault();
        lotDetailsStaticMap.style.display = 'none';
        var lotDetailsDynamicMap = document.querySelector('[data-dc="gmap"]');

        if (lotDetailsDynamicMap) lotDetailsDynamicMap.style.display = 'block';

        initGmapScriptLoading();
    });
}

/***/ }),

/***/ "./app/components/header/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/header/scss/index.scss");

var _header = __webpack_require__("./app/components/header/js/header.component.js");

var _header2 = _interopRequireDefault(_header);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('header', _header2.default);

/***/ }),

/***/ "./app/components/header/js/header-events.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EVENT_OUTER_CLICK = exports.EVENT_OUTER_CLICK = 'header:outer-click';

/***/ }),

/***/ "./app/components/header/js/header-search.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TweenLite = __webpack_require__("./node_modules/gsap/TweenLite.js");

var _TweenLite2 = _interopRequireDefault(_TweenLite);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _contentBlocker = __webpack_require__("./app/general/js/content-blocker.js");

var _contentBlocker2 = _interopRequireDefault(_contentBlocker);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

var _eventBus = __webpack_require__("./app/general/js/event-bus.js");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _urlHelper = __webpack_require__("./app/general/js/url-helper.js");

var _urlHelper2 = _interopRequireDefault(_urlHelper);

var _PredictiveSearch = __webpack_require__("./app/components/predictive-search/js/PredictiveSearch.js");

var _PredictiveSearch2 = _interopRequireDefault(_PredictiveSearch);

var _lotsSearch = __webpack_require__("./app/components/lots-search/js/lots-search.component.js");

var _headerEvents = __webpack_require__("./app/components/header/js/header-events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderSearchComponent = function (_BaseComponent) {
    _inherits(HeaderSearchComponent, _BaseComponent);

    function HeaderSearchComponent() {
        _classCallCheck(this, HeaderSearchComponent);

        var _this = _possibleConstructorReturn(this, (HeaderSearchComponent.__proto__ || Object.getPrototypeOf(HeaderSearchComponent)).apply(this, arguments));

        _this.onOpen = _this.props.onOpen;

        _this.predictive = _this.refs.predictive;
        _this.openBtn = _this.refs.open;
        _this.closeBtn = _this.refs.close;

        _this.searchUrl = _app2.default.getConfig('searchResultsUrl');
        _this.hasBeenOpened = false;
        _this.onSearchChange = _this.onSearchChange.bind(_this);
        _this.headerOuterClickSubscription = null;
        _this.onHeaderOuterClick = _this.onHeaderOuterClick.bind(_this);

        _this.init();
        return _this;
    }

    _createClass(HeaderSearchComponent, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            this.openBtn.addEventListener('click', function () {
                _this2.onOpen(_this2);
            });

            this.closeBtn.addEventListener('click', this.close.bind(this));

            _reactDom2.default.render(_react2.default.createElement(_PredictiveSearch2.default, { inputRef: function inputRef(el) {
                    return _this2.input = el;
                },
                onChange: this.onSearchChange }), this.predictive);
        }
    }, {
        key: 'onSearchChange',
        value: function onSearchChange(search) {
            var queryParams = {};
            if (search.query && search.query.length > 0) {
                queryParams.content = search.query;
            }
            if (search.queryType && search.queryType.length > 0) {
                queryParams.type = search.queryType;
            }
            window.location.href = this.getSearchUrl(queryParams);
        }
    }, {
        key: 'getSearchUrl',
        value: function getSearchUrl(params) {
            return _urlHelper2.default.getUrlByParams(this.searchUrl, params, _lotsSearch.defaultFilters);
        }
    }, {
        key: 'open',
        value: function open() {
            var _this3 = this;

            if (!this.hasBeenOpened) {
                this.hasBeenOpened = true;
                this.tween = _TweenLite2.default.fromTo(this.element, 0.2, { width: '0%' }, {
                    width: '100%',
                    paused: true,
                    onComplete: function onComplete() {
                        if (_this3.input) {
                            _this3.input.focus();
                        }
                    },
                    onReverseComplete: function onReverseComplete() {
                        _this3.element.classList.remove('is-opened');
                        _TweenLite2.default.set(_this3.element, { width: 'auto' });
                    }
                });
            }
            this.element.classList.add('is-opened');
            this.tween.play();

            if (!_app2.default.isDesktop) {
                _contentBlocker2.default.block('search', true);
            }

            this.headerOuterClickSubscription = _eventBus2.default.addListener(_headerEvents.EVENT_OUTER_CLICK, this.onHeaderOuterClick);
        }
    }, {
        key: 'onHeaderOuterClick',
        value: function onHeaderOuterClick(e) {
            this.close();
        }
    }, {
        key: 'close',
        value: function close() {
            this.tween.reverse();
            _contentBlocker2.default.unblock('search');
            this.headerOuterClickSubscription.remove();
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['predictive', 'open', 'close'];
        }
    }, {
        key: 'getRequiredProps',
        value: function getRequiredProps() {
            return ['onOpen'];
        }
    }]);

    return HeaderSearchComponent;
}(_baseComponent2.default);

exports.default = HeaderSearchComponent;

/***/ }),

/***/ "./app/components/header/js/header.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

var _contentBlocker = __webpack_require__("./app/general/js/content-blocker.js");

var _contentBlocker2 = _interopRequireDefault(_contentBlocker);

var _nav = __webpack_require__("./app/components/header/js/nav.component.js");

var _nav2 = _interopRequireDefault(_nav);

var _headerSearch = __webpack_require__("./app/components/header/js/header-search.component.js");

var _headerSearch2 = _interopRequireDefault(_headerSearch);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _eventBus = __webpack_require__("./app/general/js/event-bus.js");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _app = __webpack_require__("./app/general/js/app.js");

var _headerEvents = __webpack_require__("./app/components/header/js/header-events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderComponent = function (_BaseComponent) {
    _inherits(HeaderComponent, _BaseComponent);

    function HeaderComponent() {
        _classCallCheck(this, HeaderComponent);

        var _this = _possibleConstructorReturn(this, (HeaderComponent.__proto__ || Object.getPrototypeOf(HeaderComponent)).apply(this, arguments));

        _this.menuBtn = _this.refs.menuBtn;
        _this.navTriggers = _this.refs.navTriggers;
        _this.isMenuOpened = false;

        _this.onDeviceTypeChanged = _this.onDeviceTypeChanged.bind(_this);

        _this.init();
        return _this;
    }

    _createClass(HeaderComponent, [{
        key: 'init',
        value: function init() {
            _componentsCollection2.default.getInstance().createComponent(this.element, 'search', _headerSearch2.default, {
                onOpen: this.onSearchOpen.bind(this)
            });

            this.navComponent = _componentsCollection2.default.getInstance().createComponent(this.element, 'nav', _nav2.default, {
                triggers: this.navTriggers
            });

            this.menuBtn.addEventListener('click', this.onMenuButtonClick.bind(this));

            _eventBus2.default.addListener(_app.EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
            this.trackOuterClick();
        }
    }, {
        key: 'onDeviceTypeChanged',
        value: function onDeviceTypeChanged(oldType, newType) {
            //switch from tablet/mobile to desktop
            //we have to close burger menu properly
            if (newType === _app.DEVICE_TYPE_DESKTOP && this.isMenuOpened) {
                this.closeMenu();
            }
        }
    }, {
        key: 'onMenuButtonClick',
        value: function onMenuButtonClick() {
            if (!this.isMenuOpened) {
                this.openMenu();
            } else {
                this.closeMenu();
            }
        }
    }, {
        key: 'openMenu',
        value: function openMenu() {
            this.isMenuOpened = true;
            _contentBlocker2.default.block('menu');
            this.element.classList.add('is-menu-opened');
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            this.isMenuOpened = false;
            this.element.classList.remove('is-menu-opened');
            _contentBlocker2.default.unblock('menu');
        }

        //when the search starts to open we need close navs and then open the search

    }, {
        key: 'onSearchOpen',
        value: function onSearchOpen(searchComponent) {
            if (this.navComponent) {
                this.navComponent.reset().then(function () {
                    searchComponent.open();
                });
            }
        }
    }, {
        key: 'trackOuterClick',
        value: function trackOuterClick() {
            var _this2 = this;

            document.addEventListener('click', function (_ref) {
                var target = _ref.target;

                if (!_this2.element.contains(target)) {
                    _eventBus2.default.emit(_headerEvents.EVENT_OUTER_CLICK);
                }
            });
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['menuBtn', 'navTriggers'];
        }
    }]);

    return HeaderComponent;
}(_baseComponent2.default);

exports.default = HeaderComponent;

/***/ }),

/***/ "./app/components/header/js/nav-item.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _htmlHelper = __webpack_require__("./app/general/js/html-helper.js");

var _htmlHelper2 = _interopRequireDefault(_htmlHelper);

var _TweenLite = __webpack_require__("./node_modules/gsap/TweenLite.js");

var _TweenLite2 = _interopRequireDefault(_TweenLite);

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavItem = function (_BaseComponent) {
    _inherits(NavItem, _BaseComponent);

    function NavItem() {
        _classCallCheck(this, NavItem);

        var _this = _possibleConstructorReturn(this, (NavItem.__proto__ || Object.getPrototypeOf(NavItem)).apply(this, arguments));

        _this.trigger = _this.refs.trigger;
        _this.submenu = _this.refs.submenu;

        _this.onToggle = _this.props.onToggle;
        _this.triggers = _this.props.triggers;

        _this.outerTrigger = null;
        var id = _this.element.dataset.id;
        if (id && _this.triggers[id]) {
            _this.outerTrigger = _this.triggers[id];
        }

        _this.hasBeenOpened = false;
        _this.isOpened = false;
        //that flag shows that item has been opened by clicking on
        //desktop menu items rather than hamburger items
        _this.fromOuter = true;
        _this.init();
        return _this;
    }

    _createClass(NavItem, [{
        key: 'init',
        value: function init() {
            this.trigger.addEventListener('click', this.toggle.bind(this));
            _htmlHelper2.default.safeAddEventListener(this.outerTrigger, 'mouseenter', this.outerDesktopTriggerToggle.bind(this));
            _htmlHelper2.default.safeAddEventListener(this.submenu, 'mouseleave', this.outerDesktopTriggerToggle.bind(this));
        }
    }, {
        key: 'outerTriggerToggle',
        value: function outerTriggerToggle(e) {
            e.preventDefault();
            this.fromOuter = true;
            this.toggle(e);
        }
    }, {
        key: 'outerDesktopTriggerToggle',
        value: function outerDesktopTriggerToggle(e) {
            e.preventDefault();
            if (_app2.default.isDesktop) {
                this.fromOuter = true;
                this.toggle(e);
            }
        }
    }, {
        key: 'toggle',
        value: function toggle(e) {
            e.preventDefault();
            //difference between these options is
            //nav items on mobile can open in independently
            //but on desktop we have to close previously opened nav item
            if (_app2.default.isDesktop) {
                //so pass instance of new item through NavComponent::onToggle callback
                //and it will do logic for us
                this.onToggle(this);
            } else {
                //otherwise just open or close depending on the inner state
                if (!this.isOpened) {
                    this.open();
                } else {
                    this.close();
                }
            }
        }
    }, {
        key: 'open',
        value: function open() {
            var _this2 = this;

            if (!this.hasBeenOpened) {
                this.hasBeenOpened = true;
                this.tween = _TweenLite2.default.fromTo(this.submenu, 0.3, {
                    height: 0,
                    opacity: 0
                }, {
                    height: _app2.default.isDesktop ? 75 : 'auto',
                    opacity: 1,
                    onReverseComplete: function onReverseComplete() {
                        _this2.handleClose();
                    }
                });
            }

            if (!this.isOpened) {
                this.isOpened = true;
                this.element.classList.add('is-opened');
                //if current opening is caused by desktop navigation link
                //we have to highlight it too
                if (this.fromOuter) {
                    this.outerTrigger.classList.add('is-opened');
                }
                this.tween.play();
            }
        }
    }, {
        key: 'close',
        value: function close() {
            var _this3 = this;

            return new Promise(function (resolve) {
                _this3.finishClose = resolve;
                _this3.tween.reverse();
            });
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            this.element.classList.remove('is-opened');
            if (this.fromOuter) {
                this.outerTrigger.classList.remove('is-opened');
            }

            //resolve promise of current item closing
            if (this.finishClose) {
                this.finishClose();
            }

            this.isOpened = false;
            this.fromOuter = false;
        }
    }, {
        key: 'reset',
        value: function reset() {
            //recreate tween to reset cached heights of items
            this.hasBeenOpened = false;
            if (this.isOpened) {
                this.handleClose();
            }
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['trigger', 'submenu'];
        }
    }, {
        key: 'getRequiredProps',
        value: function getRequiredProps() {
            return ['onToggle', 'triggers'];
        }
    }]);

    return NavItem;
}(_baseComponent2.default);

exports.default = NavItem;

/***/ }),

/***/ "./app/components/header/js/nav.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

var _navItem = __webpack_require__("./app/components/header/js/nav-item.component.js");

var _navItem2 = _interopRequireDefault(_navItem);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _headerEvents = __webpack_require__("./app/components/header/js/header-events.js");

var _eventBus = __webpack_require__("./app/general/js/event-bus.js");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavComponent = function (_BaseComponent) {
    _inherits(NavComponent, _BaseComponent);

    function NavComponent() {
        _classCallCheck(this, NavComponent);

        var _this = _possibleConstructorReturn(this, (NavComponent.__proto__ || Object.getPrototypeOf(NavComponent)).apply(this, arguments));

        _this.triggers = _this.props.triggers;
        _this.currentItem = null;
        _this.onHeaderOuterClick = _this.onHeaderOuterClick.bind(_this);
        _this.onDeviceTypeChanged = _this.onDeviceTypeChanged.bind(_this);
        _this.init();
        return _this;
    }

    _createClass(NavComponent, [{
        key: 'init',
        value: function init() {

            this.navItems = _componentsCollection2.default.getInstance().createComponents(this.element, 'nav-item', _navItem2.default, {
                onToggle: this.onToggle.bind(this),
                triggers: this.triggers
            });

            _eventBus2.default.addListener(_headerEvents.EVENT_OUTER_CLICK, this.onHeaderOuterClick);
            _eventBus2.default.addListener(_app.EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
        }
    }, {
        key: 'onDeviceTypeChanged',
        value: function onDeviceTypeChanged(oldType, newType) {
            //switch from tablet/mobile to desktop
            //we have to close burger menu properly
            if (newType == _app.DEVICE_TYPE_DESKTOP || oldType == _app.DEVICE_TYPE_DESKTOP) {
                this.resetMenu();
            }
        }

        //callback for all nav-item children
        //when another nav item start to open - we have to close previously opened nav item

    }, {
        key: 'onToggle',
        value: function onToggle(component) {
            var _this2 = this;

            if (this.currentItem) {
                this.currentItem.close().then(function () {
                    //if we have closed the same nav-item
                    //just set current to null
                    if (_this2.currentItem === component) {
                        _this2.currentItem = null;
                    } else {
                        //otherwise we open new one
                        _this2.currentItem = component;
                        _this2.currentItem.open();
                    }
                });
            } else {
                this.currentItem = component;
                this.currentItem.open();
            }
        }
    }, {
        key: 'onHeaderOuterClick',
        value: function onHeaderOuterClick() {
            if (this.currentItem) {
                this.currentItem.close();
                this.currentItem = null;
            }
        }

        //resolve immediately or wait until current item finish it's close transition

    }, {
        key: 'reset',
        value: function reset() {
            var _this3 = this;

            if (this.currentItem) {
                return this.currentItem.close().then(function () {
                    _this3.currentItem = null;
                });
            } else {
                return Promise.resolve();
            }
        }
    }, {
        key: 'resetMenu',
        value: function resetMenu() {
            this.navItems.forEach(function (navItem) {
                return navItem.reset();
            });
            this.currentItem = null;
        }
    }]);

    return NavComponent;
}(_baseComponent2.default);

exports.default = NavComponent;

/***/ }),

/***/ "./app/components/header/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/hero-column/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/hero-column/scss/index.scss");

var _heroColumn = __webpack_require__("./app/components/hero-column/js/hero-column.component.js");

var _heroColumn2 = _interopRequireDefault(_heroColumn);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('hero-column', _heroColumn2.default);

/***/ }),

/***/ "./app/components/hero-column/js/hero-column.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TimelineLite = __webpack_require__("./node_modules/gsap/TimelineLite.js");

var _TimelineLite2 = _interopRequireDefault(_TimelineLite);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _styleObserver = __webpack_require__("./app/general/js/style-observer.js");

var _styleObserver2 = _interopRequireDefault(_styleObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeroColumnComponent = function (_BaseComponent) {
    _inherits(HeroColumnComponent, _BaseComponent);

    function HeroColumnComponent() {
        _classCallCheck(this, HeroColumnComponent);

        var _this = _possibleConstructorReturn(this, (HeroColumnComponent.__proto__ || Object.getPrototypeOf(HeroColumnComponent)).apply(this, arguments));

        _this.init();
        return _this;
    }

    _createClass(HeroColumnComponent, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            (0, _styleObserver2.default)(function () {
                _this2.animate();
            });
        }
    }, {
        key: 'animate',
        value: function animate() {
            new _TimelineLite2.default().staggerFrom(this.element.children, 1, { y: '50px', ease: Power4.easeOut }, 0.1);
            this.element.classList.add('is-visible');
        }
    }]);

    return HeroColumnComponent;
}(_baseComponent2.default);

exports.default = HeroColumnComponent;

/***/ }),

/***/ "./app/components/hero-column/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/hero-video/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/hero-video/scss/index.scss");

var _heroVideo = __webpack_require__("./app/components/hero-video/js/hero-video.component.js");

var _heroVideo2 = _interopRequireDefault(_heroVideo);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('hero-video', _heroVideo2.default);

/***/ }),

/***/ "./app/components/hero-video/js/hero-video.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _importsLoaderThisWindowExportsLoaderObjectFitPolyfillObjectFitPolyfill = __webpack_require__("./node_modules/imports-loader/index.js?this=>window!./node_modules/exports-loader/index.js?objectFitPolyfill!./node_modules/objectFitPolyfill/dist/objectFitPolyfill.min.js");

var _importsLoaderThisWindowExportsLoaderObjectFitPolyfillObjectFitPolyfill2 = _interopRequireDefault(_importsLoaderThisWindowExportsLoaderObjectFitPolyfillObjectFitPolyfill);

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BROWSER_HAVE_ENOUGH_DATA = 4;

var ObjectFitVideoComponent = function (_BaseComponent) {
    _inherits(ObjectFitVideoComponent, _BaseComponent);

    function ObjectFitVideoComponent() {
        _classCallCheck(this, ObjectFitVideoComponent);

        var _this = _possibleConstructorReturn(this, (ObjectFitVideoComponent.__proto__ || Object.getPrototypeOf(ObjectFitVideoComponent)).apply(this, arguments));

        _this.video = _this.element.querySelector('video');

        _this.onReadyStateChange = _this.onReadyStateChange.bind(_this);
        _this.onCanPlayThrough = _this.onCanPlayThrough.bind(_this);
        _this.init();
        return _this;
    }

    _createClass(ObjectFitVideoComponent, [{
        key: 'init',
        value: function init() {
            if (!_app2.default.isTouch) {
                if (this.isReady()) {
                    this.play();
                } else {
                    this.addListeners();
                }
            }
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            this.video.addEventListener('readystatechange', this.onReadyStateChange);
            this.video.addEventListener('canplaythrough', this.onCanPlayThrough);
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            this.video.removeEventListener('readystatechange', this.onReadyStateChange);
            this.video.removeEventListener('canplaythrough', this.onCanPlayThrough);
        }
    }, {
        key: 'isReady',
        value: function isReady() {
            return this.video.readyState === BROWSER_HAVE_ENOUGH_DATA;
        }
    }, {
        key: 'onReadyStateChange',
        value: function onReadyStateChange() {
            if (this.isReady()) {
                this.removeListeners();
                this.play();
            }
        }
    }, {
        key: 'onCanPlayThrough',
        value: function onCanPlayThrough() {
            this.removeListeners();
            this.play();
        }
    }, {
        key: 'play',
        value: function play() {
            (0, _importsLoaderThisWindowExportsLoaderObjectFitPolyfillObjectFitPolyfill2.default)(this.video);
            this.video.play();
            this.element.classList.add('is-started');
        }
    }]);

    return ObjectFitVideoComponent;
}(_baseComponent2.default);

exports.default = ObjectFitVideoComponent;

/***/ }),

/***/ "./app/components/hero-video/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/hero/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/hero/scss/index.scss");

var _underHeroPane = __webpack_require__("./app/components/hero/js/under-hero-pane.component.js");

var _underHeroPane2 = _interopRequireDefault(_underHeroPane);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('under-hero-pane', _underHeroPane2.default);

/***/ }),

/***/ "./app/components/hero/js/under-hero-pane.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnderHeroPaneComponent = function (_BaseComponent) {
    _inherits(UnderHeroPaneComponent, _BaseComponent);

    function UnderHeroPaneComponent() {
        _classCallCheck(this, UnderHeroPaneComponent);

        var _this = _possibleConstructorReturn(this, (UnderHeroPaneComponent.__proto__ || Object.getPrototypeOf(UnderHeroPaneComponent)).apply(this, arguments));

        _this.btn = _this.refs.toggle;
        _this.pane = _this.refs.pane;
        _this.scrollBtn = _this.refs.scroll;

        _this.init();
        return _this;
    }

    _createClass(UnderHeroPaneComponent, [{
        key: 'init',
        value: function init() {
            if (typeof this.btn != 'undefined' && typeof this.pane != 'undefined') {
                this.btn.addEventListener('click', this.toggle.bind(this));
            }

            if (typeof this.scrollBtn != 'undefined') {
                this.scrollBtn.addEventListener('click', this.scroll.bind(this));
            }
        }
    }, {
        key: 'toggle',
        value: function toggle(e) {
            var _this2 = this;

            e.preventDefault();
            (0, _jquery2.default)(this.pane).slideToggle('300', function () {
                _this2.element.classList.toggle('is-opened');
            });
        }
    }, {
        key: 'scroll',
        value: function scroll(e) {
            e.preventDefault();
            (0, _jquery2.default)("html, body").stop().animate({ scrollTop: (0, _jquery2.default)(this.element).offset().top + (0, _jquery2.default)(this.element).outerHeight() - (0, _jquery2.default)('.header').outerHeight() }, 500);
        }
    }]);

    return UnderHeroPaneComponent;
}(_baseComponent2.default);

exports.default = UnderHeroPaneComponent;

/***/ }),

/***/ "./app/components/hero/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/home/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/home/scss/index.scss");

/***/ }),

/***/ "./app/components/home/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/latest-news/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/latest-news/scss/index.scss");

var _latestNews = __webpack_require__("./app/components/latest-news/js/latest-news.component.js");

var _latestNews2 = _interopRequireDefault(_latestNews);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('latest-news', _latestNews2.default);

/***/ }),

/***/ "./app/components/latest-news/js/latest-news.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _styleObserver = __webpack_require__("./app/general/js/style-observer.js");

var _styleObserver2 = _interopRequireDefault(_styleObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LatestNewsComponent = function (_BaseComponent) {
    _inherits(LatestNewsComponent, _BaseComponent);

    function LatestNewsComponent() {
        _classCallCheck(this, LatestNewsComponent);

        var _this = _possibleConstructorReturn(this, (LatestNewsComponent.__proto__ || Object.getPrototypeOf(LatestNewsComponent)).apply(this, arguments));

        _this.$elemet = (0, _jquery2.default)(_this.element);

        _this.defaultOptions = {
            loop: true,
            nav: true,
            dots: false,
            margin: 29,
            navText: ['<svg class="icon" width="10" height="20"><use xlink:href="#icon-arrow-left"></use></svg>', '<svg class="icon" width="10" height="20"><use xlink:href="#icon-arrow-right"></use></svg>'],
            responsive: {
                0: {
                    items: 1
                },
                769: {
                    items: 3,
                    nav: false,
                    loop: false
                }
            }
        };
        (0, _styleObserver2.default)(function () {
            _this.init();
        });
        return _this;
    }

    _createClass(LatestNewsComponent, [{
        key: 'init',
        value: function init() {
            var options = _extends({}, this.defaultOptions, this.options);
            this.$elemet.owlCarousel(options);
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.$elemet.owlCarousel('destroy');
        }
    }]);

    return LatestNewsComponent;
}(_baseComponent2.default);

exports.default = LatestNewsComponent;

/***/ }),

/***/ "./app/components/latest-news/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/links-list/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/links-list/scss/index.scss");

/***/ }),

/***/ "./app/components/links-list/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/listing/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/listing/scss/index.scss");

/***/ }),

/***/ "./app/components/listing/js/Listing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _TimelineLite = __webpack_require__("./node_modules/gsap/TimelineLite.js");

var _TimelineLite2 = _interopRequireDefault(_TimelineLite);

var _api = __webpack_require__("./app/general/js/api.js");

var _api2 = _interopRequireDefault(_api);

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _pageSpinner = __webpack_require__("./app/general/js/page-spinner.js");

var _pageSpinner2 = _interopRequireDefault(_pageSpinner);

var _contentBlocker = __webpack_require__("./app/general/js/content-blocker.js");

var _contentBlocker2 = _interopRequireDefault(_contentBlocker);

var _urlHelper = __webpack_require__("./app/general/js/url-helper.js");

var _urlHelper2 = _interopRequireDefault(_urlHelper);

var _ListingLoadMore = __webpack_require__("./app/components/listing/js/ListingLoadMore.js");

var _ListingLoadMore2 = _interopRequireDefault(_ListingLoadMore);

var _ListingControlsTrigger = __webpack_require__("./app/components/listing/js/ListingControlsTrigger.js");

var _ListingControlsTrigger2 = _interopRequireDefault(_ListingControlsTrigger);

var _eventBus = __webpack_require__("./app/general/js/event-bus.js");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _app = __webpack_require__("./app/general/js/app.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Listing = function (_React$PureComponent) {
    _inherits(Listing, _React$PureComponent);

    function Listing(props) {
        _classCallCheck(this, Listing);

        var _this = _possibleConstructorReturn(this, (Listing.__proto__ || Object.getPrototypeOf(Listing)).call(this, props));

        _this.state = {
            items: [],
            filters: {},
            pagination: {
                perPage: 0,
                totalCount: 0,
                currentPage: 0,
                pageCount: 0
            },
            isControlsOpened: false,
            isControlsShowing: false,
            isLoadingMore: false,
            isInitialRequestFulfilled: false
        };

        _this.currentPage = null;
        _this.lastRequestCancel = null;
        _this.isControlsOpened = false;

        _this.onFiltersChange = _this.onFiltersChange.bind(_this);
        _this.onLoadMore = _this.onLoadMore.bind(_this);
        _this.onControlsTriggerClick = _this.onControlsTriggerClick.bind(_this);
        _this.onControlsOverlayClick = _this.onControlsOverlayClick.bind(_this);
        _this.animateChange = _this.animateChange.bind(_this);

        _eventBus2.default.addListener(_app.EVENT_DEVICE_TYPE_CHANGED, _this.onDeviceTypeChanged.bind(_this));
        return _this;
    }

    _createClass(Listing, [{
        key: 'onDeviceTypeChanged',
        value: function onDeviceTypeChanged(oldType, newType) {
            //switch from tablet/mobile to desktop
            //we have to close controls
            if (newType == _app.DEVICE_TYPE_DESKTOP) {
                this.closeControls();
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.baseUrl = _urlHelper2.default.getPathWithQueryString(window.location, Object.keys(this.props.defaultFilters));
            this.setFilters(this.getInitialFilters());
            window.addEventListener('popstate', this.onPopstate.bind(this));
        }
    }, {
        key: 'animateChange',
        value: function animateChange(changeAction) {
            var content = this.element.querySelector('.listing__content');
            var timiline = new _TimelineLite2.default();
            timiline.to(content, 0.2, {
                opacity: 0, onComplete: function onComplete() {
                    if (changeAction) {
                        changeAction();
                    }
                }
            }).to(content, 0.4, { opacity: 1 });
        }
    }, {
        key: 'loadItems',
        value: function loadItems() {
            var _this2 = this;

            _pageSpinner2.default.show({ fade: true });
            this.getItems().then(function (result) {
                _this2.animateChange(function () {
                    _this2.setState({
                        items: result.items,
                        pagination: result.pagination,
                        isInitialRequestFulfilled: true
                    });
                    _this2.currentPage = result.pagination.currentPage;
                    _pageSpinner2.default.hide();
                });
            }, function (error) {
                //hide after error only when our request has been canceled
                if (!_axios2.default.isCancel(error)) {
                    _pageSpinner2.default.hide();
                }
            });
        }
    }, {
        key: 'loadNextPageItems',
        value: function loadNextPageItems() {
            var _this3 = this;

            if (!this.state.isLoadingMore) {
                this.setState({ isLoadingMore: true }, function () {

                    _this3.getItems(_this3.currentPage + 1).then(function (result) {
                        _this3.setState({
                            items: [].concat(_toConsumableArray(_this3.state.items), _toConsumableArray(result.items)),
                            pagination: result.pagination
                        });
                        _this3.currentPage = result.pagination.currentPage;
                    }).finally(function () {
                        _this3.setState({
                            isLoadingMore: false
                        });
                    });
                });
            }
        }
    }, {
        key: 'setFilters',
        value: function setFilters(filters) {
            var _this4 = this;

            var newFilters = _extends({}, this.props.defaultFilters, filters);
            this.setState({ filters: newFilters }, function () {
                _this4.loadItems();
            });
        }
    }, {
        key: 'getInitialFilters',
        value: function getInitialFilters() {
            return this.getFiltersByLocation(document.location);
        }
    }, {
        key: 'onPopstate',
        value: function onPopstate(e) {
            this.setFilters(this.getFiltersByLocation(document.location));
        }
    }, {
        key: 'onFiltersChange',
        value: function onFiltersChange(filterObject) {
            var passedFilters = this.getValidFilters(filterObject);
            var updatedFilters = _extends({}, this.state.filters, passedFilters);
            this.setFilters(updatedFilters);

            var url = this.baseUrl;
            var searchableFilters = _urlHelper2.default.getSearchableParams(updatedFilters, this.props.defaultFilters);
            if (Object.keys(searchableFilters).length > 0) {
                url = _urlHelper2.default.getUrlByParams(url, searchableFilters);
            }

            window.history.pushState(updatedFilters, '', url);
            this.closeControls();
        }
    }, {
        key: 'onLoadMore',
        value: function onLoadMore() {
            this.loadNextPageItems();
        }
    }, {
        key: 'getItems',
        value: function getItems() {
            var _this5 = this;

            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            var params = _extends({}, this.state.filters);
            params.page = page;

            if (this.lastRequestCancel) {
                this.lastRequestCancel('Request was canceled');
                this.lastRequestCancel = null;
            }

            var CancelToken = _axios2.default.CancelToken;
            var source = CancelToken.source();
            this.lastRequestCancel = source.cancel.bind(source);

            return _api2.default.get(this.props.options.endpointUrl, {
                params: params,
                cancelToken: source.token,
                headers: this.props.options.customHeaders ? this.props.options.customHeaders : {}
            }).then(function (result) {
                _this5.lastRequestCancel = null;
                return result.data;
            }, function (error) {
                if (!_axios2.default.isCancel(error)) {
                    _this5.lastRequestCancel = null;
                }
                return Promise.reject(error);
            });
        }
    }, {
        key: 'getFiltersByLocation',
        value: function getFiltersByLocation(location) {
            var search = _urlHelper2.default.getSearchFromLocation(location);
            return this.getValidFilters(search);
        }
    }, {
        key: 'getValidFilters',
        value: function getValidFilters(filters) {
            var result = {};
            for (var i in filters) {
                if (i in this.props.defaultFilters) {
                    result[i] = filters[i];
                }
            }
            return result;
        }
    }, {
        key: 'onControlsTriggerClick',
        value: function onControlsTriggerClick() {
            var _this6 = this;

            if (!this.isControlsInProgress) {
                this.isControlsInProgress = true;

                if (!this.state.isControlsOpened) {
                    _contentBlocker2.default.block('listing-menu');
                    this.setState({ isControlsShowing: true }, function () {
                        setTimeout(function () {
                            _this6.setState({ isControlsOpened: true }, function () {
                                _this6.isControlsInProgress = false;
                            });
                        }, 0);
                    });
                } else {
                    this.closeControls();
                }
            }
        }
    }, {
        key: 'onControlsOverlayClick',
        value: function onControlsOverlayClick() {
            if (!this.isControlsInProgress && this.state.isControlsOpened) {
                this.closeControls();
            }
        }
    }, {
        key: 'closeControls',
        value: function closeControls() {
            var _this7 = this;

            _contentBlocker2.default.unblock('listing-menu');
            this.setState({ isControlsOpened: false }, function () {
                setTimeout(function () {
                    _this7.setState({ isControlsShowing: false }, function () {
                        _this7.isControlsInProgress = false;
                    });
                }, 500);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this8 = this;

            return _react2.default.createElement(
                'div',
                { ref: function ref(el) {
                        return _this8.element = el;
                    } },
                this.props.render({
                    isInitialRequestFulfilled: this.state.isInitialRequestFulfilled,
                    filters: this.state.filters,
                    items: this.state.items,
                    pagination: this.state.pagination,
                    onFiltersChange: this.onFiltersChange,
                    controls: {
                        isControlsOpened: this.state.isControlsOpened,
                        isControlsShowing: this.state.isControlsShowing,
                        onOverlayClick: this.onControlsOverlayClick
                    },
                    animateChange: this.animateChange
                }),
                _react2.default.createElement(_ListingLoadMore2.default, { onLoadMore: this.onLoadMore, pagination: this.state.pagination,
                    isLoadingMore: this.state.isLoadingMore }),
                _react2.default.createElement(_ListingControlsTrigger2.default, { onClick: this.onControlsTriggerClick,
                    isControlsOpened: this.state.isControlsOpened })
            );
        }
    }]);

    return Listing;
}(_react2.default.PureComponent);

exports.default = Listing;

/***/ }),

/***/ "./app/components/listing/js/ListingContentWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListingContentWrapper = function (_React$PureComponent) {
    _inherits(ListingContentWrapper, _React$PureComponent);

    function ListingContentWrapper() {
        _classCallCheck(this, ListingContentWrapper);

        return _possibleConstructorReturn(this, (ListingContentWrapper.__proto__ || Object.getPrototypeOf(ListingContentWrapper)).apply(this, arguments));
    }

    _createClass(ListingContentWrapper, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                this.props.isInitialRequestFulfilled && this.props.itemsCount === 0 ? _react2.default.createElement(
                    'div',
                    { className: 'listing__empty-result' },
                    _react2.default.createElement('div', { className: 'listing__empty-result-title',
                        dangerouslySetInnerHTML: { __html: this.props.emptyResult.title } }),
                    _react2.default.createElement('div', { className: 'listing__empty-result-message',
                        dangerouslySetInnerHTML: { __html: this.props.emptyResult.text } }),
                    this.props.emptyResult.button ? _react2.default.createElement(
                        'a',
                        { href: this.props.emptyResult.button.url, className: 'btn btn--green btn--m-full' },
                        _react2.default.createElement('span', { className: 'btn__wrap', dangerouslySetInnerHTML: { __html: this.props.emptyResult.button.text } })
                    ) : null
                ) : this.props.children
            );
        }
    }]);

    return ListingContentWrapper;
}(_react2.default.PureComponent);

exports.default = ListingContentWrapper;


ListingContentWrapper.defaultProps = {
    emptyResult: {
        title: 'no luck here!',
        text: '<p>i am afraid we don\'t have any items<p/><p>please try making your search a little wider</p>'
    }
};

/***/ }),

/***/ "./app/components/listing/js/ListingControlsTrigger.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListingControlsTrigger = function (_React$PureComponent) {
    _inherits(ListingControlsTrigger, _React$PureComponent);

    function ListingControlsTrigger() {
        _classCallCheck(this, ListingControlsTrigger);

        return _possibleConstructorReturn(this, (ListingControlsTrigger.__proto__ || Object.getPrototypeOf(ListingControlsTrigger)).apply(this, arguments));
    }

    _createClass(ListingControlsTrigger, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'listing__controls-trigger' },
                _react2.default.createElement(
                    'div',
                    { onClick: this.props.onClick, className: 'btn btn--grey btn--bordered listing__controls-trigger-btn' },
                    this.props.isControlsOpened ? _react2.default.createElement(
                        'svg',
                        { className: 'icon', width: '18', height: '18' },
                        _react2.default.createElement('use', { xlinkHref: '#icon-cross' })
                    ) : _react2.default.createElement(
                        'svg',
                        { width: '22', height: '18', className: 'icon' },
                        _react2.default.createElement('use', { xlinkHref: '#icon-refine' })
                    )
                )
            );
        }
    }]);

    return ListingControlsTrigger;
}(_react2.default.PureComponent);

exports.default = ListingControlsTrigger;

/***/ }),

/***/ "./app/components/listing/js/ListingControlsWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListingControlsWrapper = function (_React$PureComponent) {
    _inherits(ListingControlsWrapper, _React$PureComponent);

    function ListingControlsWrapper() {
        _classCallCheck(this, ListingControlsWrapper);

        return _possibleConstructorReturn(this, (ListingControlsWrapper.__proto__ || Object.getPrototypeOf(ListingControlsWrapper)).apply(this, arguments));
    }

    _createClass(ListingControlsWrapper, [{
        key: 'render',
        value: function render() {
            var _props$controls = this.props.controls,
                isControlsOpened = _props$controls.isControlsOpened,
                isControlsShowing = _props$controls.isControlsShowing,
                onOverlayClick = _props$controls.onOverlayClick;


            return _react2.default.createElement(
                'div',
                {
                    className: 'listing-controls lots-search__controls ' + (isControlsOpened ? 'is-shown' : '') + ' ' + (isControlsShowing ? 'is-showing' : '') },
                _react2.default.createElement('div', {
                    className: 'listing-controls__overlay',
                    onClick: onOverlayClick }),
                _react2.default.createElement(
                    'div',
                    { className: 'listing-controls__content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'listing-controls__container' },
                        this.props.children
                    )
                )
            );
        }
    }]);

    return ListingControlsWrapper;
}(_react2.default.PureComponent);

exports.default = ListingControlsWrapper;

/***/ }),

/***/ "./app/components/listing/js/ListingHeader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListingHeader = function (_React$PureComponent) {
    _inherits(ListingHeader, _React$PureComponent);

    function ListingHeader() {
        _classCallCheck(this, ListingHeader);

        return _possibleConstructorReturn(this, (ListingHeader.__proto__ || Object.getPrototypeOf(ListingHeader)).apply(this, arguments));
    }

    _createClass(ListingHeader, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { className: "listing__header" },
                _react2.default.createElement(
                    "div",
                    { className: "listing__header-inner" },
                    this.props.children
                )
            );
        }
    }]);

    return ListingHeader;
}(_react2.default.PureComponent);

exports.default = ListingHeader;

/***/ }),

/***/ "./app/components/listing/js/ListingLoadMore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _intersectionHelper = __webpack_require__("./app/general/js/intersection-helper.js");

var _intersectionHelper2 = _interopRequireDefault(_intersectionHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListingLoadMore = function (_React$PureComponent) {
    _inherits(ListingLoadMore, _React$PureComponent);

    function ListingLoadMore(props) {
        _classCallCheck(this, ListingLoadMore);

        var _this = _possibleConstructorReturn(this, (ListingLoadMore.__proto__ || Object.getPrototypeOf(ListingLoadMore)).call(this, props));

        _this.setLoadMoreElement = _this.setLoadMoreElement.bind(_this);
        _this.loadMore = _this.loadMore.bind(_this);
        return _this;
    }

    _createClass(ListingLoadMore, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {

            if (this.props.isLoadingMore) {
                return _react2.default.createElement(
                    'div',
                    { className: 'listing__load-more' },
                    _react2.default.createElement('div', { className: 'loading-gif' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'listing__load-more-caption' },
                        'loading more lots...'
                    )
                );
            } else {
                var shouldHandleLoadMore = this.props.pagination && this.props.pagination.currentPage < this.props.pagination.pageCount;

                if (shouldHandleLoadMore) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'listing__load-more', ref: this.setLoadMoreElement },
                        _react2.default.createElement(
                            'div',
                            { className: 'btn btn--blue', onClick: this.loadMore },
                            'load more'
                        )
                    );
                } else {
                    return '';
                }
            }
        }
    }, {
        key: 'setLoadMoreElement',
        value: function setLoadMoreElement(element) {
            if (this.observer) {
                this.observer.disconnect();
            }
            if (element) {
                this.observer = _intersectionHelper2.default.enterViewport(element, this.loadMore, {
                    rootMargin: '0px 0px 50% 0px'
                });
            }
        }
    }, {
        key: 'loadMore',
        value: function loadMore() {
            this.props.onLoadMore();
        }
    }]);

    return ListingLoadMore;
}(_react2.default.PureComponent);

exports.default = ListingLoadMore;

/***/ }),

/***/ "./app/components/listing/js/ListingPagesInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListingPagesInfo = function (_React$PureComponent) {
    _inherits(ListingPagesInfo, _React$PureComponent);

    function ListingPagesInfo() {
        _classCallCheck(this, ListingPagesInfo);

        return _possibleConstructorReturn(this, (ListingPagesInfo.__proto__ || Object.getPrototypeOf(ListingPagesInfo)).apply(this, arguments));
    }

    _createClass(ListingPagesInfo, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                null,
                'displaying ',
                this.props.itemsCount,
                ' of ',
                this.props.pagination.totalCount
            );
        }
    }]);

    return ListingPagesInfo;
}(_react2.default.PureComponent);

exports.default = ListingPagesInfo;

/***/ }),

/***/ "./app/components/listing/js/ListingSelect.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListingSelect = function (_React$PureComponent) {
    _inherits(ListingSelect, _React$PureComponent);

    function ListingSelect() {
        _classCallCheck(this, ListingSelect);

        var _this = _possibleConstructorReturn(this, (ListingSelect.__proto__ || Object.getPrototypeOf(ListingSelect)).apply(this, arguments));

        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(ListingSelect, [{
        key: 'onChange',
        value: function onChange(e) {
            this.props.onChange(_defineProperty({}, this.props.config.name, e.target.value));
        }
    }, {
        key: 'render',
        value: function render() {
            var config = this.props.config;
            return _react2.default.createElement(
                'div',
                { className: 'listing__filter' },
                _react2.default.createElement(
                    'div',
                    { className: 'select-label listing__select-label' },
                    config.label
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'select select--white select--small listing__control' },
                    _react2.default.createElement(
                        'select',
                        { value: this.props.value,
                            onChange: this.onChange,
                            className: 'select__control' },
                        config.options.map(function (option, index) {
                            return _react2.default.createElement(
                                'option',
                                { key: index, value: option.value },
                                option.label
                            );
                        })
                    ),
                    _react2.default.createElement(
                        'svg',
                        { className: 'select__arrow' },
                        _react2.default.createElement('use', { xlinkHref: '#icon-arrow-bottom' })
                    )
                )
            );
        }
    }]);

    return ListingSelect;
}(_react2.default.PureComponent);

exports.default = ListingSelect;

/***/ }),

/***/ "./app/components/listing/js/listing-helper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultFilters = getDefaultFilters;
function getDefaultFilters(filters) {
    return filters.reduce(function (defaultFilters, filterConfig) {
        var defaultItem = filterConfig.options.find(function (f) {
            return f.isDefault;
        });
        if (defaultItem) {
            defaultFilters[filterConfig.name] = defaultItem.value;
        } else {
            console.error("filter " + filterConfig.name + " doesn't have a default value. the filter will be ignored");
        }
        return defaultFilters;
    }, {});
}

/***/ }),

/***/ "./app/components/listing/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/lot-details/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/lot-details/scss/index.scss");

var _lotGallery = __webpack_require__("./app/components/lot-details/js/lot-gallery.component.js");

var _lotGallery2 = _interopRequireDefault(_lotGallery);

var _lotGalleryFullwidth = __webpack_require__("./app/components/lot-details/js/lot-gallery-fullwidth.component.js");

var _lotGalleryFullwidth2 = _interopRequireDefault(_lotGalleryFullwidth);

var _lotNavigation = __webpack_require__("./app/components/lot-details/js/lot-navigation.component.js");

var _lotNavigation2 = _interopRequireDefault(_lotNavigation);

var _lotDetailsListNavigation = __webpack_require__("./app/components/lot-details/js/lot-details-list-navigation.component.js");

var _lotDetailsListNavigation2 = _interopRequireDefault(_lotDetailsListNavigation);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('lot-gallery', _lotGallery2.default);
_componentsCollection2.default.getInstance().define('lot-gallery-fullwidth', _lotGalleryFullwidth2.default);
_componentsCollection2.default.getInstance().define('lot-navigation', _lotNavigation2.default);
_componentsCollection2.default.getInstance().define('lot-details-list-navigation', _lotDetailsListNavigation2.default);

/***/ }),

/***/ "./app/components/lot-details/js/lot-details-list-navigation.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _stickyfilljs = __webpack_require__("./node_modules/stickyfilljs/dist/stickyfill.js");

var _stickyfilljs2 = _interopRequireDefault(_stickyfilljs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotDetailsListNavigationComponent = function (_BaseComponent) {
    _inherits(LotDetailsListNavigationComponent, _BaseComponent);

    function LotDetailsListNavigationComponent() {
        _classCallCheck(this, LotDetailsListNavigationComponent);

        var _this = _possibleConstructorReturn(this, (LotDetailsListNavigationComponent.__proto__ || Object.getPrototypeOf(LotDetailsListNavigationComponent)).apply(this, arguments));

        _this.init();
        return _this;
    }

    _createClass(LotDetailsListNavigationComponent, [{
        key: 'init',
        value: function init() {
            _stickyfilljs2.default.add(this.element);
        }
    }]);

    return LotDetailsListNavigationComponent;
}(_baseComponent2.default);

exports.default = LotDetailsListNavigationComponent;

/***/ }),

/***/ "./app/components/lot-details/js/lot-gallery-fullwidth.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("./node_modules/slick-carousel/slick/slick.js");

__webpack_require__("./node_modules/slick-carousel/slick/slick.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).on('click', ".gfwol.is-clickable", function (e) {
	e.preventDefault();

	(0, _jquery2.default)(".lot-gallery-fullwidth-container").html("");

	(0, _jquery2.default)(".lot-gallery-fullwidth-container").append('<div class="lot-gallery-fullwidth"><div class="lot-gallery-fullwidth-carousel"></div></div><div class="galleryFullwidthClose"><div class="gfwc"></div></div>');

	(0, _jquery2.default)(".lot-gallery-fullwidth-carousel").append((0, _jquery2.default)(".lot-gallery-fw").html());

	var currentSlide = (0, _jquery2.default)(".lot-details__gallery-carousel .slick-current").data("slick-index");

	(0, _jquery2.default)(".lot-gallery-fullwidth-carousel").slick({
		arrows: true,
		fade: true,
		prevArrow: '<button type="button" data-role="none" class="slick-prev slick-nav-button" aria-label="Previous" tabindex="0" role="button"><div class="gfwal"></div></button>',
		nextArrow: '<button type="button" data-role="none" class="slick-next slick-nav-button" aria-label="Next" tabindex="0" role="button"><div class="gfwar"></div></button>',
		initialSlide: currentSlide
	});
});

(0, _jquery2.default)(document).on('click', ".galleryFullwidthClose", function () {
	(0, _jquery2.default)(".lot-gallery-fullwidth-container").html("");
});

/***/ }),

/***/ "./app/components/lot-details/js/lot-gallery.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("./node_modules/slick-carousel/slick/slick.js");

__webpack_require__("./node_modules/slick-carousel/slick/slick.css");

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _styleObserver = __webpack_require__("./app/general/js/style-observer.js");

var _styleObserver2 = _interopRequireDefault(_styleObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotGalleryComponent = function (_BaseComponent) {
    _inherits(LotGalleryComponent, _BaseComponent);

    function LotGalleryComponent() {
        _classCallCheck(this, LotGalleryComponent);

        var _this = _possibleConstructorReturn(this, (LotGalleryComponent.__proto__ || Object.getPrototypeOf(LotGalleryComponent)).apply(this, arguments));

        _this.carouselElement = _this.refs.carousel;
        _this.navElement = _this.refs.nav;
        _this.currentElement = _this.refs.current;
        _this.totalElement = _this.refs.total;

        (0, _styleObserver2.default)(function () {
            _this.init();
        });
        return _this;
    }

    _createClass(LotGalleryComponent, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            this.$carouselElement = (0, _jquery2.default)(this.carouselElement);

            this.$carouselElement.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                appendArrows: this.navElement,
                prevArrow: '<button type="button" class="lot-gallery__arrow lot-gallery__arrow--prev">\n                            <svg width="7" height="13" class="icon">\n                                <use xlink:href="#icon-arrow-left"></use>\n                            </svg>\n                        </button>',
                nextArrow: '<button type="button" class="lot-gallery__arrow lot-gallery__arrow--next">\n                            <svg width="7" height="13" class="icon">\n                                <use xlink:href="#icon-arrow-right"></use>\n                            </svg>\n                        </button>'
            });

            var slick = this.$carouselElement.slick('getSlick');
            this.totalElement.textContent = slick.slideCount;
            this.$carouselElement.on('afterChange', function (e, instance, currentSlideIndex) {
                _this2.currentElement.textContent = currentSlideIndex + 1;
            });
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.$carouselElement.slick('unslick');
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['carousel', 'nav', 'current', 'total'];
        }
    }]);

    return LotGalleryComponent;
}(_baseComponent2.default);

exports.default = LotGalleryComponent;

/***/ }),

/***/ "./app/components/lot-details/js/lot-navigation.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _contentBlocker = __webpack_require__("./app/general/js/content-blocker.js");

var _contentBlocker2 = _interopRequireDefault(_contentBlocker);

var _eventBus = __webpack_require__("./app/general/js/event-bus.js");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _app = __webpack_require__("./app/general/js/app.js");

var _stickyfilljs = __webpack_require__("./node_modules/stickyfilljs/dist/stickyfill.js");

var _stickyfilljs2 = _interopRequireDefault(_stickyfilljs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotNavigationComponent = function (_BaseComponent) {
    _inherits(LotNavigationComponent, _BaseComponent);

    function LotNavigationComponent() {
        _classCallCheck(this, LotNavigationComponent);

        var _this = _possibleConstructorReturn(this, (LotNavigationComponent.__proto__ || Object.getPrototypeOf(LotNavigationComponent)).apply(this, arguments));

        _this.isOpened = false;

        _this.menu = _this.refs.menu;
        _this.menuTrigger = _this.refs.menuTrigger;
        _this.overlay = _this.refs.overlay;

        _this.onMenuTriggerClick = _this.onMenuTriggerClick.bind(_this);
        _this.onLinkClick = _this.onLinkClick.bind(_this);
        _this.onOverlayClick = _this.onOverlayClick.bind(_this);

        _this.init();

        _eventBus2.default.addListener(_app.EVENT_DEVICE_TYPE_CHANGED, _this.onDeviceTypeChanged.bind(_this));
        return _this;
    }

    _createClass(LotNavigationComponent, [{
        key: 'onDeviceTypeChanged',
        value: function onDeviceTypeChanged(oldType, newType) {
            //switch from tablet/mobile to desktop
            //we have to close menu
            if (newType == _app.DEVICE_TYPE_DESKTOP) {
                this.closeMenu();
            }
        }
    }, {
        key: 'init',
        value: function init() {
            var _this2 = this;

            var links = [].concat(_toConsumableArray(this.element.querySelectorAll('a')));
            links.forEach(function (link) {
                link.addEventListener('click', _this2.onLinkClick);
            });

            this.menuTrigger.addEventListener('click', this.onMenuTriggerClick);
            this.overlay.addEventListener('click', this.onOverlayClick);
            _stickyfilljs2.default.add(this.element);
        }
    }, {
        key: 'onOverlayClick',
        value: function onOverlayClick(e) {
            this.closeMenu();
        }
    }, {
        key: 'onMenuTriggerClick',
        value: function onMenuTriggerClick() {
            if (!this.isOpened) {
                this.openMenu();
            } else {
                this.closeMenu();
            }
        }
    }, {
        key: 'openMenu',
        value: function openMenu() {
            var _this3 = this;

            this.isOpened = true;
            this.element.classList.add('is-showing');
            setTimeout(function () {
                if (_this3.isOpened) {
                    _this3.element.classList.add('is-shown');
                }
            }, 0);
            _contentBlocker2.default.block('lot-nav');
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            var _this4 = this;

            this.isOpened = false;
            this.element.classList.remove('is-shown');
            _contentBlocker2.default.unblock('lot-nav');
            setTimeout(function () {
                if (!_this4.isOpened) {
                    _this4.element.classList.remove('is-showing');
                }
            }, 500);
        }
    }, {
        key: 'onLinkClick',
        value: function onLinkClick(e) {

            var link = e.target;
            var target = link.getAttribute('href');

            if (target.indexOf('#') === 0) {
                e.preventDefault();
                var targetElement = document.querySelector(target);

                if (targetElement) {
                    this.closeMenu();
                    (0, _jquery2.default)("html, body").stop().animate({ scrollTop: (0, _jquery2.default)(targetElement).offset().top - (0, _jquery2.default)('.header').outerHeight() - (0, _jquery2.default)(this.element).outerHeight() }, 500);
                }
            }
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['menu', 'menuTrigger', 'overlay'];
        }
    }]);

    return LotNavigationComponent;
}(_baseComponent2.default);

exports.default = LotNavigationComponent;

/***/ }),

/***/ "./app/components/lot-details/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/lot-item/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/lot-item/scss/index.scss");

var _lotItem = __webpack_require__("./app/components/lot-item/js/lot-item.component.js");

var _lotItem2 = _interopRequireDefault(_lotItem);

var _lotInfo = __webpack_require__("./app/components/lot-item/js/lot-info.component.js");

var _lotInfo2 = _interopRequireDefault(_lotInfo);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('lot-item', _lotItem2.default);
_componentsCollection2.default.getInstance().define('lot-info', _lotInfo2.default);

/***/ }),

/***/ "./app/components/lot-item/js/LotInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _lot = __webpack_require__("./app/general/js/lot.js");

var _lot2 = _interopRequireDefault(_lot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotInfo = function (_React$PureComponent) {
    _inherits(LotInfo, _React$PureComponent);

    function LotInfo() {
        _classCallCheck(this, LotInfo);

        return _possibleConstructorReturn(this, (LotInfo.__proto__ || Object.getPrototypeOf(LotInfo)).apply(this, arguments));
    }

    _createClass(LotInfo, [{
        key: 'getStatusMod',
        value: function getStatusMod(name) {
            var stringId = _lot2.default.getStatusStringId(name);
            if (stringId !== null) {
                return 'lot-info__status--' + stringId;
            }
            return '';
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'div',
                { className: 'lot-info' },
                this.props.lotNumber ? _react2.default.createElement(
                    'div',
                    { className: 'lot-info__name' },
                    'Lot ',
                    this.props.lotNumber
                ) : null,
                this.props.statusLabel ? _react2.default.createElement('div', {
                    className: 'lot-info__status ' + this.getStatusMod(this.props.statusName), dangerouslySetInnerHTML: { __html: this.props.statusLabel } }) : null
            );
        }
    }]);

    return LotInfo;
}(_react2.default.PureComponent);

exports.default = LotInfo;

/***/ }),

/***/ "./app/components/lot-item/js/LotItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _LotFavoritesButton = __webpack_require__("./app/components/favorites-button/js/LotFavoritesButton.js");

var _LotFavoritesButton2 = _interopRequireDefault(_LotFavoritesButton);

var _LotItemMedia = __webpack_require__("./app/components/lot-item/js/LotItemMedia.js");

var _LotItemMedia2 = _interopRequireDefault(_LotItemMedia);

var _LotInfo = __webpack_require__("./app/components/lot-item/js/LotInfo.js");

var _LotInfo2 = _interopRequireDefault(_LotInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotItem = function (_React$PureComponent) {
    _inherits(LotItem, _React$PureComponent);

    function LotItem() {
        _classCallCheck(this, LotItem);

        return _possibleConstructorReturn(this, (LotItem.__proto__ || Object.getPrototypeOf(LotItem)).apply(this, arguments));
    }

    _createClass(LotItem, [{
        key: 'render',
        value: function render() {

            var item = this.props.item;

            return _react2.default.createElement(
                'div',
                { className: 'lot-item' },
                _react2.default.createElement(
                    'div',
                    { className: 'lot-item__header' },
                    _react2.default.createElement(_LotItemMedia2.default, { image: item.image, url: item.url }),
                    _react2.default.createElement(_LotInfo2.default, { lotNumber: item.lotNumber, statusLabel: item.statusLabel, statusName: item.statusName })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'lot-item__content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'lot-item__info' },
                        _react2.default.createElement(
                            'div',
                            { className: 'lot-item__auction-date' },
                            'auction date ',
                            _react2.default.createElement('span', {
                                dangerouslySetInnerHTML: { __html: item.auctionDate } })
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: item.url },
                            _react2.default.createElement(
                                'div',
                                { className: 'lot-item__address' },
                                item.addressLine1
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'lot-item__location' },
                                item.addressLine2
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'lot-item__description' },
                            item.description
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'lot-item__footer' },
                        _react2.default.createElement(
                            'div',
                            { className: 'lot-item__price' },
                            _react2.default.createElement(
                                'div',
                                { className: 'lot-item__price-descriptor' },
                                item.priceDescriptor,
                                item.showPriceAsterix === true ? _react2.default.createElement(
                                    'span',
                                    { className: 'disclaimer-mark' },
                                    '*'
                                ) : null
                            ),
                            _react2.default.createElement(
                                'strong',
                                null,
                                item.price,
                                item.showFees === true ? _react2.default.createElement(
                                    'span',
                                    { className: 'disclaimer-mark disclaimer-mark--plus-fees' },
                                    '**'
                                ) : null
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'lot-item__favorites-button' },
                            _react2.default.createElement(_LotFavoritesButton2.default, { button: item.saveButton })
                        )
                    )
                )
            );
        }
    }]);

    return LotItem;
}(_react2.default.PureComponent);

exports.default = LotItem;

/***/ }),

/***/ "./app/components/lot-item/js/LotItemMedia.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotItemMedia = function (_React$PureComponent) {
    _inherits(LotItemMedia, _React$PureComponent);

    function LotItemMedia() {
        _classCallCheck(this, LotItemMedia);

        return _possibleConstructorReturn(this, (LotItemMedia.__proto__ || Object.getPrototypeOf(LotItemMedia)).apply(this, arguments));
    }

    _createClass(LotItemMedia, [{
        key: 'render',
        value: function render() {
            var mainImageSrcSet = this.props.image;

            return _react2.default.createElement(
                'div',
                { className: 'lot-item__media' },
                _react2.default.createElement(
                    'div',
                    { className: 'lot-item__img' },
                    mainImageSrcSet ? _react2.default.createElement('img', { 'data-srcset': mainImageSrcSet, 'data-sizes': 'auto',
                        className: 'lazyload', alt: '' }) : null,
                    _react2.default.createElement('a', { href: this.props.url })
                )
            );
        }
    }]);

    return LotItemMedia;
}(_react2.default.PureComponent);

exports.default = LotItemMedia;

/***/ }),

/***/ "./app/components/lot-item/js/lot-info.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _LotInfo = __webpack_require__("./app/components/lot-item/js/LotInfo.js");

var _LotInfo2 = _interopRequireDefault(_LotInfo);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotItemComponent = function (_BaseComponent) {
    _inherits(LotItemComponent, _BaseComponent);

    function LotItemComponent() {
        _classCallCheck(this, LotItemComponent);

        var _this = _possibleConstructorReturn(this, (LotItemComponent.__proto__ || Object.getPrototypeOf(LotItemComponent)).apply(this, arguments));

        _this.lotNumber = _this.element.getAttribute('data-lot-number');
        _this.statusLabel = _this.element.getAttribute('data-status-label');
        _this.statusName = _this.element.getAttribute('data-status-name');

        _this.init();
        return _this;
    }

    _createClass(LotItemComponent, [{
        key: 'init',
        value: function init() {
            _reactDom2.default.render(_react2.default.createElement(_LotInfo2.default, { lotNumber: this.lotNumber, statusLabel: this.statusLabel,
                statusName: this.statusName }), this.element);
        }
    }]);

    return LotItemComponent;
}(_baseComponent2.default);

exports.default = LotItemComponent;

/***/ }),

/***/ "./app/components/lot-item/js/lot-item.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _LotItem = __webpack_require__("./app/components/lot-item/js/LotItem.js");

var _LotItem2 = _interopRequireDefault(_LotItem);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotItemComponent = function (_BaseComponent) {
    _inherits(LotItemComponent, _BaseComponent);

    function LotItemComponent() {
        _classCallCheck(this, LotItemComponent);

        var _this = _possibleConstructorReturn(this, (LotItemComponent.__proto__ || Object.getPrototypeOf(LotItemComponent)).apply(this, arguments));

        _this.item = _this.options.item;
        _this.init();
        return _this;
    }

    _createClass(LotItemComponent, [{
        key: 'init',
        value: function init() {
            _reactDom2.default.render(_react2.default.createElement(_LotItem2.default, { item: this.item }), this.element);
        }
    }]);

    return LotItemComponent;
}(_baseComponent2.default);

exports.default = LotItemComponent;

/***/ }),

/***/ "./app/components/lot-item/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/lots-carousel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/lots-carousel/scss/index.scss");

var _lotsCarousel = __webpack_require__("./app/components/lots-carousel/js/lots-carousel.component.js");

var _lotsCarousel2 = _interopRequireDefault(_lotsCarousel);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('lots-carousel', _lotsCarousel2.default);

/***/ }),

/***/ "./app/components/lots-carousel/js/lots-carousel.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _styleObserver = __webpack_require__("./app/general/js/style-observer.js");

var _styleObserver2 = _interopRequireDefault(_styleObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotsCarouselComponent = function (_BaseComponent) {
    _inherits(LotsCarouselComponent, _BaseComponent);

    function LotsCarouselComponent() {
        _classCallCheck(this, LotsCarouselComponent);

        var _this = _possibleConstructorReturn(this, (LotsCarouselComponent.__proto__ || Object.getPrototypeOf(LotsCarouselComponent)).apply(this, arguments));

        _this.$element = (0, _jquery2.default)(_this.element);
        _this.defaultOptions = {
            loop: false,
            dots: false,
            nav: true,
            margin: 29,
            navText: ['<svg class="icon" width="10" height="20"><use xlink:href="#icon-arrow-left"></use></svg>', '<svg class="icon" width="10" height="20"><use xlink:href="#icon-arrow-right"></use></svg>'],
            responsive: {
                0: {
                    items: 1
                },
                520: {
                    items: 2
                },
                769: {
                    items: 3
                },
                1025: {
                    items: 4
                }
            }
        };

        (0, _styleObserver2.default)(function () {
            _this.init();
        });
        return _this;
    }

    _createClass(LotsCarouselComponent, [{
        key: 'init',
        value: function init() {
            var options = _extends({}, this.defaultOptions, this.options);
            this.$element.owlCarousel(options);
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.$element.owlCarousel('destroy');
        }
    }]);

    return LotsCarouselComponent;
}(_baseComponent2.default);

exports.default = LotsCarouselComponent;

/***/ }),

/***/ "./app/components/lots-carousel/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/lots-search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/lots-search/scss/index.scss");

var _lotsSearch = __webpack_require__("./app/components/lots-search/js/lots-search.component.js");

var _lotsSearch2 = _interopRequireDefault(_lotsSearch);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('lots-search', _lotsSearch2.default);

/***/ }),

/***/ "./app/components/lots-search/js/LotSearchContent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _LotSearchItem = __webpack_require__("./app/components/lots-search/js/LotSearchItem.js");

var _LotSearchItem2 = _interopRequireDefault(_LotSearchItem);

var _LotSearchInfo = __webpack_require__("./app/components/lots-search/js/LotSearchInfo.js");

var _LotSearchInfo2 = _interopRequireDefault(_LotSearchInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotSearchContent = function (_React$PureComponent) {
    _inherits(LotSearchContent, _React$PureComponent);

    function LotSearchContent() {
        _classCallCheck(this, LotSearchContent);

        return _possibleConstructorReturn(this, (LotSearchContent.__proto__ || Object.getPrototypeOf(LotSearchContent)).apply(this, arguments));
    }

    _createClass(LotSearchContent, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                {
                    className: "listing-items listing__items " + (this.props.isGridView ? 'is-grid grid grid--12' : '') },
                this.props.items.map(function (item) {
                    return _react2.default.createElement(_LotSearchItem2.default, { item: item, key: item.id });
                })
            );
        }
    }]);

    return LotSearchContent;
}(_react2.default.PureComponent);

exports.default = LotSearchContent;

/***/ }),

/***/ "./app/components/lots-search/js/LotSearchControls.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VIEW_TYPE_LIST = exports.VIEW_TYPE_GRID = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _PredictiveSearch = __webpack_require__("./app/components/predictive-search/js/PredictiveSearch.js");

var _PredictiveSearch2 = _interopRequireDefault(_PredictiveSearch);

var _ListingSelect = __webpack_require__("./app/components/listing/js/ListingSelect.js");

var _ListingSelect2 = _interopRequireDefault(_ListingSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VIEW_TYPE_GRID = exports.VIEW_TYPE_GRID = "1";
var VIEW_TYPE_LIST = exports.VIEW_TYPE_LIST = "2";

var LotSearchControls = function (_React$PureComponent) {
    _inherits(LotSearchControls, _React$PureComponent);

    function LotSearchControls(props) {
        _classCallCheck(this, LotSearchControls);

        var _this = _possibleConstructorReturn(this, (LotSearchControls.__proto__ || Object.getPrototypeOf(LotSearchControls)).call(this, props));

        _this.onViewTypeChange = _this.onViewTypeChange.bind(_this);
        return _this;
    }

    _createClass(LotSearchControls, [{
        key: 'onViewTypeChange',
        value: function onViewTypeChange(e) {
            this.props.onViewTypeChange(e.target.value);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'listing-controls__content-inner' },
                this.props.options.showPredictive ? _react2.default.createElement(
                    'div',
                    { className: 'lots-search__text-search' },
                    _react2.default.createElement(_PredictiveSearch2.default, { inputClass: 'input input--white',
                        isListing: true,
                        query: this.props.filters.content,
                        queryType: this.props.filters.type,
                        onChange: this.props.onPredictiveSearchChange })
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'listing-controls__right' },
                    this.props.options.filters.map(function (filterConfig) {
                        return _react2.default.createElement(_ListingSelect2.default, {
                            key: filterConfig.name,
                            config: filterConfig,
                            value: _this2.props.filters[filterConfig.name],
                            onChange: _this2.props.onFiltersChange });
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'listing__view-type' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-buttons' },
                            _react2.default.createElement(
                                'label',
                                { className: 'radio-buttons__item' },
                                _react2.default.createElement('input', { className: 'radio-buttons__input',
                                    type: 'radio', value: VIEW_TYPE_GRID,
                                    checked: this.props.viewType === VIEW_TYPE_GRID,
                                    onChange: this.onViewTypeChange }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'radio-buttons__placeholder' },
                                    _react2.default.createElement(
                                        'svg',
                                        { className: 'radio-buttons__icon' },
                                        _react2.default.createElement('use', { xlinkHref: '#icon-grid' })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'label',
                                { className: 'radio-buttons__item' },
                                _react2.default.createElement('input', { className: 'radio-buttons__input',
                                    type: 'radio', value: VIEW_TYPE_LIST,
                                    checked: this.props.viewType === VIEW_TYPE_LIST,
                                    onChange: this.onViewTypeChange }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'radio-buttons__placeholder' },
                                    _react2.default.createElement(
                                        'svg',
                                        { className: 'radio-buttons__icon' },
                                        _react2.default.createElement('use', { xlinkHref: '#icon-list' })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return LotSearchControls;
}(_react2.default.PureComponent);

exports.default = LotSearchControls;


LotSearchControls.defaultProps = {
    options: {
        showPredictive: true,
        //filters config
        filters: []
    }
};

/***/ }),

/***/ "./app/components/lots-search/js/LotSearchInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _ListingPagesInfo = __webpack_require__("./app/components/listing/js/ListingPagesInfo.js");

var _ListingPagesInfo2 = _interopRequireDefault(_ListingPagesInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var searchTypesLabels = {
    LotNumber: 'lot number',
    Postcode: 'postcode',
    County: 'country',
    Town: 'town',
    Address: 'address'
};

var LotSearchInfo = function (_React$PureComponent) {
    _inherits(LotSearchInfo, _React$PureComponent);

    function LotSearchInfo() {
        _classCallCheck(this, LotSearchInfo);

        return _possibleConstructorReturn(this, (LotSearchInfo.__proto__ || Object.getPrototypeOf(LotSearchInfo)).apply(this, arguments));
    }

    _createClass(LotSearchInfo, [{
        key: "getLabelByType",
        value: function getLabelByType(type) {
            return type in searchTypesLabels ? searchTypesLabels[type] : null;
        }
    }, {
        key: "renderQueryType",
        value: function renderQueryType() {
            if (this.props.queryType) {
                var label = this.getLabelByType(this.props.queryType);
                if (label) {
                    return _react2.default.createElement(
                        "span",
                        { className: "lots-search__query-type" },
                        "(search by: ",
                        label,
                        _react2.default.createElement(
                            "button",
                            { onClick: this.props.onQueryTypeClear,
                                className: "lots-search__query-type-clear-button",
                                type: "button",
                                title: "Search by everything" },
                            _react2.default.createElement(
                                "svg",
                                { className: "icon", width: "10", height: "10" },
                                _react2.default.createElement("use", { xlinkHref: "#icon-cross" })
                            )
                        ),
                        ")"
                    );
                }
            }
            return null;
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { className: "lots-search__info" },
                this.props.query ? _react2.default.createElement(
                    "span",
                    { className: "lots-search__query-info" },
                    "results for",
                    _react2.default.createElement(
                        "span",
                        { className: "lots-search__query-text" },
                        " ",
                        this.props.query
                    ),
                    this.renderQueryType(),
                    ","
                ) : null,
                _react2.default.createElement(_ListingPagesInfo2.default, { itemsCount: this.props.items.length, pagination: this.props.pagination })
            );
        }
    }]);

    return LotSearchInfo;
}(_react2.default.PureComponent);

exports.default = LotSearchInfo;

/***/ }),

/***/ "./app/components/lots-search/js/LotSearchItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _LotItem = __webpack_require__("./app/components/lot-item/js/LotItem.js");

var _LotItem2 = _interopRequireDefault(_LotItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotSearchItem = function (_React$PureComponent) {
    _inherits(LotSearchItem, _React$PureComponent);

    function LotSearchItem() {
        _classCallCheck(this, LotSearchItem);

        return _possibleConstructorReturn(this, (LotSearchItem.__proto__ || Object.getPrototypeOf(LotSearchItem)).apply(this, arguments));
    }

    _createClass(LotSearchItem, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    className: 'listing__item grid__item grid__item--span-mobile-ls-6 grid__item--span-tablet-4 grid__item--span-desktop-3' },
                _react2.default.createElement(_LotItem2.default, { item: this.props.item })
            );
        }
    }]);

    return LotSearchItem;
}(_react2.default.PureComponent);

exports.default = LotSearchItem;

/***/ }),

/***/ "./app/components/lots-search/js/LotsSearch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _LotSearchControls = __webpack_require__("./app/components/lots-search/js/LotSearchControls.js");

var _LotSearchControls2 = _interopRequireDefault(_LotSearchControls);

var _LotSearchContent = __webpack_require__("./app/components/lots-search/js/LotSearchContent.js");

var _LotSearchContent2 = _interopRequireDefault(_LotSearchContent);

var _ListingHeader = __webpack_require__("./app/components/listing/js/ListingHeader.js");

var _ListingHeader2 = _interopRequireDefault(_ListingHeader);

var _ListingContentWrapper = __webpack_require__("./app/components/listing/js/ListingContentWrapper.js");

var _ListingContentWrapper2 = _interopRequireDefault(_ListingContentWrapper);

var _LotSearchInfo = __webpack_require__("./app/components/lots-search/js/LotSearchInfo.js");

var _LotSearchInfo2 = _interopRequireDefault(_LotSearchInfo);

var _Listing = __webpack_require__("./app/components/listing/js/Listing.js");

var _Listing2 = _interopRequireDefault(_Listing);

var _listingHelper = __webpack_require__("./app/components/listing/js/listing-helper.js");

var _ListingControlsWrapper = __webpack_require__("./app/components/listing/js/ListingControlsWrapper.js");

var _ListingControlsWrapper2 = _interopRequireDefault(_ListingControlsWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VIEW_TYPE_STORAGE_KEY = 'lostSearchViewType';

var isGridView = function isGridView(viewType) {
    return viewType === _LotSearchControls.VIEW_TYPE_GRID;
};

var LotsSearch = function (_React$PureComponent) {
    _inherits(LotsSearch, _React$PureComponent);

    function LotsSearch(props) {
        _classCallCheck(this, LotsSearch);

        var _this = _possibleConstructorReturn(this, (LotsSearch.__proto__ || Object.getPrototypeOf(LotsSearch)).call(this, props));

        var viewType = localStorage.getItem(VIEW_TYPE_STORAGE_KEY) || _LotSearchControls.VIEW_TYPE_GRID;
        _this.state = {
            viewType: viewType,
            isGridView: isGridView(viewType)
        };

        _this.onViewTypeChange = _this.onViewTypeChange.bind(_this);

        _this.defaultFilters = _extends({
            content: '',
            type: ''
        }, (0, _listingHelper.getDefaultFilters)(props.options.filters));
        return _this;
    }

    _createClass(LotsSearch, [{
        key: 'onViewTypeChange',
        value: function onViewTypeChange(currentViewType, animateChange) {
            var _this2 = this;

            localStorage.setItem(VIEW_TYPE_STORAGE_KEY, currentViewType);
            animateChange(function () {
                _this2.setState({
                    viewType: currentViewType,
                    isGridView: isGridView(currentViewType)
                });
            });
        }
    }, {
        key: 'onQueryTypeClear',
        value: function onQueryTypeClear(onFiltersChange) {
            onFiltersChange({ type: '' });
        }
    }, {
        key: 'onPredictiveSearchChange',
        value: function onPredictiveSearchChange(search, onFiltersChange) {
            onFiltersChange({
                content: search.query,
                type: search.queryType
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(_Listing2.default, { options: this.props.options, defaultFilters: this.defaultFilters,
                render: function render(_ref) {
                    var isInitialRequestFulfilled = _ref.isInitialRequestFulfilled,
                        onFiltersChange = _ref.onFiltersChange,
                        controls = _ref.controls,
                        filters = _ref.filters,
                        items = _ref.items,
                        pagination = _ref.pagination,
                        animateChange = _ref.animateChange;
                    return _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _ListingHeader2.default,
                            null,
                            _this3.props.options.title ? _react2.default.createElement('div', { className: 'lots-search__title',
                                dangerouslySetInnerHTML: { __html: _this3.props.options.title } }) : null,
                            _react2.default.createElement(
                                _ListingControlsWrapper2.default,
                                { controls: controls },
                                _react2.default.createElement(_LotSearchControls2.default, { options: _this3.props.options,
                                    filters: filters,
                                    onFiltersChange: onFiltersChange,
                                    onPredictiveSearchChange: function onPredictiveSearchChange(search) {
                                        return _this3.onPredictiveSearchChange(search, onFiltersChange);
                                    },
                                    onViewTypeChange: function onViewTypeChange(currentViewType) {
                                        return _this3.onViewTypeChange(currentViewType, animateChange);
                                    },
                                    viewType: _this3.state.viewType })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'listing__content' },
                            _react2.default.createElement(
                                'div',
                                { className: 'container' },
                                _react2.default.createElement(_LotSearchInfo2.default, { items: items,
                                    pagination: pagination,
                                    query: filters.content,
                                    queryType: filters.type,
                                    onQueryTypeClear: function onQueryTypeClear() {
                                        return _this3.onQueryTypeClear(onFiltersChange);
                                    } }),
                                _react2.default.createElement(
                                    _ListingContentWrapper2.default,
                                    { isInitialRequestFulfilled: isInitialRequestFulfilled,
                                        itemsCount: items.length,
                                        emptyResult: _this3.props.options.emptyResult },
                                    _react2.default.createElement(_LotSearchContent2.default, { items: items,
                                        isGridView: _this3.state.isGridView })
                                )
                            )
                        )
                    );
                } });
        }
    }]);

    return LotsSearch;
}(_react2.default.PureComponent);

exports.default = LotsSearch;

/***/ }),

/***/ "./app/components/lots-search/js/lots-search.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _LotsSearch = __webpack_require__("./app/components/lots-search/js/LotsSearch.js");

var _LotsSearch2 = _interopRequireDefault(_LotsSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LotsSearchComponent = function (_BaseComponent) {
    _inherits(LotsSearchComponent, _BaseComponent);

    function LotsSearchComponent() {
        _classCallCheck(this, LotsSearchComponent);

        var _this = _possibleConstructorReturn(this, (LotsSearchComponent.__proto__ || Object.getPrototypeOf(LotsSearchComponent)).apply(this, arguments));

        if (!_this.options.endpointUrl) {
            throw new Error('endpointUrl should be passed via options');
        }

        var _this$options = _this.options,
            _this$options$title = _this$options.title,
            title = _this$options$title === undefined ? null : _this$options$title,
            _this$options$showPre = _this$options.showPredictive,
            showPredictive = _this$options$showPre === undefined ? true : _this$options$showPre;

        _this.lotSearchOptions = _extends({}, _this.options, { title: title, showPredictive: showPredictive });
        _this.init();
        return _this;
    }

    _createClass(LotsSearchComponent, [{
        key: 'init',
        value: function init() {
            _reactDom2.default.render(_react2.default.createElement(_LotsSearch2.default, { options: this.lotSearchOptions }), this.element);
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            _reactDom2.default.unmountComponentAtNode(this.element);
        }
    }]);

    return LotsSearchComponent;
}(_baseComponent2.default);

exports.default = LotsSearchComponent;

/***/ }),

/***/ "./app/components/lots-search/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/modal-form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/modal-form/scss/index.scss");

/***/ }),

/***/ "./app/components/modal-form/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/modal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/modal/scss/index.scss");

var _modalTrigger = __webpack_require__("./app/components/modal/js/modal-trigger.component.js");

var _modalTrigger2 = _interopRequireDefault(_modalTrigger);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('modal-trigger', _modalTrigger2.default);

/***/ }),

/***/ "./app/components/modal/js/modal-trigger.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = __webpack_require__("./app/general/js/modal.js");

var _modal2 = _interopRequireDefault(_modal);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _gtm = __webpack_require__("./app/general/js/gtm.js");

var _gtm2 = _interopRequireDefault(_gtm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalTriggerComponent = function (_BaseComponent) {
    _inherits(ModalTriggerComponent, _BaseComponent);

    function ModalTriggerComponent() {
        _classCallCheck(this, ModalTriggerComponent);

        var _this = _possibleConstructorReturn(this, (ModalTriggerComponent.__proto__ || Object.getPrototypeOf(ModalTriggerComponent)).apply(this, arguments));

        _this.targetFromChildren = _this.refs.target;
        _this.targetSelector = _this.element.dataset.target;
        _this.modalTarget = null;
        _this.modal = null;
        _this.gtmEvent = undefined;

        _this.modalTarget = _this.getFromChildren();
        if (!_this.modalTarget) {
            _this.modalTarget = _this.getFromTarget();
        }

        if (!_this.modalTarget) {
            throw new Error('modal target is not defined');
        }

        _this.onClick = _this.onClick.bind(_this);

        _this.init();
        return _this;
    }

    _createClass(ModalTriggerComponent, [{
        key: 'init',
        value: function init() {
            this.element.addEventListener('click', this.onClick);
        }
    }, {
        key: 'getFromTarget',
        value: function getFromTarget() {
            return document.querySelector(this.targetSelector);
        }
    }, {
        key: 'getFromChildren',
        value: function getFromChildren() {
            return this.targetFromChildren;
        }
    }, {
        key: 'onClick',
        value: function onClick(e) {
            e.preventDefault();
            if (this.modal === null) {
                this.modal = _modal2.default.create(this.modalTarget);
            }

            var gtmEvent = this.getGtmEvent();
            if (gtmEvent) {
                _gtm2.default.push(gtmEvent);
            }
            this.modal.open();
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.element.removeEventListener('click', this.onClick);
            this.modal = null;
        }
    }, {
        key: 'getGtmEvent',
        value: function getGtmEvent() {
            if (this.gtmEvent === undefined) {
                var result = null;
                var gtmObject = this.modalTarget.getAttribute('data-gtm-event');
                if (gtmObject) {
                    try {
                        result = JSON.parse(gtmObject);
                    } catch (err) {
                        console.error('Unable to parse data-gtm-event on element:', this.modalTarget);
                    }
                }

                this.gtmEvent = result;
            }

            return this.gtmEvent;
        }
    }]);

    return ModalTriggerComponent;
}(_baseComponent2.default);

exports.default = ModalTriggerComponent;

/***/ }),

/***/ "./app/components/modal/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/news-article-item/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/news-article-item/scss/index.scss");

var _newsArticleItem = __webpack_require__("./app/components/news-article-item/js/news-article-item.component.js");

var _newsArticleItem2 = _interopRequireDefault(_newsArticleItem);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('news-article-item', _newsArticleItem2.default);

/***/ }),

/***/ "./app/components/news-article-item/js/NewsArticleItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var imageFocus = ['image-position-center', 'image-position-left', 'image-position-top', 'image-position-right', 'image-position-bottom'];

var NewsArticleItem = function (_React$PureComponent) {
    _inherits(NewsArticleItem, _React$PureComponent);

    function NewsArticleItem() {
        _classCallCheck(this, NewsArticleItem);

        return _possibleConstructorReturn(this, (NewsArticleItem.__proto__ || Object.getPrototypeOf(NewsArticleItem)).apply(this, arguments));
    }

    _createClass(NewsArticleItem, [{
        key: 'render',
        value: function render() {
            var item = this.props.item;

            return _react2.default.createElement(
                'div',
                { className: 'card' },
                _react2.default.createElement(
                    'div',
                    { className: 'card__img news-article-item__img' },
                    _react2.default.createElement('img', { 'data-srcset': item.image.srcSet, 'data-sizes': 'auto',
                        className: 'lazyload ' + imageFocus[item.image.imageFocus], alt: item.title }),
                    _react2.default.createElement('a', { href: item.url })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card__content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'card__title' },
                        _react2.default.createElement(
                            'a',
                            { href: item.url },
                            item.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'card__text' },
                        item.summary
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'card__bottom' },
                        _react2.default.createElement(
                            'a',
                            { className: 'link card__link', href: item.url },
                            'read more',
                            _react2.default.createElement(
                                'svg',
                                { width: '5', height: '9', className: 'icon icon--after' },
                                _react2.default.createElement('use', { xlinkHref: '#icon-arrow-right' })
                            )
                        ),
                        _react2.default.createElement('div', { className: 'news-article-item__date', dangerouslySetInnerHTML: { __html: item.datePublished } })
                    )
                )
            );
        }
    }]);

    return NewsArticleItem;
}(_react2.default.PureComponent);

exports.default = NewsArticleItem;

/***/ }),

/***/ "./app/components/news-article-item/js/news-article-item.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _NewsArticleItem = __webpack_require__("./app/components/news-article-item/js/NewsArticleItem.js");

var _NewsArticleItem2 = _interopRequireDefault(_NewsArticleItem);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsArticleItemComponent = function (_BaseComponent) {
    _inherits(NewsArticleItemComponent, _BaseComponent);

    function NewsArticleItemComponent() {
        _classCallCheck(this, NewsArticleItemComponent);

        var _this = _possibleConstructorReturn(this, (NewsArticleItemComponent.__proto__ || Object.getPrototypeOf(NewsArticleItemComponent)).apply(this, arguments));

        _this.item = _this.options.item;
        _this.init();
        return _this;
    }

    _createClass(NewsArticleItemComponent, [{
        key: 'init',
        value: function init() {
            _reactDom2.default.render(_react2.default.createElement(_NewsArticleItem2.default, { item: this.item }), this.element);
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            _reactDom2.default.unmountComponentAtNode(this.element);
        }
    }]);

    return NewsArticleItemComponent;
}(_baseComponent2.default);

exports.default = NewsArticleItemComponent;

/***/ }),

/***/ "./app/components/news-article-item/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/news-article/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/news-article/scss/index.scss");

/***/ }),

/***/ "./app/components/news-article/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/news-search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/news-search/scss/index.scss");

var _newsSearch = __webpack_require__("./app/components/news-search/js/news-search.component.js");

var _newsSearch2 = _interopRequireDefault(_newsSearch);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('news-search', _newsSearch2.default);

/***/ }),

/***/ "./app/components/news-search/js/NewsSearch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _NewsSearchControls = __webpack_require__("./app/components/news-search/js/NewsSearchControls.js");

var _NewsSearchControls2 = _interopRequireDefault(_NewsSearchControls);

var _NewsSearchContent = __webpack_require__("./app/components/news-search/js/NewsSearchContent.js");

var _NewsSearchContent2 = _interopRequireDefault(_NewsSearchContent);

var _Listing = __webpack_require__("./app/components/listing/js/Listing.js");

var _Listing2 = _interopRequireDefault(_Listing);

var _ListingPagesInfo = __webpack_require__("./app/components/listing/js/ListingPagesInfo.js");

var _ListingPagesInfo2 = _interopRequireDefault(_ListingPagesInfo);

var _ListingHeader = __webpack_require__("./app/components/listing/js/ListingHeader.js");

var _ListingHeader2 = _interopRequireDefault(_ListingHeader);

var _ListingContentWrapper = __webpack_require__("./app/components/listing/js/ListingContentWrapper.js");

var _ListingContentWrapper2 = _interopRequireDefault(_ListingContentWrapper);

var _listingHelper = __webpack_require__("./app/components/listing/js/listing-helper.js");

var _ListingControlsWrapper = __webpack_require__("./app/components/listing/js/ListingControlsWrapper.js");

var _ListingControlsWrapper2 = _interopRequireDefault(_ListingControlsWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsSearch = function (_React$PureComponent) {
    _inherits(NewsSearch, _React$PureComponent);

    function NewsSearch(props) {
        _classCallCheck(this, NewsSearch);

        var _this = _possibleConstructorReturn(this, (NewsSearch.__proto__ || Object.getPrototypeOf(NewsSearch)).call(this, props));

        _this.emptyResultMessage = 'I am afraid we don\'t have any news.\nPlease try making your search a little wider.';

        _this.defaultFilters = (0, _listingHelper.getDefaultFilters)(props.options.filters);
        return _this;
    }

    _createClass(NewsSearch, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(_Listing2.default, { options: this.props.options, defaultFilters: this.defaultFilters,
                render: function render(_ref) {
                    var isInitialRequestFulfilled = _ref.isInitialRequestFulfilled,
                        onFiltersChange = _ref.onFiltersChange,
                        controls = _ref.controls,
                        filters = _ref.filters,
                        items = _ref.items,
                        pagination = _ref.pagination;
                    return _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _ListingHeader2.default,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'news-search__pages-info' },
                                _react2.default.createElement(_ListingPagesInfo2.default, { itemsCount: items.length,
                                    pagination: pagination })
                            ),
                            _react2.default.createElement(
                                _ListingControlsWrapper2.default,
                                { controls: controls },
                                _react2.default.createElement(_NewsSearchControls2.default, { onFiltersChange: onFiltersChange,
                                    filters: filters,
                                    options: _this2.props.options })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'listing__content' },
                            _react2.default.createElement(
                                'div',
                                { className: 'container' },
                                _react2.default.createElement(
                                    _ListingContentWrapper2.default,
                                    { emptyResultMessage: _this2.emptyResultMessage,
                                        isInitialRequestFulfilled: isInitialRequestFulfilled,
                                        itemsCount: items.length },
                                    _react2.default.createElement(_NewsSearchContent2.default, { items: items })
                                )
                            )
                        )
                    );
                } });
        }
    }]);

    return NewsSearch;
}(_react2.default.PureComponent);

exports.default = NewsSearch;

/***/ }),

/***/ "./app/components/news-search/js/NewsSearchContent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _NewsSearchItem = __webpack_require__("./app/components/news-search/js/NewsSearchItem.js");

var _NewsSearchItem2 = _interopRequireDefault(_NewsSearchItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsSearchContent = function (_React$PureComponent) {
    _inherits(NewsSearchContent, _React$PureComponent);

    function NewsSearchContent() {
        _classCallCheck(this, NewsSearchContent);

        return _possibleConstructorReturn(this, (NewsSearchContent.__proto__ || Object.getPrototypeOf(NewsSearchContent)).apply(this, arguments));
    }

    _createClass(NewsSearchContent, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    className: 'listing-items is-grid listing__items grid grid--12' },
                this.props.items.map(function (item) {
                    return _react2.default.createElement(_NewsSearchItem2.default, { item: item, key: item.id });
                })
            );
        }
    }]);

    return NewsSearchContent;
}(_react2.default.PureComponent);

exports.default = NewsSearchContent;

/***/ }),

/***/ "./app/components/news-search/js/NewsSearchControls.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _ListingSelect = __webpack_require__("./app/components/listing/js/ListingSelect.js");

var _ListingSelect2 = _interopRequireDefault(_ListingSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsSearchControls = function (_React$PureComponent) {
    _inherits(NewsSearchControls, _React$PureComponent);

    function NewsSearchControls() {
        _classCallCheck(this, NewsSearchControls);

        return _possibleConstructorReturn(this, (NewsSearchControls.__proto__ || Object.getPrototypeOf(NewsSearchControls)).apply(this, arguments));
    }

    _createClass(NewsSearchControls, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'listing-controls__content-inner' },
                _react2.default.createElement(
                    'div',
                    { className: 'listing-controls__right' },
                    this.props.options.filters.map(function (filterConfig) {
                        return _react2.default.createElement(_ListingSelect2.default, {
                            key: filterConfig.name,
                            config: filterConfig,
                            value: _this2.props.filters[filterConfig.name],
                            onChange: _this2.props.onFiltersChange });
                    })
                )
            );
        }
    }]);

    return NewsSearchControls;
}(_react2.default.PureComponent);

exports.default = NewsSearchControls;


NewsSearchControls.defaultProps = {
    options: {
        //filters config
        filters: []
    }
};

/***/ }),

/***/ "./app/components/news-search/js/NewsSearchItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _NewsArticleItem = __webpack_require__("./app/components/news-article-item/js/NewsArticleItem.js");

var _NewsArticleItem2 = _interopRequireDefault(_NewsArticleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsSearchItem = function (_React$PureComponent) {
    _inherits(NewsSearchItem, _React$PureComponent);

    function NewsSearchItem() {
        _classCallCheck(this, NewsSearchItem);

        return _possibleConstructorReturn(this, (NewsSearchItem.__proto__ || Object.getPrototypeOf(NewsSearchItem)).apply(this, arguments));
    }

    _createClass(NewsSearchItem, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    className: 'listing__item listing__item--grid grid__item grid__item--span-tablet-6 grid__item--span-desktop-4' },
                _react2.default.createElement(_NewsArticleItem2.default, this.props)
            );
        }
    }]);

    return NewsSearchItem;
}(_react2.default.PureComponent);

exports.default = NewsSearchItem;

/***/ }),

/***/ "./app/components/news-search/js/news-search.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _NewsSearch = __webpack_require__("./app/components/news-search/js/NewsSearch.js");

var _NewsSearch2 = _interopRequireDefault(_NewsSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsSearchComponent = function (_BaseComponent) {
    _inherits(NewsSearchComponent, _BaseComponent);

    function NewsSearchComponent() {
        _classCallCheck(this, NewsSearchComponent);

        var _this = _possibleConstructorReturn(this, (NewsSearchComponent.__proto__ || Object.getPrototypeOf(NewsSearchComponent)).apply(this, arguments));

        if (!_this.options.endpointUrl) {
            throw new Error('endpointUrl should be passed via options');
        }

        _this.newsSearchOptions = _this.options;
        _this.init();
        return _this;
    }

    _createClass(NewsSearchComponent, [{
        key: 'init',
        value: function init() {
            _reactDom2.default.render(_react2.default.createElement(_NewsSearch2.default, { options: this.newsSearchOptions }), this.element);
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            _reactDom2.default.unmountComponentAtNode(this.element);
        }
    }]);

    return NewsSearchComponent;
}(_baseComponent2.default);

exports.default = NewsSearchComponent;

/***/ }),

/***/ "./app/components/news-search/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/next-auction-panel/html/template.hbs":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("./node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "        <div class=\"next-auction-panel-date__item\">\r\n            <div class=\"next-auction-panel-date__number flip-number flip-number--next-auction\">\r\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.digits : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            </div>\r\n            <div class=\"next-auction-panel-date__label\">"
    + container.escapeExpression(((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"label","hash":{},"data":data}) : helper)))
    + "</div>\r\n        </div>\r\n"
    + ((stack1 = helpers.unless.call(alias1,(data && data.last),{"name":"unless","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "                    <div class=\"flip-number__digit\">"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "</div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "            <div class=\"next-auction-panel-date__separator\">:</div>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"next-auction-panel-date\">\r\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.items : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\r\n";
},"useData":true});

/***/ }),

/***/ "./app/components/next-auction-panel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/next-auction-panel/scss/index.scss");

var _actionCountdown = __webpack_require__("./app/components/next-auction-panel/js/action-countdown.component.js");

var _actionCountdown2 = _interopRequireDefault(_actionCountdown);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('next-auction-countdown', _actionCountdown2.default);

/***/ }),

/***/ "./app/components/next-auction-panel/js/action-countdown.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("./node_modules/jquery-countdown/dist/jquery.countdown.js");

var _template = __webpack_require__("./app/components/next-auction-panel/html/template.hbs");

var _template2 = _interopRequireDefault(_template);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActionCountdownComponent = function (_BaseComponent) {
    _inherits(ActionCountdownComponent, _BaseComponent);

    function ActionCountdownComponent() {
        _classCallCheck(this, ActionCountdownComponent);

        var _this = _possibleConstructorReturn(this, (ActionCountdownComponent.__proto__ || Object.getPrototypeOf(ActionCountdownComponent)).apply(this, arguments));

        var auctionDate = _this.element.dataset.auctionDate;
        if (!auctionDate) {
            throw new Error('auctionDate is required');
        }

        _this.$element = (0, _jquery2.default)(_this.element);
        _this.auctionDate = new Date(auctionDate);
        _this.init();
        return _this;
    }

    _createClass(ActionCountdownComponent, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            //initial render
            var lastString = null;
            var initialItems = ['00', '00', '00'];
            this.render(this.getData(initialItems));

            var delimiter = ':';
            this.$element.countdown(this.auctionDate, function (event) {
                if (event.type === 'update') {
                    var newDateString = event.strftime('%D' + delimiter + '%H' + delimiter + '%M');
                    if (newDateString !== lastString) {
                        var items = newDateString.split(delimiter);
                        _this2.render(_this2.getData(items));
                        lastString = newDateString;
                    }
                }
            });
        }
    }, {
        key: 'render',
        value: function render(data) {
            this.element.innerHTML = '';
            this.element.insertAdjacentHTML('afterBegin', (0, _template2.default)(data));
        }
    }, {
        key: 'getData',
        value: function getData(items) {
            var labels = ['days', 'hours', 'minutes'];
            var resultItems = items.map(function (value, i) {
                return {
                    digits: value.split(''),
                    label: labels[i]
                };
            });
            return {
                items: resultItems
            };
        }
    }]);

    return ActionCountdownComponent;
}(_baseComponent2.default);

exports.default = ActionCountdownComponent;

/***/ }),

/***/ "./app/components/next-auction-panel/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/notifications/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/notifications/scss/index.scss");

var _notifications = __webpack_require__("./app/components/notifications/js/notifications.component.js");

var _notifications2 = _interopRequireDefault(_notifications);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('notifications', _notifications2.default);

/***/ }),

/***/ "./app/components/notifications/js/NotificationItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _htmlHelper = __webpack_require__("./app/general/js/html-helper.js");

var _htmlHelper2 = _interopRequireDefault(_htmlHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NOTIFICATION_TYPE_PROPERTY = 'Property';
var NOTIFICATION_TYPE_INFO = 'Info';

var NotificationItem = function (_React$PureComponent) {
    _inherits(NotificationItem, _React$PureComponent);

    function NotificationItem(props) {
        _classCallCheck(this, NotificationItem);

        var _this = _possibleConstructorReturn(this, (NotificationItem.__proto__ || Object.getPrototypeOf(NotificationItem)).call(this, props));

        _this.onCloseClick = _this.onCloseClick.bind(_this);
        return _this;
    }

    _createClass(NotificationItem, [{
        key: 'onCloseClick',
        value: function onCloseClick(e) {
            this.props.onClose(this.props.item);
        }
    }, {
        key: 'getClass',
        value: function getClass() {
            var result = 'notification--info';
            switch (this.props.item.type) {
                case NOTIFICATION_TYPE_PROPERTY:
                    result = 'notification--property';
                    break;
                case NOTIFICATION_TYPE_INFO:
                    result = 'notification--info';
                    break;
            }

            return result;
        }
    }, {
        key: 'render',
        value: function render() {
            var item = this.props.item;
            return _react2.default.createElement(
                'div',
                { className: 'toast notification ' + this.getClass(), 'aria-live': 'polite' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'notification__close-btn toast-close-button', role: 'button', onClick: this.onCloseClick },
                    '\xD7'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'notification__container' },
                    item.imgUrl ? _react2.default.createElement(
                        'div',
                        { className: 'notification__img' },
                        _react2.default.createElement('img', { 'data-srcset': _htmlHelper2.default.getSrcSet(item.imgUrl), 'data-sizes': 'auto',
                            className: 'lazyload', alt: '' })
                    ) : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'notification__content' },
                        _react2.default.createElement('div', { className: 'toast-title', dangerouslySetInnerHTML: { __html: item.title } }),
                        _react2.default.createElement('div', { className: 'toast-message', dangerouslySetInnerHTML: { __html: item.text } })
                    )
                )
            );
        }
    }]);

    return NotificationItem;
}(_react2.default.PureComponent);

exports.default = NotificationItem;

/***/ }),

/***/ "./app/components/notifications/js/NotificationsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _signalr = __webpack_require__("./app/general/js/signalr.js");

var _signalr2 = _interopRequireDefault(_signalr);

var _NotificationItem = __webpack_require__("./app/components/notifications/js/NotificationItem.js");

var _NotificationItem2 = _interopRequireDefault(_NotificationItem);

var _reactAddonsCssTransitionGroup = __webpack_require__("./node_modules/react-addons-css-transition-group/index.js");

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotificationsList = function (_React$PureComponent) {
    _inherits(NotificationsList, _React$PureComponent);

    function NotificationsList(props) {
        _classCallCheck(this, NotificationsList);

        var _this = _possibleConstructorReturn(this, (NotificationsList.__proto__ || Object.getPrototypeOf(NotificationsList)).call(this, props));

        _this.state = {
            allNotifications: [],
            notifications: []
        };

        _this.unsubscribe = null;
        _this.onNotificationsUpdate = _this.onNotificationsUpdate.bind(_this);
        _this.onNotificationClose = _this.onNotificationClose.bind(_this);
        return _this;
    }

    _createClass(NotificationsList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.hub = _signalr2.default.getHub(this.props.hubName);
            this.unsubscribe = this.hub.subscribe('notify', this.onNotificationsUpdate);
            _signalr2.default.connect().then(function () {
                _this2.hub.invoke('getAllNotifications').then(_this2.onNotificationsUpdate);
            });
        }
    }, {
        key: 'onNotificationsUpdate',
        value: function onNotificationsUpdate(items) {
            this.updateNotifications(items);
        }
    }, {
        key: 'onNotificationClose',
        value: function onNotificationClose(closedItem) {
            var _this3 = this;

            this.hub.invoke('closeNotification', closedItem.id).then(function () {
                var newNotifications = _this3.state.allNotifications.filter(function (item) {
                    return item !== closedItem;
                });
                _this3.updateNotifications(newNotifications);
            });
        }
    }, {
        key: 'updateNotifications',
        value: function updateNotifications(items) {
            var length = items.length;
            var start = Math.max(length - this.props.maxCount, 0);
            var notifications = items.slice(start, length);

            this.setState({
                allNotifications: items,
                notifications: notifications
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (!this.unsubscribe) {
                this.unsubscribe();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var items = this.state.notifications;

            return _react2.default.createElement(
                _reactAddonsCssTransitionGroup2.default,
                {
                    component: 'div',
                    className: 'toast-bottom-right toast-container notifications-list',
                    transitionName: 'notification',
                    transitionEnterTimeout: 300,
                    transitionLeaveTimeout: 300 },
                items.map(function (item) {
                    return _react2.default.createElement(_NotificationItem2.default, { onClose: _this4.onNotificationClose, key: item.id, item: item });
                })
            );
        }
    }]);

    return NotificationsList;
}(_react2.default.PureComponent);

exports.default = NotificationsList;

/***/ }),

/***/ "./app/components/notifications/js/notifications.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _NotificationsList = __webpack_require__("./app/components/notifications/js/NotificationsList.js");

var _NotificationsList2 = _interopRequireDefault(_NotificationsList);

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotificationsComponent = function (_BaseComponent) {
    _inherits(NotificationsComponent, _BaseComponent);

    function NotificationsComponent() {
        _classCallCheck(this, NotificationsComponent);

        var _this = _possibleConstructorReturn(this, (NotificationsComponent.__proto__ || Object.getPrototypeOf(NotificationsComponent)).apply(this, arguments));

        _this.maxCount = _this.options.maxCount || 5;
        _this.maxTabletCount = _this.options.maxTabletCount || 3;
        _this.hubName = _this.options.hubName;

        if (!_app2.default.isDesktop) {
            _this.maxCount = _this.maxTabletCount;
        }

        _this.init();
        return _this;
    }

    _createClass(NotificationsComponent, [{
        key: 'init',
        value: function init() {
            _reactDom2.default.render(_react2.default.createElement(_NotificationsList2.default, { maxCount: this.maxCount, hubName: this.hubName }), this.element);
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            _reactDom2.default.unmountComponentAtNode(this.element);
        }
    }]);

    return NotificationsComponent;
}(_baseComponent2.default);

exports.default = NotificationsComponent;

/***/ }),

/***/ "./app/components/notifications/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/offer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/offer/scss/index.scss");

var _offer = __webpack_require__("./app/components/offer/js/offer.component.js");

var _offer2 = _interopRequireDefault(_offer);

var _offerForm = __webpack_require__("./app/components/offer/js/offer-form.component.js");

var _offerForm2 = _interopRequireDefault(_offerForm);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('offer', _offer2.default);

_componentsCollection2.default.getInstance().define('offer-form', _offerForm2.default);

/***/ }),

/***/ "./app/components/offer/js/offer-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _popupResultForm = __webpack_require__("./app/components/form/js/popup-result-form.component.js");

var _popupResultForm2 = _interopRequireDefault(_popupResultForm);

var _createEvent = __webpack_require__("./app/general/js/create-event.js");

var _createEvent2 = _interopRequireDefault(_createEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OfferFormComponent = function (_PopupResultFormCompo) {
    _inherits(OfferFormComponent, _PopupResultFormCompo);

    function OfferFormComponent() {
        _classCallCheck(this, OfferFormComponent);

        var _this = _possibleConstructorReturn(this, (OfferFormComponent.__proto__ || Object.getPrototypeOf(OfferFormComponent)).apply(this, arguments));

        _this.checkbox = _this.refs.checkbox;
        _this.initCheckbox();
        return _this;
    }

    _createClass(OfferFormComponent, [{
        key: 'initCheckbox',
        value: function initCheckbox() {
            var _this2 = this;

            if (typeof this.checkbox != 'undefined') {
                this.checkbox.addEventListener('change', function () {
                    if (_this2.checkbox.checked) {
                        _this2.element.querySelector('button').classList.remove('is-disabled');
                    } else {
                        _this2.element.querySelector('button').classList.add('is-disabled');
                    }
                });
            }
        }
    }, {
        key: 'onAfterReset',
        value: function onAfterReset() {
            this.checkbox.dispatchEvent((0, _createEvent2.default)('change'));
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['checkbox'];
        }
    }]);

    return OfferFormComponent;
}(_popupResultForm2.default);

exports.default = OfferFormComponent;

/***/ }),

/***/ "./app/components/offer/js/offer.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OfferComponent = function (_BaseComponent) {
    _inherits(OfferComponent, _BaseComponent);

    function OfferComponent() {
        _classCallCheck(this, OfferComponent);

        var _this = _possibleConstructorReturn(this, (OfferComponent.__proto__ || Object.getPrototypeOf(OfferComponent)).apply(this, arguments));

        _this.openLink = _this.refs.openLink;
        _this.offerForm = _this.refs.offerForm;

        _this.init();
        return _this;
    }

    _createClass(OfferComponent, [{
        key: 'init',
        value: function init() {
            if (this.openLink && this.offerForm) {
                this.openLink.addEventListener('click', this.open.bind(this));
            }
        }
    }, {
        key: 'open',
        value: function open(e) {
            var _this2 = this;

            e.preventDefault();

            if (!this.offerForm.classList.contains('is-opened')) {
                (0, _jquery2.default)(this.offerForm).slideDown(400, function () {
                    _this2.offerForm.classList.add('is-opened');
                });
            }

            this.offerForm.getElementsByTagName('INPUT')[0].focus();
        }
    }]);

    return OfferComponent;
}(_baseComponent2.default);

exports.default = OfferComponent;

/***/ }),

/***/ "./app/components/offer/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/owl-carousel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/owl-carousel/scss/index.scss");

/***/ }),

/***/ "./app/components/owl-carousel/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/page-spinner/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/page-spinner/scss/index.scss");

/***/ }),

/***/ "./app/components/page-spinner/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/page-switch-tabs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/page-switch-tabs/scss/index.scss");

var _pageSwitchTabs = __webpack_require__("./app/components/page-switch-tabs/js/page-switch-tabs.component.js");

var _pageSwitchTabs2 = _interopRequireDefault(_pageSwitchTabs);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('page-switch-tabs', _pageSwitchTabs2.default);

/***/ }),

/***/ "./app/components/page-switch-tabs/js/page-switch-tabs.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _radioSwitch = __webpack_require__("./app/components/radio-switch/js/radio-switch.component.js");

var _radioSwitch2 = _interopRequireDefault(_radioSwitch);

var _TimelineLite = __webpack_require__("./node_modules/gsap/TimelineLite.js");

var _TimelineLite2 = _interopRequireDefault(_TimelineLite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageSwitchTabsComponent = function (_BaseComponent) {
    _inherits(PageSwitchTabsComponent, _BaseComponent);

    function PageSwitchTabsComponent() {
        _classCallCheck(this, PageSwitchTabsComponent);

        var _this = _possibleConstructorReturn(this, (PageSwitchTabsComponent.__proto__ || Object.getPrototypeOf(PageSwitchTabsComponent)).apply(this, arguments));

        _this.tabs = _this.refs.tabs;

        _this.onSwitch = _this.onSwitch.bind(_this);
        _this.currentTab = null;
        _this.inProgress = false;

        _this.init();
        return _this;
    }

    _createClass(PageSwitchTabsComponent, [{
        key: 'init',
        value: function init() {
            this.switcherElement = document.getElementById('page-switcher');
            if (this.switcherElement) {
                this.radioSwitcher = new _radioSwitch2.default(this.switcherElement, {
                    id: 'page-switcher',
                    props: {
                        onSwitch: this.onSwitch
                    }
                });

                this.activate(this.radioSwitcher.getValue());
            }
        }
    }, {
        key: 'onSwitch',
        value: function onSwitch(e) {
            if (!this.inProgress) {
                this.activate(e.target.value);
            } else {
                this.newTabOpenedKey = e.target.value;
            }
        }
    }, {
        key: 'activate',
        value: function activate(key) {
            var _this2 = this;

            if (key in this.tabs) {
                this.inProgress = true;
                var newTab = this.tabs[key];
                if (this.currentTab === null || this.currentTab !== newTab) {
                    this.hideCurrentTab().then(function () {
                        //if a new tab had been activated during hiding process
                        //we activate it instead of newTab
                        if (_this2.newTabOpenedKey) {
                            var newKey = _this2.newTabOpenedKey;
                            _this2.newTabOpenedKey = null;
                            _this2.currentTab = null;
                            _this2.activate(newKey);
                        } else {
                            _this2.showTab(newTab);
                            _this2.currentTab = newTab;
                            _this2.inProgress = false;
                        }
                    });
                }
            }
        }
    }, {
        key: 'hideCurrentTab',
        value: function hideCurrentTab() {
            var _this3 = this;

            if (this.currentTab) {
                this.currentTab.classList.remove('is-visible');
                return new Promise(function (resolve) {
                    setTimeout(function () {
                        _this3.currentTab.classList.remove('is-active');
                        resolve();
                    }, 400);
                });
            }
            return Promise.resolve();
        }
    }, {
        key: 'showTab',
        value: function showTab(tab) {
            new _TimelineLite2.default().staggerFrom(tab.querySelectorAll('.bidding-card'), 0.3, {
                y: '30px',
                ease: Power4.easeOut
            }, 0.1);

            tab.classList.add('is-active');
            tab.classList.add('is-visible');
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['tabs'];
        }
    }]);

    return PageSwitchTabsComponent;
}(_baseComponent2.default);

exports.default = PageSwitchTabsComponent;

/***/ }),

/***/ "./app/components/page-switch-tabs/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/predictive-search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/predictive-search/scss/index.scss");

/***/ }),

/***/ "./app/components/predictive-search/js/PredictiveSearch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("./node_modules/devbridge-autocomplete/dist/jquery.autocomplete.js");

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

var _api = __webpack_require__("./app/general/js/api.js");

var _api2 = _interopRequireDefault(_api);

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PredictiveSearch = function (_React$PureComponent) {
    _inherits(PredictiveSearch, _React$PureComponent);

    function PredictiveSearch(props) {
        _classCallCheck(this, PredictiveSearch);

        var _this = _possibleConstructorReturn(this, (PredictiveSearch.__proto__ || Object.getPrototypeOf(PredictiveSearch)).call(this, props));

        _this.state = {
            query: '',
            queryType: ''
        };
        _this.isBindedToProps = 'query' in props;
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.handleContentChange = _this.handleContentChange.bind(_this);
        _this.inputRef = _this.inputRef.bind(_this);
        _this.formRef = _this.formRef.bind(_this);

        _this.baseElement = null;
        _this.inputElement = null;
        _this.lastRequestCancel = null;
        _this.predictiveSearchUrl = _app2.default.getConfig('predictiveSearchUrl');
        _this.maxToShow = _app2.default.getConfig('predictiveSearchMaxItemsToShow');
        _this.moreSuggestionsAvailableClass = 'more-suggestions-available';

        return _this;
    }

    _createClass(PredictiveSearch, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.$inputElement = (0, _jquery2.default)(this.inputElement);

            this.autocompleteInstance = this.$inputElement.devbridgeAutocomplete({
                groupBy: 'group',
                minChars: 3,
                deferRequestBy: 300,
                zIndex: 30,
                appendTo: this.baseElement,
                showNoSuggestionNotice: true,
                noSuggestionNotice: 'No results found!',
                triggerSelectOnValidInput: false,
                lookup: function lookup(query, done) {

                    if (_this2.lastRequestCancel) {
                        _this2.lastRequestCancel();
                        _this2.lastRequestCancel = null;
                    }

                    var CancelToken = _axios2.default.CancelToken;
                    var source = CancelToken.source();
                    _this2.lastRequestCancel = source.cancel.bind(source);

                    _this2.spinnerElement.classList.add('is-loading');
                    _api2.default.get(_this2.predictiveSearchUrl, {
                        params: { input: query },
                        cancelToken: source.token
                    }).then(function (_ref) {
                        var data = _ref.data;

                        if (data.total > _this2.maxToShow) {
                            _this2.baseElement.classList.add(_this2.moreSuggestionsAvailableClass);
                        } else {
                            _this2.baseElement.classList.remove(_this2.moreSuggestionsAvailableClass);
                        }
                        done({ suggestions: data.results });
                    }, function (error) {
                        if (_axios2.default.isCancel(error)) {
                            console.log('Request canceled', error.message);
                        } else {
                            console.error(error);
                        }
                    }).finally(function () {
                        _this2.lastRequestCancel = null;
                        _this2.spinnerElement.classList.remove('is-loading');
                    });
                },
                onSelect: function onSelect(suggestion) {
                    _this2.handlePredictiveSelect(suggestion);
                }
            }).devbridgeAutocomplete();
            this.autocompleteInstance.suggestionsContainer.setAttribute('data-max-to-show', this.maxToShow);

            if (this.isBindedToProps) {
                this.setState({
                    query: this.props.query,
                    queryType: this.props.queryType
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.autocompleteInstance.dispose();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.isBindedToProps) {
                this.setState({
                    query: nextProps.query,
                    queryType: nextProps.queryType
                });
            }
        }
    }, {
        key: 'formRef',
        value: function formRef(el) {
            if (el) {
                this.baseElement = el.parentElement;
            }
        }
    }, {
        key: 'inputRef',
        value: function inputRef(el) {
            this.inputElement = el;
            if (this.props.inputRef) {
                this.props.inputRef(el);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'form',
                { ref: this.formRef,
                    className: 'predictive-search ' + (this.props.isListing ? 'predictive-search--listing' : ''),
                    onSubmit: this.onSubmit },
                _react2.default.createElement('input', { onChange: this.handleContentChange, value: this.state.query,
                    ref: this.inputRef,
                    placeholder: 'lot no, postcode, address...',
                    className: 'predictive-search__input ' + this.props.inputClass, type: 'text' }),
                _react2.default.createElement('input', { type: 'hidden', value: this.state.queryType }),
                _react2.default.createElement('div', { className: 'predictive-search__spinner spinner', ref: function ref(el) {
                        return _this3.spinnerElement = el;
                    } }),
                this.props.isListing ? _react2.default.createElement(
                    'button',
                    { type: 'submit', className: 'predictive-search__submit' },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                            'svg',
                            { className: 'icon', width: '14', height: '14' },
                            _react2.default.createElement('use', { xlinkHref: '#icon-search' })
                        )
                    )
                ) : null
            );
        }
    }, {
        key: 'handleContentChange',
        value: function handleContentChange(e) {
            var value = e.target.value;
            this.setState({
                query: value,
                queryType: ''
            });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            this.handleSubmit(this.state.query, this.state.queryType);
        }
    }, {
        key: 'handlePredictiveSelect',
        value: function handlePredictiveSelect(suggestion) {
            if (suggestion.data.url) {
                window.location.href = suggestion.data.url;
            } else {
                this.handleSubmit(suggestion.value, suggestion.data.type);
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(query, queryType) {
            this.props.onChange({
                query: query,
                queryType: queryType
            });
        }
    }]);

    return PredictiveSearch;
}(_react2.default.PureComponent);

exports.default = PredictiveSearch;


PredictiveSearch.defaultProps = {
    inputClass: '',
    isListing: false
};

/***/ }),

/***/ "./app/components/predictive-search/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/profile/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/profile/scss/index.scss");

/***/ }),

/***/ "./app/components/profile/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/promo/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/promo/scss/index.scss");

/***/ }),

/***/ "./app/components/promo/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/quotes-carousel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/quotes-carousel/scss/index.scss");

var _quotesCarousel = __webpack_require__("./app/components/quotes-carousel/js/quotes-carousel.component.js");

var _quotesCarousel2 = _interopRequireDefault(_quotesCarousel);

var _quotesBorder = __webpack_require__("./app/components/quotes-carousel/js/quotes-border.component.js");

var _quotesBorder2 = _interopRequireDefault(_quotesBorder);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('quotes-carousel', _quotesCarousel2.default);

_componentsCollection2.default.getInstance().define('quotes-border', _quotesBorder2.default);

/***/ }),

/***/ "./app/components/quotes-carousel/js/quotes-border.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _intersectionHelper = __webpack_require__("./app/general/js/intersection-helper.js");

var _intersectionHelper2 = _interopRequireDefault(_intersectionHelper);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _styleObserver = __webpack_require__("./app/general/js/style-observer.js");

var _styleObserver2 = _interopRequireDefault(_styleObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuotesBorderComponent = function (_BaseComponent) {
    _inherits(QuotesBorderComponent, _BaseComponent);

    function QuotesBorderComponent() {
        _classCallCheck(this, QuotesBorderComponent);

        var _this = _possibleConstructorReturn(this, (QuotesBorderComponent.__proto__ || Object.getPrototypeOf(QuotesBorderComponent)).apply(this, arguments));

        (0, _styleObserver2.default)(function () {
            _intersectionHelper2.default.enterViewportOnce(_this.element, _this.animate.bind(_this), {
                threshold: 0.5
            });
        });

        document.addEventListener('buyingSelling:switch', _this.animate.bind(_this));
        return _this;
    }

    _createClass(QuotesBorderComponent, [{
        key: 'animate',
        value: function animate() {
            var path = this.element.querySelector('path');
            var length = path.getTotalLength();

            // Clear any previous transition
            path.style.transition = path.style.WebkitTransition = 'none';

            // Set up the starting positions
            path.style.strokeDasharray = length + ' ' + length;
            path.style.strokeDashoffset = length;

            // Trigger a layout so styles are calculated & the browser
            // picks up the starting position before animating
            path.getBoundingClientRect();

            // Define our transition
            path.style.transition = path.style.WebkitTransition = 'stroke-dashoffset 2s ease-in-out 0.5s';
            // Initial animation
            path.style.strokeDashoffset = '0';
            path.style.stroke = "#fff";
        }
    }]);

    return QuotesBorderComponent;
}(_baseComponent2.default);

exports.default = QuotesBorderComponent;

/***/ }),

/***/ "./app/components/quotes-carousel/js/quotes-carousel.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _styleObserver = __webpack_require__("./app/general/js/style-observer.js");

var _styleObserver2 = _interopRequireDefault(_styleObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuotesCarouselComponent = function (_BaseComponent) {
    _inherits(QuotesCarouselComponent, _BaseComponent);

    function QuotesCarouselComponent() {
        _classCallCheck(this, QuotesCarouselComponent);

        var _this = _possibleConstructorReturn(this, (QuotesCarouselComponent.__proto__ || Object.getPrototypeOf(QuotesCarouselComponent)).apply(this, arguments));

        _this.$element = (0, _jquery2.default)(_this.element);

        _this.defaultOptions = {
            loop: true,
            dots: true,
            nav: true,
            navText: ['<svg class="icon" width="15" height="26"><use xlink:href="#icon-arrow-left"></use></svg>', '<svg class="icon" width="15" height="26"><use xlink:href="#icon-arrow-right"></use></svg>'],
            items: 1,
            autoplay: true,
            autoplayTimeout: 30000,
            autoHeight: false
        };

        (0, _styleObserver2.default)(function () {
            _this.init();
        });
        return _this;
    }

    _createClass(QuotesCarouselComponent, [{
        key: 'init',
        value: function init() {
            var options = _extends({}, this.defaultOptions, this.options);
            this.$element.owlCarousel(options);
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.$element.owlCarousel('destroy');
        }
    }]);

    return QuotesCarouselComponent;
}(_baseComponent2.default);

exports.default = QuotesCarouselComponent;

/***/ }),

/***/ "./app/components/quotes-carousel/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/radio-switch/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/radio-switch/scss/index.scss");

var _radioSwitch = __webpack_require__("./app/components/radio-switch/js/radio-switch.component.js");

var _radioSwitch2 = _interopRequireDefault(_radioSwitch);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('radio-switch', _radioSwitch2.default);

/***/ }),

/***/ "./app/components/radio-switch/js/radio-switch.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioSwitchComponent = function (_BaseComponent) {
    _inherits(RadioSwitchComponent, _BaseComponent);

    function RadioSwitchComponent() {
        _classCallCheck(this, RadioSwitchComponent);

        var _this = _possibleConstructorReturn(this, (RadioSwitchComponent.__proto__ || Object.getPrototypeOf(RadioSwitchComponent)).apply(this, arguments));

        _this.inputs = _this.refs.inputs;
        _this.labels = _this.refs.labels;
        _this.bg = _this.refs.bg;

        _this.init();
        return _this;
    }

    _createClass(RadioSwitchComponent, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            this.labels.forEach(function (label) {
                label.addEventListener("click", _this2.onClick.bind(_this2));
            });

            if (this.props.onSwitch) {
                this.inputs.forEach(function (input) {
                    return input.addEventListener("change", _this2.props.onSwitch);
                });
            }
        }
    }, {
        key: 'onClick',
        value: function onClick(e) {
            this.bg.style.left = e.target.offsetLeft + "px";
            this.bg.style.width = e.target.offsetWidth + "px";
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            var value = null;
            var checkedInput = this.inputs.filter(function (input) {
                return input.checked;
            });
            if (checkedInput.length > 0) {
                value = checkedInput[0].value;
            }
            return value;
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['inputs', 'labels', 'bg'];
        }
    }]);

    return RadioSwitchComponent;
}(_baseComponent2.default);

exports.default = RadioSwitchComponent;

/***/ }),

/***/ "./app/components/radio-switch/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/recaptcha/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/recaptcha/scss/index.scss");

var _recaptcha = __webpack_require__("./app/components/recaptcha/js/recaptcha.component.js");

var _recaptcha2 = _interopRequireDefault(_recaptcha);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('recaptcha', _recaptcha2.default);

/***/ }),

/***/ "./app/components/recaptcha/js/loadRecaptcha.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onReady = onReady;

var _persistentConnector = __webpack_require__("./app/general/js/persistent-connector.js");

var _persistentConnector2 = _interopRequireDefault(_persistentConnector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var callbackName = 'onRecatpchaLoad';

var isLoaded = false;
var onloadQueue = [];

window[callbackName] = function () {
    isLoaded = true;
    onloadQueue.forEach(function (callback) {
        return callback(window.grecaptcha);
    });
};

function onReady(callback) {
    if (isLoaded) {
        callback(window.grecaptcha);
    } else {
        onloadQueue.push(callback);
    }
}

function insertScript() {
    var script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.onerror = function () {
        connector.recover();
    };
    script.src = 'https://www.google.com/recaptcha/api.js?onload=' + callbackName + '&render=explicit';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(script, s);
}

var connector = new _persistentConnector2.default(insertScript, { name: 'Recaptcha script' });
insertScript();

/***/ }),

/***/ "./app/components/recaptcha/js/recaptcha.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EVENT_ON_ERROR = exports.EVENT_AFTER_SUBMIT = exports.DEFAULT_RECAPTCHA_FIELD_NAME = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

var _createEvent = __webpack_require__("./app/general/js/create-event.js");

var _createEvent2 = _interopRequireDefault(_createEvent);

var _loadRecaptcha = __webpack_require__("./app/components/recaptcha/js/loadRecaptcha.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_RECAPTCHA_FIELD_NAME = exports.DEFAULT_RECAPTCHA_FIELD_NAME = 'g-recaptcha-response';
var EVENT_AFTER_SUBMIT = exports.EVENT_AFTER_SUBMIT = 'recaptcha:afterSubmit';
var EVENT_ON_ERROR = exports.EVENT_ON_ERROR = 'recaptcha:onError';

var RecaptchaComponent = function (_BaseComponent) {
    _inherits(RecaptchaComponent, _BaseComponent);

    function RecaptchaComponent() {
        _classCallCheck(this, RecaptchaComponent);

        var _this = _possibleConstructorReturn(this, (RecaptchaComponent.__proto__ || Object.getPrototypeOf(RecaptchaComponent)).apply(this, arguments));

        _this.captchaId = null;

        _this.containerElement = _this.refs.container;
        _this.inputElement = _this.refs.input;

        _this.isLoading = true;

        _this.onAfterSubmit = _this.onAfterSubmit.bind(_this);
        _this.onError = _this.onError.bind(_this);

        if (_this.containerElement && _this.inputElement) {
            _this.init = _this.init.bind(_this);
            _this.successCallback = _this.successCallback.bind(_this);
            _this.expiredCallback = _this.expiredCallback.bind(_this);

            (0, _loadRecaptcha.onReady)(_this.init.bind(_this));
        }
        return _this;
    }

    _createClass(RecaptchaComponent, [{
        key: "init",
        value: function init(grecaptcha) {
            this.grecaptcha = grecaptcha;

            this.captchaId = grecaptcha.render(this.containerElement, {
                sitekey: _app2.default.getConfig('recaptchaKey'),
                callback: this.successCallback,
                "expired-callback": this.expiredCallback
            });
            this.isLoading = false;
            this.element.classList.remove('is-loading');
            this.inputElement.addEventListener(EVENT_AFTER_SUBMIT, this.onAfterSubmit);
            this.inputElement.addEventListener(EVENT_ON_ERROR, this.onError);
        }
    }, {
        key: "successCallback",
        value: function successCallback(response) {
            this.inputElement.value = response;
            this.inputElement.dispatchEvent((0, _createEvent2.default)('input'));
            this.inputElement.dispatchEvent((0, _createEvent2.default)('change'));
        }
    }, {
        key: "expiredCallback",
        value: function expiredCallback() {
            this.reset();
        }
    }, {
        key: "onAfterSubmit",
        value: function onAfterSubmit() {
            this.grecaptcha.reset(this.captchaId);
            this.reset();
        }
    }, {
        key: "onError",
        value: function onError() {
            this.grecaptcha.reset(this.captchaId);
            this.reset();
        }
    }, {
        key: "reset",
        value: function reset() {
            this.inputElement.value = '';
            this.inputElement.dispatchEvent((0, _createEvent2.default)('input'));
            this.inputElement.dispatchEvent((0, _createEvent2.default)('change'));
        }
    }], [{
        key: "getRequiredRefs",
        value: function getRequiredRefs() {
            return ['container', 'input'];
        }
    }]);

    return RecaptchaComponent;
}(_baseComponent2.default);

exports.default = RecaptchaComponent;

/***/ }),

/***/ "./app/components/recaptcha/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/register-to-bid/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/register-to-bid/scss/index.scss");

var _registerToBidReplacer = __webpack_require__("./app/components/register-to-bid/js/register-to-bid-replacer.component.js");

var _registerToBidReplacer2 = _interopRequireDefault(_registerToBidReplacer);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('register-to-bid-form-replacer', _registerToBidReplacer2.default);

/***/ }),

/***/ "./app/components/register-to-bid/js/buyer-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _htmlHelper = __webpack_require__("./app/general/js/html-helper.js");

var _htmlHelper2 = _interopRequireDefault(_htmlHelper);

var _buyingForOptions = __webpack_require__("./app/components/register-to-bid/js/buying-for-options.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuyerFormComponent = function (_BaseComponent) {
    _inherits(BuyerFormComponent, _BaseComponent);

    function BuyerFormComponent() {
        _classCallCheck(this, BuyerFormComponent);

        var _this = _possibleConstructorReturn(this, (BuyerFormComponent.__proto__ || Object.getPrototypeOf(BuyerFormComponent)).apply(this, arguments));

        _this.buyerStatusSection = _this.refs.buyerStatusSection;
        _this.buyerStatusInput = _this.refs.buyerStatusInput;

        _this.privatIndividualValue = _this.buyerStatusInput.getAttribute('data-private-individual-value');
        if (!_this.privatIndividualValue) {
            throw new Error('data-private-individual-value should be defined');
        }

        _this.directorshipConfirmedSection = _this.refs.directorshipConfirmed;

        _this.buyingFor = null;
        _this.registerByTelephone = false;

        _this.onBuyerStatusChange = _this.onBuyerStatusChange.bind(_this);
        _this.init();
        return _this;
    }

    _createClass(BuyerFormComponent, [{
        key: 'init',
        value: function init() {
            this.buyerStatusInput.addEventListener('change', this.onBuyerStatusChange);
            this.updateDirectorshipConfirmedVisibility();
        }
    }, {
        key: 'onBuyerStatusChange',
        value: function onBuyerStatusChange(e) {
            this.updateDirectorshipConfirmedVisibility();
        }
    }, {
        key: 'setBuyingFor',
        value: function setBuyingFor(value) {
            this.buyingFor = value;

            if (this.buyingFor !== _buyingForOptions.BUYING_FOR_SOMEONE_ELSE) {
                _htmlHelper2.default.showFormHiddenGroup(this.buyerStatusSection);
            } else {
                _htmlHelper2.default.hideFormHiddenGroup(this.buyerStatusSection);
                _htmlHelper2.default.resetFormSection(this.buyerStatusSection);
            }

            this.updateDirectorshipConfirmedVisibility();
        }
    }, {
        key: 'setRegisterByTelephone',
        value: function setRegisterByTelephone(value) {
            this.registerByTelephone = value;
            this.updateDirectorshipConfirmedVisibility();
        }
    }, {
        key: 'updateDirectorshipConfirmedVisibility',
        value: function updateDirectorshipConfirmedVisibility() {
            if (this.buyingFor !== _buyingForOptions.BUYING_FOR_SOMEONE_ELSE && this.registerByTelephone && this.buyerStatusInput.value && this.buyerStatusInput.value !== this.privatIndividualValue) {
                _htmlHelper2.default.showFormHiddenGroup(this.directorshipConfirmedSection);
            } else {
                _htmlHelper2.default.hideFormHiddenGroup(this.directorshipConfirmedSection);
                _htmlHelper2.default.resetFormSection(this.directorshipConfirmedSection);
            }
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            this.buyerStatusInput.removeEventListener('change', this.onBuyerStatusChange);
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['buyerStatusSection', 'buyerStatusInput', 'directorshipConfirmed'];
        }
    }]);

    return BuyerFormComponent;
}(_baseComponent2.default);

exports.default = BuyerFormComponent;

/***/ }),

/***/ "./app/components/register-to-bid/js/buyers-subform-list.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _subformList = __webpack_require__("./app/components/register-to-bid/js/subform-list.component.js");

var _subformList2 = _interopRequireDefault(_subformList);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

var _buyerForm = __webpack_require__("./app/components/register-to-bid/js/buyer-form.component.js");

var _buyerForm2 = _interopRequireDefault(_buyerForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuyersSubformListComponent = function (_SubformListComponent) {
    _inherits(BuyersSubformListComponent, _SubformListComponent);

    function BuyersSubformListComponent() {
        _classCallCheck(this, BuyersSubformListComponent);

        var _this = _possibleConstructorReturn(this, (BuyersSubformListComponent.__proto__ || Object.getPrototypeOf(BuyersSubformListComponent)).apply(this, arguments));

        _this.buyersForms = {};
        return _this;
    }

    _createClass(BuyersSubformListComponent, [{
        key: "setRegisterByTelephone",
        value: function setRegisterByTelephone(value) {
            var _this2 = this;

            this.registerByTelephone = value;
            Object.keys(this.buyersForms).forEach(function (id) {
                _this2.buyersForms[id].setRegisterByTelephone(value);
            });
        }
    }, {
        key: "setBuyingFor",
        value: function setBuyingFor(value) {
            var _this3 = this;

            this.buyingFor = value;
            Object.keys(this.buyersForms).forEach(function (id) {
                _this3.buyersForms[id].setBuyingFor(value);
            });
        }
    }, {
        key: "onSubformConnected",
        value: function onSubformConnected(_ref) {
            var element = _ref.element,
                id = _ref.id;

            var buyerForm = _componentsCollection2.default.getInstance().createComponent(element, 'buyer-form', _buyerForm2.default);
            if (buyerForm) {
                buyerForm.setBuyingFor(this.buyingFor);
                buyerForm.setRegisterByTelephone(this.registerByTelephone);
                this.buyersForms[id] = buyerForm;
            }
        }
    }, {
        key: "onSubformDisconnected",
        value: function onSubformDisconnected(_ref2) {
            var id = _ref2.id;

            if (id in this.buyersForms) {
                _componentsCollection2.default.getInstance().destroy(this.buyersForms[id].element);
                delete this.buyersForms[id];
            }
        }
    }]);

    return BuyersSubformListComponent;
}(_subformList2.default);

exports.default = BuyersSubformListComponent;

/***/ }),

/***/ "./app/components/register-to-bid/js/buying-for-options.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BUYING_FOR_OWN_NAME = exports.BUYING_FOR_OWN_NAME = 'buyingOwnName';
var BUYING_FOR_OWN_NAME_PLUS_BUYERS = exports.BUYING_FOR_OWN_NAME_PLUS_BUYERS = 'buyingOwnNamePlusBuyers';
var BUYING_FOR_SOMEONE_ELSE = exports.BUYING_FOR_SOMEONE_ELSE = 'buyingSomeoneElse';

/***/ }),

/***/ "./app/components/register-to-bid/js/register-to-bid-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _subformList = __webpack_require__("./app/components/register-to-bid/js/subform-list.component.js");

var _subformList2 = _interopRequireDefault(_subformList);

var _buyersSubformList = __webpack_require__("./app/components/register-to-bid/js/buyers-subform-list.component.js");

var _buyersSubformList2 = _interopRequireDefault(_buyersSubformList);

var _htmlHelper = __webpack_require__("./app/general/js/html-helper.js");

var _htmlHelper2 = _interopRequireDefault(_htmlHelper);

var _buyerForm = __webpack_require__("./app/components/register-to-bid/js/buyer-form.component.js");

var _buyerForm2 = _interopRequireDefault(_buyerForm);

var _buyingForOptions = __webpack_require__("./app/components/register-to-bid/js/buying-for-options.js");

var _asyncForm = __webpack_require__("./app/components/form/js/async-form.component.js");

var _asyncForm2 = _interopRequireDefault(_asyncForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var REGISTER_TO_BID_IN_PERSON = 'inPerson';
var REGISTER_TO_BID_BY_TELEPHONE = 'byTelephone';

var RegisterToBidFormComponent = function (_AsyncFormComponent) {
    _inherits(RegisterToBidFormComponent, _AsyncFormComponent);

    function RegisterToBidFormComponent() {
        _classCallCheck(this, RegisterToBidFormComponent);

        var _this = _possibleConstructorReturn(this, (RegisterToBidFormComponent.__proto__ || Object.getPrototypeOf(RegisterToBidFormComponent)).apply(this, arguments));

        _this.registerToBid = _this.refs.registerToBid;
        _this.currentRegisterToBidCheckbox = null;

        _this.buyingOption = _this.refs.buyingOption;
        _this.currentBuyingForCheckbox = null;

        _this.contactDetails = _this.refs.contactDetails;

        _this.solicitorSection = _this.refs.solicitor;
        _this.lotsSection = _this.refs.lots;
        _this.lotsList = _this.refs.lotsList;

        _this.buyersSection = _this.refs.buyers;
        _this.buyersList = _this.refs.buyersList;

        _this.confirmationCheckboxesSection = _this.refs.confirmationCheckboxes;

        _this.initComponent();
        return _this;
    }

    _createClass(RegisterToBidFormComponent, [{
        key: 'initComponent',
        value: function initComponent() {
            var _this2 = this;

            this.lotsSubformList = new _subformList2.default(this.lotsList, { id: 'subform-list' });
            this.buyersSubformList = new _buyersSubformList2.default(this.buyersList, { id: 'subform-list' });

            this.buyerForm = new _buyerForm2.default(this.contactDetails, { id: 'buyer-form' });

            this.updateRegisterToBid();
            Object.keys(this.registerToBid).forEach(function (name) {
                return _this2.registerToBid[name].addEventListener('change', function () {
                    _this2.updateRegisterToBid();
                });
            });

            this.updateBuying();
            Object.keys(this.buyingOption).forEach(function (name) {
                return _this2.buyingOption[name].addEventListener('change', function () {
                    _this2.updateBuying();
                });
            });
        }
    }, {
        key: 'updateRegisterToBid',
        value: function updateRegisterToBid() {
            var _this3 = this;

            var currentValue = Object.keys(this.registerToBid).find(function (name) {
                return _this3.registerToBid[name].checked;
            });
            var currentCheckbox = this.registerToBid[currentValue];

            switch (currentValue) {
                case REGISTER_TO_BID_IN_PERSON:
                    this.confirmRegisterToBidInPerson().then(function () {
                        _this3.currentRegisterToBidCheckbox = currentCheckbox;
                        _this3.buyersSubformList.setRegisterByTelephone(false);
                        _this3.buyerForm.setRegisterByTelephone(false);

                        _htmlHelper2.default.hideFormHiddenGroup(_this3.solicitorSection);
                        _htmlHelper2.default.hideFormHiddenGroup(_this3.lotsSection);
                        _this3.lotsSubformList.removeAll();
                        _htmlHelper2.default.hideFormHiddenGroup(_this3.confirmationCheckboxesSection);
                        _htmlHelper2.default.resetFormSections([_this3.solicitorSection, _this3.confirmationCheckboxesSection]);
                    }, function () {
                        if (_this3.currentRegisterToBidCheckbox) {
                            _this3.currentRegisterToBidCheckbox.checked = true;
                        }
                    });
                    break;
                case REGISTER_TO_BID_BY_TELEPHONE:
                    this.currentRegisterToBidCheckbox = currentCheckbox;

                    this.buyersSubformList.setRegisterByTelephone(true);
                    this.buyerForm.setRegisterByTelephone(true);

                    _htmlHelper2.default.showFormHiddenGroup(this.solicitorSection);
                    _htmlHelper2.default.showFormHiddenGroup(this.lotsSection);
                    _htmlHelper2.default.showFormHiddenGroup(this.confirmationCheckboxesSection);
                    break;
            }
        }
    }, {
        key: 'confirmRegisterToBidInPerson',
        value: function confirmRegisterToBidInPerson() {
            var _this4 = this;

            return new Promise(function (resolve, reject) {
                if (!_htmlHelper2.default.hasFormSectionsDirtyFields([_this4.solicitorSection, _this4.lotsList])) {
                    resolve();
                    return;
                }

                if (confirm('Solicitor and lot details will be removed. Are you sure you want to do it?')) {
                    resolve();
                } else {
                    reject();
                }
            });
        }
    }, {
        key: 'updateBuying',
        value: function updateBuying() {
            var _this5 = this;

            var currentValue = Object.keys(this.buyingOption).find(function (name) {
                return _this5.buyingOption[name].checked;
            });
            var currentCheckbox = this.buyingOption[currentValue];

            switch (currentValue) {
                case _buyingForOptions.BUYING_FOR_OWN_NAME:
                    this.confirmBuyingForOwnName().then(function () {
                        _this5.currentBuyingForCheckbox = currentCheckbox;
                        _this5.buyersSubformList.setBuyingFor(currentValue);
                        _this5.buyerForm.setBuyingFor(currentValue);

                        _htmlHelper2.default.hideFormHiddenGroup(_this5.buyersSection);
                        _this5.buyersSubformList.removeAll();
                    }, function () {
                        _this5.currentBuyingForCheckbox.checked = true;
                    });
                    break;
                case _buyingForOptions.BUYING_FOR_OWN_NAME_PLUS_BUYERS:
                    this.currentBuyingForCheckbox = currentCheckbox;
                    this.buyersSubformList.setBuyingFor(currentValue);
                    this.buyerForm.setBuyingFor(currentValue);

                    // not for own name
                    _htmlHelper2.default.showFormHiddenGroup(this.buyersSection);
                    break;
                case _buyingForOptions.BUYING_FOR_SOMEONE_ELSE:
                    this.currentBuyingForCheckbox = currentCheckbox;
                    this.buyersSubformList.setBuyingFor(currentValue);
                    this.buyerForm.setBuyingFor(currentValue);

                    // not for own name
                    _htmlHelper2.default.showFormHiddenGroup(this.buyersSection);
                    break;
            }
        }
    }, {
        key: 'confirmBuyingForOwnName',
        value: function confirmBuyingForOwnName() {
            var _this6 = this;

            return new Promise(function (resolve, reject) {
                if (!_htmlHelper2.default.hasFormSectionDirtyFields(_this6.buyersList)) {
                    resolve();
                    return;
                }

                if (confirm('Buyers will be removed. Are you sure you want to do it?')) {
                    resolve();
                } else {
                    reject();
                }
            });
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['registerToBid', 'buyingOption', 'contactDetails', 'solicitor', 'lots', 'lotsList', 'buyers', 'buyersList', 'confirmationCheckboxes'];
        }
    }]);

    return RegisterToBidFormComponent;
}(_asyncForm2.default);

exports.default = RegisterToBidFormComponent;

/***/ }),

/***/ "./app/components/register-to-bid/js/register-to-bid-replacer.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formResultReplacer = __webpack_require__("./app/components/form-result-replacer/js/form-result-replacer.component.js");

var _formResultReplacer2 = _interopRequireDefault(_formResultReplacer);

var _registerToBidForm = __webpack_require__("./app/components/register-to-bid/js/register-to-bid-form.component.js");

var _registerToBidForm2 = _interopRequireDefault(_registerToBidForm);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RegisterToBidFormReplacer = function (_FormResultReplacer) {
    _inherits(RegisterToBidFormReplacer, _FormResultReplacer);

    function RegisterToBidFormReplacer() {
        _classCallCheck(this, RegisterToBidFormReplacer);

        return _possibleConstructorReturn(this, (RegisterToBidFormReplacer.__proto__ || Object.getPrototypeOf(RegisterToBidFormReplacer)).apply(this, arguments));
    }

    _createClass(RegisterToBidFormReplacer, [{
        key: 'createFormInstance',
        value: function createFormInstance() {
            return _componentsCollection2.default.getInstance().createComponent(this.element, 'register-to-bid-form', _registerToBidForm2.default, { onSuccess: this.onFormSuccess.bind(this) });
        }
    }]);

    return RegisterToBidFormReplacer;
}(_formResultReplacer2.default);

exports.default = RegisterToBidFormReplacer;

/***/ }),

/***/ "./app/components/register-to-bid/js/subform-list.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _handlebars = __webpack_require__("./node_modules/handlebars/dist/handlebars.js");

var _handlebars2 = _interopRequireDefault(_handlebars);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubformListComponent = function (_BaseComponent) {
    _inherits(SubformListComponent, _BaseComponent);

    function SubformListComponent() {
        _classCallCheck(this, SubformListComponent);

        var _this = _possibleConstructorReturn(this, (SubformListComponent.__proto__ || Object.getPrototypeOf(SubformListComponent)).apply(this, arguments));

        _this.addButton = _this.refs.addButton;
        _this.list = _this.refs.list;

        _this.templateId = _this.options.template || '';
        _this.max = _this.options.max || 0;

        _this.id = 0;

        /**
         * [{element, removeButtonElement, removeHandler}]
         * @type {Array}
         */
        _this.subforms = [];

        _this.onAddClick = _this.onAddClick.bind(_this);

        _this.init();
        return _this;
    }

    _createClass(SubformListComponent, [{
        key: 'init',
        value: function init() {
            if (!this.templateId) {
                return;
            }

            var source = document.getElementById(this.templateId).innerHTML;
            this.template = _handlebars2.default.compile(source);
            this.addButton.addEventListener('click', this.onAddClick);
        }
    }, {
        key: 'onAddClick',
        value: function onAddClick(e) {
            e.preventDefault();
            if (this.max === 0 || this.subforms.length < this.max) {
                this.addSubform();
            }
        }
    }, {
        key: 'addSubform',
        value: function addSubform() {
            var _this2 = this;

            var number = this.subforms.length + 1;

            var element = document.createElement("div");
            element.classList.add('subform');
            element.innerHTML = this.template({ number: number, i: this.id });
            this.list.insertAdjacentElement('beforeEnd', element);

            var subformData = {
                element: element,
                removeButton: element.querySelector('.js-subform-remove-button'),
                removeHandler: function removeHandler(e) {
                    e.preventDefault();
                    _this2.removeSubform(subformData);
                },
                id: this.id
            };

            this.id++;

            if (subformData.removeButton) {
                subformData.removeButton.addEventListener('click', subformData.removeHandler);
            }

            this.subforms.push(subformData);

            if (this.max > 0 && this.subforms.length >= this.max) {
                this.addButton.classList.add('is-hidden');
            }

            _componentsCollection2.default.getInstance().init(element);
            this.onSubformConnected(subformData);
        }
    }, {
        key: 'onSubformConnected',
        value: function onSubformConnected(data) {
            // hook
        }
    }, {
        key: 'onSubformDisconnected',
        value: function onSubformDisconnected(data) {
            // hook
        }
    }, {
        key: 'removeSubform',
        value: function removeSubform(data) {
            this.disconnectSubform(data);
            this.subforms = this.subforms.filter(function (item) {
                return item !== data;
            });
            this.updateAddButtonVisibility();
            this.updateNumbers();
            this.id--;
        }
    }, {
        key: 'updateNumbers',
        value: function updateNumbers() {
            this.subforms.forEach(function (item, i) {
                var number = i + 1;
                var numbers = [].concat(_toConsumableArray(item.element.querySelectorAll('.js-subform-number')));
                numbers.forEach(function (numberElement) {
                    return numberElement.textContent = number;
                });

                var subformFields = [].concat(_toConsumableArray(item.element.querySelectorAll('input, select')));
                subformFields.forEach(function (element) {
                    return element.name = element.name.replace(element.name.match(/\[.+\]/g), '[' + i + ']');
                });
            });
        }
    }, {
        key: 'disconnectSubform',
        value: function disconnectSubform(data, i) {
            var element = data.element;
            if (data.removeButton) {
                data.removeButton.removeEventListener('click', data.removeHandler);
            }
            this.onSubformDisconnected(data, i);
            _componentsCollection2.default.getInstance().destroy(element);
            element.parentNode.removeChild(element);
        }
    }, {
        key: 'removeAll',
        value: function removeAll() {
            var _this3 = this;

            this.subforms.forEach(function (item, i) {
                return _this3.disconnectSubform(item, i);
            });
            this.subforms = [];
            this.updateAddButtonVisibility();
            this.index = 0;
            this.id = 0;
        }
    }, {
        key: 'updateAddButtonVisibility',
        value: function updateAddButtonVisibility() {
            if (this.subforms.length < this.max) {
                this.addButton.classList.remove('is-hidden');
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.element.classList.add('is-hidden');
        }
    }, {
        key: 'show',
        value: function show() {
            this.element.classList.remove('is-hidden');
        }
    }], [{
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return ['list', 'addButton'];
        }
    }]);

    return SubformListComponent;
}(_baseComponent2.default);

exports.default = SubformListComponent;

/***/ }),

/***/ "./app/components/register-to-bid/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/register/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/register/scss/index.scss");

/***/ }),

/***/ "./app/components/register/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/request-catalogue/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/request-catalogue/scss/index.scss");

var _requestCatalogue = __webpack_require__("./app/components/request-catalogue/js/request-catalogue.component.js");

var _requestCatalogue2 = _interopRequireDefault(_requestCatalogue);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('request-catalogue', _requestCatalogue2.default);

/***/ }),

/***/ "./app/components/request-catalogue/js/request-catalogue.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formResultReplacer = __webpack_require__("./app/components/form-result-replacer/js/form-result-replacer.component.js");

var _formResultReplacer2 = _interopRequireDefault(_formResultReplacer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RequestCatalogueComponent = function (_FormResultReplacer) {
  _inherits(RequestCatalogueComponent, _FormResultReplacer);

  function RequestCatalogueComponent() {
    _classCallCheck(this, RequestCatalogueComponent);

    return _possibleConstructorReturn(this, (RequestCatalogueComponent.__proto__ || Object.getPrototypeOf(RequestCatalogueComponent)).apply(this, arguments));
  }

  return RequestCatalogueComponent;
}(_formResultReplacer2.default);

exports.default = RequestCatalogueComponent;

/***/ }),

/***/ "./app/components/request-catalogue/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/reset-password-form/html/sucess-template.hbs":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("./node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"modal__content modal__content--centered\">\r\n    <div class=\"modal__heading\">\r\n        "
    + alias4(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper)))
    + "\r\n    </div>\r\n    <div class=\"modal__body\">\r\n        "
    + alias4(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper)))
    + "\r\n    </div>\r\n    <a href=\""
    + alias4(((helper = (helper = helpers.loginUrl || (depth0 != null ? depth0.loginUrl : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"loginUrl","hash":{},"data":data}) : helper)))
    + "\" class=\"link modal__close-link\">go to login</a>\r\n</div>\r\n";
},"useData":true});

/***/ }),

/***/ "./app/components/reset-password-form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/reset-password-form/scss/index.scss");

var _resetPasswordForm = __webpack_require__("./app/components/reset-password-form/js/reset-password-form.component.js");

var _resetPasswordForm2 = _interopRequireDefault(_resetPasswordForm);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('reset-password-form', _resetPasswordForm2.default);

/***/ }),

/***/ "./app/components/reset-password-form/js/reset-password-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _popupResultForm = __webpack_require__("./app/components/form/js/popup-result-form.component.js");

var _popupResultForm2 = _interopRequireDefault(_popupResultForm);

var _sucessTemplate = __webpack_require__("./app/components/reset-password-form/html/sucess-template.hbs");

var _sucessTemplate2 = _interopRequireDefault(_sucessTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResetPasswordFormComponent = function (_PopupResultFormCompo) {
    _inherits(ResetPasswordFormComponent, _PopupResultFormCompo);

    function ResetPasswordFormComponent() {
        _classCallCheck(this, ResetPasswordFormComponent);

        return _possibleConstructorReturn(this, (ResetPasswordFormComponent.__proto__ || Object.getPrototypeOf(ResetPasswordFormComponent)).apply(this, arguments));
    }

    _createClass(ResetPasswordFormComponent, [{
        key: 'getTemplate',
        value: function getTemplate() {
            return _sucessTemplate2.default;
        }
    }]);

    return ResetPasswordFormComponent;
}(_popupResultForm2.default);

exports.default = ResetPasswordFormComponent;

/***/ }),

/***/ "./app/components/reset-password-form/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/responsive-images/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/responsive-images/scss/index.scss");

__webpack_require__("./node_modules/lazysizes/plugins/object-fit/ls.object-fit.js");

__webpack_require__("./node_modules/lazysizes/plugins/bgset/ls.bgset.js");

__webpack_require__("./node_modules/lazysizes/plugins/respimg/ls.respimg.js");

__webpack_require__("./node_modules/lazysizes/plugins/parent-fit/ls.parent-fit.js");

__webpack_require__("./node_modules/lazysizes/lazysizes.js");

/***/ }),

/***/ "./app/components/responsive-images/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/section/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/section/scss/index.scss");

/***/ }),

/***/ "./app/components/section/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/select/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/select/scss/index.scss");

/***/ }),

/***/ "./app/components/select/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/sell-lot/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/sell-lot/scss/index.scss");

/***/ }),

/***/ "./app/components/sell-lot/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/shifted-content/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/shifted-content/scss/index.scss");

/***/ }),

/***/ "./app/components/shifted-content/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/show-rule/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _showRule = __webpack_require__("./app/components/show-rule/js/show-rule.component.js");

var _showRule2 = _interopRequireDefault(_showRule);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('show-rule', _showRule2.default);

/***/ }),

/***/ "./app/components/show-rule/js/show-rule.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _handlebars = __webpack_require__("./node_modules/handlebars/dist/handlebars.js");

var _handlebars2 = _interopRequireDefault(_handlebars);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CONDITION_AND = 'and';

var ACTION_SHOW = 'show';
var ACTION_HIDE = 'hide';
var ACTION_CLASS = 'class';

/**
 * example of data-rule attribute
 *
 * {
 *      elements: "id1,id2:false,id3:concreteValue"
 *      condition: 'and'
 *      action: 'show' // hide, class
 *      class: 'example-class' // if action is class
 *      template: 'hbs-template-name' // insert/remove node instead of show/hide
 * }
 *
 */

var ShowRuleComponent = function (_BaseComponent) {
    _inherits(ShowRuleComponent, _BaseComponent);

    function ShowRuleComponent() {
        _classCallCheck(this, ShowRuleComponent);

        var _this = _possibleConstructorReturn(this, (ShowRuleComponent.__proto__ || Object.getPrototypeOf(ShowRuleComponent)).apply(this, arguments));

        _this.idAttributeName = 'data-rule-id';
        _this.defaultConfig = {
            action: ACTION_SHOW,
            condition: CONDITION_AND
        };

        _this._config = null;
        _this.elementsValues = {};
        _this.lastResult = null;

        _this.checkFunction = _this.checkFunction.bind(_this);

        _this.init();
        return _this;
    }

    _createClass(ShowRuleComponent, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            // initial input values
            this.elementsValues = this.getValuableElement().reduce(function (result, element) {
                result[_this2.getElementId(element)] = _this2.getElementValue(element);
                return result;
            }, {});

            this.getElements().forEach(function (element) {
                if (element.tagName === 'INPUT' && element.type === 'text') {
                    element.addEventListener('input', _this2.onElementChange.bind(_this2));
                } else {
                    element.addEventListener('change', _this2.onElementChange.bind(_this2));
                }
            });

            this.checkVisibility();
        }
    }, {
        key: 'getConfig',
        value: function getConfig() {
            if (this._config === null) {
                this._config = this.getParsedConfig();
            }

            return this._config;
        }
    }, {
        key: 'getElements',
        value: function getElements() {
            var config = this.getConfig();
            return config.elements;
        }

        /**
         * Returns all elements except unchecked radio inputs because their value is useless
         *
         * @returns Array
         */

    }, {
        key: 'getValuableElement',
        value: function getValuableElement() {
            var _this3 = this;

            return this.getElements().filter(function (element) {
                return !_this3.isUncheckedRadioInput(element);
            });
        }
    }, {
        key: 'isUncheckedRadioInput',
        value: function isUncheckedRadioInput(element) {
            return element.tagName === 'INPUT' && element.type === 'radio' && element.checked === false;
        }
    }, {
        key: 'getParsedConfig',
        value: function getParsedConfig() {
            var _this4 = this;

            var configString = this.element.getAttribute('data-rule');
            var parsedConfig = {};
            try {
                parsedConfig = JSON.parse(configString);
            } catch (e) {
                //maybe we pass single string to set element(s) only
                parsedConfig = { elements: configString };
            }

            var elementsString = parsedConfig.elements;
            if (elementsString) {
                var elements = [];
                var elementsConditions = {};
                elementsString.split(',').forEach(function (elementCondition) {
                    var _elementCondition$tri = elementCondition.trim().split(':'),
                        _elementCondition$tri2 = _slicedToArray(_elementCondition$tri, 2),
                        elementId = _elementCondition$tri2[0],
                        elementValue = _elementCondition$tri2[1];

                    var nodes = [].concat(_toConsumableArray(document.querySelectorAll('[' + _this4.idAttributeName + '="' + elementId + '"]')));
                    if (nodes.length > 0) {
                        if (nodes.length === 1) {
                            // handle single node
                            var element = nodes[0];
                            if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.tagName === 'SELECT') {
                                elements.push(element);
                            }
                        } else {
                            //handle radio list
                            var name = nodes[0].name;
                            var isValidRadioList = nodes.every(function (element) {
                                return element.tagName === 'INPUT' && element.type === 'radio' && element.name === name;
                            });
                            if (isValidRadioList) {
                                nodes.forEach(function (element) {
                                    return elements.push(element);
                                });
                            }
                        }
                        elementsConditions[elementId] = elementValue === undefined || elementValue === 'true' ? true : elementValue === 'false' ? false : elementValue;
                    }
                });
                parsedConfig.elementsConditions = elementsConditions;
                if (!elements.length) {
                    throw new Error('there is no elements in config');
                }

                if (parsedConfig.template) {
                    var templateNode = document.getElementById(parsedConfig.template);
                    if (!templateNode) {
                        throw new Error('there is no templateNode with id ' + parsedConfig.template);
                    }
                    parsedConfig.template = _handlebars2.default.compile(templateNode.innerHTML);
                }

                return _extends({}, this.defaultConfig, parsedConfig, { elements: elements });
            } else {
                throw new Error('there is no elements section in config');
            }
        }
    }, {
        key: 'getElementId',
        value: function getElementId(element) {
            return element.getAttribute(this.idAttributeName);
        }
    }, {
        key: 'getElementValue',
        value: function getElementValue(element) {
            switch (element.type) {
                case 'checkbox':
                    return element.checked;
                default:
                    return element.value;
            }
        }
    }, {
        key: 'onElementChange',
        value: function onElementChange(e) {
            var element = e.target;
            this.elementsValues[this.getElementId(element)] = this.getElementValue(element);
            this.checkVisibility();
        }
    }, {
        key: 'checkFunction',
        value: function checkFunction(id) {
            return this.elementsValues[id] === this.getConfig().elementsConditions[id];
        }
    }, {
        key: 'checkVisibility',
        value: function checkVisibility() {
            var result = false;

            if (this.getConfig().condition === CONDITION_AND) {
                result = Object.keys(this.elementsValues).every(this.checkFunction);
            } else {
                result = Object.keys(this.elementsValues).some(this.checkFunction);
            }
            if (result !== this.lastResult) {
                this.update(result);
            }
        }
    }, {
        key: 'update',
        value: function update(result) {
            this.lastResult = result;
            switch (this.getConfig().action) {
                case ACTION_SHOW:
                    this.updateShow(result);
                    break;
                case ACTION_HIDE:
                    this.updateShow(!result);
                    break;
                case ACTION_CLASS:
                    this.updateClass(result);
                    break;
            }
        }
    }, {
        key: 'updateShow',
        value: function updateShow(result) {
            if (this.getConfig().template) {
                this.updatePresence(result);
            } else {
                this.updateVisibility();
            }
        }
    }, {
        key: 'updatePresence',
        value: function updatePresence(result) {
            if (result) {
                var renderedElement = this.getConfig().template();
                this.element.insertAdjacentHTML('afterBegin', renderedElement);
                _componentsCollection2.default.getInstance().init(this.element);
            } else {
                _componentsCollection2.default.getInstance().destroy(this.element);
                this.element.innerHTML = '';
            }
        }
    }, {
        key: 'updateClass',
        value: function updateClass(result) {
            if (result) {
                this.element.classList.add(this.getConfig().class);
            } else {
                this.element.classList.remove(this.getConfig().class);
            }
        }
    }, {
        key: 'updateVisibility',
        value: function updateVisibility(result) {
            if (result) {
                this.element.style.display = 'block';
            } else {
                this.element.style.display = 'none';
            }
        }
    }]);

    return ShowRuleComponent;
}(_baseComponent2.default);

exports.default = ShowRuleComponent;

/***/ }),

/***/ "./app/components/signup/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/signup/scss/index.scss");

/***/ }),

/***/ "./app/components/signup/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/social/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/social/scss/index.scss");

/***/ }),

/***/ "./app/components/social/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/spinner/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/spinner/scss/index.scss");

/***/ }),

/***/ "./app/components/spinner/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/tabs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/tabs/scss/index.scss");

var _tabs = __webpack_require__("./app/components/tabs/js/tabs.component.js");

var _tabs2 = _interopRequireDefault(_tabs);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('default-tabs', _tabs2.default);

/***/ }),

/***/ "./app/components/tabs/js/tabs.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _eventBus = __webpack_require__("./app/general/js/event-bus.js");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _styleObserver = __webpack_require__("./app/general/js/style-observer.js");

var _styleObserver2 = _interopRequireDefault(_styleObserver);

var _app = __webpack_require__("./app/general/js/app.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabsComponent = function (_BaseComponent) {
    _inherits(TabsComponent, _BaseComponent);

    function TabsComponent() {
        _classCallCheck(this, TabsComponent);

        var _this = _possibleConstructorReturn(this, (TabsComponent.__proto__ || Object.getPrototypeOf(TabsComponent)).apply(this, arguments));

        _this.contentHolder = _this.refs.contentHolder;

        (0, _styleObserver2.default)(function () {
            _this.init();

            _eventBus2.default.addListener(_app.EVENT_DEVICE_TYPE_CHANGED, function () {
                setTimeout(function () {
                    _this.init();
                }, 500);
            });

            window.addEventListener('load', function () {
                _this.init();
            });
        });
        return _this;
    }

    _createClass(TabsComponent, [{
        key: 'init',
        value: function init() {
            this.setHeight();
            this.setButtonsSize();
        }
    }, {
        key: 'setHeight',
        value: function setHeight() {
            var height = 0;

            [].forEach.call(this.contentHolder.children, function (item) {
                height = height > item.offsetHeight ? height : item.offsetHeight;
            });

            this.contentHolder.style.height = height + 'px';
        }
    }, {
        key: 'setButtonsSize',
        value: function setButtonsSize() {
            var labels = this.element.querySelectorAll('label.tab-label');
            var offset = 0;

            [].forEach.call(labels, function (label) {
                offset += parseInt(window.getComputedStyle(label).marginLeft);
                if (label.previousElementSibling.tagName == 'INPUT') {
                    label.previousElementSibling.style.height = label.offsetHeight + 'px';
                    label.previousElementSibling.style.width = label.offsetWidth + 'px';
                    label.previousElementSibling.style.left = offset + 'px';
                }
                offset += label.offsetWidth + parseInt(window.getComputedStyle(label).marginRight);
            });
        }
    }]);

    return TabsComponent;
}(_baseComponent2.default);

exports.default = TabsComponent;

/***/ }),

/***/ "./app/components/tabs/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/upcoming-auctions/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/upcoming-auctions/scss/index.scss");

var _upcomingAuctions = __webpack_require__("./app/components/upcoming-auctions/js/upcoming-auctions.component.js");

var _upcomingAuctions2 = _interopRequireDefault(_upcomingAuctions);

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_componentsCollection2.default.getInstance().define('upcoming-auctions', _upcomingAuctions2.default);

/***/ }),

/***/ "./app/components/upcoming-auctions/js/upcoming-auctions.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TimelineLite = __webpack_require__("./node_modules/gsap/TimelineLite.js");

var _TimelineLite2 = _interopRequireDefault(_TimelineLite);

var _intersectionHelper = __webpack_require__("./app/general/js/intersection-helper.js");

var _intersectionHelper2 = _interopRequireDefault(_intersectionHelper);

var _baseComponent = __webpack_require__("./app/general/js/base-component.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpcomingAuctionsComponent = function (_BaseComponent) {
    _inherits(UpcomingAuctionsComponent, _BaseComponent);

    function UpcomingAuctionsComponent() {
        _classCallCheck(this, UpcomingAuctionsComponent);

        var _this = _possibleConstructorReturn(this, (UpcomingAuctionsComponent.__proto__ || Object.getPrototypeOf(UpcomingAuctionsComponent)).apply(this, arguments));

        _this.auctions = _this.refs.auctions;

        _this.init();
        return _this;
    }

    _createClass(UpcomingAuctionsComponent, [{
        key: 'init',
        value: function init() {
            this.timeline = new _TimelineLite2.default({ paused: true });
            this.timeline.staggerFrom(this.auctions, 0.4, { opacity: 0, left: '-80px', delay: 0.3 }, 0.3);
            _intersectionHelper2.default.enterViewportOnce(this.element, this.render.bind(this));
        }
    }, {
        key: 'render',
        value: function render() {
            this.timeline.play();
        }
    }]);

    return UpcomingAuctionsComponent;
}(_baseComponent2.default);

exports.default = UpcomingAuctionsComponent;

/***/ }),

/***/ "./app/components/upcoming-auctions/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/video/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/video/scss/index.scss");

/***/ }),

/***/ "./app/components/video/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/components/widget-list/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app/components/widget-list/scss/index.scss");

/***/ }),

/***/ "./app/components/widget-list/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/general/html/default-modal-notification-template.hbs":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("./node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"modal__content modal__content--centered\">\r\n    <div class=\"modal__heading\">\r\n        "
    + alias4(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper)))
    + "\r\n    </div>\r\n    <div class=\"modal__body\">\r\n        "
    + alias4(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper)))
    + "\r\n    </div>\r\n    <div class=\"modal__close-link js-modal-close\">close window</div>\r\n</div>\r\n";
},"useData":true});

/***/ }),

/***/ "./app/general/html/default-modal.hbs":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("./node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"modal\">\r\n    <div class=\"modal__container\">\r\n        <div class=\"js-modal-wrapper modal__wrapper\">\r\n            <button type=\"button\" class=\"js-modal-close modal__close\">\r\n                <svg width=\"10\" height=\"10\" class=\"modal__close-icon\">\r\n                    <use xlink:href=\"#icon-cross\"></use>\r\n                </svg>\r\n            </button>\r\n            <div class=\"js-modal-content\">\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n";
},"useData":true});

/***/ }),

/***/ "./app/general/js/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isValidationError = isValidationError;
exports.getValidationErrors = getValidationErrors;

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _toastr = __webpack_require__("./app/general/js/toastr.js");

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = _axios2.default.create({
    timeout: 30000,
    withCredentials: true
});

instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

instance.interceptors.request.use(function (config) {
    config.headers['X-Ensure-Content'] = getPageId();
    return config;
});

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    if (!_axios2.default.isCancel(error)) {
        if (error && error.response) {
            console.error(error.response);
            if (!isValidationError(error)) {
                showErrorNotification(error);
            }
        }
    }

    return Promise.reject(error);
});

function isValidationError(_ref) {
    var _ref$response = _ref.response,
        status = _ref$response.status,
        data = _ref$response.data;

    return status === 400 && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && 'errors' in data;
}

function getValidationErrors(_ref2) {
    var data = _ref2.response.data;

    return data.errors;
}

function showErrorNotification(_ref3) {
    var status = _ref3.response.status;

    var message = void 0;
    switch (status) {
        case 404:
            message = 'Not found';
            break;
        default:
            message = 'Sorry for inconvenience. Please try again later';
    }

    _toastr2.default.error(message, 'Request failed');
}

var pageId = null;

function getPageId() {
    if (pageId === null) {
        pageId = document.body.getAttribute('data-page-id');
    }

    return pageId;
}

exports.default = instance;

/***/ }),

/***/ "./app/general/js/app.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EVENT_AUTH_TRIGGER_CLICK = exports.EVENT_RESIZE_FINISHED = exports.EVENT_DEVICE_TYPE_CHANGED = exports.DEVICE_TYPE_MOBILE = exports.DEVICE_TYPE_TABLET = exports.DEVICE_TYPE_DESKTOP = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _componentsCollection = __webpack_require__("./app/general/js/components-collection.js");

var _componentsCollection2 = _interopRequireDefault(_componentsCollection);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _modernizrBuild = __webpack_require__("./node_modules/imports-loader/index.js?this=>window!./node_modules/exports-loader/index.js?Modernizr!./app/general/js/modernizr-build.js");

var _modernizrBuild2 = _interopRequireDefault(_modernizrBuild);

var _eventBus = __webpack_require__("./app/general/js/event-bus.js");

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEVICE_TYPE_DESKTOP = exports.DEVICE_TYPE_DESKTOP = 'desktop';
var DEVICE_TYPE_TABLET = exports.DEVICE_TYPE_TABLET = 'tablet';
var DEVICE_TYPE_MOBILE = exports.DEVICE_TYPE_MOBILE = 'mobile';

var EVENT_DEVICE_TYPE_CHANGED = exports.EVENT_DEVICE_TYPE_CHANGED = 'device-type-changed';
var EVENT_RESIZE_FINISHED = exports.EVENT_RESIZE_FINISHED = 'resize:finished';
var EVENT_AUTH_TRIGGER_CLICK = exports.EVENT_AUTH_TRIGGER_CLICK = 'auth:trigger-click';

var App = function () {
    function App() {
        _classCallCheck(this, App);

        this.componentsCollection = _componentsCollection2.default.getInstance();
        this.resizeDebounceTime = 150;
        this.timeoutId = null;
        this.isTouch = _modernizrBuild2.default.touchevents;
        this.config = window.appConfig || {};
    }

    _createClass(App, [{
        key: 'init',
        value: function init() {
            this.$window = (0, _jquery2.default)(window);
            this.applyViewportData();
            this.$window.on('resize orientationchange', this.onWindowResize.bind(this));

            this.componentsCollection.init();
        }
    }, {
        key: 'applyViewportData',
        value: function applyViewportData() {
            this.viewport = {
                width: this.$window.outerWidth(),
                height: this.$window.outerHeight(),
                orientation: typeof window.orientation === "undefined" || Math.abs(window.orientation) === 90 ? "landscape" : "portrait"
            };
            this.isDesktop = _modernizrBuild2.default.mq('only screen and (min-width:1024px)');
            if (this.isDesktop) {
                this.isTablet = true;
            } else {
                this.isTablet = _modernizrBuild2.default.mq('only screen and (min-width:768px)');
            }
            this.deviceTypeByViewport = this.isDesktop ? DEVICE_TYPE_DESKTOP : this.isTablet ? DEVICE_TYPE_TABLET : DEVICE_TYPE_MOBILE;
        }
    }, {
        key: 'onWindowResize',
        value: function onWindowResize() {
            if (this.timeoutId !== null) {
                clearTimeout(this.timeoutId);
            }
            this.timeoutId = setTimeout(this.handleWindowResize.bind(this), this.resizeDebounceTime);
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            var oldDeviceType = this.deviceTypeByViewport;
            this.applyViewportData();
            _eventBus2.default.emit(EVENT_RESIZE_FINISHED);
            if (oldDeviceType !== this.deviceTypeByViewport) {
                _eventBus2.default.emit(EVENT_DEVICE_TYPE_CHANGED, oldDeviceType, this.deviceTypeByViewport);
            }
        }
    }, {
        key: 'getConfig',
        value: function getConfig(property) {
            var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            if (!(property in this.config) && defaultValue === undefined) {
                throw new Error('cannot find a property \xAB' + property + '\xBB in config and default value is absent');
            }
            return property in this.config ? this.config[property] : defaultValue;
        }
    }]);

    return App;
}();

var instance = new App();
exports.default = instance;

/***/ }),

/***/ "./app/general/js/base-component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _componentConfig = __webpack_require__("./app/general/js/component-config.js");

var _componentConfig2 = _interopRequireDefault(_componentConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseComponent = function () {
    function BaseComponent(element, _ref) {
        var props = _ref.props,
            id = _ref.id;

        _classCallCheck(this, BaseComponent);

        this.id = id;

        this._isDestroyed = false;
        this.element = element;
        this.props = props || {};
        this.options = {};
        this.refs = {};

        this.checkRequiredProps(this.props);

        if (this.id) {
            this.initOptions();
            this.initRefs();
        }

        this.checkRequiredRefs(this.refs);
    }

    _createClass(BaseComponent, [{
        key: 'initOptions',
        value: function initOptions() {
            var options = {};
            var datasetOptionsProperty = _componentConfig2.default.getDatasetOptionsProperty(this.id);
            if (this.element.dataset && datasetOptionsProperty in this.element.dataset) {
                try {
                    options = JSON.parse(this.element.dataset[datasetOptionsProperty]);
                } catch (error) {
                    console.error('Unable to parse options from ' + datasetOptionsProperty + ' on element:', this.element);
                    return;
                }
            }
            this.options = options;
        }
    }, {
        key: 'initRefs',
        value: function initRefs() {
            var _this = this;

            var refs = {};
            var refElements = [].concat(_toConsumableArray(this.element.querySelectorAll('[' + _componentConfig2.default.getRefProperty(this.id) + ']')));
            if (refElements.length) {
                refElements.forEach(function (element) {
                    var datasetRefProperty = _componentConfig2.default.getDatasetRefProperty(_this.id);
                    if (element.dataset && datasetRefProperty in element.dataset) {
                        _componentConfig2.default.insertToCollection(refs, element.dataset[datasetRefProperty], element);
                    }
                });
            }
            this.refs = refs;
        }
    }, {
        key: 'checkRequiredProps',
        value: function checkRequiredProps(props) {
            this.constructor.getRequiredProps().forEach(function (name) {
                if (!props[name]) {
                    throw new Error('the value of required prop ' + name + ' is ' + props[name]);
                }
            });
        }
    }, {
        key: 'checkRequiredRefs',
        value: function checkRequiredRefs(refs) {
            this.constructor.getRequiredRefs().forEach(function (name) {
                if (!refs[name]) {
                    throw new Error('the value of required ref ' + name + ' is ' + refs[name]);
                }
            });
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this._isDestroyed = true;
            this.onDestroy();
        }
    }, {
        key: 'isDestroyed',
        value: function isDestroyed() {
            return this._isDestroyed;
        }
    }, {
        key: 'onDestroy',
        value: function onDestroy() {
            // hook for children
        }
    }], [{
        key: 'getRequiredProps',
        value: function getRequiredProps() {
            return [];
        }
    }, {
        key: 'getRequiredRefs',
        value: function getRequiredRefs() {
            return [];
        }
    }]);

    return BaseComponent;
}();

exports.default = BaseComponent;

/***/ }),

/***/ "./app/general/js/component-config.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ComponentConfig = function () {
    function ComponentConfig(id, className) {
        _classCallCheck(this, ComponentConfig);

        this.id = id;
        this.className = className;
    }

    _createClass(ComponentConfig, null, [{
        key: 'getComponentProperty',
        value: function getComponentProperty() {
            return 'data-dc';
        }
    }, {
        key: 'getDatasetCamelCase',
        value: function getDatasetCamelCase(attrName) {
            attrName = attrName.substr(5);
            return this.getCamelCaseSrt(attrName);
        }
    }, {
        key: 'getCamelCaseSrt',
        value: function getCamelCaseSrt(str) {
            return str.replace(/-./g, function (word) {
                return word.charAt(1).toUpperCase();
            });
        }
    }, {
        key: 'getOptionsProperty',
        value: function getOptionsProperty(id) {
            return 'data-dc-' + id + '-options';
        }
    }, {
        key: 'getRefProperty',
        value: function getRefProperty(id) {
            return 'data-dc-' + id + '-ref';
        }
    }, {
        key: 'getDatasetOptionsProperty',
        value: function getDatasetOptionsProperty(id) {
            return this.getDatasetCamelCase(this.getOptionsProperty(id));
        }
    }, {
        key: 'getDatasetRefProperty',
        value: function getDatasetRefProperty(id) {
            return this.getDatasetCamelCase(this.getRefProperty(id));
        }
    }, {
        key: 'insertToCollection',
        value: function insertToCollection(result, name, value) {
            name = this.getCamelCaseSrt(name);
            var arrayRegexp = /(.+)\[(.*)\]/;
            var arrayParseResult = name.match(arrayRegexp);
            if (arrayParseResult !== null) {
                var _name = arrayParseResult[1];
                var key = arrayParseResult[2];
                var isObject = key !== '';
                if (!(_name in result)) {
                    result[_name] = isObject ? {} : [];
                }
                if (isObject) {
                    result[_name][key] = value;
                } else {
                    result[_name].push(value);
                }
            } else {
                result[name] = value;
            }
        }
    }]);

    return ComponentConfig;
}();

exports.default = ComponentConfig;

/***/ }),

/***/ "./app/general/js/components-collection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _componentConfig = __webpack_require__("./app/general/js/component-config.js");

var _componentConfig2 = _interopRequireDefault(_componentConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ComponentsCollection = function () {
    _createClass(ComponentsCollection, null, [{
        key: 'getInstance',
        value: function getInstance() {
            if (ComponentsCollection.instance === null) {
                ComponentsCollection.instance = new ComponentsCollection();
            }
            return ComponentsCollection.instance;
        }
    }]);

    function ComponentsCollection() {
        _classCallCheck(this, ComponentsCollection);

        if (ComponentsCollection.instance !== null) {
            return ComponentsCollection.instance;
        }

        this.registeredConfigs = [];
        this.instances = [];
    }

    _createClass(ComponentsCollection, [{
        key: 'define',
        value: function define(id, className) {
            var componentConfig = new _componentConfig2.default(id, className);
            this.registeredConfigs.push(componentConfig);
        }
    }, {
        key: 'init',
        value: function init() {
            var _this = this;

            var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.registeredConfigs.forEach(function (config) {
                // we are able to create the same component on the same node multiple times
                // and we don't want to change existing ones or add repetitive to this.instances
                var createdInstances = _this._bootstrapConfig(config, root);
                var newInstances = createdInstances.reduce(function (result, instance) {
                    if (_this.instances.indexOf(instance) === -1) {
                        result.push(instance);
                    }
                    return result;
                }, []);

                if (newInstances.length > 0) {
                    _this.instances = [].concat(_toConsumableArray(_this.instances), _toConsumableArray(newInstances));
                }
            });
        }
    }, {
        key: 'createComponents',
        value: function createComponents(root, id, className) {
            var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            var config = new _componentConfig2.default(id, className);
            return this._bootstrapConfig(config, root, props);
        }
    }, {
        key: 'createComponent',
        value: function createComponent(root, id, className) {
            var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            var components = this.createComponents(root, id, className, props);
            return components.length > 0 ? components[0] : null;
        }
    }, {
        key: 'destroy',
        value: function destroy(root) {
            var _this2 = this;

            this.instances = this.instances.filter(function (instance) {
                if (instance.element === root || root.contains(instance.element)) {
                    _this2._destroyComponent(instance);
                    return false;
                }

                return true;
            });
        }
    }, {
        key: '_bootstrapConfig',
        value: function _bootstrapConfig(componentConfig) {
            var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (root === null) {
                root = document.body;
            }
            var className = componentConfig.className;

            //finds component1 for data-dc="component1,component2" but not data-dc="component11,component2"
            var selector1 = '[' + _componentConfig2.default.getComponentProperty() + '*="' + componentConfig.id + ',"]';
            //finds component2 for data-dc="component1,component2"
            var selector2 = '[' + _componentConfig2.default.getComponentProperty() + '$="' + componentConfig.id + '"]';
            var elements = [].concat(_toConsumableArray(root.querySelectorAll(selector1)), _toConsumableArray(root.querySelectorAll(selector2)));

            var instances = [];

            elements.forEach(function (element) {
                if (!element.components) {
                    element.components = {};
                }

                if (element.components[componentConfig.id]) {
                    instances.push(element.components[componentConfig.id]);
                } else {
                    try {
                        var instance = new className(element, {
                            props: props,
                            id: componentConfig.id
                        });
                        element.components[componentConfig.id] = instance;
                        instances.push(instance);
                    } catch (error) {
                        console.error('Component ' + className.name + ' with id "' + componentConfig.id + '" was not created due to error: ' + error.message, element);
                        console.error(error);
                    }
                }
            });

            return instances;
        }
    }, {
        key: '_destroyComponent',
        value: function _destroyComponent(component) {
            component.element.components[component.id] = null;
            component.destroy();
        }
    }]);

    return ComponentsCollection;
}();

exports.default = ComponentsCollection;


ComponentsCollection.instance = null;

/***/ }),

/***/ "./app/general/js/content-blocker.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContentBlocker = function () {
    function ContentBlocker() {
        _classCallCheck(this, ContentBlocker);

        this.body = document.body;
        this.pageOffset = 0;
        this._isBlocked = false;
        this._isOverlapped = false;
        this.sources = {};
        this.overlap = {};
    }

    _createClass(ContentBlocker, [{
        key: 'block',
        value: function block(source) {
            var overlap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this.sources[source] = true;
            this.overlap[source] = overlap;
            if (!this._isBlocked) {
                if (_app2.default.isTouch) {
                    this.pageOffset = window.pageYOffset;
                    this.body.classList.add('is-blocked-touch');
                    this.body.style.top = -this.pageOffset + 'px';
                } else {
                    this.body.classList.add('is-blocked');
                }
                this._isBlocked = true;
            }
            if (!this._isOverlapped && overlap) {
                this.body.classList.add('is-overlapped');
                this._isOverlapped = true;
            }
        }
    }, {
        key: 'unblock',
        value: function unblock(source) {
            this.sources[source] = false;
            this.overlap[source] = false;
            if (this.isFree() && this._isBlocked) {
                if (_app2.default.isTouch) {
                    this.body.style.top = 'initial';
                    this.body.classList.remove('is-blocked-touch');
                    window.scrollTo(0, this.pageOffset);
                } else {
                    this.body.classList.remove('is-blocked');
                }
                this._isBlocked = false;
            }
            if (this.isNotOverlapped() && this._isOverlapped) {
                this.body.classList.remove('is-overlapped');
                this._isOverlapped = false;
            }
        }
    }, {
        key: 'isBlocked',
        value: function isBlocked(source) {
            return this.sources[source] === true;
        }
    }, {
        key: 'isFree',
        value: function isFree() {
            var _this = this;

            return Object.keys(this.sources).every(function (key) {
                return _this.sources[key] === false;
            });
        }
    }, {
        key: 'isNotOverlapped',
        value: function isNotOverlapped() {
            var _this2 = this;

            return Object.keys(this.overlap).every(function (key) {
                return _this2.overlap[key] === false;
            });
        }
    }]);

    return ContentBlocker;
}();

var instance = new ContentBlocker();

exports.default = instance;

/***/ }),

/***/ "./app/general/js/create-event.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createEvent;
function createEvent(name) {
    if (typeof Event === 'function') {
        return new Event(name, { bubbles: true });
    } else {
        var event = document.createEvent("Event");
        event.initEvent(name, true, true);
        return event;
    }
};

/***/ }),

/***/ "./app/general/js/event-bus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fbemitter = __webpack_require__("./node_modules/fbemitter/index.js");

var emitter = new _fbemitter.EventEmitter();
exports.default = emitter;

/***/ }),

/***/ "./app/general/js/font-loader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fontsPromise = undefined;

var _fontfaceobserver = __webpack_require__("./node_modules/fontfaceobserver/fontfaceobserver.standalone.js");

var _fontfaceobserver2 = _interopRequireDefault(_fontfaceobserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//global fonts loading error handler
function reject(error) {
    console.error('Fond loading error:', error);
    return Promise.reject(error);
}

var fonts = [];
var opensansLight = new _fontfaceobserver2.default('Open Sans', {
    weight: 300
});
var opensansRegular = new _fontfaceobserver2.default('Open Sans', {
    weight: 400
});
var opensansSemiBold = new _fontfaceobserver2.default('Open Sans', {
    weight: 600
});
var opensansBold = new _fontfaceobserver2.default('Open Sans', {
    weight: 700
});

var timeout = 4000;
fonts.push(opensansLight.load(null, timeout));
fonts.push(opensansRegular.load(null, timeout));
fonts.push(opensansSemiBold.load(null, timeout));
fonts.push(opensansBold.load(null, timeout));

var fontsPromise = Promise.all(fonts).then(function () {
    if (!sessionStorage.isFontsLoaded) {
        document.documentElement.className += " fonts-loaded";
        sessionStorage.isFontsLoaded = true;
    }
}, function (error) {
    return reject(error);
});

//by chaining from this promise we are able to catch font loading error
exports.fontsPromise = fontsPromise;

//by chaining from this promise we are able to make sure all fonts process are finished

var fontsFinally = fontsPromise.catch(function () {
    //we do not want to handle just wrap
});

exports.default = fontsFinally;

/***/ }),

/***/ "./app/general/js/gtm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GTM = function () {
    function GTM() {
        _classCallCheck(this, GTM);
    }

    _createClass(GTM, [{
        key: "push",
        value: function push(event) {
            if (event) {
                window.dataLayer.push(event);
            }
        }
    }]);

    return GTM;
}();

exports.default = new GTM();

/***/ }),

/***/ "./app/general/js/html-helper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

var _createEvent = __webpack_require__("./app/general/js/create-event.js");

var _createEvent2 = _interopRequireDefault(_createEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FIELD_TYPE_TEXT = 1;
var FIELD_TYPE_TEXTAREA = 2;
var FIELD_TYPE_SELECT = 3;
var FIELD_TYPE_RADIO = 4;
var FIELD_TYPE_CHECKBOX = 5;
var FIELD_TYPE_FILE = 6;

var HtmlHelper = function () {
    function HtmlHelper() {
        _classCallCheck(this, HtmlHelper);
    }

    _createClass(HtmlHelper, null, [{
        key: "createElement",
        value: function createElement(htmlString) {
            var domParser = new DOMParser();
            var pseudoDocument = domParser.parseFromString(htmlString, "text/html");
            return pseudoDocument.body.firstChild;
        }
    }, {
        key: "safeAddEventListener",
        value: function safeAddEventListener(element) {
            if (element) {
                var args = [].concat(Array.prototype.slice.call(arguments)).slice(1);
                element.addEventListener.apply(element, args);
            }
        }
    }, {
        key: "hasElementParentWithClass",
        value: function hasElementParentWithClass(target, parentClass) {
            var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            return this.getElementParentWithClass(target, parentClass, includeSelf) !== null;
        }
    }, {
        key: "getElementParentWithClass",
        value: function getElementParentWithClass(target, parentClass) {
            var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


            if (includeSelf && target.classList.contains(parentClass)) {
                return target;
            }

            var parent = target.parentElement;
            while (parent !== null) {
                if (parent.classList.contains(parentClass)) {
                    return parent;
                }
                parent = parent.parentElement;
            }

            return null;
        }
    }, {
        key: "isHtmlElement",
        value: function isHtmlElement(element) {
            return (typeof element === "undefined" ? "undefined" : _typeof(element)) === 'object' && 'nodeType' in element;
        }
    }, {
        key: "getSrcSet",
        value: function getSrcSet(imageUrl) {
            var addSizes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var defaultSizes = [320, 360, 640, 720, 1280, 1440];
            var sizes = [].concat(defaultSizes);

            if (addSizes && addSizes.length > 0) {
                sizes = [].concat(_toConsumableArray(sizes), _toConsumableArray(addSizes));
            }

            if (!imageUrl || imageUrl.length === 0) {
                imageUrl = _app2.default.getConfig('defaultImageUrl', null);
            }

            if (imageUrl === null) {
                return "";
            }

            return sizes.map(function (width) {
                return HtmlHelper.GetResizedMediaUrl(imageUrl, width) + " " + width + "w";
            }).join(', ');
        }
    }, {
        key: "GetResizedMediaUrl",
        value: function GetResizedMediaUrl(imageUrl, width) {
            if (imageUrl) {
                imageUrl = imageUrl.replace(/(~)|&?(width|height)=[0-9]+/, "");
                imageUrl = imageUrl.replace(/\?&/, "");
                imageUrl = imageUrl.replace(/(\?|&)$/, "");

                var paramsPrefix = imageUrl.indexOf('?') === -1 ? '?' : '&';
                imageUrl = imageUrl + paramsPrefix;
                return imageUrl + "width=" + width;
            }

            return '';
        }
    }, {
        key: "getSectionFormFields",
        value: function getSectionFormFields(root) {
            return [].concat(_toConsumableArray(root.querySelectorAll('input, select, textarea')));
        }
    }, {
        key: "resetFormSection",
        value: function resetFormSection(root) {
            var _this = this;

            this.getSectionFormFields(root).forEach(function (field) {
                return _this.resetFormField(field);
            });
        }
    }, {
        key: "resetFormSections",
        value: function resetFormSections(sections) {
            var _this2 = this;

            sections.forEach(function (section) {
                return _this2.resetFormSection(section);
            });
        }
    }, {
        key: "isTextField",
        value: function isTextField(element) {
            return this.getFieldType(element) === FIELD_TYPE_TEXT;
        }
    }, {
        key: "isTextareaField",
        value: function isTextareaField(element) {
            return this.getFieldType(element) === FIELD_TYPE_TEXTAREA;
        }
    }, {
        key: "isCheckboxField",
        value: function isCheckboxField(element) {
            return this.getFieldType(element) === FIELD_TYPE_CHECKBOX;
        }
    }, {
        key: "isSelectField",
        value: function isSelectField(element) {
            return this.getFieldType(element) === FIELD_TYPE_SELECT;
        }
    }, {
        key: "getFieldType",
        value: function getFieldType(element) {
            var result = null;

            switch (element.tagName) {
                case 'INPUT':
                    switch (element.type) {
                        case 'text':
                            result = FIELD_TYPE_TEXT;
                            break;
                        case 'radio':
                            result = FIELD_TYPE_RADIO;
                            break;
                        case 'checkbox':
                            result = FIELD_TYPE_CHECKBOX;
                            break;
                        case 'file':
                            result = FIELD_TYPE_FILE;
                            break;
                    }
                    break;
                case 'TEXTAREA':
                    result = FIELD_TYPE_TEXTAREA;
                    break;
                case 'SELECT':
                    result = FIELD_TYPE_SELECT;
                    break;
            }
            return result;
        }
    }, {
        key: "resetFormField",
        value: function resetFormField(element) {
            if (this.isHtmlElement(element)) {
                var type = this.getFieldType(element);
                if (type) {
                    switch (type) {
                        case FIELD_TYPE_TEXT:
                        case FIELD_TYPE_TEXTAREA:
                        case FIELD_TYPE_FILE:
                            element.value = element.defaultValue;
                            break;
                        case FIELD_TYPE_SELECT:
                            [].concat(_toConsumableArray(element.querySelectorAll('option'))).forEach(function (option) {
                                return option.selected = option.defaultSelected;
                            });
                            break;
                        case FIELD_TYPE_RADIO:
                        case FIELD_TYPE_CHECKBOX:
                            element.checked = element.defaultChecked;
                            break;
                    }
                }
            }
        }
    }, {
        key: "hasFormSectionsDirtyFields",
        value: function hasFormSectionsDirtyFields(sections) {
            var _this3 = this;

            return sections.some(function (section) {
                return _this3.hasFormSectionDirtyFields(section);
            });
        }
    }, {
        key: "hasFormSectionDirtyFields",
        value: function hasFormSectionDirtyFields(root) {
            var _this4 = this;

            return this.getSectionFormFields(root).some(function (field) {
                return _this4.isFieldDirty(field);
            });
        }
    }, {
        key: "isFieldDirty",
        value: function isFieldDirty(element) {
            var result = false;

            var type = this.getFieldType(element);
            if (type) {
                switch (type) {
                    case FIELD_TYPE_TEXT:
                    case FIELD_TYPE_TEXTAREA:
                    case FIELD_TYPE_FILE:
                        result = element.value !== element.defaultValue;
                        break;
                    case FIELD_TYPE_SELECT:
                        result = [].concat(_toConsumableArray(element.querySelectorAll('option'))).some(function (option) {
                            return option.selected !== option.defaultSelected;
                        });
                        break;
                    case FIELD_TYPE_RADIO:
                    case FIELD_TYPE_CHECKBOX:
                        result = element.checked !== element.defaultChecked;
                        break;
                }
            }

            return result;
        }
    }, {
        key: "hideFormHiddenGroup",
        value: function hideFormHiddenGroup(confirmationCheckboxesSection) {
            confirmationCheckboxesSection.setAttribute('data-hidden-group', 'is-hidden');
        }
    }, {
        key: "showFormHiddenGroup",
        value: function showFormHiddenGroup(confirmationCheckboxesSection) {
            confirmationCheckboxesSection.setAttribute('data-hidden-group', '');
        }
    }]);

    return HtmlHelper;
}();

exports.default = HtmlHelper;

/***/ }),

/***/ "./app/general/js/intersection-helper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IntersectionHelper = function () {
    function IntersectionHelper() {
        _classCallCheck(this, IntersectionHelper);

        //take a fixed header into consideration
        this.defaultOptions = {
            rootMargin: '-100px 0px 0px 0px'
        };
    }

    _createClass(IntersectionHelper, [{
        key: 'enterViewportOnce',
        value: function enterViewportOnce(element, callback) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            options = _extends({}, this.defaultOptions, options);
            var observer = new IntersectionObserver(function (changes, observer) {
                var change = changes[0];
                if (change.isIntersecting) {
                    observer.disconnect();
                    callback(change);
                }
            }, options);
            observer.observe(element);
            return observer;
        }
    }, {
        key: 'enterViewport',
        value: function enterViewport(element, callback) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            options = _extends({}, this.defaultOptions, options);
            var observer = new IntersectionObserver(function (changes, observer) {
                var change = changes[0];
                if (change.isIntersecting) {
                    callback(change);
                }
            }, options);
            observer.observe(element);
            return observer;
        }
    }]);

    return IntersectionHelper;
}();

var instance = new IntersectionHelper();
exports.default = instance;

/***/ }),

/***/ "./app/general/js/inview.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
Waypoints Inview Shortcut - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blog/master/licenses.txt
*/
(function () {
  'use strict';

  function noop() {}

  var Waypoint = window.Waypoint;

  /* http://imakewebthings.com/waypoints/shortcuts/inview */
  function Inview(options) {
    this.options = Waypoint.Adapter.extend({}, Inview.defaults, options);
    this.axis = this.options.horizontal ? 'horizontal' : 'vertical';
    this.waypoints = [];
    this.element = this.options.element;
    this.createWaypoints();
  }

  /* Private */
  Inview.prototype.createWaypoints = function () {
    var configs = {
      vertical: [{
        down: 'enter',
        up: 'exited',
        offset: '100%'
      }, {
        down: 'entered',
        up: 'exit',
        offset: 'bottom-in-view'
      }, {
        down: 'exit',
        up: 'entered',
        offset: 0
      }, {
        down: 'exited',
        up: 'enter',
        offset: function offset() {
          return -this.adapter.outerHeight();
        }
      }],
      horizontal: [{
        right: 'enter',
        left: 'exited',
        offset: '100%'
      }, {
        right: 'entered',
        left: 'exit',
        offset: 'right-in-view'
      }, {
        right: 'exit',
        left: 'entered',
        offset: 0
      }, {
        right: 'exited',
        left: 'enter',
        offset: function offset() {
          return -this.adapter.outerWidth();
        }
      }]
    };

    for (var i = 0, end = configs[this.axis].length; i < end; i++) {
      var config = configs[this.axis][i];
      this.createWaypoint(config);
    }
  };

  /* Private */
  Inview.prototype.createWaypoint = function (config) {
    var self = this;
    this.waypoints.push(new Waypoint({
      context: this.options.context,
      element: this.options.element,
      enabled: this.options.enabled,
      handler: function (config) {
        return function (direction) {
          self.options[config[direction]].call(self, direction);
        };
      }(config),
      offset: config.offset,
      horizontal: this.options.horizontal
    }));
  };

  /* Public */
  Inview.prototype.destroy = function () {
    for (var i = 0, end = this.waypoints.length; i < end; i++) {
      this.waypoints[i].destroy();
    }
    this.waypoints = [];
  };

  Inview.prototype.disable = function () {
    for (var i = 0, end = this.waypoints.length; i < end; i++) {
      this.waypoints[i].disable();
    }
  };

  Inview.prototype.enable = function () {
    for (var i = 0, end = this.waypoints.length; i < end; i++) {
      this.waypoints[i].enable();
    }
  };

  Inview.defaults = {
    context: window,
    enabled: true,
    enter: noop,
    entered: noop,
    exit: noop,
    exited: noop
  };

  Waypoint.Inview = Inview;
})();

/***/ }),

/***/ "./app/general/js/jquery-plugins.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./node_modules/jquery-serializejson/jquery.serializejson.js");

__webpack_require__("./node_modules/owl.carousel/dist/owl.carousel.js");

__webpack_require__("./node_modules/owl.carousel/src/js/owl.autoheight.js");

/***/ }),

/***/ "./app/general/js/jquery.waypoints.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {

/*!
Waypoints - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blog/master/licenses.txt
*/
(function () {
  'use strict';

  var keyCounter = 0;
  var allWaypoints = {};

  /* http://imakewebthings.com/waypoints/api/waypoint */
  function Waypoint(options) {
    if (!options) {
      throw new Error('No options passed to Waypoint constructor');
    }
    if (!options.element) {
      throw new Error('No element option passed to Waypoint constructor');
    }
    if (!options.handler) {
      throw new Error('No handler option passed to Waypoint constructor');
    }

    this.key = 'waypoint-' + keyCounter;
    this.options = Waypoint.Adapter.extend({}, Waypoint.defaults, options);
    this.element = this.options.element;
    this.adapter = new Waypoint.Adapter(this.element);
    this.callback = options.handler;
    this.axis = this.options.horizontal ? 'horizontal' : 'vertical';
    this.enabled = this.options.enabled;
    this.triggerPoint = null;
    this.group = Waypoint.Group.findOrCreate({
      name: this.options.group,
      axis: this.axis
    });
    this.context = Waypoint.Context.findOrCreateByElement(this.options.context);

    if (Waypoint.offsetAliases[this.options.offset]) {
      this.options.offset = Waypoint.offsetAliases[this.options.offset];
    }
    this.group.add(this);
    this.context.add(this);
    allWaypoints[this.key] = this;
    keyCounter += 1;
  }

  /* Private */
  Waypoint.prototype.queueTrigger = function (direction) {
    this.group.queueTrigger(this, direction);
  };

  /* Private */
  Waypoint.prototype.trigger = function (args) {
    if (!this.enabled) {
      return;
    }
    if (this.callback) {
      this.callback.apply(this, args);
    }
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy */
  Waypoint.prototype.destroy = function () {
    this.context.remove(this);
    this.group.remove(this);
    delete allWaypoints[this.key];
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable */
  Waypoint.prototype.disable = function () {
    this.enabled = false;
    return this;
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable */
  Waypoint.prototype.enable = function () {
    this.context.refresh();
    this.enabled = true;
    return this;
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/next */
  Waypoint.prototype.next = function () {
    return this.group.next(this);
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/previous */
  Waypoint.prototype.previous = function () {
    return this.group.previous(this);
  };

  /* Private */
  Waypoint.invokeAll = function (method) {
    var allWaypointsArray = [];
    for (var waypointKey in allWaypoints) {
      allWaypointsArray.push(allWaypoints[waypointKey]);
    }
    for (var i = 0, end = allWaypointsArray.length; i < end; i++) {
      allWaypointsArray[i][method]();
    }
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy-all */
  Waypoint.destroyAll = function () {
    Waypoint.invokeAll('destroy');
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable-all */
  Waypoint.disableAll = function () {
    Waypoint.invokeAll('disable');
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable-all */
  Waypoint.enableAll = function () {
    Waypoint.invokeAll('enable');
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/refresh-all */
  Waypoint.refreshAll = function () {
    Waypoint.Context.refreshAll();
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-height */
  Waypoint.viewportHeight = function () {
    return window.innerHeight || document.documentElement.clientHeight;
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-width */
  Waypoint.viewportWidth = function () {
    return document.documentElement.clientWidth;
  };

  Waypoint.adapters = [];

  Waypoint.defaults = {
    context: window,
    continuous: true,
    enabled: true,
    group: 'default',
    horizontal: false,
    offset: 0
  };

  Waypoint.offsetAliases = {
    'bottom-in-view': function bottomInView() {
      return this.context.innerHeight() - this.adapter.outerHeight();
    },
    'right-in-view': function rightInView() {
      return this.context.innerWidth() - this.adapter.outerWidth();
    }
  };

  window.Waypoint = Waypoint;
})();(function () {
  'use strict';

  function requestAnimationFrameShim(callback) {
    window.setTimeout(callback, 1000 / 60);
  }

  var keyCounter = 0;
  var contexts = {};
  var Waypoint = window.Waypoint;
  var oldWindowLoad = window.onload;

  /* http://imakewebthings.com/waypoints/api/context */
  function Context(element) {
    this.element = element;
    this.Adapter = Waypoint.Adapter;
    this.adapter = new this.Adapter(element);
    this.key = 'waypoint-context-' + keyCounter;
    this.didScroll = false;
    this.didResize = false;
    this.oldScroll = {
      x: this.adapter.scrollLeft(),
      y: this.adapter.scrollTop()
    };
    this.waypoints = {
      vertical: {},
      horizontal: {}
    };

    element.waypointContextKey = this.key;
    contexts[element.waypointContextKey] = this;
    keyCounter += 1;

    this.createThrottledScrollHandler();
    this.createThrottledResizeHandler();
  }

  /* Private */
  Context.prototype.add = function (waypoint) {
    var axis = waypoint.options.horizontal ? 'horizontal' : 'vertical';
    this.waypoints[axis][waypoint.key] = waypoint;
    this.refresh();
  };

  /* Private */
  Context.prototype.checkEmpty = function () {
    var horizontalEmpty = this.Adapter.isEmptyObject(this.waypoints.horizontal);
    var verticalEmpty = this.Adapter.isEmptyObject(this.waypoints.vertical);
    if (horizontalEmpty && verticalEmpty) {
      this.adapter.off('.waypoints');
      delete contexts[this.key];
    }
  };

  /* Private */
  Context.prototype.createThrottledResizeHandler = function () {
    var self = this;

    function resizeHandler() {
      self.handleResize();
      self.didResize = false;
    }

    this.adapter.on('resize.waypoints', function () {
      if (!self.didResize) {
        self.didResize = true;
        Waypoint.requestAnimationFrame(resizeHandler);
      }
    });
  };

  /* Private */
  Context.prototype.createThrottledScrollHandler = function () {
    var self = this;
    function scrollHandler() {
      self.handleScroll();
      self.didScroll = false;
    }

    this.adapter.on('scroll.waypoints', function () {
      if (!self.didScroll || Waypoint.isTouch) {
        self.didScroll = true;
        Waypoint.requestAnimationFrame(scrollHandler);
      }
    });
  };

  /* Private */
  Context.prototype.handleResize = function () {
    Waypoint.Context.refreshAll();
  };

  /* Private */
  Context.prototype.handleScroll = function () {
    var triggeredGroups = {};
    var axes = {
      horizontal: {
        newScroll: this.adapter.scrollLeft(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left'
      },
      vertical: {
        newScroll: this.adapter.scrollTop(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up'
      }
    };

    for (var axisKey in axes) {
      var axis = axes[axisKey];
      var isForward = axis.newScroll > axis.oldScroll;
      var direction = isForward ? axis.forward : axis.backward;

      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey];
        var wasBeforeTriggerPoint = axis.oldScroll < waypoint.triggerPoint;
        var nowAfterTriggerPoint = axis.newScroll >= waypoint.triggerPoint;
        var crossedForward = wasBeforeTriggerPoint && nowAfterTriggerPoint;
        var crossedBackward = !wasBeforeTriggerPoint && !nowAfterTriggerPoint;
        if (crossedForward || crossedBackward) {
          waypoint.queueTrigger(direction);
          triggeredGroups[waypoint.group.id] = waypoint.group;
        }
      }
    }

    for (var groupKey in triggeredGroups) {
      triggeredGroups[groupKey].flushTriggers();
    }

    this.oldScroll = {
      x: axes.horizontal.newScroll,
      y: axes.vertical.newScroll
    };
  };

  /* Private */
  Context.prototype.innerHeight = function () {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportHeight();
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerHeight();
  };

  /* Private */
  Context.prototype.remove = function (waypoint) {
    delete this.waypoints[waypoint.axis][waypoint.key];
    this.checkEmpty();
  };

  /* Private */
  Context.prototype.innerWidth = function () {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportWidth();
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerWidth();
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-destroy */
  Context.prototype.destroy = function () {
    var allWaypoints = [];
    for (var axis in this.waypoints) {
      for (var waypointKey in this.waypoints[axis]) {
        allWaypoints.push(this.waypoints[axis][waypointKey]);
      }
    }
    for (var i = 0, end = allWaypoints.length; i < end; i++) {
      allWaypoints[i].destroy();
    }
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-refresh */
  Context.prototype.refresh = function () {
    /*eslint-disable eqeqeq */
    var isWindow = this.element == this.element.window;
    /*eslint-enable eqeqeq */
    var contextOffset = isWindow ? undefined : this.adapter.offset();
    var triggeredGroups = {};
    var axes;

    this.handleScroll();
    axes = {
      horizontal: {
        contextOffset: isWindow ? 0 : contextOffset.left,
        contextScroll: isWindow ? 0 : this.oldScroll.x,
        contextDimension: this.innerWidth(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left',
        offsetProp: 'left'
      },
      vertical: {
        contextOffset: isWindow ? 0 : contextOffset.top,
        contextScroll: isWindow ? 0 : this.oldScroll.y,
        contextDimension: this.innerHeight(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up',
        offsetProp: 'top'
      }
    };

    for (var axisKey in axes) {
      var axis = axes[axisKey];
      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey];
        var adjustment = waypoint.options.offset;
        var oldTriggerPoint = waypoint.triggerPoint;
        var elementOffset = 0;
        var freshWaypoint = oldTriggerPoint == null;
        var contextModifier, wasBeforeScroll, nowAfterScroll;
        var triggeredBackward, triggeredForward;

        if (waypoint.element !== waypoint.element.window) {
          elementOffset = waypoint.adapter.offset()[axis.offsetProp];
        }

        if (typeof adjustment === 'function') {
          adjustment = adjustment.apply(waypoint);
        } else if (typeof adjustment === 'string') {
          adjustment = parseFloat(adjustment);
          if (waypoint.options.offset.indexOf('%') > -1) {
            adjustment = Math.ceil(axis.contextDimension * adjustment / 100);
          }
        }

        contextModifier = axis.contextScroll - axis.contextOffset;
        waypoint.triggerPoint = elementOffset + contextModifier - adjustment;
        wasBeforeScroll = oldTriggerPoint < axis.oldScroll;
        nowAfterScroll = waypoint.triggerPoint >= axis.oldScroll;
        triggeredBackward = wasBeforeScroll && nowAfterScroll;
        triggeredForward = !wasBeforeScroll && !nowAfterScroll;

        if (!freshWaypoint && triggeredBackward) {
          waypoint.queueTrigger(axis.backward);
          triggeredGroups[waypoint.group.id] = waypoint.group;
        } else if (!freshWaypoint && triggeredForward) {
          waypoint.queueTrigger(axis.forward);
          triggeredGroups[waypoint.group.id] = waypoint.group;
        } else if (freshWaypoint && axis.oldScroll >= waypoint.triggerPoint) {
          waypoint.queueTrigger(axis.forward);
          triggeredGroups[waypoint.group.id] = waypoint.group;
        }
      }
    }

    Waypoint.requestAnimationFrame(function () {
      for (var groupKey in triggeredGroups) {
        triggeredGroups[groupKey].flushTriggers();
      }
    });

    return this;
  };

  /* Private */
  Context.findOrCreateByElement = function (element) {
    return Context.findByElement(element) || new Context(element);
  };

  /* Private */
  Context.refreshAll = function () {
    for (var contextId in contexts) {
      contexts[contextId].refresh();
    }
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-find-by-element */
  Context.findByElement = function (element) {
    return contexts[element.waypointContextKey];
  };

  window.onload = function () {
    if (oldWindowLoad) {
      oldWindowLoad();
    }
    Context.refreshAll();
  };

  Waypoint.requestAnimationFrame = function (callback) {
    var requestFn = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || requestAnimationFrameShim;
    requestFn.call(window, callback);
  };
  Waypoint.Context = Context;
})();(function () {
  'use strict';

  function byTriggerPoint(a, b) {
    return a.triggerPoint - b.triggerPoint;
  }

  function byReverseTriggerPoint(a, b) {
    return b.triggerPoint - a.triggerPoint;
  }

  var groups = {
    vertical: {},
    horizontal: {}
  };
  var Waypoint = window.Waypoint;

  /* http://imakewebthings.com/waypoints/api/group */
  function Group(options) {
    this.name = options.name;
    this.axis = options.axis;
    this.id = this.name + '-' + this.axis;
    this.waypoints = [];
    this.clearTriggerQueues();
    groups[this.axis][this.name] = this;
  }

  /* Private */
  Group.prototype.add = function (waypoint) {
    this.waypoints.push(waypoint);
  };

  /* Private */
  Group.prototype.clearTriggerQueues = function () {
    this.triggerQueues = {
      up: [],
      down: [],
      left: [],
      right: []
    };
  };

  /* Private */
  Group.prototype.flushTriggers = function () {
    for (var direction in this.triggerQueues) {
      var waypoints = this.triggerQueues[direction];
      var reverse = direction === 'up' || direction === 'left';
      waypoints.sort(reverse ? byReverseTriggerPoint : byTriggerPoint);
      for (var i = 0, end = waypoints.length; i < end; i += 1) {
        var waypoint = waypoints[i];
        if (waypoint.options.continuous || i === waypoints.length - 1) {
          waypoint.trigger([direction]);
        }
      }
    }
    this.clearTriggerQueues();
  };

  /* Private */
  Group.prototype.next = function (waypoint) {
    this.waypoints.sort(byTriggerPoint);
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints);
    var isLast = index === this.waypoints.length - 1;
    return isLast ? null : this.waypoints[index + 1];
  };

  /* Private */
  Group.prototype.previous = function (waypoint) {
    this.waypoints.sort(byTriggerPoint);
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints);
    return index ? this.waypoints[index - 1] : null;
  };

  /* Private */
  Group.prototype.queueTrigger = function (waypoint, direction) {
    this.triggerQueues[direction].push(waypoint);
  };

  /* Private */
  Group.prototype.remove = function (waypoint) {
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints);
    if (index > -1) {
      this.waypoints.splice(index, 1);
    }
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/first */
  Group.prototype.first = function () {
    return this.waypoints[0];
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/last */
  Group.prototype.last = function () {
    return this.waypoints[this.waypoints.length - 1];
  };

  /* Private */
  Group.findOrCreate = function (options) {
    return groups[options.axis][options.name] || new Group(options);
  };

  Waypoint.Group = Group;
})();(function () {
  'use strict';

  var $ = __webpack_provided_window_dot_jQuery;
  var Waypoint = window.Waypoint;

  function JQueryAdapter(element) {
    this.$element = $(element);
  }

  $.each(['innerHeight', 'innerWidth', 'off', 'offset', 'on', 'outerHeight', 'outerWidth', 'scrollLeft', 'scrollTop'], function (i, method) {
    JQueryAdapter.prototype[method] = function () {
      var args = Array.prototype.slice.call(arguments);
      return this.$element[method].apply(this.$element, args);
    };
  });

  $.each(['extend', 'inArray', 'isEmptyObject'], function (i, method) {
    JQueryAdapter[method] = $[method];
  });

  Waypoint.adapters.push({
    name: 'jquery',
    Adapter: JQueryAdapter
  });
  Waypoint.Adapter = JQueryAdapter;
})();(function () {
  'use strict';

  var Waypoint = window.Waypoint;

  function createExtension(framework) {
    return function () {
      var waypoints = [];
      var overrides = arguments[0];

      if (framework.isFunction(arguments[0])) {
        overrides = framework.extend({}, arguments[1]);
        overrides.handler = arguments[0];
      }

      this.each(function () {
        var options = framework.extend({}, overrides, {
          element: this
        });
        if (typeof options.context === 'string') {
          options.context = framework(this).closest(options.context)[0];
        }
        waypoints.push(new Waypoint(options));
      });

      return waypoints;
    };
  }

  if (__webpack_provided_window_dot_jQuery) {
    __webpack_provided_window_dot_jQuery.fn.waypoint = createExtension(__webpack_provided_window_dot_jQuery);
  }
  if (window.Zepto) {
    window.Zepto.fn.waypoint = createExtension(window.Zepto);
  }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./app/general/js/lot.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _stringIdByLabel;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STATUS_GROUP_PENDING = exports.STATUS_GROUP_PENDING = 'Pending';
var STATUS_GROUP_UNSOLD = exports.STATUS_GROUP_UNSOLD = 'Unsold';
var STATUS_GROUP_SOLD = exports.STATUS_GROUP_SOLD = 'Sold';
var STATUS_GROUP_WITHDRAWN = exports.STATUS_GROUP_WITHDRAWN = 'Withdrawn';

var stringIdByLabel = (_stringIdByLabel = {}, _defineProperty(_stringIdByLabel, STATUS_GROUP_PENDING, 'pending'), _defineProperty(_stringIdByLabel, STATUS_GROUP_UNSOLD, 'unsold'), _defineProperty(_stringIdByLabel, STATUS_GROUP_SOLD, 'sold'), _defineProperty(_stringIdByLabel, STATUS_GROUP_WITHDRAWN, 'withdrawn'), _stringIdByLabel);

var Lot = function () {
    function Lot() {
        _classCallCheck(this, Lot);
    }

    _createClass(Lot, null, [{
        key: 'getStatusStringId',
        value: function getStatusStringId(statusLabel) {
            var result = null;
            if (statusLabel !== null && stringIdByLabel[statusLabel]) {
                result = stringIdByLabel[statusLabel];
            }
            return result;
        }
    }]);

    return Lot;
}();

exports.default = Lot;

/***/ }),

/***/ "./app/general/js/modal-controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _contentBlocker = __webpack_require__("./app/general/js/content-blocker.js");

var _contentBlocker2 = _interopRequireDefault(_contentBlocker);

var _htmlHelper = __webpack_require__("./app/general/js/html-helper.js");

var _htmlHelper2 = _interopRequireDefault(_htmlHelper);

var _TweenLite = __webpack_require__("./node_modules/gsap/TweenLite.js");

var _TweenLite2 = _interopRequireDefault(_TweenLite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModalController = function () {
    _createClass(ModalController, null, [{
        key: 'getInstance',
        value: function getInstance() {
            if (ModalController.instance === null) {
                ModalController.instance = new ModalController();
            }
            return ModalController.instance;
        }
    }]);

    function ModalController() {
        _classCallCheck(this, ModalController);

        this.openedModal = null;
        this.modalOverlay = document.getElementById('modal-overlay');
        this.overlayTween = _TweenLite2.default.fromTo(this.modalOverlay, 0.3, { opacity: '0', display: 'none', paused: true }, { opacity: '1', display: 'block' });
        this.setOuterHandler();
    }

    _createClass(ModalController, [{
        key: 'setOuterHandler',
        value: function setOuterHandler() {
            (0, _jquery2.default)(document).on('click touchstart', this._outerClickHandle.bind(this));
        }
    }, {
        key: '_outerClickHandle',
        value: function _outerClickHandle(e) {
            if (this.openedModal) {
                if (this.openedModal.getElement().contains(e.target)) {
                    if (!this.openedModal.getWrapperElement().contains(e.target)) {
                        this.closeOpened();
                    }
                }
            }
        }
    }, {
        key: 'close',
        value: function close(modal) {
            if (this.openedModal && this.openedModal === modal) {
                this._beforeClose();
                modal.onClose();
                this.openedModal = null;
            }
        }
    }, {
        key: 'swap',
        value: function swap(modal, swapModal) {
            var _this = this;

            if (this.openedModal && this.openedModal === modal) {
                modal.onClose(true).then(function () {
                    swapModal.onOpen();
                    _this.openedModal = swapModal;
                });
            }
        }
    }, {
        key: 'open',
        value: function open(modal) {
            if (this.openedModal) {
                if (this.openedModal !== modal) {
                    this.swap(this.openedModal, modal);
                }
                return;
            }

            modal.onOpen();
            this.openedModal = modal;
            this._afterOpen();
        }
    }, {
        key: '_afterOpen',
        value: function _afterOpen() {
            _contentBlocker2.default.block('modal');
            this.overlayTween.play();
            this.openedModal.getElement().style['-webkit-overflow-scrolling'] = 'touch';
        }
    }, {
        key: '_beforeClose',
        value: function _beforeClose() {
            _contentBlocker2.default.unblock('modal');
            this.overlayTween.reverse();
            this.openedModal.getElement().style['-webkit-overflow-scrolling'] = 'auto';
        }
    }, {
        key: 'closeOpened',
        value: function closeOpened() {
            if (this.openedModal) {
                this.close(this.openedModal);
            }
        }
    }]);

    return ModalController;
}();

exports.default = ModalController;


ModalController.instance = null;

/***/ }),

/***/ "./app/general/js/modal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TimelineLite = __webpack_require__("./node_modules/gsap/TimelineLite.js");

var _TimelineLite2 = _interopRequireDefault(_TimelineLite);

var _htmlHelper = __webpack_require__("./app/general/js/html-helper.js");

var _htmlHelper2 = _interopRequireDefault(_htmlHelper);

var _defaultModal = __webpack_require__("./app/general/html/default-modal.hbs");

var _defaultModal2 = _interopRequireDefault(_defaultModal);

var _modalController = __webpack_require__("./app/general/js/modal-controller.js");

var _modalController2 = _interopRequireDefault(_modalController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var elementModalProperty = Symbol.for("modalProperty");

var Modal = function () {
    _createClass(Modal, null, [{
        key: 'create',
        value: function create(content) {

            var fromString = false;

            //create element if we got a string here
            if (typeof content === 'string') {
                fromString = true;
                content = _htmlHelper2.default.createElement(content);
            }

            if (!_htmlHelper2.default.isHtmlElement(content)) {
                throw new Error('HTMLElement or string are allowed');
            }

            if (fromString) {
                //if we previously create element from string
                //we need to add it to DOM, so pass it through spicific method
                //todo: check if current document and element's document are the same
                if (content.classList.contains(Modal.className)) {
                    //if content is a modal element
                    return Modal.createFromElement(content);
                } else {
                    //if content is a modal content element
                    return Modal.createFromContentElement(content);
                }
            } else {
                var actualModalElement = _htmlHelper2.default.getElementParentWithClass(content, Modal.className);
                //simple check is it just a content of modal
                // or a whole modal element (current element or it's parent)
                if (actualModalElement) {
                    return new Modal(actualModalElement);
                } else {
                    return Modal.createFromContentElement(content);
                }
            }
        }
    }, {
        key: 'createFromContentElement',
        value: function createFromContentElement(contentElement) {
            if (!_htmlHelper2.default.isHtmlElement(contentElement)) {
                throw new Error('HTMLElement or string are allowed');
            }

            var modalElement = _htmlHelper2.default.createElement((0, _defaultModal2.default)());
            var modalContentElement = modalElement.querySelector('.js-modal-content');
            modalContentElement.insertAdjacentElement('beforeend', contentElement);

            return Modal.createFromElement(modalElement);
        }
    }, {
        key: 'createFromElement',
        value: function createFromElement(modalElement) {
            document.body.insertAdjacentElement('beforeend', modalElement);
            return new Modal(modalElement);
        }
    }]);

    function Modal(element) {
        var _this = this;

        _classCallCheck(this, Modal);

        if (!element) {
            throw new Error('element should be valid HTMLElement instance');
        }

        if (element[elementModalProperty]) {
            return element[elementModalProperty];
        } else {
            element[elementModalProperty] = this;
        }

        this.controller = _modalController2.default.getInstance();
        this.element = element;
        this.closeElements = [].concat(_toConsumableArray(this.element.querySelectorAll('.js-modal-close')));
        this.wrapperElement = this.element.querySelector('.js-modal-wrapper');

        this.tween = new _TimelineLite2.default({ paused: true });
        this.tween.fromTo(this.element, 0.3, { opacity: '0' }, { opacity: '1' });

        this.reserseResolve = null;
        this.startResolve = null;

        this.tween.eventCallback('onStart', function () {
            _this.element.classList.add('is-opened');
            if (_this.startResolve) {
                _this.startResolve();
            }
        });
        this.tween.eventCallback('onReverseComplete', function () {
            _this.element.classList.remove('is-opened');
            if (_this.reserseResolve) {
                _this.reserseResolve();
            }
        });

        this.hasOpened = false;
    }

    _createClass(Modal, [{
        key: 'open',
        value: function open() {
            this.controller.open(this);
        }
    }, {
        key: 'onOpen',
        value: function onOpen() {
            var _this2 = this;

            if (!this.hasOpened) {
                this.hasOpened = true;
                this.closeElements.forEach(function (el) {
                    return el.addEventListener('click', _this2.close.bind(_this2));
                });
            }

            return new Promise(function (resolve) {
                _this2.startResolve = resolve;
                _this2.tween.play();
            });
        }
    }, {
        key: 'close',
        value: function close() {
            this.controller.close(this);
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            var _this3 = this;

            var fast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return new Promise(function (resolve) {
                _this3.reserseResolve = resolve;
                if (fast) {
                    _this3.tween.timeScale(2);
                }
                _this3.tween.reverse();
            }).then(function () {
                if (fast) {
                    _this3.tween.timeScale(1);
                }
            });
        }
    }, {
        key: 'getElement',
        value: function getElement() {
            return this.element;
        }
    }, {
        key: 'getWrapperElement',
        value: function getWrapperElement() {
            return this.wrapperElement;
        }
    }]);

    return Modal;
}();

exports.default = Modal;

Modal.className = 'modal';

/***/ }),

/***/ "./app/general/js/noframework.waypoints.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
(function () {
  'use strict';

  var keyCounter = 0;
  var allWaypoints = {};

  /* http://imakewebthings.com/waypoints/api/waypoint */
  function Waypoint(options) {
    if (!options) {
      throw new Error('No options passed to Waypoint constructor');
    }
    if (!options.element) {
      throw new Error('No element option passed to Waypoint constructor');
    }
    if (!options.handler) {
      throw new Error('No handler option passed to Waypoint constructor');
    }

    this.key = 'waypoint-' + keyCounter;
    this.options = Waypoint.Adapter.extend({}, Waypoint.defaults, options);
    this.element = this.options.element;
    this.adapter = new Waypoint.Adapter(this.element);
    this.callback = options.handler;
    this.axis = this.options.horizontal ? 'horizontal' : 'vertical';
    this.enabled = this.options.enabled;
    this.triggerPoint = null;
    this.group = Waypoint.Group.findOrCreate({
      name: this.options.group,
      axis: this.axis
    });
    this.context = Waypoint.Context.findOrCreateByElement(this.options.context);

    if (Waypoint.offsetAliases[this.options.offset]) {
      this.options.offset = Waypoint.offsetAliases[this.options.offset];
    }
    this.group.add(this);
    this.context.add(this);
    allWaypoints[this.key] = this;
    keyCounter += 1;
  }

  /* Private */
  Waypoint.prototype.queueTrigger = function (direction) {
    this.group.queueTrigger(this, direction);
  };

  /* Private */
  Waypoint.prototype.trigger = function (args) {
    if (!this.enabled) {
      return;
    }
    if (this.callback) {
      this.callback.apply(this, args);
    }
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy */
  Waypoint.prototype.destroy = function () {
    this.context.remove(this);
    this.group.remove(this);
    delete allWaypoints[this.key];
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable */
  Waypoint.prototype.disable = function () {
    this.enabled = false;
    return this;
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable */
  Waypoint.prototype.enable = function () {
    this.context.refresh();
    this.enabled = true;
    return this;
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/next */
  Waypoint.prototype.next = function () {
    return this.group.next(this);
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/previous */
  Waypoint.prototype.previous = function () {
    return this.group.previous(this);
  };

  /* Private */
  Waypoint.invokeAll = function (method) {
    var allWaypointsArray = [];
    for (var waypointKey in allWaypoints) {
      allWaypointsArray.push(allWaypoints[waypointKey]);
    }
    for (var i = 0, end = allWaypointsArray.length; i < end; i++) {
      allWaypointsArray[i][method]();
    }
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy-all */
  Waypoint.destroyAll = function () {
    Waypoint.invokeAll('destroy');
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable-all */
  Waypoint.disableAll = function () {
    Waypoint.invokeAll('disable');
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable-all */
  Waypoint.enableAll = function () {
    Waypoint.Context.refreshAll();
    for (var waypointKey in allWaypoints) {
      allWaypoints[waypointKey].enabled = true;
    }
    return this;
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/refresh-all */
  Waypoint.refreshAll = function () {
    Waypoint.Context.refreshAll();
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-height */
  Waypoint.viewportHeight = function () {
    return window.innerHeight || document.documentElement.clientHeight;
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-width */
  Waypoint.viewportWidth = function () {
    return document.documentElement.clientWidth;
  };

  Waypoint.adapters = [];

  Waypoint.defaults = {
    context: window,
    continuous: true,
    enabled: true,
    group: 'default',
    horizontal: false,
    offset: 0
  };

  Waypoint.offsetAliases = {
    'bottom-in-view': function bottomInView() {
      return this.context.innerHeight() - this.adapter.outerHeight();
    },
    'right-in-view': function rightInView() {
      return this.context.innerWidth() - this.adapter.outerWidth();
    }
  };

  window.Waypoint = Waypoint;
})();(function () {
  'use strict';

  function requestAnimationFrameShim(callback) {
    window.setTimeout(callback, 1000 / 60);
  }

  var keyCounter = 0;
  var contexts = {};
  var Waypoint = window.Waypoint;
  var oldWindowLoad = window.onload;

  /* http://imakewebthings.com/waypoints/api/context */
  function Context(element) {
    this.element = element;
    this.Adapter = Waypoint.Adapter;
    this.adapter = new this.Adapter(element);
    this.key = 'waypoint-context-' + keyCounter;
    this.didScroll = false;
    this.didResize = false;
    this.oldScroll = {
      x: this.adapter.scrollLeft(),
      y: this.adapter.scrollTop()
    };
    this.waypoints = {
      vertical: {},
      horizontal: {}
    };

    element.waypointContextKey = this.key;
    contexts[element.waypointContextKey] = this;
    keyCounter += 1;
    if (!Waypoint.windowContext) {
      Waypoint.windowContext = true;
      Waypoint.windowContext = new Context(window);
    }

    this.createThrottledScrollHandler();
    this.createThrottledResizeHandler();
  }

  /* Private */
  Context.prototype.add = function (waypoint) {
    var axis = waypoint.options.horizontal ? 'horizontal' : 'vertical';
    this.waypoints[axis][waypoint.key] = waypoint;
    this.refresh();
  };

  /* Private */
  Context.prototype.checkEmpty = function () {
    var horizontalEmpty = this.Adapter.isEmptyObject(this.waypoints.horizontal);
    var verticalEmpty = this.Adapter.isEmptyObject(this.waypoints.vertical);
    var isWindow = this.element == this.element.window;
    if (horizontalEmpty && verticalEmpty && !isWindow) {
      this.adapter.off('.waypoints');
      delete contexts[this.key];
    }
  };

  /* Private */
  Context.prototype.createThrottledResizeHandler = function () {
    var self = this;

    function resizeHandler() {
      self.handleResize();
      self.didResize = false;
    }

    this.adapter.on('resize.waypoints', function () {
      if (!self.didResize) {
        self.didResize = true;
        Waypoint.requestAnimationFrame(resizeHandler);
      }
    });
  };

  /* Private */
  Context.prototype.createThrottledScrollHandler = function () {
    var self = this;
    function scrollHandler() {
      self.handleScroll();
      self.didScroll = false;
    }

    this.adapter.on('scroll.waypoints', function () {
      if (!self.didScroll || Waypoint.isTouch) {
        self.didScroll = true;
        Waypoint.requestAnimationFrame(scrollHandler);
      }
    });
  };

  /* Private */
  Context.prototype.handleResize = function () {
    Waypoint.Context.refreshAll();
  };

  /* Private */
  Context.prototype.handleScroll = function () {
    var triggeredGroups = {};
    var axes = {
      horizontal: {
        newScroll: this.adapter.scrollLeft(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left'
      },
      vertical: {
        newScroll: this.adapter.scrollTop(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up'
      }
    };

    for (var axisKey in axes) {
      var axis = axes[axisKey];
      var isForward = axis.newScroll > axis.oldScroll;
      var direction = isForward ? axis.forward : axis.backward;

      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey];
        if (waypoint.triggerPoint === null) {
          continue;
        }
        var wasBeforeTriggerPoint = axis.oldScroll < waypoint.triggerPoint;
        var nowAfterTriggerPoint = axis.newScroll >= waypoint.triggerPoint;
        var crossedForward = wasBeforeTriggerPoint && nowAfterTriggerPoint;
        var crossedBackward = !wasBeforeTriggerPoint && !nowAfterTriggerPoint;
        if (crossedForward || crossedBackward) {
          waypoint.queueTrigger(direction);
          triggeredGroups[waypoint.group.id] = waypoint.group;
        }
      }
    }

    for (var groupKey in triggeredGroups) {
      triggeredGroups[groupKey].flushTriggers();
    }

    this.oldScroll = {
      x: axes.horizontal.newScroll,
      y: axes.vertical.newScroll
    };
  };

  /* Private */
  Context.prototype.innerHeight = function () {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportHeight();
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerHeight();
  };

  /* Private */
  Context.prototype.remove = function (waypoint) {
    delete this.waypoints[waypoint.axis][waypoint.key];
    this.checkEmpty();
  };

  /* Private */
  Context.prototype.innerWidth = function () {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportWidth();
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerWidth();
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-destroy */
  Context.prototype.destroy = function () {
    var allWaypoints = [];
    for (var axis in this.waypoints) {
      for (var waypointKey in this.waypoints[axis]) {
        allWaypoints.push(this.waypoints[axis][waypointKey]);
      }
    }
    for (var i = 0, end = allWaypoints.length; i < end; i++) {
      allWaypoints[i].destroy();
    }
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-refresh */
  Context.prototype.refresh = function () {
    /*eslint-disable eqeqeq */
    var isWindow = this.element == this.element.window;
    /*eslint-enable eqeqeq */
    var contextOffset = isWindow ? undefined : this.adapter.offset();
    var triggeredGroups = {};
    var axes;

    this.handleScroll();
    axes = {
      horizontal: {
        contextOffset: isWindow ? 0 : contextOffset.left,
        contextScroll: isWindow ? 0 : this.oldScroll.x,
        contextDimension: this.innerWidth(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left',
        offsetProp: 'left'
      },
      vertical: {
        contextOffset: isWindow ? 0 : contextOffset.top,
        contextScroll: isWindow ? 0 : this.oldScroll.y,
        contextDimension: this.innerHeight(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up',
        offsetProp: 'top'
      }
    };

    for (var axisKey in axes) {
      var axis = axes[axisKey];
      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey];
        var adjustment = waypoint.options.offset;
        var oldTriggerPoint = waypoint.triggerPoint;
        var elementOffset = 0;
        var freshWaypoint = oldTriggerPoint == null;
        var contextModifier, wasBeforeScroll, nowAfterScroll;
        var triggeredBackward, triggeredForward;

        if (waypoint.element !== waypoint.element.window) {
          elementOffset = waypoint.adapter.offset()[axis.offsetProp];
        }

        if (typeof adjustment === 'function') {
          adjustment = adjustment.apply(waypoint);
        } else if (typeof adjustment === 'string') {
          adjustment = parseFloat(adjustment);
          if (waypoint.options.offset.indexOf('%') > -1) {
            adjustment = Math.ceil(axis.contextDimension * adjustment / 100);
          }
        }

        contextModifier = axis.contextScroll - axis.contextOffset;
        waypoint.triggerPoint = Math.floor(elementOffset + contextModifier - adjustment);
        wasBeforeScroll = oldTriggerPoint < axis.oldScroll;
        nowAfterScroll = waypoint.triggerPoint >= axis.oldScroll;
        triggeredBackward = wasBeforeScroll && nowAfterScroll;
        triggeredForward = !wasBeforeScroll && !nowAfterScroll;

        if (!freshWaypoint && triggeredBackward) {
          waypoint.queueTrigger(axis.backward);
          triggeredGroups[waypoint.group.id] = waypoint.group;
        } else if (!freshWaypoint && triggeredForward) {
          waypoint.queueTrigger(axis.forward);
          triggeredGroups[waypoint.group.id] = waypoint.group;
        } else if (freshWaypoint && axis.oldScroll >= waypoint.triggerPoint) {
          waypoint.queueTrigger(axis.forward);
          triggeredGroups[waypoint.group.id] = waypoint.group;
        }
      }
    }

    Waypoint.requestAnimationFrame(function () {
      for (var groupKey in triggeredGroups) {
        triggeredGroups[groupKey].flushTriggers();
      }
    });

    return this;
  };

  /* Private */
  Context.findOrCreateByElement = function (element) {
    return Context.findByElement(element) || new Context(element);
  };

  /* Private */
  Context.refreshAll = function () {
    for (var contextId in contexts) {
      contexts[contextId].refresh();
    }
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-find-by-element */
  Context.findByElement = function (element) {
    return contexts[element.waypointContextKey];
  };

  window.onload = function () {
    if (oldWindowLoad) {
      oldWindowLoad();
    }
    Context.refreshAll();
  };

  Waypoint.requestAnimationFrame = function (callback) {
    var requestFn = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || requestAnimationFrameShim;
    requestFn.call(window, callback);
  };
  Waypoint.Context = Context;
})();(function () {
  'use strict';

  function byTriggerPoint(a, b) {
    return a.triggerPoint - b.triggerPoint;
  }

  function byReverseTriggerPoint(a, b) {
    return b.triggerPoint - a.triggerPoint;
  }

  var groups = {
    vertical: {},
    horizontal: {}
  };
  var Waypoint = window.Waypoint;

  /* http://imakewebthings.com/waypoints/api/group */
  function Group(options) {
    this.name = options.name;
    this.axis = options.axis;
    this.id = this.name + '-' + this.axis;
    this.waypoints = [];
    this.clearTriggerQueues();
    groups[this.axis][this.name] = this;
  }

  /* Private */
  Group.prototype.add = function (waypoint) {
    this.waypoints.push(waypoint);
  };

  /* Private */
  Group.prototype.clearTriggerQueues = function () {
    this.triggerQueues = {
      up: [],
      down: [],
      left: [],
      right: []
    };
  };

  /* Private */
  Group.prototype.flushTriggers = function () {
    for (var direction in this.triggerQueues) {
      var waypoints = this.triggerQueues[direction];
      var reverse = direction === 'up' || direction === 'left';
      waypoints.sort(reverse ? byReverseTriggerPoint : byTriggerPoint);
      for (var i = 0, end = waypoints.length; i < end; i += 1) {
        var waypoint = waypoints[i];
        if (waypoint.options.continuous || i === waypoints.length - 1) {
          waypoint.trigger([direction]);
        }
      }
    }
    this.clearTriggerQueues();
  };

  /* Private */
  Group.prototype.next = function (waypoint) {
    this.waypoints.sort(byTriggerPoint);
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints);
    var isLast = index === this.waypoints.length - 1;
    return isLast ? null : this.waypoints[index + 1];
  };

  /* Private */
  Group.prototype.previous = function (waypoint) {
    this.waypoints.sort(byTriggerPoint);
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints);
    return index ? this.waypoints[index - 1] : null;
  };

  /* Private */
  Group.prototype.queueTrigger = function (waypoint, direction) {
    this.triggerQueues[direction].push(waypoint);
  };

  /* Private */
  Group.prototype.remove = function (waypoint) {
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints);
    if (index > -1) {
      this.waypoints.splice(index, 1);
    }
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/first */
  Group.prototype.first = function () {
    return this.waypoints[0];
  };

  /* Public */
  /* http://imakewebthings.com/waypoints/api/last */
  Group.prototype.last = function () {
    return this.waypoints[this.waypoints.length - 1];
  };

  /* Private */
  Group.findOrCreate = function (options) {
    return groups[options.axis][options.name] || new Group(options);
  };

  Waypoint.Group = Group;
})();(function () {
  'use strict';

  var Waypoint = window.Waypoint;

  function isWindow(element) {
    return element === element.window;
  }

  function getWindow(element) {
    if (isWindow(element)) {
      return element;
    }
    return element.defaultView;
  }

  function NoFrameworkAdapter(element) {
    this.element = element;
    this.handlers = {};
  }

  NoFrameworkAdapter.prototype.innerHeight = function () {
    var isWin = isWindow(this.element);
    return isWin ? this.element.innerHeight : this.element.clientHeight;
  };

  NoFrameworkAdapter.prototype.innerWidth = function () {
    var isWin = isWindow(this.element);
    return isWin ? this.element.innerWidth : this.element.clientWidth;
  };

  NoFrameworkAdapter.prototype.off = function (event, handler) {
    function removeListeners(element, listeners, handler) {
      for (var i = 0, end = listeners.length - 1; i < end; i++) {
        var listener = listeners[i];
        if (!handler || handler === listener) {
          element.removeEventListener(listener);
        }
      }
    }

    var eventParts = event.split('.');
    var eventType = eventParts[0];
    var namespace = eventParts[1];
    var element = this.element;

    if (namespace && this.handlers[namespace] && eventType) {
      removeListeners(element, this.handlers[namespace][eventType], handler);
      this.handlers[namespace][eventType] = [];
    } else if (eventType) {
      for (var ns in this.handlers) {
        removeListeners(element, this.handlers[ns][eventType] || [], handler);
        this.handlers[ns][eventType] = [];
      }
    } else if (namespace && this.handlers[namespace]) {
      for (var type in this.handlers[namespace]) {
        removeListeners(element, this.handlers[namespace][type], handler);
      }
      this.handlers[namespace] = {};
    }
  };

  /* Adapted from jQuery 1.x offset() */
  NoFrameworkAdapter.prototype.offset = function () {
    if (!this.element.ownerDocument) {
      return null;
    }

    var documentElement = this.element.ownerDocument.documentElement;
    var win = getWindow(this.element.ownerDocument);
    var rect = {
      top: 0,
      left: 0
    };

    if (this.element.getBoundingClientRect) {
      rect = this.element.getBoundingClientRect();
    }

    return {
      top: rect.top + win.pageYOffset - documentElement.clientTop,
      left: rect.left + win.pageXOffset - documentElement.clientLeft
    };
  };

  NoFrameworkAdapter.prototype.on = function (event, handler) {
    var eventParts = event.split('.');
    var eventType = eventParts[0];
    var namespace = eventParts[1] || '__default';
    var nsHandlers = this.handlers[namespace] = this.handlers[namespace] || {};
    var nsTypeList = nsHandlers[eventType] = nsHandlers[eventType] || [];

    nsTypeList.push(handler);
    this.element.addEventListener(eventType, handler);
  };

  NoFrameworkAdapter.prototype.outerHeight = function (includeMargin) {
    var height = this.innerHeight();
    var computedStyle;

    if (includeMargin && !isWindow(this.element)) {
      computedStyle = window.getComputedStyle(this.element);
      height += parseInt(computedStyle.marginTop, 10);
      height += parseInt(computedStyle.marginBottom, 10);
    }

    return height;
  };

  NoFrameworkAdapter.prototype.outerWidth = function (includeMargin) {
    var width = this.innerWidth();
    var computedStyle;

    if (includeMargin && !isWindow(this.element)) {
      computedStyle = window.getComputedStyle(this.element);
      width += parseInt(computedStyle.marginLeft, 10);
      width += parseInt(computedStyle.marginRight, 10);
    }

    return width;
  };

  NoFrameworkAdapter.prototype.scrollLeft = function () {
    var win = getWindow(this.element);
    return win ? win.pageXOffset : this.element.scrollLeft;
  };

  NoFrameworkAdapter.prototype.scrollTop = function () {
    var win = getWindow(this.element);
    return win ? win.pageYOffset : this.element.scrollTop;
  };

  NoFrameworkAdapter.extend = function () {
    var args = Array.prototype.slice.call(arguments);

    function merge(target, obj) {
      if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            target[key] = obj[key];
          }
        }
      }

      return target;
    }

    for (var i = 1, end = args.length; i < end; i++) {
      merge(args[0], args[i]);
    }
    return args[0];
  };

  NoFrameworkAdapter.inArray = function (element, array, i) {
    return array == null ? -1 : array.indexOf(element, i);
  };

  NoFrameworkAdapter.isEmptyObject = function (obj) {
    /* eslint no-unused-vars: 0 */
    for (var name in obj) {
      return false;
    }
    return true;
  };

  Waypoint.adapters.push({
    name: 'noframework',
    Adapter: NoFrameworkAdapter
  });
  Waypoint.Adapter = NoFrameworkAdapter;
})();

/***/ }),

/***/ "./app/general/js/notification.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _defaultModalNotificationTemplate = __webpack_require__("./app/general/html/default-modal-notification-template.hbs");

var _defaultModalNotificationTemplate2 = _interopRequireDefault(_defaultModalNotificationTemplate);

var _modal = __webpack_require__("./app/general/js/modal.js");

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Notification = function (_Modal) {
    _inherits(Notification, _Modal);

    function Notification() {
        _classCallCheck(this, Notification);

        return _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).apply(this, arguments));
    }

    _createClass(Notification, null, [{
        key: "createDefault",
        value: function createDefault(data) {
            return _modal2.default.create((0, _defaultModalNotificationTemplate2.default)(data));
        }

        /* static createFromContentString(content) {
             return Modal.createFromContentString(content);
         }*/

    }]);

    return Notification;
}(_modal2.default);

exports.default = Notification;

/***/ }),

/***/ "./app/general/js/page-spinner.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _contentBlocker = __webpack_require__("./app/general/js/content-blocker.js");

var _contentBlocker2 = _interopRequireDefault(_contentBlocker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PageSpinner = function () {
    function PageSpinner() {
        _classCallCheck(this, PageSpinner);

        this.isVisible = false;
        this.isInited = false;
        this.currentOptions = null;
        this.spinnerElement = null;
    }

    _createClass(PageSpinner, [{
        key: 'init',
        value: function init() {
            this.spinnerElement = document.querySelector('.js-page-spinner');
            this.isInited = true;
        }
    }, {
        key: 'show',
        value: function show() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { fade: false, blockContent: false };

            if (!this.isInited) {
                this.init();
            }
            if (!this.isVisible) {
                this.applyOptions(options);
                this.currentOptions = options;
                if (this.currentOptions.blockContent) {
                    _contentBlocker2.default.block('page-spinner');
                }
                this.spinnerElement.classList.add('is-visible');
                this.isVisible = true;
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            if (this.isVisible) {
                if (this.currentOptions.blockContent) {
                    _contentBlocker2.default.unblock('page-spinner');
                }
                this.spinnerElement.classList.remove('is-visible');
                this.isVisible = false;
            }
        }
    }, {
        key: 'applyOptions',
        value: function applyOptions(options) {
            if (options.fade) {
                this.spinnerElement.classList.add('has-fade');
            } else {
                this.spinnerElement.classList.remove('has-fade');
            }
        }
    }]);

    return PageSpinner;
}();

var instance = new PageSpinner();
exports.default = instance;

/***/ }),

/***/ "./app/general/js/persistent-connector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PersistentConnector = function () {
    function PersistentConnector(reconnectHandler) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$maxReconnectAtte = _ref.maxReconnectAttempts,
            maxReconnectAttempts = _ref$maxReconnectAtte === undefined ? 10 : _ref$maxReconnectAtte,
            _ref$connectionRetryT = _ref.connectionRetryTimeRate,
            connectionRetryTimeRate = _ref$connectionRetryT === undefined ? 2 : _ref$connectionRetryT,
            _ref$baseReconnectTim = _ref.baseReconnectTimeout,
            baseReconnectTimeout = _ref$baseReconnectTim === undefined ? 5000 : _ref$baseReconnectTim,
            _ref$name = _ref.name,
            name = _ref$name === undefined ? 'Unnamed Connection' : _ref$name;

        _classCallCheck(this, PersistentConnector);

        this.reconnectHandler = reconnectHandler;
        this.maxReconnectAttempts = maxReconnectAttempts;
        this.connectionRetryTimeRate = connectionRetryTimeRate;
        this.baseReconnectTimeout = baseReconnectTimeout;
        this.name = name;
        this.reset();
    }

    _createClass(PersistentConnector, [{
        key: 'reset',
        value: function reset() {
            this.reconnectTimeout = null;
            this.reconnectAttempts = 0;
        }
    }, {
        key: 'recover',
        value: function recover() {
            var _this = this;

            if (this.reconnectAttempts < this.maxReconnectAttempts) {
                this.reconnectAttempts += 1;

                if (this.reconnectTimeout === null) {
                    this.reconnectTimeout = this.baseReconnectTimeout;
                }
                console.log('Attempt ' + this.reconnectAttempts + ' to recover ' + this.name + ' connection. Next try after ' + this.reconnectTimeout + 'ms timeout');

                setTimeout(function () {
                    _this.reconnectTimeout *= _this.connectionRetryTimeRate;
                    _this.reconnectHandler();
                }, this.reconnectTimeout);
            } else {
                console.log('Max reconnection attempts count for ' + this.name + ' was reached');
            }
        }
    }, {
        key: 'onConnect',
        value: function onConnect() {
            this.reset();
        }
    }]);

    return PersistentConnector;
}();

exports.default = PersistentConnector;

/***/ }),

/***/ "./app/general/js/signalr-hub.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Wrapper above the signar hub for promisifying invoke method and convenient unsubscribe
 */
var SignalRHub = function () {
    function SignalRHub(connection, name) {
        _classCallCheck(this, SignalRHub);

        this.connection = connection;
        this.instance = connection.createHubProxy(name);
        this.name = name;
    }

    _createClass(SignalRHub, [{
        key: "subscribe",
        value: function subscribe(type, handler) {
            var _this = this;

            this.instance.on(type, handler);

            return function () {
                _this.instance.off(type, handler);
            };
        }
    }, {
        key: "invoke",
        value: function invoke() {
            var _this2 = this,
                _arguments = arguments;

            return new Promise(function (resolve, reject) {
                _this2.instance.invoke.apply(_this2.instance, _arguments).done(function (result) {
                    resolve(result);
                }).fail(function (error) {
                    reject(error);
                });
            });
        }
    }]);

    return SignalRHub;
}();

exports.default = SignalRHub;

/***/ }),

/***/ "./app/general/js/signalr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("./node_modules/signalr/jquery.signalR.js");

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

var _signalrHub = __webpack_require__("./app/general/js/signalr-hub.js");

var _signalrHub2 = _interopRequireDefault(_signalrHub);

var _persistentConnector = __webpack_require__("./app/general/js/persistent-connector.js");

var _persistentConnector2 = _interopRequireDefault(_persistentConnector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SignalR = function () {
    function SignalR() {
        _classCallCheck(this, SignalR);

        this.connection = _jquery2.default.hubConnection();
        this.connection.logging = true;
        this.hubs = {};
        this.initConnectionPromise = null;
        this.initConnectionResolve = null;
        this.isInitConnectionResolved = false;
        this.reconnect = this.reconnect.bind(this);

        this.connector = new _persistentConnector2.default(this.reconnect, { name: 'SignalR' });
        this.init();
    }

    _createClass(SignalR, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.connection.starting(function () {
                console.log('SignalR starting');
            });
            this.connection.reconnecting(function () {
                console.log('SignalR reconnecting');
            });
            this.connection.reconnected(function () {
                console.log('SignalR reconnected');
            });
            this.connection.disconnected(function () {
                console.log('SignalR disconnected');
                //inner signalr logic of connection persistency failed so we will try our
                _this.connector.recover();
            });

            this.connection.error(function (error) {
                console.log('SignalR connection error');
            });
        }
    }, {
        key: 'onConnect',
        value: function onConnect() {
            if (!this.isInitConnectionResolved) {
                this.isInitConnectionResolved = true;
                this.initConnectionResolve();
            }
            this.connector.onConnect();
        }
    }, {
        key: 'connect',
        value: function connect() {
            var _this2 = this;

            if (this.initConnectionPromise === null) {
                this.initConnectionPromise = new Promise(function (resolve) {
                    //expose resolve function
                    //for handling a situation when first attempt was failed
                    //in this case we want to resolve the promise anyway as soon as connection is established
                    _this2.initConnectionResolve = resolve;
                    _this2.connection.start().done(function () {
                        _this2.onConnect();
                    });
                });
            }
            return this.initConnectionPromise;
        }
    }, {
        key: 'reconnect',
        value: function reconnect() {
            var _this3 = this;

            this.connection.start().done(function () {
                _this3.onConnect();
            });
        }
    }, {
        key: 'getHub',
        value: function getHub(hubName) {
            if (!(hubName in this.hubs)) {
                this.hubs[hubName] = new _signalrHub2.default(this.connection, hubName);
            }
            return this.hubs[hubName];
        }
    }]);

    return SignalR;
}();

var instance = new SignalR();
exports.default = instance;

/***/ }),

/***/ "./app/general/js/style-observer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = stylesFinally;
/**
 * REQUIREMENTS
 * window.appState.isStylesLoaded must be true when onLoad is done for stylesheets
 * window.appState.isStylesFailed must be true when onLoad is failed
 */

var isReady = false;
var isStarted = false;
var onSuccessOrErrorSubscribers = [];

function stylesFinally(callback) {
    if (isReady) {
        callback();
    } else {
        onSuccessOrErrorSubscribers.push(callback);
    }

    if (!isStarted) {
        isStarted = true;
        startCheckStyles();
    }
}

var timeoutId = null;

function startCheckStyles() {
    //window onLoad fallback
    window.addEventListener('load', onWindowLoadFallback);
    checkStylesReady();
}

function onWindowLoadFallback() {
    if (isReady) {
        return;
    }

    if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
    }
    handleSuccessOrError();
}

function checkStylesReady() {
    if (isReady) {
        return;
    }

    if (window.appState) {
        if (window.appState.isStylesLoaded === true) {
            window.removeEventListener('load', onWindowLoadFallback);
            handleSuccessOrError();
            return;
        }
        if (window.appState.isStylesFailed === true) {
            handleSuccessOrError();
            return;
        }
    } else {
        console.error('no window.appState');
        return;
    }

    timeoutId = setTimeout(checkStylesReady, 75);
}

function handleSuccessOrError() {
    isReady = true;
    onSuccessOrErrorSubscribers.forEach(function (callback) {
        return callback();
    });
}

/***/ }),

/***/ "./app/general/js/toastr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toastr = __webpack_require__("./node_modules/toastr/toastr.js");

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_toastr2.default.options.positionClass = "toast-top-right";
_toastr2.default.options.newestOnTop = true;
_toastr2.default.options.preventDuplicates = true;
_toastr2.default.options.closeButton = true;
_toastr2.default.options.timeOut = 0;
_toastr2.default.options.extendedTimeOut = 0;

exports.default = _toastr2.default;

/***/ }),

/***/ "./app/general/js/url-helper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UrlHelper = function () {
    function UrlHelper() {
        _classCallCheck(this, UrlHelper);
    }

    _createClass(UrlHelper, null, [{
        key: 'getUrlByParams',
        value: function getUrlByParams(url, params) {
            var defaultParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var paramsPrefix = url.indexOf('?') === -1 ? '?' : '&';
            var paramsString = UrlHelper.getQueryStringByParams(params, defaultParams);
            return '' + url + (paramsString !== '' ? '' + paramsPrefix + paramsString : '');
        }
    }, {
        key: 'getQueryStringByParams',
        value: function getQueryStringByParams(params) {
            var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var searchableParams = this.getSearchableParams(params, defaultParams);
            return Object.keys(searchableParams).map(function (key) {
                return key + '=' + encodeURIComponent(searchableParams[key]);
            }).join('&');
        }
    }, {
        key: 'getSearchableParams',
        value: function getSearchableParams(params) {
            var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var result = {};
            for (var i in params) {
                if (!(i in defaultParams) || params[i] !== defaultParams[i]) {
                    result[i] = params[i];
                }
            }
            return result;
        }
    }, {
        key: 'getSearchFromLocation',
        value: function getSearchFromLocation(location) {
            return this.getParamsFromQueryString(location.search.substring(1));
        }
    }, {
        key: 'getParamsFromQueryString',
        value: function getParamsFromQueryString(queryString) {
            var str = queryString.replace(/\/$/, '') || '';
            var obj = {};
            var key = void 0;
            var value = void 0;

            str.split('&').forEach(function (keyValue) {
                if (keyValue) {
                    value = keyValue.split('=');
                    key = decodeURIComponent(value[0]);
                    obj[key] = value[1] ? decodeURIComponent(value[1]) : '';
                }
            });
            return obj;
        }
    }, {
        key: 'getPathWithQueryString',
        value: function getPathWithQueryString(location) {
            var exceptParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var baseUrl = location.pathname;
            var searchObject = this.getSearchFromLocation(location);
            var paramsKeys = Object.keys(searchObject).filter(function (key) {
                return exceptParams.indexOf(key) === -1;
            });
            var paramsObject = paramsKeys.reduce(function (result, key) {
                result[key] = searchObject[key];
                return result;
            }, {});
            return this.getUrlByParams(baseUrl, paramsObject);
        }
    }]);

    return UrlHelper;
}();

exports.default = UrlHelper;

/***/ }),

/***/ "./app/general/scss/font-face.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/general/scss/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app/general/svg recursive ^\\.\\/.*\\.svg":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arrow-bottom.svg": "./app/general/svg/arrow-bottom.svg",
	"./arrow-left.svg": "./app/general/svg/arrow-left.svg",
	"./arrow-right.svg": "./app/general/svg/arrow-right.svg",
	"./arrow-top.svg": "./app/general/svg/arrow-top.svg",
	"./auction.svg": "./app/general/svg/auction.svg",
	"./bid.svg": "./app/general/svg/bid.svg",
	"./close.svg": "./app/general/svg/close.svg",
	"./cross.svg": "./app/general/svg/cross.svg",
	"./download.svg": "./app/general/svg/download.svg",
	"./facebook.svg": "./app/general/svg/facebook.svg",
	"./googlecalendar.svg": "./app/general/svg/googlecalendar.svg",
	"./grid.svg": "./app/general/svg/grid.svg",
	"./icalendar.svg": "./app/general/svg/icalendar.svg",
	"./info.svg": "./app/general/svg/info.svg",
	"./list.svg": "./app/general/svg/list.svg",
	"./logo.svg": "./app/general/svg/logo.svg",
	"./menu.svg": "./app/general/svg/menu.svg",
	"./minus-thin.svg": "./app/general/svg/minus-thin.svg",
	"./minus.svg": "./app/general/svg/minus.svg",
	"./outlook.svg": "./app/general/svg/outlook.svg",
	"./phone.svg": "./app/general/svg/phone.svg",
	"./photo.svg": "./app/general/svg/photo.svg",
	"./plus-thin.svg": "./app/general/svg/plus-thin.svg",
	"./plus.svg": "./app/general/svg/plus.svg",
	"./print.svg": "./app/general/svg/print.svg",
	"./refine.svg": "./app/general/svg/refine.svg",
	"./search.svg": "./app/general/svg/search.svg",
	"./share.svg": "./app/general/svg/share.svg",
	"./star.svg": "./app/general/svg/star.svg",
	"./tick.svg": "./app/general/svg/tick.svg",
	"./twitter.svg": "./app/general/svg/twitter.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/general/svg recursive ^\\.\\/.*\\.svg";

/***/ }),

/***/ "./app/general/svg/arrow-bottom.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-bottom",
  "use": "icon-arrow-bottom-usage",
  "viewBox": "0 0 62.58 36.29",
  "content": "<symbol viewBox=\"0 0 62.58 36.29\" id=\"icon-arrow-bottom\">\r\n    <path d=\"M61.12,1.46a5,5,0,0,0-7.07,0L31.29,24.22,8.53,1.46A5,5,0,0,0,1.46,8.53L27.76,34.83a5,5,0,0,0,7.07,0L61.12,8.53a5,5,0,0,0,0-7.07\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/arrow-left.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 36.29 62.58",
  "content": "<symbol viewBox=\"0 0 36.29 62.58\" id=\"icon-arrow-left\">\r\n    <path d=\"M34.83,61.12a5,5,0,0,0,0-7.07L12.07,31.29,34.83,8.53a5,5,0,1,0-7.07-7.07L1.47,27.76a5,5,0,0,0,0,7.07L27.76,61.12a5,5,0,0,0,7.07,0\" transform=\"translate(0 0)\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/arrow-right.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 36.293 62.585",
  "content": "<symbol viewBox=\"0 0 36.293 62.585\" id=\"icon-arrow-right\">\r\n<path d=\"M1.464,1.465c-1.952,1.951-1.952,5.119,0,7.07l22.757,22.757L1.464,54.05c-1.952,1.951-1.952,5.119,0,7.07\r\n\tc1.953,1.953,5.119,1.953,7.071,0l26.293-26.293c0.977-0.976,1.465-2.257,1.465-3.536s-0.488-2.56-1.465-3.535L8.535,1.465\r\n\tC6.583-0.488,3.417-0.488,1.464,1.465\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/arrow-top.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-top",
  "use": "icon-arrow-top-usage",
  "viewBox": "0 0 62.58 36.29",
  "content": "<symbol viewBox=\"0 0 62.58 36.29\" id=\"icon-arrow-top\">\r\n    <path d=\"M1.46,34.83a5,5,0,0,0,7.07,0L31.29,12.07,54,34.83a5,5,0,0,0,7.07-7.07L34.83,1.47a5,5,0,0,0-7.07,0L1.46,27.76a5,5,0,0,0,0,7.07\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/auction.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-auction",
  "use": "icon-auction-usage",
  "viewBox": "0 0 57.2 57.2",
  "content": "<symbol viewBox=\"0 0 57.2 57.2\" id=\"icon-auction\">\r\n<path d=\"M2.6,31.9l16.9,9.5c1.5,0.9,3.5,0.2,4.2-1.2l0.2-0.5c0.4-0.7,0.5-1.5,0.2-2.4c-0.2-0.7-0.7-1.5-1.5-1.9\r\n\tl-12.2-6.9l-4.7-2.6c-0.5-0.2-1-0.4-1.5-0.4c-1.1,0-2.1,0.6-2.7,1.6l-0.2,0.5C1,28.4,0.9,29.2,1.1,30C1.4,30.9,1.9,31.5,2.6,31.9z\" />\r\n<path d=\"M16.8,6.4l16.9,9.5c1.5,0.9,3.5,0.2,4.2-1.2l0.2-0.5c0.4-0.7,0.5-1.5,0.2-2.4c-0.2-0.7-0.7-1.5-1.5-1.9\r\n\tL20.2,0.4c-0.5-0.2-1-0.4-1.5-0.4c-1.1,0-2.1,0.6-2.7,1.6l-0.2,0.5c-0.4,0.7-0.5,1.5-0.2,2.4C15.6,5.2,16.2,5.9,16.8,6.4z\" />\r\n<rect x=\"11.2\" y=\"12.6\" transform=\"matrix(0.4868 -0.8735 0.8735 0.4868 -7.925 28.0074)\" class=\"st0\" width=\"17.4\" height=\"16.3\" />\r\n<path d=\"M55.8,38L30.4,23.8l-2.5,4.4l25.4,14.1c0.4,0.2,0.7,0.4,1.2,0.4c0.9,0,1.7-0.5,2.2-1.2\r\n\tC57.5,40.1,57,38.6,55.8,38z\" />\r\n<path d=\"M49.7,50.5H5.9C4.2,50.5,3,52,3,53.8c0,1.7,1.2,3.4,2.9,3.4h43.7c1.6,0,2.9-1.5,2.9-3.4S51.4,50.5,49.7,50.5z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/bid.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-bid",
  "use": "icon-bid-usage",
  "viewBox": "0 0 504.76 322.96",
  "content": "<symbol viewBox=\"0 0 504.76 322.96\" id=\"icon-bid\">\r\n  <title>icon_bid</title>\r\n  <g>\r\n    <path d=\"M279.29,322.93c-29,0-58,.07-87-.05-11.55,0-13.67-2.4-13.74-14.14-.05-9.15-.75-18.38.13-27.46,2.94-30.53-6.21-57.31-21.88-83.21-16.1-26.6-30-55-34.89-85.83-5-31.77-6.31-64.17-8.7-96.33C112.61,7.83,117,1.76,125.55.24,133.17-1.11,139,3.37,141.78,13c6.91,24,13.37,48.09,20.35,72.06C170,112,184.68,134.9,203.85,155.14c6.44,6.8,14,10,23.59,9.92,29-.31,58,.29,87-.19,18.38-.31,31.26,7.4,40.73,22.85,22.64,36.9,30.95,77.17,29.28,119.9-.43,11.05-5.25,15.22-17.25,15.27C337.9,323,308.59,322.94,279.29,322.93Z\" />\r\n    <path d=\"M159.7,260.46h-79c-22.29,0-44.58-.07-66.86,0-8.33,0-13.4-3-13.74-12.06-1.07-28,5.72-53.76,22-76.81,6.3-8.89,14.8-13.21,25.71-13.25q28.38-.12,56.77-.64c9.49-.18,15.91,3.49,20.18,12.3,10,20.57,20.56,40.81,30.75,61.27C161.82,243.93,162.53,249.32,159.7,260.46Z\" />\r\n    <path d=\"M359.87,163.73c11.5-2.06,20.89-4.86,30.38-5.21,21.8-.82,43.64-.68,65.47-.48,11.37.11,20.56,5.38,27.22,14.59,16.59,23,22.49,49.05,21.76,76.93-.15,5.87-3.26,10.54-9.29,10.6-32,.3-64,.14-96.25.14C394.21,225.36,380.46,194.74,359.87,163.73Z\" />\r\n    <path d=\"M325.94,92.22c.32,31.4-25.57,57.85-57,58.27-34.18.45-61.12-25.49-61.33-59.05-.2-32.93,25.85-59.83,58.33-60.21C300.19,30.82,325.58,56.61,325.94,92.22Z\" />\r\n    <path d=\"M462.7,105.59c0,23.61-19.21,42.47-43.36,42.62-22.62.14-42.08-20.05-41.8-43.38a42.83,42.83,0,0,1,43.12-42.1C444,62.82,462.72,81.93,462.7,105.59Z\" />\r\n    <path d=\"M42.46,104.82c.36-25.14,19.76-43.68,44.86-42,3.35.22,8.48,4.4,9.23,7.58,4.88,20.69,8.79,41.6,13,62.44,1.2,5.93-2.1,8.92-7,11.14C69.59,158.89,38.52,130.74,42.46,104.82Z\" />\r\n  </g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/close.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 39.03 39.03",
  "content": "<symbol viewBox=\"0 0 39.03 39.03\" id=\"icon-close\">\r\n    <path d=\"M39,7.62a3,3,0,0,0-.92-2.23L33.64.92a3.17,3.17,0,0,0-4.47,0l-9.66,9.66L9.86.92A3,3,0,0,0,7.62,0,3,3,0,0,0,5.39.92L.92,5.39A3,3,0,0,0,0,7.62,3,3,0,0,0,.92,9.86l9.66,9.66L.92,29.17a3.17,3.17,0,0,0,0,4.47l4.47,4.47A3,3,0,0,0,7.62,39a3,3,0,0,0,2.23-.92l9.66-9.66,9.66,9.66a3.17,3.17,0,0,0,4.47,0l4.47-4.47a3.17,3.17,0,0,0,0-4.47l-9.66-9.66,9.66-9.66A3,3,0,0,0,39,7.62Z\" transform=\"translate(0 0)\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/cross.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-cross",
  "use": "icon-cross-usage",
  "viewBox": "0 0 39.76 39.03",
  "content": "<symbol viewBox=\"0 0 39.76 39.03\" id=\"icon-cross\">\r\n    <path d=\"M38.84,5.39,24,20.19l13,13a3.07,3.07,0,0,1-4.33,4.34l-13-13L6.12,38.1a3.15,3.15,0,0,1-4.46-4.46L15.24,20.06.9,5.73A3.07,3.07,0,0,1,5.24,1.39L19.58,15.73,34.37.93a3.16,3.16,0,0,1,4.47,4.46Z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/download.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" id=\"icon-download\">\r\n<g>\r\n\t<path d=\"M13.133,9.411v3.716H1.867V9.414H0V15h15V9.411H13.133z M11.277,5.599H9.378V0H5.611v5.609H3.739\r\n\t\tc1.276,1.916,2.511,3.77,3.767,5.654C8.768,9.367,10,7.517,11.277,5.599z\" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/facebook.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 9 17",
  "content": "<symbol viewBox=\"0 0 9 17\" id=\"icon-facebook\">\r\n<path d=\"M8.003,8.517H5.617v8.504H2.083V8.517H0.402V5.513h1.681V3.568C2.083,2.175,2.745,0,5.649,0l2.618,0.01\r\n\tv2.917h-1.9c-0.31,0-0.75,0.154-0.75,0.819v1.766h2.695L8.003,8.517z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/googlecalendar.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-googlecalendar",
  "use": "icon-googlecalendar-usage",
  "viewBox": "0 0 432.591 432.592",
  "content": "<symbol viewBox=\"0 0 432.591 432.592\" id=\"icon-googlecalendar\">\r\n<g>\r\n\t<path d=\"M356.063,0c0,0-100.478,0-133.97,0c-60.062,0-116.585,45.503-116.585,98.211c0,53.863,40.941,97.333,102.044,97.333\r\n\t\tc4.249,0,8.378-0.085,12.42-0.376c-3.964,7.593-6.8,16.144-6.8,25.021c0,14.969,8.052,27.104,18.233,37.012\r\n\t\tc-7.692,0-15.12,0.224-23.226,0.224c-74.391-0.001-131.65,47.38-131.65,96.511c0,48.391,62.771,78.656,137.167,78.656\r\n\t\tc84.812,0,131.653-48.122,131.653-96.514c0-38.801-11.447-62.036-46.843-87.067c-12.107-8.571-35.267-29.418-35.267-41.672\r\n\t\tc0-14.36,4.099-21.434,25.714-38.323c22.156-17.312,37.837-41.651,37.837-69.958c0-33.703-15.011-66.549-43.188-77.386h42.479\r\n\t\tL356.063,0z M309.27,327.729c1.062,4.486,1.643,9.104,1.643,13.814c0,39.1-25.194,69.655-97.487,69.655\r\n\t\tc-51.421,0-88.558-32.552-88.558-71.65c0-38.321,46.063-70.222,97.482-69.666c12,0.127,23.184,2.058,33.334,5.345\r\n\t\tC283.597,294.641,303.621,305.607,309.27,327.729z M226.939,181.888c-34.519-1.032-67.317-38.613-73.275-83.93\r\n\t\tc-5.958-45.333,17.185-80.021,51.694-78.995C239.86,20,272.675,56.37,278.636,101.692\r\n\t\tC284.589,147.022,261.441,182.921,226.939,181.888z\" />\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/grid.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-grid",
  "use": "icon-grid-usage",
  "viewBox": "0 0 85.51 85.51",
  "content": "<symbol viewBox=\"0 0 85.51 85.51\" id=\"icon-grid\">\r\n    <path d=\"M33.91,39.51H5.6A5.6,5.6,0,0,1,0,33.91V5.6A5.6,5.6,0,0,1,5.6,0H33.91a5.6,5.6,0,0,1,5.6,5.6V33.91A5.6,5.6,0,0,1,33.91,39.51Zm51.6-5.6V5.6A5.6,5.6,0,0,0,79.91,0H51.6A5.6,5.6,0,0,0,46,5.6V33.91a5.6,5.6,0,0,0,5.6,5.6H79.91A5.6,5.6,0,0,0,85.51,33.91Zm-46,46V51.6a5.6,5.6,0,0,0-5.6-5.6H5.6A5.6,5.6,0,0,0,0,51.6V79.91a5.6,5.6,0,0,0,5.6,5.6H33.91A5.6,5.6,0,0,0,39.51,79.91Zm46,0V51.6a5.6,5.6,0,0,0-5.6-5.6H51.6A5.6,5.6,0,0,0,46,51.6V79.91a5.6,5.6,0,0,0,5.6,5.6H79.91A5.6,5.6,0,0,0,85.51,79.91Z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/icalendar.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-icalendar",
  "use": "icon-icalendar-usage",
  "viewBox": "0 -256 1850 1850",
  "content": "<symbol viewBox=\"0 -256 1850 1850\" id=\"icon-icalendar\">\r\n\r\n  <g transform=\"matrix(1,0,0,-1,91.118644,1297.8644)\">\r\n    <path d=\"M 128,-128 H 416 V 160 H 128 v -288 z m 352,0 H 800 V 160 H 480 V -128 z M 128,224 H 416 V 544 H 128 V 224 z m 352,0 H 800 V 544 H 480 V 224 z M 128,608 H 416 V 896 H 128 V 608 z m 736,-736 h 320 V 160 H 864 V -128 z M 480,608 H 800 V 896 H 480 V 608 z m 768,-736 h 288 V 160 H 1248 V -128 z M 864,224 h 320 V 544 H 864 V 224 z m -352,864 v 288 q 0,13 -9.5,22.5 -9.5,9.5 -22.5,9.5 h -64 q -13,0 -22.5,-9.5 Q 384,1389 384,1376 v -288 q 0,-13 9.5,-22.5 9.5,-9.5 22.5,-9.5 h 64 q 13,0 22.5,9.5 9.5,9.5 9.5,22.5 z m 736,-864 h 288 V 544 H 1248 V 224 z M 864,608 h 320 V 896 H 864 V 608 z m 384,0 h 288 V 896 H 1248 V 608 z m 32,480 v 288 q 0,13 -9.5,22.5 -9.5,9.5 -22.5,9.5 h -64 q -13,0 -22.5,-9.5 -9.5,-9.5 -9.5,-22.5 v -288 q 0,-13 9.5,-22.5 9.5,-9.5 22.5,-9.5 h 64 q 13,0 22.5,9.5 9.5,9.5 9.5,22.5 z m 384,64 V -128 q 0,-52 -38,-90 -38,-38 -90,-38 H 128 q -52,0 -90,38 -38,38 -38,90 v 1280 q 0,52 38,90 38,38 90,38 h 128 v 96 q 0,66 47,113 47,47 113,47 h 64 q 66,0 113,-47 47,-47 47,-113 v -96 h 384 v 96 q 0,66 47,113 47,47 113,47 h 64 q 66,0 113,-47 47,-47 47,-113 v -96 h 128 q 52,0 90,-38 38,-38 38,-90 z\" />\r\n  </g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/info.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 39.03 39.03",
  "content": "<symbol viewBox=\"0 0 39.03 39.03\" id=\"icon-info\">\r\n    <path d=\"M25.79,32.3a.79.79,0,0,1-.58.23H13.82a.78.78,0,0,1-.81-.81V27.65a.78.78,0,0,1,.81-.81h2.44V18.7H13.82a.78.78,0,0,1-.81-.81V13.82a.78.78,0,0,1,.81-.81H22a.78.78,0,0,1,.81.81v13h2.44a.78.78,0,0,1,.81.81v4.07A.79.79,0,0,1,25.79,32.3ZM22.54,9.53a.79.79,0,0,1-.58.23H17.08a.78.78,0,0,1-.81-.81V4.88a.78.78,0,0,1,.81-.81H22a.78.78,0,0,1,.81.81V8.94A.79.79,0,0,1,22.54,9.53Zm13.87.19a19.43,19.43,0,0,0-7.1-7.1A19.09,19.09,0,0,0,19.51,0a19.09,19.09,0,0,0-9.8,2.62,19.43,19.43,0,0,0-7.1,7.1A19.09,19.09,0,0,0,0,19.51a19.09,19.09,0,0,0,2.62,9.8,19.43,19.43,0,0,0,7.1,7.1A19.09,19.09,0,0,0,19.51,39a19.09,19.09,0,0,0,9.8-2.62,19.43,19.43,0,0,0,7.1-7.1A19.09,19.09,0,0,0,39,19.51,19.09,19.09,0,0,0,36.41,9.72Z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/list.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 85.51 85.48",
  "content": "<symbol viewBox=\"0 0 85.51 85.48\" id=\"icon-list\">\r\n    <path d=\"M18.08,0a5.6,5.6,0,0,1,5.6,5.6V18.08a5.6,5.6,0,0,1-5.6,5.6H5.6A5.6,5.6,0,0,1,0,18.08V5.6A5.6,5.6,0,0,1,5.6,0Zm5.6,49V36.5a5.6,5.6,0,0,0-5.6-5.6H5.6A5.6,5.6,0,0,0,0,36.5V49a5.6,5.6,0,0,0,5.6,5.6H18.08A5.6,5.6,0,0,0,23.68,49Zm0,30.9V67.4a5.6,5.6,0,0,0-5.6-5.6H5.6A5.6,5.6,0,0,0,0,67.4V79.88a5.6,5.6,0,0,0,5.6,5.6H18.08A5.6,5.6,0,0,0,23.68,79.88ZM35.6,0A5.6,5.6,0,0,0,30,5.6V18.08a5.6,5.6,0,0,0,5.6,5.6H79.91a5.6,5.6,0,0,0,5.6-5.6V5.6A5.6,5.6,0,0,0,79.91,0ZM85.51,49V36.5a5.6,5.6,0,0,0-5.6-5.6H35.6A5.6,5.6,0,0,0,30,36.5V49a5.6,5.6,0,0,0,5.6,5.6H79.91A5.6,5.6,0,0,0,85.51,49Zm0,30.9V67.4a5.6,5.6,0,0,0-5.6-5.6H35.6A5.6,5.6,0,0,0,30,67.4V79.88a5.6,5.6,0,0,0,5.6,5.6H79.91A5.6,5.6,0,0,0,85.51,79.88Z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/logo.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-logo",
  "use": "icon-logo-usage",
  "viewBox": "0 0 445.04 107.72",
  "content": "<symbol viewBox=\"0 0 445.04 107.72\" id=\"icon-logo\">\r\n<path d=\"M187.389,87.785c-0.082,9.918,7.371,17.926,17.178,18.004c9.072,0.152,14.258-2.711,16.043-3.48c0,0,0-40.125,0-46.379\r\n\th-6.184c0.07,7.785,0,20.145,0,20.145c-1.414-2.516-4.965-4.213-9.67-4.367C195.111,71.322,187.471,76.57,187.389,87.785z\r\n\t M204.838,74c6.4,0.07,9.691,3.371,9.691,11.689c0,12.51-0.24,15.211-0.24,15.211c-1.703,1.83-5.754,3.129-9.563,2.904\r\n\tc-7.293-0.766-10.213-7.176-10.453-15.488C194.033,79.848,197.711,73.918,204.838,74z\" />\r\n<path d=\"M442.289,73.969L439,76.277c-0.816-0.531-3.109-2.309-5.998-2.309c-3.645-0.078-6.908,1.445-6.838,4.859\r\n\tc0.074,4.342,4.605,4.715,9.289,6.609c4.598,1.828,8.834,4.717,8.02,11.256c-0.674,4.787-4.605,9.271-11.809,9.037\r\n\tc-2.682-0.07-6.76-0.832-10.252-3.031l3.189-2.363c2.6,1.98,4.533,3.129,7.211,3.277c2.818,0.223,7.203-1.225,7.424-6.006\r\n\tc0.299-4.4-4.311-6.393-8.393-7.898c-3.785-1.299-9.063-2.818-8.617-9.961c0.375-5.17,5.203-7.764,10.998-7.764\r\n\tC437.676,71.984,440.648,73.209,442.289,73.969z\" />\r\n<path d=\"M379.996,76.379c-1.393-1.645-2.863-2.543-5.859-2.543c-7.539,0.676-9.443,9.516-9.586,13.939\r\n\tc-0.301,7.266,1.83,14.982,9.293,15.279c3.447,0.148,6.078-1.355,9.891-5.242l1.309,1.273c-3.512,4.945-7.391,6.367-11.047,6.367\r\n\tc-9.746,0-16.041-6.521-15.453-18.055c0.443-9.434,6.666-15.66,15.668-15.584c7.246,0.08,9.523,2.174,9.523,2.174L379.996,76.379z\" />\r\n<path d=\"M118.342,105.699c0-0.07-0.035-13.637,0-21.439c0.041-8.15-3.861-10.588-8.221-10.588\r\n\tc-4.531,0.031-8.254,2.438-8.215,10.588c0.039,7.803,0,21.369,0,21.439c-0.297,0-5.602,0-5.602,0s0-15.438,0-22.482\r\n\tc0-8.986,6.99-11.193,13.166-11.209c0.223-0.006,1.078-0.006,1.307,0c6.164,0.016,13.166,2.223,13.166,11.209\r\n\tc0,7.045,0,22.482,0,22.482S118.629,105.699,118.342,105.699z\" />\r\n<path d=\"M395.385,71.617c0,0.078,0.037,13.645,0,21.43c-0.041,8.16,3.867,10.605,8.217,10.605c4.533-0.039,8.254-2.445,8.219-10.605\r\n\tc-0.047-7.785,0-21.352,0-21.43c0.293,0,5.602,0,5.602,0s0,15.443,0,22.484c0,8.984-6.996,11.195-13.168,11.215\r\n\tc-0.227,0-1.082,0-1.311,0c-6.166-0.02-13.166-2.23-13.166-11.215c0-7.041,0-22.484,0-22.484S395.086,71.617,395.385,71.617z\" />\r\n<path d=\"M284.244,71.777c-0.229,0-1.088,0-1.313,0c-3.744,0.004-7.787,0.824-10.395,3.461c-2.602-2.637-6.645-3.457-10.383-3.461\r\n\tc-0.234,0-1.088,0-1.314,0c-6.174,0.004-13.168,2.211-13.168,11.207c0,7.041,0,22.48,0,22.48s5.313,0,5.609,0\r\n\tc0-0.066,0.035-13.633,0-21.43c-0.043-8.152,3.682-10.566,8.217-10.594c4.354,0,8.256,2.441,8.215,10.594\r\n\tc-0.041,7.797,0,21.363,0,21.43c0.01,0,0.033,0,0.059,0c0.635,0,5.543,0,5.543,0c0.023,0,0.041,0,0.059,0\r\n\tc0-0.066,0.037-13.633,0-21.43c-0.045-8.152,3.686-10.566,8.213-10.594c4.355,0,8.262,2.441,8.217,10.594\r\n\tc-0.033,7.797,0,21.363,0,21.43c0.299,0,5.602,0,5.602,0s0-15.439,0-22.48C297.404,73.988,290.414,71.781,284.244,71.777z\" />\r\n<path d=\"M18.252,72.191C13.553,72.34,9.5,74.699,7.635,79.508l-0.01-23H1.563c0,6.25,0,47.191,0,47.191\r\n\tc1.777,0.754,6.963,2.813,16.039,2.672c9.805-0.08,17.262-8.096,17.18-18.01C34.699,77.145,27.891,71.803,18.252,72.191z\r\n\t M27.891,88.895c-0.24,8.314-3.156,14.719-10.447,15.486c-3.814,0.232-7.863-1.072-9.563-2.9c0,0-0.246,0.156-0.246-12.359\r\n\tc0-8.316,4.137-14.564,10.535-14.645C25.301,74.402,28.137,80.426,27.891,88.895z\" />\r\n<path d=\"M91.383,77.486l3.416-2.701c-2.59-2.109-6.234-2.783-9.631-2.793c-0.227,0-1.082,0-1.309,0\r\n\tc-6.176,0.016-13.166,2.223-13.166,11.211c0,7.047,0,22.479,0,22.479s5.307,0,5.602,0c0-0.059,0.041-13.629,0-21.422\r\n\tc-0.041-8.158,3.375-10.26,7.91-10.289C86.977,73.971,89.877,74.662,91.383,77.486z\" />\r\n<path d=\"M354.932,77.262l3.42-2.705c-2.6-2.098-6.244-2.779-9.637-2.791c-0.227,0-1.084,0-1.309,0\r\n\tc-6.18,0.025-13.158,2.229-13.158,11.217c0,7.041,0,22.482,0,22.482s5.303,0,5.59,0c0-0.07,0.045-13.645,0-21.43\r\n\tc-0.035-8.154,3.385-10.264,7.912-10.287C350.525,73.748,353.426,74.426,354.932,77.262z\" />\r\n<path d=\"M183.076,77.275l3.416-2.713c-2.59-2.104-6.234-2.783-9.633-2.783c-0.223-0.006-1.078-0.006-1.309,0\r\n\tc-6.174,0.014-13.164,2.225-13.164,11.209c0,7.047,0,22.482,0,22.482s5.309,0,5.602,0c0-0.07,0.041-13.639,0-21.439\r\n\tc-0.041-8.15,3.684-10.555,8.221-10.588C178.98,73.443,181.574,74.434,183.076,77.275z\" />\r\n<path d=\"M63.152,75.332c-2.914-3.379-8.83-3.379-11.344-3.23c-3.727,0.227-8.344,1.004-12.076,5l3.627,2.355\r\n\tc1.213-2.461,3.184-5.508,8.613-5.355c3.064,0.074,6.383,1.814,6.609,5.168v6.762c-3.58,0-5.988,0.074-8.477,0.465\r\n\tc-6.641,1.145-12.719,4.773-11.984,11.617c0.555,5.213,5.016,8.049,9.785,8.082l-0.027,0.039c11.133,0.418,15.01-2.32,16.77-3.078\r\n\tl0.045-19.273C64.693,80.416,65.098,77.721,63.152,75.332z M44.27,97.268c-0.645-6.234,4.381-8.162,6.566-8.625\r\n\tc3.082-0.701,7.035-0.572,7.746-0.539v5.766c0,0.041,0,0.082-0.006,0.119h-0.018c0.006,0.045,0.012,0.078,0.018,0.125\r\n\tc-0.061,3.154-0.123,6.391-0.123,6.391c-0.615,3.713-5.713,3.875-8.316,3.508C46.203,103.461,44.68,101.039,44.27,97.268z\" />\r\n<path d=\"M154.477,75.348c-2.914-3.381-8.83-3.381-11.344-3.23c-3.727,0.225-8.344,1.004-12.076,5l3.627,2.355\r\n\tc1.213-2.461,3.188-5.508,8.613-5.355c3.064,0.074,6.387,1.813,6.609,5.168v6.762c-3.58,0-5.988,0.074-8.473,0.463\r\n\tc-6.645,1.146-12.721,4.775-11.988,11.619c0.557,5.211,5.016,8.047,9.789,8.08l-0.027,0.041c11.133,0.416,15.006-2.32,16.766-3.078\r\n\tl0.045-19.275C156.018,80.43,156.422,77.734,154.477,75.348z M135.602,97.281c-0.648-6.234,4.373-8.16,6.559-8.625\r\n\tc3.082-0.699,7.037-0.57,7.746-0.539v5.766c0,0.043,0,0.082,0,0.121h-0.023c0.006,0.043,0.016,0.076,0.023,0.123\r\n\tc-0.064,3.154-0.129,6.393-0.129,6.393c-0.615,3.711-5.713,3.873-8.314,3.508C137.531,103.477,136.004,101.053,135.602,97.281z\" />\r\n<path d=\"M327.004,75.352c-2.922-3.383-8.834-3.383-11.348-3.232c-3.727,0.225-8.344,1.006-12.074,5.002l3.625,2.355\r\n\tc1.213-2.461,3.184-5.508,8.609-5.355c3.07,0.072,6.391,1.813,6.613,5.168v6.762c-3.586,0-5.988,0.072-8.473,0.461\r\n\tc-6.645,1.146-12.721,4.777-11.988,11.621c0.551,5.211,5.016,8.047,9.785,8.078l-0.023,0.043c11.133,0.414,15.006-2.32,16.77-3.08\r\n\tl0.041-19.275C328.541,80.434,328.945,77.738,327.004,75.352z M308.121,97.285c-0.645-6.234,4.377-8.162,6.563-8.625\r\n\tc3.082-0.699,7.035-0.57,7.746-0.539v5.766c0,0.041,0,0.082-0.004,0.121h-0.02c0.006,0.043,0.012,0.074,0.02,0.121\r\n\tc-0.061,3.156-0.125,6.395-0.125,6.395c-0.615,3.711-5.713,3.871-8.316,3.506C310.055,103.479,308.525,101.055,308.121,97.285z\" />\r\n<g>\r\n\t<path fill=\"#72C9D3\" d=\"M147.17,42.105c-11.482,0-20.789-9.314-20.789-20.787c0-11.479,9.307-20.789,20.789-20.789\r\n\t\tc11.475,0,20.783,9.311,20.783,20.789C167.953,32.791,158.645,42.105,147.17,42.105z\" />\r\n\t<g>\r\n\t\t<path fill=\"#C71E58\" d=\"M84.105,0.529c-6.891,0-12.984,3.369-16.77,8.533c2.516,3.445,4.02,7.672,4.02,12.256\r\n\t\t\ts-1.504,8.811-4.02,12.244c3.785,5.168,9.879,8.543,16.77,8.543c11.479,0,20.783-9.314,20.783-20.787\r\n\t\t\tC104.889,9.84,95.584,0.529,84.105,0.529z\" />\r\n\t\t<path fill=\"#EF452E\" d=\"M67.336,9.063c-3.779-5.164-9.867-8.533-16.762-8.533c-2.299,0-4.508,0.389-6.576,1.076\r\n\t\t\tc8.252,2.75,14.215,10.531,14.215,19.713S52.25,38.277,43.998,41.023c2.068,0.691,4.277,1.082,6.576,1.082\r\n\t\t\tc6.895,0,12.982-3.375,16.762-8.543c-2.514-3.434-4.02-7.66-4.02-12.244S64.822,12.508,67.336,9.063z\" />\r\n\t\t<path fill=\"#EA2B3E\" d=\"M67.336,9.063c-2.514,3.445-4.02,7.672-4.02,12.256s1.506,8.811,4.02,12.244\r\n\t\t\tc2.516-3.434,4.02-7.66,4.02-12.244S69.852,12.508,67.336,9.063z\" />\r\n\t\t<path fill=\"#FDC436\" d=\"M35.807,35.934c-1.869,1.895-4.096,3.426-6.574,4.484c2.52,1.082,5.285,1.688,8.197,1.688\r\n\t\t\tc2.297,0,4.504-0.391,6.568-1.082C40.875,39.977,38.07,38.227,35.807,35.934z\" />\r\n\t\t<path fill=\"#FDC436\" d=\"M35.807,6.703c2.264-2.301,5.068-4.053,8.191-5.098c-2.064-0.688-4.271-1.076-6.568-1.076\r\n\t\t\tc-2.912,0-5.678,0.607-8.197,1.682C31.711,3.277,33.938,4.807,35.807,6.703z\" />\r\n\t\t<path fill=\"#F89736\" d=\"M58.213,21.318c0-9.182-5.963-16.963-14.215-19.713c-3.123,1.045-5.928,2.797-8.191,5.098\r\n\t\t\tc3.715,3.75,6.018,8.918,6.018,14.615c0,5.701-2.303,10.863-6.018,14.615c2.264,2.293,5.068,4.043,8.191,5.09\r\n\t\t\tC52.25,38.277,58.213,30.5,58.213,21.318z\" />\r\n\t\t<path fill=\"#86C440\" d=\"M16.641,21.318c0-8.576,5.191-15.924,12.592-19.107c-2.51-1.074-5.285-1.682-8.191-1.682\r\n\t\t\tC9.563,0.529,0.252,9.84,0.252,21.318c0,11.473,9.311,20.787,20.789,20.787c2.906,0,5.682-0.605,8.191-1.688\r\n\t\t\tC21.832,37.238,16.641,29.885,16.641,21.318z\" />\r\n\t\t<path fill=\"#BACE36\" d=\"M35.807,35.934c-3.717-3.752-6.018-8.914-6.018-14.615c0-5.697,2.301-10.865,6.018-14.615\r\n\t\t\tc-1.869-1.896-4.096-3.426-6.574-4.492c-7.4,3.184-12.592,10.531-12.592,19.107c0,8.566,5.191,15.92,12.592,19.1\r\n\t\t\tC31.711,39.359,33.938,37.828,35.807,35.934z\" />\r\n\t\t<path fill=\"#B9B834\" d=\"M35.807,35.934c3.715-3.752,6.018-8.914,6.018-14.615c0-5.697-2.303-10.865-6.018-14.615\r\n\t\t\tc-3.717,3.75-6.018,8.918-6.018,14.615C29.789,27.02,32.09,32.182,35.807,35.934z\" />\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/menu.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 19.68 13.38",
  "content": "<symbol viewBox=\"0 0 19.68 13.38\" id=\"icon-menu\">\r\n    <path d=\"M19.68,12.2a1.17,1.17,0,0,1-1.18,1.18H1.18a1.18,1.18,0,1,1,0-2.36H18.5A1.18,1.18,0,0,1,19.68,12.2Z\" />\r\n    <path d=\"M19.68,6.69A1.18,1.18,0,0,1,18.5,7.87H1.18a1.18,1.18,0,1,1,0-2.36H18.5A1.18,1.18,0,0,1,19.68,6.69Z\" />\r\n    <path d=\"M19.68,1.18A1.18,1.18,0,0,1,18.5,2.36H1.18A1.18,1.18,0,1,1,1.18,0H18.5A1.18,1.18,0,0,1,19.68,1.18Z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/minus-thin.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-minus-thin",
  "use": "icon-minus-thin-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" id=\"icon-minus-thin\">\r\n<path d=\"M25,12.5v1H0v-1H25z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/minus.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" id=\"icon-minus\">\r\n<g>\r\n\t<polyline points=\"6,6.5 0,6.5 0,9.5 6,9.5 6,9.5 9,9.5 9,9.5 15,9.5 15,6.5 9,6.5 \t\" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/outlook.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-outlook",
  "use": "icon-outlook-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" id=\"icon-outlook\">\r\n<g id=\"icon-outlook_surface1\">\r\n<path style=\" \" d=\"M 28.875 0 C 28.855469 0.0078125 28.832031 0.0195313 28.8125 0.03125 L 0.8125 5.34375 C 0.335938 5.433594 -0.0078125 5.855469 0 6.34375 L 0 43.65625 C -0.0078125 44.144531 0.335938 44.566406 0.8125 44.65625 L 28.8125 49.96875 C 29.101563 50.023438 29.402344 49.949219 29.632813 49.761719 C 29.859375 49.574219 29.996094 49.296875 30 49 L 30 38 L 34.0625 38 C 34.019531 38.332031 34 38.660156 34 39 C 34 43.40625 37.59375 47 42 47 C 46.40625 47 50 43.40625 50 39 C 50 37.609375 49.628906 36.296875 49 35.15625 C 49.003906 35.105469 49.003906 35.050781 49 35 L 49 17.65625 C 49.082031 17.433594 49.082031 17.191406 49 16.96875 L 49 12 C 49 11.449219 48.550781 11 48 11 L 30 11 L 30 1 C 30.003906 0.710938 29.878906 0.4375 29.664063 0.246094 C 29.449219 0.0546875 29.160156 -0.0351563 28.875 0 Z M 28 2.1875 L 28 11.6875 C 27.941406 11.882813 27.941406 12.085938 28 12.28125 L 28 36.6875 C 27.941406 36.882813 27.941406 37.085938 28 37.28125 L 28 47.8125 L 2 42.84375 L 2 7.15625 Z M 30 13 L 47 13 L 47 16.78125 L 33.75 24.625 L 30 21.53125 Z M 14.84375 15.53125 C 12.324219 15.53125 10.308594 16.40625 8.78125 18.1875 C 7.253906 19.96875 6.5 22.304688 6.5 25.1875 C 6.5 27.917969 7.246094 30.144531 8.75 31.84375 C 10.253906 33.542969 12.207031 34.40625 14.59375 34.40625 C 17.042969 34.40625 19.007813 33.503906 20.53125 31.75 C 22.054688 29.992188 22.8125 27.679688 22.8125 24.8125 C 22.8125 22.023438 22.09375 19.800781 20.625 18.09375 C 19.15625 16.390625 17.222656 15.53125 14.84375 15.53125 Z M 14.75 19.0625 C 16.027344 19.0625 17.042969 19.605469 17.78125 20.65625 C 18.519531 21.707031 18.875 23.171875 18.875 25.0625 C 18.875 26.878906 18.476563 28.292969 17.71875 29.3125 C 16.957031 30.335938 15.949219 30.84375 14.65625 30.84375 C 13.398438 30.84375 12.371094 30.332031 11.59375 29.28125 C 10.820313 28.230469 10.4375 26.773438 10.4375 24.96875 C 10.4375 23.1875 10.816406 21.769531 11.59375 20.6875 C 12.367188 19.605469 13.433594 19.0625 14.75 19.0625 Z M 47 19.125 L 47 32.78125 C 45.628906 31.679688 43.886719 31 42 31 C 38.660156 31 35.789063 33.082031 34.59375 36 L 30 36 L 30 24.09375 L 33.03125 26.59375 C 33.355469 26.867188 33.820313 26.90625 34.1875 26.6875 Z M 42 33 C 45.324219 33 48 35.675781 48 39 C 48 42.324219 45.324219 45 42 45 C 38.675781 45 36 42.324219 36 39 C 36 35.675781 38.675781 33 42 33 Z M 41 34 L 41 41 L 46 41 L 46 39 L 43 39 L 43 34 Z \" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/phone.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 34.063 34.063",
  "content": "<symbol viewBox=\"0 0 34.063 34.063\" id=\"icon-phone\">\r\n    <path d=\"M14.418,19.647c3.367,3.371,7.273,6.593,8.816,5.05c2.207-2.21,3.571-4.132,8.442-0.218 c4.866,3.914,1.129,6.522-1.013,8.664c-2.469,2.469-11.676,0.129-20.773-8.969C0.789,15.076-1.551,5.869,0.922,3.397 c2.14-2.141,4.75-5.879,8.66-1.008c3.914,4.867,1.992,6.23-0.219,8.441C7.824,12.374,11.047,16.276,14.418,19.647\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/photo.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-photo",
  "use": "icon-photo-usage",
  "viewBox": "0 0 21 19",
  "content": "<symbol viewBox=\"0 0 21 19\" id=\"icon-photo\">\r\n<g>\r\n\t<path d=\"M18.793,3.683h-3.68l-0.721-2.25C14.119,0.574,13.367,0,12.521,0H8.479C7.633,0,6.881,0.574,6.608,1.433\r\n\t\tl-0.72,2.25h-3.68C0.991,3.683,0,4.746,0,6.051v10.582C0,17.938,0.991,19,2.208,19h16.585C20.01,19,21,17.938,21,16.633V6.051\r\n\t\tC21,4.746,20.01,3.683,18.793,3.683z M7.907,1.91c0.084-0.261,0.314-0.438,0.572-0.438h4.042c0.258,0,0.488,0.177,0.572,0.438\r\n\t\tl0.475,1.486c-0.916-0.521-1.961-0.818-3.068-0.818c-1.107,0-2.151,0.297-3.068,0.818L7.907,1.91z M10.5,4.473\r\n\t\tc2.652,0,4.808,2.314,4.808,5.159c0,2.843-2.156,5.158-4.808,5.158c-2.651,0-4.809-2.314-4.809-5.158\r\n\t\tC5.692,6.787,7.849,4.473,10.5,4.473z M19.627,16.633c0,0.492-0.375,0.893-0.834,0.893H2.208c-0.459,0-0.834-0.4-0.834-0.893V6.051\r\n\t\tc0-0.494,0.375-0.895,0.834-0.895h3.214C4.487,6.375,3.925,7.934,3.925,9.631c0,3.888,2.95,7.052,6.575,7.052\r\n\t\tc3.625,0,6.574-3.164,6.574-7.052c0-1.698-0.561-3.256-1.496-4.475h3.215c0.459,0,0.834,0.401,0.834,0.895V16.633z M8.734,9.052\r\n\t\tc0.624,0,1.129-0.542,1.129-1.211c0-0.668-0.505-1.21-1.129-1.21c-0.623,0-1.128,0.542-1.128,1.21\r\n\t\tC7.605,8.51,8.111,9.052,8.734,9.052z\" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/plus-thin.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-plus-thin",
  "use": "icon-plus-thin-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" id=\"icon-plus-thin\">\r\n<g>\r\n\t<polygon points=\"25,12 13,12 13,0 12,0 12,12 0,12 0,13 12,13 12,25 13,25 13,13 25,13 \t\" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/plus.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" id=\"icon-plus\">\r\n<g>\r\n\t<polygon points=\"14.997,6.499 9,6.499 9,0.493 6.001,0.493 6.001,6.499 0.003,6.499 0.003,9.502 6.001,9.502\r\n\t\t6.001,15.508 9,15.508 9,9.502 14.997,9.502 \t\" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/print.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-print",
  "use": "icon-print-usage",
  "viewBox": "0 0 359.257 314.349",
  "content": "<symbol viewBox=\"0 0 359.257 314.349\" id=\"icon-print\">\r\n<g>\r\n\t<path d=\"M74.697,314.349V208.985H0V76.004h359.257V208.63h-74.48v105.719H74.697z M254.561,180.022\r\n\t\tH104.997v104.31h149.563V180.022z M337.077,127.156c-0.048-12.461-10.197-22.531-22.618-22.439\r\n\t\tc-12.391,0.092-22.437,10.393-22.244,22.81c0.191,12.287,10.135,22.158,22.358,22.197\r\n\t\tC326.959,149.763,337.124,139.569,337.077,127.156\" />\r\n\t<rect x=\"74.868\" width=\"209.532\" height=\"59.353\" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/refine.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-refine",
  "use": "icon-refine-usage",
  "viewBox": "0 0 48.54 40.87",
  "content": "<symbol viewBox=\"0 0 48.54 40.87\" id=\"icon-refine\">\r\n    <title>refine</title>\r\n    <path d=\"M39.26.43h4.87V41.29H39.26Z\" transform=\"translate(-0.46 -0.43)\" /><path d=\"M41.7,19.66a7.2,7.2,0,1,1-7.3,7.2A7.25,7.25,0,0,1,41.7,19.66Z\" transform=\"translate(-0.46 -0.43)\" /><path d=\"M22.27.43h4.87V41.29H22.27Z\" transform=\"translate(-0.46 -0.43)\" /><path d=\"M24.73,5.26a7.2,7.2,0,1,1-7.27,7.2A7.23,7.23,0,0,1,24.73,5.26Z\" transform=\"translate(-0.46 -0.43)\" /><path d=\"M5.28.43h4.87V41.29H5.28Z\" transform=\"translate(-0.46 -0.43)\" /><path d=\"M7.73,26.89a7.2,7.2,0,1,1-7.27,7.2A7.23,7.23,0,0,1,7.73,26.89Z\" transform=\"translate(-0.46 -0.43)\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/search.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 141.5 147.72",
  "content": "<symbol viewBox=\"0 0 141.5 147.72\" id=\"icon-search\">\r\n    <path d=\"M111.79,103.88A63.31,63.31,0,1,0,96.65,117l30.7,30.69,14.15-14.14Zm-48.51,2.69a43.29,43.29,0,1,1,43.29-43.28A43.33,43.33,0,0,1,63.28,106.57Z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/share.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-share",
  "use": "icon-share-usage",
  "viewBox": "0 0 129.5 141.5",
  "content": "<symbol viewBox=\"0 0 129.5 141.5\" id=\"icon-share\">\r\n<g>\r\n\t<path d=\"M129.5,23.75c0,13.117-10.633,23.75-23.75,23.75S82,36.867,82,23.75\r\n\t\tS92.633,0,105.75,0S129.5,10.633,129.5,23.75\" />\r\n\t<path d=\"M129.5,117.75c0,13.117-10.633,23.75-23.75,23.75S82,130.867,82,117.75\r\n\t\tS92.633,94,105.75,94S129.5,104.633,129.5,117.75\" />\r\n\t<path d=\"M47.5,70.75c0,13.117-10.633,23.75-23.75,23.75S0,83.867,0,70.75\r\n\t\tS10.633,47,23.75,47S47.5,57.633,47.5,70.75\" />\r\n\t<polygon points=\"103.015,122.521 12.689,70.75 103.015,18.979 108.485,28.521\r\n\t\t34.81,70.75 108.485,112.979 \t\" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/star.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol viewBox=\"0 0 16 15\" id=\"icon-star\">\r\n<path d=\"M8-0.012l2.396,5.043l5.592,0.695l-4.111,3.813l1.06,5.473L8,12.324l-4.938,2.688l1.06-5.473l-4.11-3.813\r\n\tl5.592-0.695L8-0.012z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/tick.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tick",
  "use": "icon-tick-usage",
  "viewBox": "0 0 10 8.4",
  "content": "<symbol viewBox=\"0 0 10 8.4\" id=\"icon-tick\">\r\n    <path d=\"M10,1.7,8.3,0l-5,5L1.7,3.4,0,5,1.7,6.7h0L3.3,8.4,5,6.7H5Z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/general/svg/twitter.svg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("./node_modules/svg-baker-runtime/browser-symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-twitter",
  "use": "icon-twitter-usage",
  "viewBox": "0 0 200 162.536",
  "content": "<symbol viewBox=\"0 0 200 162.536\" id=\"icon-twitter\">\r\n<g>\r\n\t<path d=\"M200,19.24c-7.358,3.264-15.267,5.469-23.566,6.461c8.471-5.078,14.978-13.119,18.041-22.701\r\n\t\tc-7.929,4.702-16.71,8.117-26.057,9.957C160.934,4.982,150.27,0,138.468,0c-22.66,0-41.033,18.371-41.033,41.031\r\n\t\tc0,3.216,0.363,6.348,1.063,9.351C64.396,48.671,34.161,32.335,13.924,7.51c-3.532,6.06-5.556,13.108-5.556,20.628\r\n\t\tc0,14.236,7.244,26.795,18.254,34.154c-6.726-0.214-13.053-2.059-18.585-5.133c-0.004,0.172-0.004,0.343-0.004,0.517\r\n\t\tc0,19.88,14.144,36.463,32.915,40.234c-3.443,0.938-7.068,1.439-10.81,1.439c-2.644,0-5.215-0.258-7.721-0.736\r\n\t\tc5.222,16.301,20.375,28.165,38.331,28.495c-14.043,11.006-31.735,17.565-50.96,17.565c-3.312,0-6.578-0.194-9.788-0.574\r\n\t\tc18.159,11.643,39.727,18.437,62.899,18.437c75.473,0,116.746-62.524,116.746-116.747c0-1.779-0.041-3.549-0.119-5.309\r\n\t\tC187.543,34.695,194.499,27.469,200,19.24\" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "./app/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * styles
 */

__webpack_require__("./app/general/scss/font-face.scss");

__webpack_require__("./app/general/scss/index.scss");

__webpack_require__("./node_modules/intersection-observer/intersection-observer.js");

__webpack_require__("./app/general/js/font-loader.js");

__webpack_require__("./app/general/js/jquery-plugins.js");

__webpack_require__("./app/components/select/index.js");

__webpack_require__("./app/components/header/index.js");

__webpack_require__("./app/components/footer/index.js");

__webpack_require__("./app/components/hero/index.js");

__webpack_require__("./app/components/hero-column/index.js");

__webpack_require__("./app/components/next-auction-panel/index.js");

__webpack_require__("./app/components/home/index.js");

__webpack_require__("./app/components/widget-list/index.js");

__webpack_require__("./app/components/upcoming-auctions/index.js");

__webpack_require__("./app/components/promo/index.js");

__webpack_require__("./app/components/full-width-promo/index.js");

__webpack_require__("./app/components/owl-carousel/index.js");

__webpack_require__("./app/components/lots-carousel/index.js");

__webpack_require__("./app/components/lot-item/index.js");

__webpack_require__("./app/components/responsive-images/index.js");

__webpack_require__("./app/components/section/index.js");

__webpack_require__("./app/components/buying-selling/index.js");

__webpack_require__("./app/components/quotes-carousel/index.js");

__webpack_require__("./app/components/form/index.js");

__webpack_require__("./app/components/signup/index.js");

__webpack_require__("./app/components/flip-number/index.js");

__webpack_require__("./app/components/auction-results/index.js");

__webpack_require__("./app/components/latest-news/index.js");

__webpack_require__("./app/components/news-article-item/index.js");

__webpack_require__("./app/components/lot-details/index.js");

__webpack_require__("./app/components/banners/index.js");

__webpack_require__("./app/components/energy-certificate/index.js");

__webpack_require__("./app/components/collapsed/index.js");

__webpack_require__("./app/components/hero-video/index.js");

__webpack_require__("./app/components/modal/index.js");

__webpack_require__("./app/components/auth-forms/index.js");

__webpack_require__("./app/components/auth-modal/index.js");

__webpack_require__("./app/components/featured-lots/index.js");

__webpack_require__("./app/components/tabs/index.js");

__webpack_require__("./app/components/profile/index.js");

__webpack_require__("./app/components/register/index.js");

__webpack_require__("./app/components/account-settings/index.js");

__webpack_require__("./app/components/spinner/index.js");

__webpack_require__("./app/components/page-spinner/index.js");

__webpack_require__("./app/components/reset-password-form/index.js");

__webpack_require__("./app/components/lots-search/index.js");

__webpack_require__("./app/components/about/index.js");

__webpack_require__("./app/components/contact/index.js");

__webpack_require__("./app/components/radio-switch/index.js");

__webpack_require__("./app/components/gmap/index.js");

__webpack_require__("./app/components/card/index.js");

__webpack_require__("./app/components/bidding-cards/index.js");

__webpack_require__("./app/components/page-switch-tabs/index.js");

__webpack_require__("./app/components/links-list/index.js");

__webpack_require__("./app/components/cta-block/index.js");

__webpack_require__("./app/components/cookie-management/index.js");

__webpack_require__("./app/components/favorites-button/index.js");

__webpack_require__("./app/components/listing/index.js");

__webpack_require__("./app/components/predictive-search/index.js");

__webpack_require__("./app/components/news-search/index.js");

__webpack_require__("./app/components/article/index.js");

__webpack_require__("./app/components/news-article/index.js");

__webpack_require__("./app/components/request-catalogue/index.js");

__webpack_require__("./app/components/offer/index.js");

__webpack_require__("./app/components/social/index.js");

__webpack_require__("./app/components/form-result-replacer/index.js");

__webpack_require__("./app/components/shifted-content/index.js");

__webpack_require__("./app/components/modal-form/index.js");

__webpack_require__("./app/components/download-catalogue/index.js");

__webpack_require__("./app/components/sell-lot/index.js");

__webpack_require__("./app/components/disclaimer/index.js");

__webpack_require__("./app/components/notifications/index.js");

__webpack_require__("./app/components/get-document-form/index.js");

__webpack_require__("./app/components/recaptcha/index.js");

__webpack_require__("./app/components/video/index.js");

__webpack_require__("./app/components/register-to-bid/index.js");

__webpack_require__("./app/components/file-input/index.js");

__webpack_require__("./app/components/show-rule/index.js");

var _app = __webpack_require__("./app/general/js/app.js");

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import './components/cookie-warning';

//import './general/js/cookie-management';

/**
 * components
 */


//start font loading stuff as soon as possible
_app2.default.init();

/**
 * require svg
 */


/**
 * init app
 */


/**
 * base
 */
//intersection observer polyfill
var files = __webpack_require__("./app/general/svg recursive ^\\.\\/.*\\.svg");
files.keys().forEach(files);

/***/ }),

/***/ "./node_modules/chain-function/index.js":
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),

/***/ "./node_modules/dom-helpers/class/addClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__("./node_modules/dom-helpers/class/hasClass.js");

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/dom-helpers/class/hasClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/class/removeClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),

/***/ "./node_modules/dom-helpers/transition/properties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__("./node_modules/dom-helpers/util/inDOM.js");

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),

/***/ "./node_modules/dom-helpers/util/inDOM.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/dom-helpers/util/requestAnimationFrame.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__("./node_modules/dom-helpers/util/inDOM.js");

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/fbemitter/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var fbemitter = {
  EventEmitter: __webpack_require__("./node_modules/fbemitter/lib/BaseEventEmitter.js"),
  EmitterSubscription : __webpack_require__("./node_modules/fbemitter/lib/EmitterSubscription.js")
};

module.exports = fbemitter;


/***/ }),

/***/ "./node_modules/fbemitter/lib/BaseEventEmitter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BaseEventEmitter
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EmitterSubscription = __webpack_require__("./node_modules/fbemitter/lib/EmitterSubscription.js");
var EventSubscriptionVendor = __webpack_require__("./node_modules/fbemitter/lib/EventSubscriptionVendor.js");

var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * @class BaseEventEmitter
 * @description
 * An EventEmitter is responsible for managing a set of listeners and publishing
 * events to them when it is told that such events happened. In addition to the
 * data for the given event it also sends a event control object which allows
 * the listeners/handlers to prevent the default behavior of the given event.
 *
 * The emitter is designed to be generic enough to support all the different
 * contexts in which one might want to emit events. It is a simple multicast
 * mechanism on top of which extra functionality can be composed. For example, a
 * more advanced emitter may use an EventHolder and EventFactory.
 */

var BaseEventEmitter = (function () {
  /**
   * @constructor
   */

  function BaseEventEmitter() {
    _classCallCheck(this, BaseEventEmitter);

    this._subscriber = new EventSubscriptionVendor();
    this._currentSubscription = null;
  }

  /**
   * Adds a listener to be invoked when events of the specified type are
   * emitted. An optional calling context may be provided. The data arguments
   * emitted will be passed to the listener function.
   *
   * TODO: Annotate the listener arg's type. This is tricky because listeners
   *       can be invoked with varargs.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
    return this._subscriber.addSubscription(eventType, new EmitterSubscription(this._subscriber, listener, context));
  };

  /**
   * Similar to addListener, except that the listener is removed after it is
   * invoked once.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke only once when the
   *   specified event is emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.once = function once(eventType, listener, context) {
    var emitter = this;
    return this.addListener(eventType, function () {
      emitter.removeCurrentListener();
      listener.apply(context, arguments);
    });
  };

  /**
   * Removes all of the registered listeners, including those registered as
   * listener maps.
   *
   * @param {?string} eventType - Optional name of the event whose registered
   *   listeners to remove
   */

  BaseEventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
    this._subscriber.removeAllSubscriptions(eventType);
  };

  /**
   * Provides an API that can be called during an eventing cycle to remove the
   * last listener that was invoked. This allows a developer to provide an event
   * object that can remove the listener (or listener map) during the
   * invocation.
   *
   * If it is called when not inside of an emitting cycle it will throw.
   *
   * @throws {Error} When called not during an eventing cycle
   *
   * @example
   *   var subscription = emitter.addListenerMap({
   *     someEvent: function(data, event) {
   *       console.log(data);
   *       emitter.removeCurrentListener();
   *     }
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   *   emitter.emit('someEvent', 'def'); // does not log anything
   */

  BaseEventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {
    !!!this._currentSubscription ?  false ? invariant(false, 'Not in an emitting cycle; there is no current subscription') : invariant(false) : undefined;
    this._subscriber.removeSubscription(this._currentSubscription);
  };

  /**
   * Returns an array of listeners that are currently registered for the given
   * event.
   *
   * @param {string} eventType - Name of the event to query
   * @return {array}
   */

  BaseEventEmitter.prototype.listeners = function listeners(eventType) /* TODO: Array<EventSubscription> */{
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    return subscriptions ? subscriptions.filter(emptyFunction.thatReturnsTrue).map(function (subscription) {
      return subscription.listener;
    }) : [];
  };

  /**
   * Emits an event of the given type with the given data. All handlers of that
   * particular type will be notified.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {*} Arbitrary arguments to be passed to each registered listener
   *
   * @example
   *   emitter.addListener('someEvent', function(message) {
   *     console.log(message);
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   */

  BaseEventEmitter.prototype.emit = function emit(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    if (subscriptions) {
      var keys = Object.keys(subscriptions);
      for (var ii = 0; ii < keys.length; ii++) {
        var key = keys[ii];
        var subscription = subscriptions[key];
        // The subscription may have been removed during this event loop.
        if (subscription) {
          this._currentSubscription = subscription;
          this.__emitToSubscription.apply(this, [subscription].concat(Array.prototype.slice.call(arguments)));
        }
      }
      this._currentSubscription = null;
    }
  };

  /**
   * Provides a hook to override how the emitter emits an event to a specific
   * subscription. This allows you to set up logging and error boundaries
   * specific to your environment.
   *
   * @param {EmitterSubscription} subscription
   * @param {string} eventType
   * @param {*} Arbitrary arguments to be passed to each registered listener
   */

  BaseEventEmitter.prototype.__emitToSubscription = function __emitToSubscription(subscription, eventType) {
    var args = Array.prototype.slice.call(arguments, 2);
    subscription.listener.apply(subscription.context, args);
  };

  return BaseEventEmitter;
})();

module.exports = BaseEventEmitter;

/***/ }),

/***/ "./node_modules/fbemitter/lib/EmitterSubscription.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 * 
 * @providesModule EmitterSubscription
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventSubscription = __webpack_require__("./node_modules/fbemitter/lib/EventSubscription.js");

/**
 * EmitterSubscription represents a subscription with listener and context data.
 */

var EmitterSubscription = (function (_EventSubscription) {
  _inherits(EmitterSubscription, _EventSubscription);

  /**
   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
   *   this subscription
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  function EmitterSubscription(subscriber, listener, context) {
    _classCallCheck(this, EmitterSubscription);

    _EventSubscription.call(this, subscriber);
    this.listener = listener;
    this.context = context;
  }

  return EmitterSubscription;
})(EventSubscription);

module.exports = EmitterSubscription;

/***/ }),

/***/ "./node_modules/fbemitter/lib/EventSubscription.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventSubscription
 * @typechecks
 */



/**
 * EventSubscription represents a subscription to a particular event. It can
 * remove its own subscription.
 */

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EventSubscription = (function () {

  /**
   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
   *   this subscription.
   */

  function EventSubscription(subscriber) {
    _classCallCheck(this, EventSubscription);

    this.subscriber = subscriber;
  }

  /**
   * Removes this subscription from the subscriber that controls it.
   */

  EventSubscription.prototype.remove = function remove() {
    if (this.subscriber) {
      this.subscriber.removeSubscription(this);
      this.subscriber = null;
    }
  };

  return EventSubscription;
})();

module.exports = EventSubscription;

/***/ }),

/***/ "./node_modules/fbemitter/lib/EventSubscriptionVendor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 * 
 * @providesModule EventSubscriptionVendor
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * EventSubscriptionVendor stores a set of EventSubscriptions that are
 * subscribed to a particular event type.
 */

var EventSubscriptionVendor = (function () {
  function EventSubscriptionVendor() {
    _classCallCheck(this, EventSubscriptionVendor);

    this._subscriptionsForType = {};
    this._currentSubscription = null;
  }

  /**
   * Adds a subscription keyed by an event type.
   *
   * @param {string} eventType
   * @param {EventSubscription} subscription
   */

  EventSubscriptionVendor.prototype.addSubscription = function addSubscription(eventType, subscription) {
    !(subscription.subscriber === this) ?  false ? invariant(false, 'The subscriber of the subscription is incorrectly set.') : invariant(false) : undefined;
    if (!this._subscriptionsForType[eventType]) {
      this._subscriptionsForType[eventType] = [];
    }
    var key = this._subscriptionsForType[eventType].length;
    this._subscriptionsForType[eventType].push(subscription);
    subscription.eventType = eventType;
    subscription.key = key;
    return subscription;
  };

  /**
   * Removes a bulk set of the subscriptions.
   *
   * @param {?string} eventType - Optional name of the event type whose
   *   registered supscriptions to remove, if null remove all subscriptions.
   */

  EventSubscriptionVendor.prototype.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
    if (eventType === undefined) {
      this._subscriptionsForType = {};
    } else {
      delete this._subscriptionsForType[eventType];
    }
  };

  /**
   * Removes a specific subscription. Instead of calling this function, call
   * `subscription.remove()` directly.
   *
   * @param {object} subscription
   */

  EventSubscriptionVendor.prototype.removeSubscription = function removeSubscription(subscription) {
    var eventType = subscription.eventType;
    var key = subscription.key;

    var subscriptionsForType = this._subscriptionsForType[eventType];
    if (subscriptionsForType) {
      delete subscriptionsForType[key];
    }
  };

  /**
   * Returns the array of subscriptions that are currently registered for the
   * given event type.
   *
   * Note: This array can be potentially sparse as subscriptions are deleted
   * from it when they are removed.
   *
   * TODO: This returns a nullable array. wat?
   *
   * @param {string} eventType
   * @return {?array}
   */

  EventSubscriptionVendor.prototype.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
    return this._subscriptionsForType[eventType];
  };

  return EventSubscriptionVendor;
})();

module.exports = EventSubscriptionVendor;

/***/ }),

/***/ "./node_modules/fbjs/lib/invariant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "./node_modules/fontfaceobserver/fontfaceobserver.standalone.js":
/***/ (function(module, exports, __webpack_require__) {

/* Font Face Observer v2.0.13 - © Bram Stein. License: BSD-3-Clause */(function(){function l(a,b){document.addEventListener?a.addEventListener("scroll",b,!1):a.attachEvent("scroll",b)}function m(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function c(){document.removeEventListener("DOMContentLoaded",c);a()}):document.attachEvent("onreadystatechange",function k(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",k),a()})};function r(a){this.a=document.createElement("div");this.a.setAttribute("aria-hidden","true");this.a.appendChild(document.createTextNode(a));this.b=document.createElement("span");this.c=document.createElement("span");this.h=document.createElement("span");this.f=document.createElement("span");this.g=-1;this.b.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.c.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
this.f.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.h.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.b.appendChild(this.h);this.c.appendChild(this.f);this.a.appendChild(this.b);this.a.appendChild(this.c)}
function t(a,b){a.a.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+b+";"}function y(a){var b=a.a.offsetWidth,c=b+100;a.f.style.width=c+"px";a.c.scrollLeft=c;a.b.scrollLeft=a.b.scrollWidth+100;return a.g!==b?(a.g=b,!0):!1}function z(a,b){function c(){var a=k;y(a)&&a.a.parentNode&&b(a.g)}var k=a;l(a.b,c);l(a.c,c);y(a)};function A(a,b){var c=b||{};this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal"}var B=null,C=null,E=null,F=null;function G(){if(null===C)if(J()&&/Apple/.test(window.navigator.vendor)){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent);C=!!a&&603>parseInt(a[1],10)}else C=!1;return C}function J(){null===F&&(F=!!document.fonts);return F}
function K(){if(null===E){var a=document.createElement("div");try{a.style.font="condensed 100px sans-serif"}catch(b){}E=""!==a.style.font}return E}function L(a,b){return[a.style,a.weight,K()?a.stretch:"","100px",b].join(" ")}
A.prototype.load=function(a,b){var c=this,k=a||"BESbswy",q=0,D=b||3E3,H=(new Date).getTime();return new Promise(function(a,b){if(J()&&!G()){var M=new Promise(function(a,b){function e(){(new Date).getTime()-H>=D?b():document.fonts.load(L(c,'"'+c.family+'"'),k).then(function(c){1<=c.length?a():setTimeout(e,25)},function(){b()})}e()}),N=new Promise(function(a,c){q=setTimeout(c,D)});Promise.race([N,M]).then(function(){clearTimeout(q);a(c)},function(){b(c)})}else m(function(){function u(){var b;if(b=-1!=
f&&-1!=g||-1!=f&&-1!=h||-1!=g&&-1!=h)(b=f!=g&&f!=h&&g!=h)||(null===B&&(b=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),B=!!b&&(536>parseInt(b[1],10)||536===parseInt(b[1],10)&&11>=parseInt(b[2],10))),b=B&&(f==v&&g==v&&h==v||f==w&&g==w&&h==w||f==x&&g==x&&h==x)),b=!b;b&&(d.parentNode&&d.parentNode.removeChild(d),clearTimeout(q),a(c))}function I(){if((new Date).getTime()-H>=D)d.parentNode&&d.parentNode.removeChild(d),b(c);else{var a=document.hidden;if(!0===a||void 0===a)f=e.a.offsetWidth,
g=n.a.offsetWidth,h=p.a.offsetWidth,u();q=setTimeout(I,50)}}var e=new r(k),n=new r(k),p=new r(k),f=-1,g=-1,h=-1,v=-1,w=-1,x=-1,d=document.createElement("div");d.dir="ltr";t(e,L(c,"sans-serif"));t(n,L(c,"serif"));t(p,L(c,"monospace"));d.appendChild(e.a);d.appendChild(n.a);d.appendChild(p.a);document.body.appendChild(d);v=e.a.offsetWidth;w=n.a.offsetWidth;x=p.a.offsetWidth;I();z(e,function(a){f=a;u()});t(e,L(c,'"'+c.family+'",sans-serif'));z(n,function(a){g=a;u()});t(n,L(c,'"'+c.family+'",serif'));
z(p,function(a){h=a;u()});t(p,L(c,'"'+c.family+'",monospace'))})})}; true?module.exports=A:(window.FontFaceObserver=A,window.FontFaceObserver.prototype.load=A.prototype.load);}());


/***/ }),

/***/ "./node_modules/handlebars/runtime.js":
/***/ (function(module, exports, __webpack_require__) {

// Create a simple path alias to allow browserify to resolve
// the runtime on a supported path.
module.exports = __webpack_require__("./node_modules/handlebars/dist/cjs/handlebars.runtime.js")['default'];


/***/ }),

/***/ "./node_modules/imports-loader/index.js?this=>window!./node_modules/exports-loader/index.js?Modernizr!./app/general/js/modernizr-build.js":
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-mediaqueries-touchevents-setclasses !*/
!function (e, n, t) {
  function o(e, n) {
    return (typeof e === "undefined" ? "undefined" : _typeof(e)) === n;
  }function s() {
    var e, n, t, s, a, i, r;for (var l in d) {
      if (d.hasOwnProperty(l)) {
        if (e = [], n = d[l], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (t = 0; t < n.options.aliases.length; t++) {
          e.push(n.options.aliases[t].toLowerCase());
        }for (s = o(n.fn, "function") ? n.fn() : n.fn, a = 0; a < e.length; a++) {
          i = e[a], r = i.split("."), 1 === r.length ? Modernizr[r[0]] = s : (!Modernizr[r[0]] || Modernizr[r[0]] instanceof Boolean || (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])), Modernizr[r[0]][r[1]] = s), f.push((s ? "" : "no-") + r.join("-"));
        }
      }
    }
  }function a(e) {
    var n = c.className,
        t = Modernizr._config.classPrefix || "";if (p && (n = n.baseVal), Modernizr._config.enableJSClass) {
      var o = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");n = n.replace(o, "$1" + t + "js$2");
    }Modernizr._config.enableClasses && (n += " " + t + e.join(" " + t), p ? c.className.baseVal = n : c.className = n);
  }function i() {
    return "function" != typeof n.createElement ? n.createElement(arguments[0]) : p ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0]) : n.createElement.apply(n, arguments);
  }function r() {
    var e = n.body;return e || (e = i(p ? "svg" : "body"), e.fake = !0), e;
  }function l(e, t, o, s) {
    var a,
        l,
        f,
        d,
        u = "modernizr",
        p = i("div"),
        m = r();if (parseInt(o, 10)) for (; o--;) {
      f = i("div"), f.id = s ? s[o] : u + (o + 1), p.appendChild(f);
    }return a = i("style"), a.type = "text/css", a.id = "s" + u, (m.fake ? m : p).appendChild(a), m.appendChild(p), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(n.createTextNode(e)), p.id = u, m.fake && (m.style.background = "", m.style.overflow = "hidden", d = c.style.overflow, c.style.overflow = "hidden", c.appendChild(m)), l = t(p, e), m.fake ? (m.parentNode.removeChild(m), c.style.overflow = d, c.offsetHeight) : p.parentNode.removeChild(p), !!l;
  }var f = [],
      d = [],
      u = { _version: "3.5.0", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, n) {
      var t = this;setTimeout(function () {
        n(t[e]);
      }, 0);
    }, addTest: function addTest(e, n, t) {
      d.push({ name: e, fn: n, options: t });
    }, addAsyncTest: function addAsyncTest(e) {
      d.push({ name: null, fn: e });
    } },
      Modernizr = function Modernizr() {};Modernizr.prototype = u, Modernizr = new Modernizr();var c = n.documentElement,
      p = "svg" === c.nodeName.toLowerCase(),
      m = function () {
    var n = e.matchMedia || e.msMatchMedia;return n ? function (e) {
      var t = n(e);return t && t.matches || !1;
    } : function (n) {
      var t = !1;return l("@media " + n + " { #modernizr { position: absolute; } }", function (n) {
        t = "absolute" == (e.getComputedStyle ? e.getComputedStyle(n, null) : n.currentStyle).position;
      }), t;
    };
  }();u.mq = m, Modernizr.addTest("mediaqueries", m("only all"));var h = u._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];u._prefixes = h;var v = u.testStyles = l;Modernizr.addTest("touchevents", function () {
    var t;if ("ontouchstart" in e || e.DocumentTouch && n instanceof DocumentTouch) t = !0;else {
      var o = ["@media (", h.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");v(o, function (e) {
        t = 9 === e.offsetTop;
      });
    }return t;
  }), s(), a(f), delete u.addTest, delete u.addAsyncTest;for (var y = 0; y < Modernizr._q.length; y++) {
    Modernizr._q[y]();
  }e.Modernizr = Modernizr;
}(window, document);

/*** EXPORTS FROM exports-loader ***/
module.exports = Modernizr;
}.call(window));

/***/ }),

/***/ "./node_modules/imports-loader/index.js?this=>window!./node_modules/exports-loader/index.js?objectFitPolyfill!./node_modules/objectFitPolyfill/dist/objectFitPolyfill.min.js":
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

!function(){"use strict";if("undefined"!=typeof window){var t=window.navigator.userAgent.match(/Edge\/(\d{2})\./),e=!!t&&parseInt(t[1],10)>=16;if("objectFit"in document.documentElement.style!=!1&&!e)return void(window.objectFitPolyfill=function(){return!1});var i=function(t){var e=window.getComputedStyle(t,null),i=e.getPropertyValue("position"),n=e.getPropertyValue("overflow"),o=e.getPropertyValue("display");i&&"static"!==i||(t.style.position="relative"),"hidden"!==n&&(t.style.overflow="hidden"),o&&"inline"!==o||(t.style.display="block"),0===t.clientHeight&&(t.style.height="100%"),-1===t.className.indexOf("object-fit-polyfill")&&(t.className=t.className+" object-fit-polyfill")},n=function(t){var e=window.getComputedStyle(t,null),i={"max-width":"none","max-height":"none","min-width":"0px","min-height":"0px",top:"auto",right:"auto",bottom:"auto",left:"auto","margin-top":"0px","margin-right":"0px","margin-bottom":"0px","margin-left":"0px"};for(var n in i){e.getPropertyValue(n)!==i[n]&&(t.style[n]=i[n])}},o=function(t,e,i){var n,o,l,a,d;if(i=i.split(" "),i.length<2&&(i[1]=i[0]),"x"===t)n=i[0],o=i[1],l="left",a="right",d=e.clientWidth;else{if("y"!==t)return;n=i[1],o=i[0],l="top",a="bottom",d=e.clientHeight}return n===l||o===l?void(e.style[l]="0"):n===a||o===a?void(e.style[a]="0"):"center"===n||"50%"===n?(e.style[l]="50%",void(e.style["margin-"+l]=d/-2+"px")):n.indexOf("%")>=0?(n=parseInt(n),void(n<50?(e.style[l]=n+"%",e.style["margin-"+l]=d*(n/-100)+"px"):(n=100-n,e.style[a]=n+"%",e.style["margin-"+a]=d*(n/-100)+"px"))):void(e.style[l]=n)},l=function(t){var e=t.dataset?t.dataset.objectFit:t.getAttribute("data-object-fit"),l=t.dataset?t.dataset.objectPosition:t.getAttribute("data-object-position");e=e||"cover",l=l||"50% 50%";var a=t.parentNode;i(a),n(t),t.style.position="absolute",t.style.height="100%",t.style.width="auto","scale-down"===e&&(t.style.height="auto",t.clientWidth<a.clientWidth&&t.clientHeight<a.clientHeight?(o("x",t,l),o("y",t,l)):(e="contain",t.style.height="100%")),"none"===e?(t.style.width="auto",t.style.height="auto",o("x",t,l),o("y",t,l)):"cover"===e&&t.clientWidth>a.clientWidth||"contain"===e&&t.clientWidth<a.clientWidth?(t.style.top="0",t.style.marginTop="0",o("x",t,l)):"scale-down"!==e&&(t.style.width="100%",t.style.height="auto",t.style.left="0",t.style.marginLeft="0",o("y",t,l))},a=function(t){if(void 0===t)t=document.querySelectorAll("[data-object-fit]");else if(t&&t.nodeName)t=[t];else{if("object"!=typeof t||!t.length||!t[0].nodeName)return!1;t=t}for(var i=0;i<t.length;i++)if(t[i].nodeName){var n=t[i].nodeName.toLowerCase();"img"!==n||e?"video"===n&&(t[i].readyState>0?l(t[i]):t[i].addEventListener("loadedmetadata",function(){l(this)})):t[i].complete?l(t[i]):t[i].addEventListener("load",function(){l(this)})}return!0};document.addEventListener("DOMContentLoaded",function(){a()}),window.addEventListener("resize",function(){a()}),window.objectFitPolyfill=a}}();

/*** EXPORTS FROM exports-loader ***/
module.exports = objectFitPolyfill;
}.call(window));

/***/ }),

/***/ "./node_modules/jquery-countdown/dist/jquery.countdown.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * The Final Countdown for jQuery v2.2.0 (http://hilios.github.io/jQuery.countdown/)
 * Copyright (c) 2016 Edson Hilios
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
(function(factory) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__("./node_modules/jquery/dist/jquery.js") ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        factory(jQuery);
    }
})(function($) {
    "use strict";
    var instances = [], matchers = [], defaultOptions = {
        precision: 100,
        elapse: false,
        defer: false
    };
    matchers.push(/^[0-9]*$/.source);
    matchers.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
    matchers.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
    matchers = new RegExp(matchers.join("|"));
    function parseDateString(dateString) {
        if (dateString instanceof Date) {
            return dateString;
        }
        if (String(dateString).match(matchers)) {
            if (String(dateString).match(/^[0-9]*$/)) {
                dateString = Number(dateString);
            }
            if (String(dateString).match(/\-/)) {
                dateString = String(dateString).replace(/\-/g, "/");
            }
            return new Date(dateString);
        } else {
            throw new Error("Couldn't cast `" + dateString + "` to a date object.");
        }
    }
    var DIRECTIVE_KEY_MAP = {
        Y: "years",
        m: "months",
        n: "daysToMonth",
        d: "daysToWeek",
        w: "weeks",
        W: "weeksToMonth",
        H: "hours",
        M: "minutes",
        S: "seconds",
        D: "totalDays",
        I: "totalHours",
        N: "totalMinutes",
        T: "totalSeconds"
    };
    function escapedRegExp(str) {
        var sanitize = str.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        return new RegExp(sanitize);
    }
    function strftime(offsetObject) {
        return function(format) {
            var directives = format.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
            if (directives) {
                for (var i = 0, len = directives.length; i < len; ++i) {
                    var directive = directives[i].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/), regexp = escapedRegExp(directive[0]), modifier = directive[1] || "", plural = directive[3] || "", value = null;
                    directive = directive[2];
                    if (DIRECTIVE_KEY_MAP.hasOwnProperty(directive)) {
                        value = DIRECTIVE_KEY_MAP[directive];
                        value = Number(offsetObject[value]);
                    }
                    if (value !== null) {
                        if (modifier === "!") {
                            value = pluralize(plural, value);
                        }
                        if (modifier === "") {
                            if (value < 10) {
                                value = "0" + value.toString();
                            }
                        }
                        format = format.replace(regexp, value.toString());
                    }
                }
            }
            format = format.replace(/%%/, "%");
            return format;
        };
    }
    function pluralize(format, count) {
        var plural = "s", singular = "";
        if (format) {
            format = format.replace(/(:|;|\s)/gi, "").split(/\,/);
            if (format.length === 1) {
                plural = format[0];
            } else {
                singular = format[0];
                plural = format[1];
            }
        }
        if (Math.abs(count) > 1) {
            return plural;
        } else {
            return singular;
        }
    }
    var Countdown = function(el, finalDate, options) {
        this.el = el;
        this.$el = $(el);
        this.interval = null;
        this.offset = {};
        this.options = $.extend({}, defaultOptions);
        this.instanceNumber = instances.length;
        instances.push(this);
        this.$el.data("countdown-instance", this.instanceNumber);
        if (options) {
            if (typeof options === "function") {
                this.$el.on("update.countdown", options);
                this.$el.on("stoped.countdown", options);
                this.$el.on("finish.countdown", options);
            } else {
                this.options = $.extend({}, defaultOptions, options);
            }
        }
        this.setFinalDate(finalDate);
        if (this.options.defer === false) {
            this.start();
        }
    };
    $.extend(Countdown.prototype, {
        start: function() {
            if (this.interval !== null) {
                clearInterval(this.interval);
            }
            var self = this;
            this.update();
            this.interval = setInterval(function() {
                self.update.call(self);
            }, this.options.precision);
        },
        stop: function() {
            clearInterval(this.interval);
            this.interval = null;
            this.dispatchEvent("stoped");
        },
        toggle: function() {
            if (this.interval) {
                this.stop();
            } else {
                this.start();
            }
        },
        pause: function() {
            this.stop();
        },
        resume: function() {
            this.start();
        },
        remove: function() {
            this.stop.call(this);
            instances[this.instanceNumber] = null;
            delete this.$el.data().countdownInstance;
        },
        setFinalDate: function(value) {
            this.finalDate = parseDateString(value);
        },
        update: function() {
            if (this.$el.closest("html").length === 0) {
                this.remove();
                return;
            }
            var hasEventsAttached = $._data(this.el, "events") !== undefined, now = new Date(), newTotalSecsLeft;
            newTotalSecsLeft = this.finalDate.getTime() - now.getTime();
            newTotalSecsLeft = Math.ceil(newTotalSecsLeft / 1e3);
            newTotalSecsLeft = !this.options.elapse && newTotalSecsLeft < 0 ? 0 : Math.abs(newTotalSecsLeft);
            if (this.totalSecsLeft === newTotalSecsLeft || !hasEventsAttached) {
                return;
            } else {
                this.totalSecsLeft = newTotalSecsLeft;
            }
            this.elapsed = now >= this.finalDate;
            this.offset = {
                seconds: this.totalSecsLeft % 60,
                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 % 30.4368),
                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                weeksToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                years: Math.abs(this.finalDate.getFullYear() - now.getFullYear()),
                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
                totalMinutes: Math.floor(this.totalSecsLeft / 60),
                totalSeconds: this.totalSecsLeft
            };
            if (!this.options.elapse && this.totalSecsLeft === 0) {
                this.stop();
                this.dispatchEvent("finish");
            } else {
                this.dispatchEvent("update");
            }
        },
        dispatchEvent: function(eventName) {
            var event = $.Event(eventName + ".countdown");
            event.finalDate = this.finalDate;
            event.elapsed = this.elapsed;
            event.offset = $.extend({}, this.offset);
            event.strftime = strftime(this.offset);
            this.$el.trigger(event);
        }
    });
    $.fn.countdown = function() {
        var argumentsArray = Array.prototype.slice.call(arguments, 0);
        return this.each(function() {
            var instanceNumber = $(this).data("countdown-instance");
            if (instanceNumber !== undefined) {
                var instance = instances[instanceNumber], method = argumentsArray[0];
                if (Countdown.prototype.hasOwnProperty(method)) {
                    instance[method].apply(instance, argumentsArray.slice(1));
                } else if (String(method).match(/^[$A-Z_][0-9A-Z_$]*$/i) === null) {
                    instance.setFinalDate.call(instance, method);
                    instance.start();
                } else {
                    $.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, method));
                }
            } else {
                new Countdown(this, argumentsArray[0], argumentsArray[1]);
            }
        });
    };
});

/***/ }),

/***/ "./node_modules/js-cookie/src/js.cookie.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "./node_modules/lazysizes/plugins/bgset/ls.bgset.js":
/***/ (function(module, exports, __webpack_require__) {

(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(__webpack_require__("./node_modules/lazysizes/lazysizes.js"));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	'use strict';
	if(!window.addEventListener){return;}

	var regWhite = /\s+/g;
	var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
	var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/;
	var regBgUrlEscape = /\(|\)|'/;
	var allowedBackgroundSize = {contain: 1, cover: 1};
	var proxyWidth = function(elem){
		var width = lazySizes.gW(elem, elem.parentNode);

		if(!elem._lazysizesWidth || width > elem._lazysizesWidth){
			elem._lazysizesWidth = width;
		}
		return elem._lazysizesWidth;
	};
	var getBgSize = function(elem){
		var bgSize;

		bgSize = (getComputedStyle(elem) || {getPropertyValue: function(){}}).getPropertyValue('background-size');

		if(!allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize]){
			bgSize = elem.style.backgroundSize;
		}

		return bgSize;
	};
	var createPicture = function(sets, elem, img){
		var picture = document.createElement('picture');
		var sizes = elem.getAttribute(lazySizesConfig.sizesAttr);
		var ratio = elem.getAttribute('data-ratio');
		var optimumx = elem.getAttribute('data-optimumx');

		if(elem._lazybgset && elem._lazybgset.parentNode == elem){
			elem.removeChild(elem._lazybgset);
		}

		Object.defineProperty(img, '_lazybgset', {
			value: elem,
			writable: true
		});
		Object.defineProperty(elem, '_lazybgset', {
			value: picture,
			writable: true
		});

		sets = sets.replace(regWhite, ' ').split(regSplitSet);

		picture.style.display = 'none';
		img.className = lazySizesConfig.lazyClass;

		if(sets.length == 1 && !sizes){
			sizes = 'auto';
		}

		sets.forEach(function(set){
			var source = document.createElement('source');

			if(sizes && sizes != 'auto'){
				source.setAttribute('sizes', sizes);
			}

			if(set.match(regSource)){
				source.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1);
				if(RegExp.$2){
					source.setAttribute('media', lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2);
				}
			}
			picture.appendChild(source);
		});

		if(sizes){
			img.setAttribute(lazySizesConfig.sizesAttr, sizes);
			elem.removeAttribute(lazySizesConfig.sizesAttr);
			elem.removeAttribute('sizes');
		}
		if(optimumx){
			img.setAttribute('data-optimumx', optimumx);
		}
		if(ratio) {
			img.setAttribute('data-ratio', ratio);
		}

		picture.appendChild(img);

		elem.appendChild(picture);
	};

	var proxyLoad = function(e){
		if(!e.target._lazybgset){return;}

		var image = e.target;
		var elem = image._lazybgset;
		var bg = image.currentSrc || image.src;

		if(bg){
			elem.style.backgroundImage = 'url(' + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg ) + ')';
		}

		if(image._lazybgsetLoading){
			lazySizes.fire(elem, '_lazyloaded', {}, false, true);
			delete image._lazybgsetLoading;
		}
	};

	addEventListener('lazybeforeunveil', function(e){
		var set, image, elem;

		if(e.defaultPrevented || !(set = e.target.getAttribute('data-bgset'))){return;}

		elem = e.target;
		image = document.createElement('img');

		image.alt = '';

		image._lazybgsetLoading = true;
		e.detail.firesLoad = true;

		createPicture(set, elem, image);

		setTimeout(function(){
			lazySizes.loader.unveil(image);

			lazySizes.rAF(function(){
				lazySizes.fire(image, '_lazyloaded', {}, true, true);
				if(image.complete) {
					proxyLoad({target: image});
				}
			});
		});

	});

	document.addEventListener('load', proxyLoad, true);

	window.addEventListener('lazybeforesizes', function(e){
		if(e.detail.instance != lazySizes){return;}
		if(e.target._lazybgset && e.detail.dataAttr){
			var elem = e.target._lazybgset;
			var bgSize = getBgSize(elem);

			if(allowedBackgroundSize[bgSize]){
				e.target._lazysizesParentFit = bgSize;

				lazySizes.rAF(function(){
					e.target.setAttribute('data-parent-fit', bgSize);
					if(e.target._lazysizesParentFit){
						delete e.target._lazysizesParentFit;
					}
				});
			}
		}
	}, true);

	document.documentElement.addEventListener('lazybeforesizes', function(e){
		if(e.defaultPrevented || !e.target._lazybgset || e.detail.instance != lazySizes){return;}
		e.detail.width = proxyWidth(e.target._lazybgset);
	});
}));


/***/ }),

/***/ "./node_modules/lazysizes/plugins/fix-ios-sizes/fix-ios-sizes.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Some versions of iOS (8.1-) do load the first candidate of a srcset candidate list, if width descriptors with the sizes attribute is used.
 * This tiny extension prevents this wasted download by creating a picture structure around the image.
 * Note: This extension is already included in the ls.respimg.js file.
 *
 * Usage:
 *
 * <img
 * 	class="lazyload"
 * 	data-sizes="auto"
 * 	data-srcset="small.jpg 640px,
 * 		medium.jpg 980w,
 * 		large.jpg 1280w"
 * 	/>
 */

(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(__webpack_require__("./node_modules/lazysizes/lazysizes.js"));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	'use strict';
	var regPicture;
	var img = document.createElement('img');

	if(('srcset' in img) && !('sizes' in img) && !window.HTMLPictureElement){
		regPicture = /^picture$/i;
		document.addEventListener('lazybeforeunveil', function(e){
			if(e.detail.instance != lazySizes){return;}

			var elem, parent, srcset, sizes, isPicture;
			var picture, source;
			if(e.defaultPrevented ||
				lazySizesConfig.noIOSFix ||
				!(elem = e.target) ||
				!(srcset = elem.getAttribute(lazySizesConfig.srcsetAttr)) ||
				!(parent = elem.parentNode) ||
				(
					!(isPicture = regPicture.test(parent.nodeName || '')) &&
					!(sizes = elem.getAttribute('sizes') || elem.getAttribute(lazySizesConfig.sizesAttr))
				)
			){return;}

			picture = isPicture ? parent : document.createElement('picture');

			if(!elem._lazyImgSrc){
				Object.defineProperty(elem, '_lazyImgSrc', {
					value: document.createElement('source'),
					writable: true
				});
			}
			source = elem._lazyImgSrc;

			if(sizes){
				source.setAttribute('sizes', sizes);
			}

			source.setAttribute(lazySizesConfig.srcsetAttr, srcset);
			elem.setAttribute('data-pfsrcset', srcset);
			elem.removeAttribute(lazySizesConfig.srcsetAttr);

			if(!isPicture){
				parent.insertBefore(picture, elem);
				picture.appendChild(elem);
			}
			picture.insertBefore(source, elem);
		});
	}
}));


/***/ }),

/***/ "./node_modules/lazysizes/plugins/object-fit/ls.object-fit.js":
/***/ (function(module, exports, __webpack_require__) {

(function(window, factory) {
	var globalInstall = function(initialEvent){
		factory(window.lazySizes, initialEvent);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(__webpack_require__("./node_modules/lazysizes/lazysizes.js"));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes, initialEvent) {
	'use strict';
	var style = document.createElement('a').style;
	var fitSupport = 'objectFit' in style;
	var positionSupport = fitSupport && 'objectPosition' in style;
	var regCssFit = /object-fit["']*\s*:\s*["']*(contain|cover)/;
	var regCssPosition = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/;
	var blankSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	var regBgUrlEscape = /\(|\)|'/;
	var positionDefaults = {
		center: 'center',
		'50% 50%': 'center',
	};

	function getObject(element){
		var css = (getComputedStyle(element, null) || {});
		var content = css.fontFamily || '';
		var objectFit = content.match(regCssFit) || '';
		var objectPosition = objectFit && content.match(regCssPosition) || '';

		if(objectPosition){
			objectPosition = objectPosition[1];
		}

		return {
			fit: objectFit && objectFit[1] || '',
			position: positionDefaults[objectPosition] || objectPosition || 'center',
		};
	}

	function initFix(element, config){
		var switchClassesAdded;
		var lazysizesCfg = lazySizes.cfg;
		var styleElement = element.cloneNode(false);
		var styleElementStyle = styleElement.style;

		var onChange = function(){
			var src = element.currentSrc || element.src;

			if(src){
				styleElementStyle.backgroundImage = 'url(' + (regBgUrlEscape.test(src) ? JSON.stringify(src) : src ) + ')';

				if(!switchClassesAdded){
					switchClassesAdded = true;
					lazySizes.rC(styleElement, lazysizesCfg.loadingClass);
					lazySizes.aC(styleElement, lazysizesCfg.loadedClass);
				}
			}
		};

		element._lazysizesParentFit = config.fit;

		element.addEventListener('load', function(){
			lazySizes.rAF(onChange);
		}, true);

		styleElement.addEventListener('load', function(){
			var curSrc = styleElement.currentSrc || styleElement.src;

			if(curSrc && curSrc != blankSrc){
				styleElement.src = blankSrc;
				styleElement.srcset = '';
			}
		});

		lazySizes.rAF(function(){

			var hideElement = element;
			var container = element.parentNode;

			if(container.nodeName.toUpperCase() == 'PICTURE'){
				hideElement = container;
				container = container.parentNode;
			}

			lazySizes.rC(styleElement, lazysizesCfg.loadedClass);
			lazySizes.rC(styleElement, lazysizesCfg.lazyClass);
			lazySizes.aC(styleElement, lazysizesCfg.loadingClass);
			lazySizes.aC(styleElement, lazysizesCfg.objectFitClass || 'lazysizes-display-clone');

			if(styleElement.getAttribute(lazysizesCfg.srcsetAttr)){
				styleElement.setAttribute(lazysizesCfg.srcsetAttr, '');
			}

			if(styleElement.getAttribute(lazysizesCfg.srcAttr)){
				styleElement.setAttribute(lazysizesCfg.srcAttr, '');
			}

			styleElement.src = blankSrc;
			styleElement.srcset = '';

			styleElementStyle.backgroundRepeat = 'no-repeat';
			styleElementStyle.backgroundPosition = config.position;
			styleElementStyle.backgroundSize = config.fit;

			hideElement.style.display = 'none';

			element.setAttribute('data-parent-fit', config.fit);
			element.setAttribute('data-parent-container', 'prev');

			container.insertBefore(styleElement, hideElement);

			if(element._lazysizesParentFit){
				delete element._lazysizesParentFit;
			}

			if(element.complete){
				onChange();
			}
		});
	}

	if(!fitSupport || !positionSupport){
		var onRead = function(e){
			if(e.detail.instance != lazySizes){return;}

			var element = e.target;
			var obj = getObject(element);

			if(obj.fit && (!fitSupport || (obj.position != 'center'))){
				initFix(element, obj);
			}
		};

		window.addEventListener('lazyunveilread', onRead, true);

		if(initialEvent && initialEvent.detail){
			onRead(initialEvent);
		}
	}
}));


/***/ }),

/***/ "./node_modules/lazysizes/plugins/parent-fit/ls.parent-fit.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(__webpack_require__("./node_modules/lazysizes/lazysizes.js"));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	'use strict';

	if(!window.addEventListener){return;}

	var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
	var regCssFit = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/;
	var regCssObject = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/;
	var regPicture = /^picture$/i;

	var getCSS = function (elem){
		return (getComputedStyle(elem, null) || {});
	};

	var parentFit = {

		getParent: function(element, parentSel){
			var parent = element;
			var parentNode = element.parentNode;

			if((!parentSel || parentSel == 'prev') && parentNode && regPicture.test(parentNode.nodeName || '')){
				parentNode = parentNode.parentNode;
			}

			if(parentSel != 'self'){
				if(parentSel == 'prev'){
					parent = element.previousElementSibling;
				} else if(parentSel && (parentNode.closest || window.jQuery)){
					parent = (parentNode.closest ?
							parentNode.closest(parentSel) :
							jQuery(parentNode).closest(parentSel)[0]) ||
						parentNode
					;
				} else {
					parent = parentNode;
				}
			}

			return parent;
		},

		getFit: function(element){
			var tmpMatch, parentObj;
			var css = getCSS(element);
			var content = css.content || css.fontFamily;
			var obj = {
				fit: element._lazysizesParentFit || element.getAttribute('data-parent-fit')
			};

			if(!obj.fit && content && (tmpMatch = content.match(regCssFit))){
				obj.fit = tmpMatch[1];
			}

			if(obj.fit){
				parentObj = element._lazysizesParentContainer || element.getAttribute('data-parent-container');

				if(!parentObj && content && (tmpMatch = content.match(regCssObject))){
					parentObj = tmpMatch[1];
				}

				obj.parent = parentFit.getParent(element, parentObj);


			} else {
				obj.fit = css.objectFit;
			}

			return obj;
		},

		getImageRatio: function(element){
			var i, srcset, media, ratio;
			var parent = element.parentNode;
			var elements = parent && regPicture.test(parent.nodeName || '') ?
					parent.querySelectorAll('source, img') :
					[element]
				;

			for(i = 0; i < elements.length; i++){
				element = elements[i];
				srcset = element.getAttribute(lazySizesConfig.srcsetAttr) || element.getAttribute('srcset') || element.getAttribute('data-pfsrcset') || element.getAttribute('data-risrcset') || '';
				media = element._lsMedia || element.getAttribute('media');
				media = lazySizesConfig.customMedia[element.getAttribute('data-media') || media] || media;

				if(srcset && (!media || (window.matchMedia && matchMedia(media) || {}).matches )){
					ratio = parseFloat(element.getAttribute('data-aspectratio'));

					if(!ratio && srcset.match(regDescriptors)){
						if(RegExp.$2 == 'w'){
							ratio = RegExp.$1 / RegExp.$3;
						} else {
							ratio = RegExp.$3 / RegExp.$1;
						}
					}
					break;
				}
			}

			return ratio;
		},

		calculateSize: function(element, width){
			var displayRatio, height, imageRatio, retWidth;
			var fitObj = this.getFit(element);
			var fit = fitObj.fit;
			var fitElem = fitObj.parent;

			if(fit != 'width' && ((fit != 'contain' && fit != 'cover') || !(imageRatio = this.getImageRatio(element)))){
				return width;
			}

			if(fitElem){
				width = fitElem.clientWidth;
			} else {
				fitElem = element;
			}

			retWidth = width;

			if(fit == 'width'){
				retWidth = width;
			} else {
				height = fitElem.clientHeight;

				if(height > 40 && (displayRatio =  width / height) && ((fit == 'cover' && displayRatio < imageRatio) || (fit == 'contain' && displayRatio > imageRatio))){
					retWidth = width * (imageRatio / displayRatio);
				}
			}

			return retWidth;
		}
	};

	lazySizes.parentFit = parentFit;

	document.addEventListener('lazybeforesizes', function(e){
		if(e.defaultPrevented || e.detail.instance != lazySizes){return;}

		var element = e.target;
		e.detail.width = parentFit.calculateSize(element, e.detail.width);
	});
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./node_modules/lazysizes/plugins/respimg/ls.respimg.js":
/***/ (function(module, exports, __webpack_require__) {

(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(__webpack_require__("./node_modules/lazysizes/lazysizes.js"), __webpack_require__("./node_modules/lazysizes/plugins/fix-ios-sizes/fix-ios-sizes.js"));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	/*jshint eqnull:true */
	'use strict';
	var polyfill;
	var config = (lazySizes && lazySizes.cfg) || window.lazySizesConfig;
	var img = document.createElement('img');
	var supportSrcset = ('sizes' in img) && ('srcset' in img);
	var regHDesc = /\s+\d+h/g;
	var fixEdgeHDescriptor = (function(){
		var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
		var forEach = Array.prototype.forEach;

		return function(edgeMatch){
			var img = document.createElement('img');
			var removeHDescriptors = function(source){
				var ratio;
				var srcset = source.getAttribute(lazySizesConfig.srcsetAttr);
				if(srcset){
					if(srcset.match(regDescriptors)){
						if(RegExp.$2 == 'w'){
							ratio = RegExp.$1 / RegExp.$3;
						} else {
							ratio = RegExp.$3 / RegExp.$1;
						}

						if(ratio){
							source.setAttribute('data-aspectratio', ratio);
						}
					}
					source.setAttribute(lazySizesConfig.srcsetAttr, srcset.replace(regHDesc, ''));
				}
			};
			var handler = function(e){
				var picture = e.target.parentNode;

				if(picture && picture.nodeName == 'PICTURE'){
					forEach.call(picture.getElementsByTagName('source'), removeHDescriptors);
				}
				removeHDescriptors(e.target);
			};

			var test = function(){
				if(!!img.currentSrc){
					document.removeEventListener('lazybeforeunveil', handler);
				}
			};

			if(edgeMatch[1]){
				document.addEventListener('lazybeforeunveil', handler);

				if(true){
					img.onload = test;
					img.onerror = test;

					img.srcset = 'data:,a 1w 1h';

					if(img.complete){
						test();
					}
				}
			}
		};
	})();


	if(!config){
		config = {};
		window.lazySizesConfig = config;
	}

	if(!config.supportsType){
		config.supportsType = function(type/*, elem*/){
			return !type;
		};
	}

	if(window.picturefill || config.pf){return;}

	if(window.HTMLPictureElement && supportSrcset){

		if(document.msElementsFromPoint){
			fixEdgeHDescriptor(navigator.userAgent.match(/Edge\/(\d+)/));
		}

		config.pf = function(){};
		return;
	}

	config.pf = function(options){
		var i, len;
		if(window.picturefill){return;}
		for(i = 0, len = options.elements.length; i < len; i++){
			polyfill(options.elements[i]);
		}
	};

	// partial polyfill
	polyfill = (function(){
		var ascendingSort = function( a, b ) {
			return a.w - b.w;
		};
		var regPxLength = /^\s*\d+\.*\d*px\s*$/;
		var reduceCandidate = function (srces) {
			var lowerCandidate, bonusFactor;
			var len = srces.length;
			var candidate = srces[len -1];
			var i = 0;

			for(i; i < len;i++){
				candidate = srces[i];
				candidate.d = candidate.w / srces.w;

				if(candidate.d >= srces.d){
					if(!candidate.cached && (lowerCandidate = srces[i - 1]) &&
						lowerCandidate.d > srces.d - (0.13 * Math.pow(srces.d, 2.2))){

						bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

						if(lowerCandidate.cached) {
							lowerCandidate.d += 0.15 * bonusFactor;
						}

						if(lowerCandidate.d + ((candidate.d - srces.d) * bonusFactor) > srces.d){
							candidate = lowerCandidate;
						}
					}
					break;
				}
			}
			return candidate;
		};

		var parseWsrcset = (function(){
			var candidates;
			var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
			var regMultiple = /\s/;
			var addCandidate = function(match, candidate, url, wDescriptor){
				candidates.push({
					c: candidate,
					u: url,
					w: wDescriptor * 1
				});
			};

			return function(input){
				candidates = [];
				input = input.trim();
				input
					.replace(regHDesc, '')
					.replace(regWCandidates, addCandidate)
				;

				if(!candidates.length && input && !regMultiple.test(input)){
					candidates.push({
						c: input,
						u: input,
						w: 99
					});
				}

				return candidates;
			};
		})();

		var runMatchMedia = function(){
			if(runMatchMedia.init){return;}

			runMatchMedia.init = true;
			addEventListener('resize', (function(){
				var timer;
				var matchMediaElems = document.getElementsByClassName('lazymatchmedia');
				var run = function(){
					var i, len;
					for(i = 0, len = matchMediaElems.length; i < len; i++){
						polyfill(matchMediaElems[i]);
					}
				};

				return function(){
					clearTimeout(timer);
					timer = setTimeout(run, 66);
				};
			})());
		};

		var createSrcset = function(elem, isImage){
			var parsedSet;
			var srcSet = elem.getAttribute('srcset') || elem.getAttribute(config.srcsetAttr);

			if(!srcSet && isImage){
				srcSet = !elem._lazypolyfill ?
					(elem.getAttribute(config.srcAttr) || elem.getAttribute('src')) :
					elem._lazypolyfill._set
				;
			}

			if(!elem._lazypolyfill || elem._lazypolyfill._set != srcSet){

				parsedSet = parseWsrcset( srcSet || '' );
				if(isImage && elem.parentNode){
					parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == 'PICTURE';

					if(parsedSet.isPicture){
						if(window.matchMedia){
							lazySizes.aC(elem, 'lazymatchmedia');
							runMatchMedia();
						}
					}
				}

				parsedSet._set = srcSet;
				Object.defineProperty(elem, '_lazypolyfill', {
					value: parsedSet,
					writable: true
				});
			}
		};

		var getX = function(elem){
			var dpr = window.devicePixelRatio || 1;
			var optimum = lazySizes.getX && lazySizes.getX(elem);
			return Math.min(optimum || dpr, 2.5, dpr);
		};

		var matchesMedia = function(media){
			if(window.matchMedia){
				matchesMedia = function(media){
					return !media || (matchMedia(media) || {}).matches;
				};
			} else {
				return !media;
			}

			return matchesMedia(media);
		};

		var getCandidate = function(elem){
			var sources, i, len, media, source, srces, src, width;

			source = elem;
			createSrcset(source, true);
			srces = source._lazypolyfill;

			if(srces.isPicture){
				for(i = 0, sources = elem.parentNode.getElementsByTagName('source'), len = sources.length; i < len; i++){
					if( config.supportsType(sources[i].getAttribute('type'), elem) && matchesMedia( sources[i].getAttribute('media')) ){
						source = sources[i];
						createSrcset(source);
						srces = source._lazypolyfill;
						break;
					}
				}
			}

			if(srces.length > 1){
				width = source.getAttribute('sizes') || '';
				width = regPxLength.test(width) && parseInt(width, 10) || lazySizes.gW(elem, elem.parentNode);
				srces.d = getX(elem);
				if(!srces.src || !srces.w || srces.w < width){
					srces.w = width;
					src = reduceCandidate(srces.sort(ascendingSort));
					srces.src = src;
				} else {
					src = srces.src;
				}
			} else {
				src = srces[0];
			}

			return src;
		};

		var p = function(elem){
			if(supportSrcset && elem.parentNode && elem.parentNode.nodeName.toUpperCase() != 'PICTURE'){return;}
			var candidate = getCandidate(elem);

			if(candidate && candidate.u && elem._lazypolyfill.cur != candidate.u){
				elem._lazypolyfill.cur = candidate.u;
				candidate.cached = true;
				elem.setAttribute(config.srcAttr, candidate.u);
				elem.setAttribute('src', candidate.u);
			}
		};

		p.parse = parseWsrcset;

		return p;
	})();

	if(config.loadedClass && config.loadingClass){
		(function(){
			var sels = [];
			['img[sizes$="px"][srcset].', 'picture > img:not([srcset]).'].forEach(function(sel){
				sels.push(sel + config.loadedClass);
				sels.push(sel + config.loadingClass);
			});
			config.pf({
				elements: document.querySelectorAll(sels.join(', '))
			});
		})();

	}
}));


/***/ }),

/***/ "./node_modules/owl.carousel/src/js/owl.autoheight.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
 * AutoHeight Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the auto height plugin.
	 * @class The Auto Height Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoHeight = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		this._previousHeight = null;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight) {
					this.update();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight && e.property.name === 'position'){
					this.update();
				}
			}, this),
			'loaded.owl.lazy': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight
					&& e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {
					this.update();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
		this._intervalId = null;
		var refThis = this;

		// These changes have been taken from a PR by gavrochelegnou proposed in #1575
		// and have been made compatible with the latest jQuery version
		$(window).on('load', function() {
			if (refThis._core.settings.autoHeight) {
				refThis.update();
			}
		});

		// Autoresize the height of the carousel when window is resized
		// When carousel has images, the height is dependent on the width
		// and should also change on resize
		$(window).resize(function() {
			if (refThis._core.settings.autoHeight) {
				if (refThis._intervalId != null) {
					clearTimeout(refThis._intervalId);
				}

				refThis._intervalId = setTimeout(function() {
					refThis.update();
				}, 250);
			}
		});

	};

	/**
	 * Default options.
	 * @public
	 */
	AutoHeight.Defaults = {
		autoHeight: false,
		autoHeightClass: 'owl-height'
	};

	/**
	 * Updates the view.
	 */
	AutoHeight.prototype.update = function() {
		var start = this._core._current,
			end = start + this._core.settings.items,
			lazyLoadEnabled = this._core.settings.lazyLoad,
			visible = this._core.$stage.children().toArray().slice(start, end),
			heights = [],
			maxheight = 0;

		$.each(visible, function(index, item) {
			heights.push($(item).height());
		});

		maxheight = Math.max.apply(null, heights);

		if (maxheight <= 1 && lazyLoadEnabled && this._previousHeight) {
			maxheight = this._previousHeight;
		}

		this._previousHeight = maxheight;

		this._core.$stage.parent()
			.height(maxheight)
			.addClass(this._core.settings.autoHeightClass);
	};

	AutoHeight.prototype.destroy = function() {
		var handler, property;

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] !== 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var ReactPropTypesSecret = __webpack_require__("./node_modules/prop-types/lib/ReactPropTypesSecret.js");

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("./node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "./node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./node_modules/react-addons-css-transition-group/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__("./node_modules/react-transition-group/CSSTransitionGroup.js");


/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__("./node_modules/react-transition-group/TransitionGroup.js");

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__("./node_modules/react-transition-group/CSSTransitionGroupChild.js");

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransitionGroupChild.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__("./node_modules/dom-helpers/class/addClass.js");

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__("./node_modules/dom-helpers/class/removeClass.js");

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__("./node_modules/dom-helpers/util/requestAnimationFrame.js");

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__("./node_modules/dom-helpers/transition/properties.js");

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/TransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__("./node_modules/chain-function/index.js");

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__("./node_modules/warning/browser.js");

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__("./node_modules/react-transition-group/utils/ChildMapping.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/utils/ChildMapping.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__("./node_modules/react/index.js");

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),

/***/ "./node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),

/***/ "./node_modules/slick-carousel/slick/slick.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/stickyfilljs/dist/stickyfill.js":
/***/ (function(module, exports) {

/*!
  * Stickyfill – `position: sticky` polyfill
  * v. 2.1.0 | https://github.com/wilddeer/stickyfill
  * MIT License
  */

;(function(window, document) {
    'use strict';
    
    /*
     * 1. Check if the browser supports `position: sticky` natively or is too old to run the polyfill.
     *    If either of these is the case set `seppuku` flag. It will be checked later to disable key features
     *    of the polyfill, but the API will remain functional to avoid breaking things.
     */
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    var seppuku = false;
    
    var isWindowDefined = typeof window !== 'undefined';
    
    // The polyfill can’t function properly without `window` or `window.getComputedStyle`.
    if (!isWindowDefined || !window.getComputedStyle) seppuku = true;
    // Dont’t get in a way if the browser supports `position: sticky` natively.
    else {
            (function () {
                var testNode = document.createElement('div');
    
                if (['', '-webkit-', '-moz-', '-ms-'].some(function (prefix) {
                    try {
                        testNode.style.position = prefix + 'sticky';
                    } catch (e) {}
    
                    return testNode.style.position != '';
                })) seppuku = true;
            })();
        }
    
    /*
     * 2. “Global” vars used across the polyfill
     */
    var isInitialized = false;
    
    // Check if Shadow Root constructor exists to make further checks simpler
    var shadowRootExists = typeof ShadowRoot !== 'undefined';
    
    // Last saved scroll position
    var scroll = {
        top: null,
        left: null
    };
    
    // Array of created Sticky instances
    var stickies = [];
    
    /*
     * 3. Utility functions
     */
    function extend(targetObj, sourceObject) {
        for (var key in sourceObject) {
            if (sourceObject.hasOwnProperty(key)) {
                targetObj[key] = sourceObject[key];
            }
        }
    }
    
    function parseNumeric(val) {
        return parseFloat(val) || 0;
    }
    
    function getDocOffsetTop(node) {
        var docOffsetTop = 0;
    
        while (node) {
            docOffsetTop += node.offsetTop;
            node = node.offsetParent;
        }
    
        return docOffsetTop;
    }
    
    /*
     * 4. Sticky class
     */
    
    var Sticky = function () {
        function Sticky(node) {
            _classCallCheck(this, Sticky);
    
            if (!(node instanceof HTMLElement)) throw new Error('First argument must be HTMLElement');
            if (stickies.some(function (sticky) {
                return sticky._node === node;
            })) throw new Error('Stickyfill is already applied to this node');
    
            this._node = node;
            this._stickyMode = null;
            this._active = false;
    
            stickies.push(this);
    
            this.refresh();
        }
    
        _createClass(Sticky, [{
            key: 'refresh',
            value: function refresh() {
                if (seppuku || this._removed) return;
                if (this._active) this._deactivate();
    
                var node = this._node;
    
                /*
                 * 1. Save node computed props
                 */
                var nodeComputedStyle = getComputedStyle(node);
                var nodeComputedProps = {
                    position: nodeComputedStyle.position,
                    top: nodeComputedStyle.top,
                    display: nodeComputedStyle.display,
                    marginTop: nodeComputedStyle.marginTop,
                    marginBottom: nodeComputedStyle.marginBottom,
                    marginLeft: nodeComputedStyle.marginLeft,
                    marginRight: nodeComputedStyle.marginRight,
                    cssFloat: nodeComputedStyle.cssFloat
                };
    
                /*
                 * 2. Check if the node can be activated
                 */
                if (isNaN(parseFloat(nodeComputedProps.top)) || nodeComputedProps.display == 'table-cell' || nodeComputedProps.display == 'none') return;
    
                this._active = true;
    
                /*
                 * 3. Check if the current node position is `sticky`. If it is, it means that the browser supports sticky positioning,
                 *    but the polyfill was force-enabled. We set the node’s position to `static` before continuing, so that the node
                 *    is in it’s initial position when we gather its params.
                 */
                var originalPosition = node.style.position;
                if (nodeComputedStyle.position == 'sticky' || nodeComputedStyle.position == '-webkit-sticky') node.style.position = 'static';
    
                /*
                 * 4. Get necessary node parameters
                 */
                var referenceNode = node.parentNode;
                var parentNode = shadowRootExists && referenceNode instanceof ShadowRoot ? referenceNode.host : referenceNode;
                var nodeWinOffset = node.getBoundingClientRect();
                var parentWinOffset = parentNode.getBoundingClientRect();
                var parentComputedStyle = getComputedStyle(parentNode);
    
                this._parent = {
                    node: parentNode,
                    styles: {
                        position: parentNode.style.position
                    },
                    offsetHeight: parentNode.offsetHeight
                };
                this._offsetToWindow = {
                    left: nodeWinOffset.left,
                    right: document.documentElement.clientWidth - nodeWinOffset.right
                };
                this._offsetToParent = {
                    top: nodeWinOffset.top - parentWinOffset.top - parseNumeric(parentComputedStyle.borderTopWidth),
                    left: nodeWinOffset.left - parentWinOffset.left - parseNumeric(parentComputedStyle.borderLeftWidth),
                    right: -nodeWinOffset.right + parentWinOffset.right - parseNumeric(parentComputedStyle.borderRightWidth)
                };
                this._styles = {
                    position: originalPosition,
                    top: node.style.top,
                    bottom: node.style.bottom,
                    left: node.style.left,
                    right: node.style.right,
                    width: node.style.width,
                    marginTop: node.style.marginTop,
                    marginLeft: node.style.marginLeft,
                    marginRight: node.style.marginRight
                };
    
                var nodeTopValue = parseNumeric(nodeComputedProps.top);
                this._limits = {
                    start: nodeWinOffset.top + window.pageYOffset - nodeTopValue,
                    end: parentWinOffset.top + window.pageYOffset + parentNode.offsetHeight - parseNumeric(parentComputedStyle.borderBottomWidth) - node.offsetHeight - nodeTopValue - parseNumeric(nodeComputedProps.marginBottom)
                };
    
                /*
                 * 5. Ensure that the node will be positioned relatively to the parent node
                 */
                var parentPosition = parentComputedStyle.position;
    
                if (parentPosition != 'absolute' && parentPosition != 'relative') {
                    parentNode.style.position = 'relative';
                }
    
                /*
                 * 6. Recalc node position.
                 *    It’s important to do this before clone injection to avoid scrolling bug in Chrome.
                 */
                this._recalcPosition();
    
                /*
                 * 7. Create a clone
                 */
                var clone = this._clone = {};
                clone.node = document.createElement('div');
    
                // Apply styles to the clone
                extend(clone.node.style, {
                    width: nodeWinOffset.right - nodeWinOffset.left + 'px',
                    height: nodeWinOffset.bottom - nodeWinOffset.top + 'px',
                    marginTop: nodeComputedProps.marginTop,
                    marginBottom: nodeComputedProps.marginBottom,
                    marginLeft: nodeComputedProps.marginLeft,
                    marginRight: nodeComputedProps.marginRight,
                    cssFloat: nodeComputedProps.cssFloat,
                    padding: 0,
                    border: 0,
                    borderSpacing: 0,
                    fontSize: '1em',
                    position: 'static'
                });
    
                referenceNode.insertBefore(clone.node, node);
                clone.docOffsetTop = getDocOffsetTop(clone.node);
            }
        }, {
            key: '_recalcPosition',
            value: function _recalcPosition() {
                if (!this._active || this._removed) return;
    
                var stickyMode = scroll.top <= this._limits.start ? 'start' : scroll.top >= this._limits.end ? 'end' : 'middle';
    
                if (this._stickyMode == stickyMode) return;
    
                switch (stickyMode) {
                    case 'start':
                        extend(this._node.style, {
                            position: 'absolute',
                            left: this._offsetToParent.left + 'px',
                            right: this._offsetToParent.right + 'px',
                            top: this._offsetToParent.top + 'px',
                            bottom: 'auto',
                            width: 'auto',
                            marginLeft: 0,
                            marginRight: 0,
                            marginTop: 0
                        });
                        break;
    
                    case 'middle':
                        extend(this._node.style, {
                            position: 'fixed',
                            left: this._offsetToWindow.left + 'px',
                            right: this._offsetToWindow.right + 'px',
                            top: this._styles.top,
                            bottom: 'auto',
                            width: 'auto',
                            marginLeft: 0,
                            marginRight: 0,
                            marginTop: 0
                        });
                        break;
    
                    case 'end':
                        extend(this._node.style, {
                            position: 'absolute',
                            left: this._offsetToParent.left + 'px',
                            right: this._offsetToParent.right + 'px',
                            top: 'auto',
                            bottom: 0,
                            width: 'auto',
                            marginLeft: 0,
                            marginRight: 0
                        });
                        break;
                }
    
                this._stickyMode = stickyMode;
            }
        }, {
            key: '_fastCheck',
            value: function _fastCheck() {
                if (!this._active || this._removed) return;
    
                if (Math.abs(getDocOffsetTop(this._clone.node) - this._clone.docOffsetTop) > 1 || Math.abs(this._parent.node.offsetHeight - this._parent.offsetHeight) > 1) this.refresh();
            }
        }, {
            key: '_deactivate',
            value: function _deactivate() {
                var _this = this;
    
                if (!this._active || this._removed) return;
    
                this._clone.node.parentNode.removeChild(this._clone.node);
                delete this._clone;
    
                extend(this._node.style, this._styles);
                delete this._styles;
    
                // Check whether element’s parent node is used by other stickies.
                // If not, restore parent node’s styles.
                if (!stickies.some(function (sticky) {
                    return sticky !== _this && sticky._parent && sticky._parent.node === _this._parent.node;
                })) {
                    extend(this._parent.node.style, this._parent.styles);
                }
                delete this._parent;
    
                this._stickyMode = null;
                this._active = false;
    
                delete this._offsetToWindow;
                delete this._offsetToParent;
                delete this._limits;
            }
        }, {
            key: 'remove',
            value: function remove() {
                var _this2 = this;
    
                this._deactivate();
    
                stickies.some(function (sticky, index) {
                    if (sticky._node === _this2._node) {
                        stickies.splice(index, 1);
                        return true;
                    }
                });
    
                this._removed = true;
            }
        }]);
    
        return Sticky;
    }();
    
    /*
     * 5. Stickyfill API
     */
    
    
    var Stickyfill = {
        stickies: stickies,
        Sticky: Sticky,
    
        forceSticky: function forceSticky() {
            seppuku = false;
            init();
    
            this.refreshAll();
        },
        addOne: function addOne(node) {
            // Check whether it’s a node
            if (!(node instanceof HTMLElement)) {
                // Maybe it’s a node list of some sort?
                // Take first node from the list then
                if (node.length && node[0]) node = node[0];else return;
            }
    
            // Check if Stickyfill is already applied to the node
            // and return existing sticky
            for (var i = 0; i < stickies.length; i++) {
                if (stickies[i]._node === node) return stickies[i];
            }
    
            // Create and return new sticky
            return new Sticky(node);
        },
        add: function add(nodeList) {
            // If it’s a node make an array of one node
            if (nodeList instanceof HTMLElement) nodeList = [nodeList];
            // Check if the argument is an iterable of some sort
            if (!nodeList.length) return;
    
            // Add every element as a sticky and return an array of created Sticky instances
            var addedStickies = [];
    
            var _loop = function _loop(i) {
                var node = nodeList[i];
    
                // If it’s not an HTMLElement – create an empty element to preserve 1-to-1
                // correlation with input list
                if (!(node instanceof HTMLElement)) {
                    addedStickies.push(void 0);
                    return 'continue';
                }
    
                // If Stickyfill is already applied to the node
                // add existing sticky
                if (stickies.some(function (sticky) {
                    if (sticky._node === node) {
                        addedStickies.push(sticky);
                        return true;
                    }
                })) return 'continue';
    
                // Create and add new sticky
                addedStickies.push(new Sticky(node));
            };
    
            for (var i = 0; i < nodeList.length; i++) {
                var _ret2 = _loop(i);
    
                if (_ret2 === 'continue') continue;
            }
    
            return addedStickies;
        },
        refreshAll: function refreshAll() {
            stickies.forEach(function (sticky) {
                return sticky.refresh();
            });
        },
        removeOne: function removeOne(node) {
            // Check whether it’s a node
            if (!(node instanceof HTMLElement)) {
                // Maybe it’s a node list of some sort?
                // Take first node from the list then
                if (node.length && node[0]) node = node[0];else return;
            }
    
            // Remove the stickies bound to the nodes in the list
            stickies.some(function (sticky) {
                if (sticky._node === node) {
                    sticky.remove();
                    return true;
                }
            });
        },
        remove: function remove(nodeList) {
            // If it’s a node make an array of one node
            if (nodeList instanceof HTMLElement) nodeList = [nodeList];
            // Check if the argument is an iterable of some sort
            if (!nodeList.length) return;
    
            // Remove the stickies bound to the nodes in the list
    
            var _loop2 = function _loop2(i) {
                var node = nodeList[i];
    
                stickies.some(function (sticky) {
                    if (sticky._node === node) {
                        sticky.remove();
                        return true;
                    }
                });
            };
    
            for (var i = 0; i < nodeList.length; i++) {
                _loop2(i);
            }
        },
        removeAll: function removeAll() {
            while (stickies.length) {
                stickies[0].remove();
            }
        }
    };
    
    /*
     * 6. Setup events (unless the polyfill was disabled)
     */
    function init() {
        if (isInitialized) {
            return;
        }
    
        isInitialized = true;
    
        // Watch for scroll position changes and trigger recalc/refresh if needed
        function checkScroll() {
            if (window.pageXOffset != scroll.left) {
                scroll.top = window.pageYOffset;
                scroll.left = window.pageXOffset;
    
                Stickyfill.refreshAll();
            } else if (window.pageYOffset != scroll.top) {
                scroll.top = window.pageYOffset;
                scroll.left = window.pageXOffset;
    
                // recalc position for all stickies
                stickies.forEach(function (sticky) {
                    return sticky._recalcPosition();
                });
            }
        }
    
        checkScroll();
        window.addEventListener('scroll', checkScroll);
    
        // Watch for window resizes and device orientation changes and trigger refresh
        window.addEventListener('resize', Stickyfill.refreshAll);
        window.addEventListener('orientationchange', Stickyfill.refreshAll);
    
        //Fast dirty check for layout changes every 500ms
        var fastCheckTimer = void 0;
    
        function startFastCheckTimer() {
            fastCheckTimer = setInterval(function () {
                stickies.forEach(function (sticky) {
                    return sticky._fastCheck();
                });
            }, 500);
        }
    
        function stopFastCheckTimer() {
            clearInterval(fastCheckTimer);
        }
    
        var docHiddenKey = void 0;
        var visibilityChangeEventName = void 0;
    
        if ('hidden' in document) {
            docHiddenKey = 'hidden';
            visibilityChangeEventName = 'visibilitychange';
        } else if ('webkitHidden' in document) {
            docHiddenKey = 'webkitHidden';
            visibilityChangeEventName = 'webkitvisibilitychange';
        }
    
        if (visibilityChangeEventName) {
            if (!document[docHiddenKey]) startFastCheckTimer();
    
            document.addEventListener(visibilityChangeEventName, function () {
                if (document[docHiddenKey]) {
                    stopFastCheckTimer();
                } else {
                    startFastCheckTimer();
                }
            });
        } else startFastCheckTimer();
    }
    
    if (!seppuku) init();
    
    /*
     * 7. Expose Stickyfill
     */
    if (typeof module != 'undefined' && module.exports) {
        module.exports = Stickyfill;
    } else if (isWindowDefined) {
        window.Stickyfill = Stickyfill;
    }
    
})(window, document);

/***/ }),

/***/ "./node_modules/svg-baker-runtime/browser-symbol.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSpriteSymbol = factory());
}(this, (function () { 'use strict';

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var index = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = index(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

return BrowserSpriteSymbol;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/svg-sprite-loader/runtime/browser-sprite.build.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSprite = factory());
}(this, (function () { 'use strict';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var index = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

//      
// An event handler can take an optional event argument
// and should not return a value
                                          
// An array of all currently registered event handlers for a type
                                            
// A map of event types and their corresponding event handlers.
                        
                                   
  

/** Mitt: Tiny (~200b) functional event emitter / pubsub.
 *  @name mitt
 *  @returns {Mitt}
 */
function mitt(all                 ) {
	all = all || Object.create(null);

	return {
		/**
		 * Register an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to listen for, or `"*"` for all events
		 * @param  {Function} handler Function to call in response to given event
		 * @memberOf mitt
		 */
		on: function on(type        , handler              ) {
			(all[type] || (all[type] = [])).push(handler);
		},

		/**
		 * Remove an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
		 * @param  {Function} handler Handler function to remove
		 * @memberOf mitt
		 */
		off: function off(type        , handler              ) {
			if (all[type]) {
				all[type].splice(all[type].indexOf(handler) >>> 0, 1);
			}
		},

		/**
		 * Invoke all handlers for the given type.
		 * If present, `"*"` handlers are invoked after type-matched handlers.
		 *
		 * @param {String} type  The event type to invoke
		 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
		 * @memberof mitt
		 */
		emit: function emit(type        , evt     ) {
			(all[type] || []).map(function (handler) { handler(evt); });
			(all['*'] || []).map(function (handler) { handler(type, evt); });
		}
	};
}

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = index(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var svg$1 = namespaces_1.svg;
var xlink$1 = namespaces_1.xlink;

var defaultConfig = {
  attrs: ( obj = {
    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
};
var obj;

var Sprite = function Sprite(config) {
  this.config = index(defaultConfig, config || {});
  this.symbols = [];
};

/**
 * Add new symbol. If symbol with the same id exists it will be replaced.
 * @param {SpriteSymbol} symbol
 * @return {boolean} `true` - symbol was added, `false` - replaced
 */
Sprite.prototype.add = function add (symbol) {
  var ref = this;
    var symbols = ref.symbols;
  var existing = this.find(symbol.id);

  if (existing) {
    symbols[symbols.indexOf(existing)] = symbol;
    return false;
  }

  symbols.push(symbol);
  return true;
};

/**
 * Remove symbol & destroy it
 * @param {string} id
 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
 */
Sprite.prototype.remove = function remove (id) {
  var ref = this;
    var symbols = ref.symbols;
  var symbol = this.find(id);

  if (symbol) {
    symbols.splice(symbols.indexOf(symbol), 1);
    symbol.destroy();
    return true;
  }

  return false;
};

/**
 * @param {string} id
 * @return {SpriteSymbol|null}
 */
Sprite.prototype.find = function find (id) {
  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
};

/**
 * @param {string} id
 * @return {boolean}
 */
Sprite.prototype.has = function has (id) {
  return this.find(id) !== null;
};

/**
 * @return {string}
 */
Sprite.prototype.stringify = function stringify () {
  var ref = this.config;
    var attrs = ref.attrs;
  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
  return wrapInSvgString(stringifiedSymbols, attrs);
};

/**
 * @return {string}
 */
Sprite.prototype.toString = function toString () {
  return this.stringify();
};

Sprite.prototype.destroy = function destroy () {
  this.symbols.forEach(function (s) { return s.destroy(); });
};

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

var defaultConfig$1 = {
  /**
   * Should following options be automatically configured:
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @type {boolean}
   */
  autoConfigure: true,

  /**
   * Default mounting selector
   * @type {string}
   */
  mountTo: 'body',

  /**
   * Fix disappearing SVG elements when <base href> exists.
   * Executes when sprite mounted.
   * @see http://stackoverflow.com/a/18265336/796152
   * @see https://github.com/everdimension/angular-svg-base-fix
   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
   * @type {boolean}
   */
  syncUrlsWithBaseTag: false,

  /**
   * Should sprite listen custom location change event
   * @type {boolean}
   */
  listenLocationChangeEvent: true,

  /**
   * Custom window event name which should be emitted to update sprite urls
   * @type {string}
   */
  locationChangeEvent: 'locationChange',

  /**
   * Emit location change event in Angular automatically
   * @type {boolean}
   */
  locationChangeAngularEmitter: false,

  /**
   * Selector to find symbols usages when updating sprite urls
   * @type {string}
   */
  usagesToUpdate: 'use[*|href]',

  /**
   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
   * Executes when sprite is rendered, but not mounted.
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
   * @type {boolean}
   */
  moveGradientsOutsideSymbol: false
};

/**
 * @param {*} arrayLike
 * @return {Array}
 */
var arrayFrom = function (arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
};

var ua = navigator.userAgent;

var browser = {
  isChrome: /chrome/i.test(ua),
  isFirefox: /firefox/i.test(ua),

  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
  isIE: /msie/i.test(ua) || /trident/i.test(ua),
  isEdge: /edge/i.test(ua)
};

/**
 * @param {string} name
 * @param {*} data
 */
var dispatchEvent = function (name, data) {
  var event = document.createEvent('CustomEvent');
  event.initCustomEvent(name, false, false, data);
  window.dispatchEvent(event);
};

/**
 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
 * This trick will trigger IE to read and use any existing SVG <style> tags.
 * @see https://github.com/iconic/SVGInjector/issues/23
 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
 *
 * @param {Element} node DOM Element to search <style> tags in
 * @return {Array<HTMLStyleElement>}
 */
var evalStylesIEWorkaround = function (node) {
  var updatedNodes = [];

  arrayFrom(node.querySelectorAll('style'))
    .forEach(function (style) {
      style.textContent += '';
      updatedNodes.push(style);
    });

  return updatedNodes;
};

/**
 * @param {string} [url] If not provided - current URL will be used
 * @return {string}
 */
var getUrlWithoutFragment = function (url) {
  return (url || window.location.href).split('#')[0];
};

/* global angular */
/**
 * @param {string} eventName
 */
var locationChangeAngularEmitter = function (eventName) {
  angular.module('ng').run(['$rootScope', function ($rootScope) {
    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
    });
  }]);
};

var defaultSelector = 'linearGradient, radialGradient, pattern';

/**
 * @param {Element} svg
 * @param {string} [selector]
 * @return {Element}
 */
var moveGradientsOutsideSymbol = function (svg, selector) {
  if ( selector === void 0 ) selector = defaultSelector;

  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
      symbol.parentNode.insertBefore(node, symbol);
    });
  });
  return svg;
};

/**
 * @param {NodeList} nodes
 * @param {Function} [matcher]
 * @return {Attr[]}
 */
function selectAttributes(nodes, matcher) {
  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
    if (!node.attributes) {
      return acc;
    }

    var arrayfied = arrayFrom(node.attributes);
    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
    return acc.concat(matched);
  }, []);

  return attrs;
}

/**
 * @param {NodeList|Node} nodes
 * @param {boolean} [clone=true]
 * @return {string}
 */

var xLinkNS = namespaces_1.xlink.uri;
var xLinkAttrName = 'xlink:href';

// eslint-disable-next-line no-useless-escape
var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;

function encoder(url) {
  return url.replace(specialUrlCharsPattern, function (match) {
    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
  });
}

/**
 * @param {NodeList} nodes
 * @param {string} startsWith
 * @param {string} replaceWith
 * @return {NodeList}
 */
function updateReferences(nodes, startsWith, replaceWith) {
  arrayFrom(nodes).forEach(function (node) {
    var href = node.getAttribute(xLinkAttrName);
    if (href && href.indexOf(startsWith) === 0) {
      var newUrl = href.replace(startsWith, replaceWith);
      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
    }
  });

  return nodes;
}

/**
 * List of SVG attributes to update url() target in them
 */
var attList = [
  'clipPath',
  'colorProfile',
  'src',
  'cursor',
  'fill',
  'filter',
  'marker',
  'markerStart',
  'markerMid',
  'markerEnd',
  'mask',
  'stroke',
  'style'
];

var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');

/**
 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
 * @param {Element} svg
 * @param {NodeList} references
 * @param {string|RegExp} startsWith
 * @param {string} replaceWith
 * @return {void}
 *
 * @example
 * const sprite = document.querySelector('svg.sprite');
 * const usages = document.querySelectorAll('use');
 * updateUrls(sprite, usages, '#', 'prefix#');
 */
var updateUrls = function (svg, references, startsWith, replaceWith) {
  var startsWithEncoded = encoder(startsWith);
  var replaceWithEncoded = encoder(replaceWith);

  var nodes = svg.querySelectorAll(attSelector);
  var attrs = selectAttributes(nodes, function (ref) {
    var localName = ref.localName;
    var value = ref.value;

    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
  });

  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
  updateReferences(references, startsWithEncoded, replaceWithEncoded);
};

/**
 * Internal emitter events
 * @enum
 * @private
 */
var Events = {
  MOUNT: 'mount',
  SYMBOL_MOUNT: 'symbol_mount'
};

var BrowserSprite = (function (Sprite$$1) {
  function BrowserSprite(cfg) {
    var this$1 = this;
    if ( cfg === void 0 ) cfg = {};

    Sprite$$1.call(this, index(defaultConfig$1, cfg));

    var emitter = mitt();
    this._emitter = emitter;
    this.node = null;

    var ref = this;
    var config = ref.config;

    if (config.autoConfigure) {
      this._autoConfigure(cfg);
    }

    if (config.syncUrlsWithBaseTag) {
      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
    }

    var handleLocationChange = this._handleLocationChange.bind(this);
    this._handleLocationChange = handleLocationChange;

    // Provide way to update sprite urls externally via dispatching custom window event
    if (config.listenLocationChangeEvent) {
      window.addEventListener(config.locationChangeEvent, handleLocationChange);
    }

    // Emit location change event in Angular automatically
    if (config.locationChangeAngularEmitter) {
      locationChangeAngularEmitter(config.locationChangeEvent);
    }

    // After sprite mounted
    emitter.on(Events.MOUNT, function (spriteNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(spriteNode);
      }
    });

    // After symbol mounted into sprite
    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(symbolNode.parentNode);
      }

      if (browser.isIE || browser.isEdge) {
        evalStylesIEWorkaround(symbolNode);
      }
    });
  }

  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
  BrowserSprite.prototype.constructor = BrowserSprite;

  var prototypeAccessors = { isMounted: {} };

  /**
   * @return {boolean}
   */
  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * Automatically configure following options
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @param {Object} cfg
   * @private
   */
  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
    var ref = this;
    var config = ref.config;

    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
    }

    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
      config.locationChangeAngularEmitter = 'angular' in window;
    }

    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
      config.moveGradientsOutsideSymbol = browser.isFirefox;
    }
  };

  /**
   * @param {Event} event
   * @param {Object} event.detail
   * @param {string} event.detail.oldUrl
   * @param {string} event.detail.newUrl
   * @private
   */
  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
    var ref = event.detail;
    var oldUrl = ref.oldUrl;
    var newUrl = ref.newUrl;
    this.updateUrls(oldUrl, newUrl);
  };

  /**
   * Add new symbol. If symbol with the same id exists it will be replaced.
   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
   * @fires Events#SYMBOL_MOUNT
   * @param {BrowserSpriteSymbol} symbol
   * @return {boolean} `true` - symbol was added, `false` - replaced
   */
  BrowserSprite.prototype.add = function add (symbol) {
    var sprite = this;
    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);

    if (this.isMounted && isNewSymbol) {
      symbol.mount(sprite.node);
      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    }

    return isNewSymbol;
  };

  /**
   * Attach to existing DOM node
   * @param {string|Element} target
   * @return {Element|null} attached DOM Element. null if node to attach not found.
   */
  BrowserSprite.prototype.attach = function attach (target) {
    var this$1 = this;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    /** @type Element */
    var node = typeof target === 'string' ? document.querySelector(target) : target;
    sprite.node = node;

    // Already added symbols needs to be mounted
    this.symbols.forEach(function (symbol) {
      symbol.mount(sprite.node);
      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    });

    // Create symbols from existing DOM nodes, add and mount them
    arrayFrom(node.querySelectorAll('symbol'))
      .forEach(function (symbolNode) {
        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
        sprite.add(symbol);
      });

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  BrowserSprite.prototype.destroy = function destroy () {
    var ref = this;
    var config = ref.config;
    var symbols = ref.symbols;
    var _emitter = ref._emitter;

    symbols.forEach(function (s) { return s.destroy(); });

    _emitter.off('*');
    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);

    if (this.isMounted) {
      this.unmount();
    }
  };

  /**
   * @fires Events#MOUNT
   * @param {string|Element} [target]
   * @param {boolean} [prepend=false]
   * @return {Element|null} rendered sprite node. null if mount node not found.
   */
  BrowserSprite.prototype.mount = function mount (target, prepend) {
    if ( target === void 0 ) target = this.config.mountTo;
    if ( prepend === void 0 ) prepend = false;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
    var node = sprite.render();
    this.node = node;

    if (prepend && mountNode.childNodes[0]) {
      mountNode.insertBefore(node, mountNode.childNodes[0]);
    } else {
      mountNode.appendChild(node);
    }

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSprite.prototype.render = function render () {
    return parse(this.stringify());
  };

  /**
   * Detach sprite from the DOM
   */
  BrowserSprite.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  /**
   * Update URLs in sprite and usage elements
   * @param {string} oldUrl
   * @param {string} newUrl
   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
   */
  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
    if (!this.isMounted) {
      return false;
    }

    var usages = document.querySelectorAll(this.config.usagesToUpdate);

    updateUrls(
      this.node,
      usages,
      ((getUrlWithoutFragment(oldUrl)) + "#"),
      ((getUrlWithoutFragment(newUrl)) + "#")
    );

    return true;
  };

  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );

  return BrowserSprite;
}(Sprite));

var ready$1 = createCommonjsModule(function (module) {
/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  { module.exports = definition(); }

}('domready', function () {

  var fns = [], listener
    , doc = document
    , hack = doc.documentElement.doScroll
    , domContentLoaded = 'DOMContentLoaded'
    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);


  if (!loaded)
  { doc.addEventListener(domContentLoaded, listener = function () {
    doc.removeEventListener(domContentLoaded, listener);
    loaded = 1;
    while (listener = fns.shift()) { listener(); }
  }); }

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  }

});
});

var spriteNodeId = '__SVG_SPRITE_NODE__';
var spriteGlobalVarName = '__SVG_SPRITE__';
var isSpriteExists = !!window[spriteGlobalVarName];

// eslint-disable-next-line import/no-mutable-exports
var sprite;

if (isSpriteExists) {
  sprite = window[spriteGlobalVarName];
} else {
  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
  window[spriteGlobalVarName] = sprite;
}

var loadSprite = function () {
  /**
   * Check for page already contains sprite node
   * If found - attach to and reuse it's content
   * If not - render and mount the new sprite
   */
  var existing = document.getElementById(spriteNodeId);

  if (existing) {
    sprite.attach(existing);
  } else {
    sprite.mount(document.body, true);
  }
};

if (document.body) {
  loadSprite();
} else {
  ready$1(loadSprite);
}

var sprite$1 = sprite;

return sprite$1;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/warning/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ })

},["./app/index.js"]);


// WEBPACK FOOTER //
// app.d6ba9125b85daee86b33.js